import React, { useState, useEffect, useRef } from "react";
import "../History/DocumentHistory.css";
// import "react-quill/dist/quill.snow.css";
import "../../Shared/CommonTab/common-tabs.css";
import "./Manage.css";
import "../../Shared/SendCreate/CustomDatePicker.css";
import $ from "jquery";
import Header from "../../Shared/Header/Header";
import Footer from "../../Shared/Footer/Footer";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import SelectCountry, { components, NonceProvider } from "react-select";
import momenttimezone from "moment-timezone";
import Alert from "../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import APIRequest from "../../../Services/commonAPIConsumer";
import { Tooltip as ReactTooltip } from "react-tooltip";
// import { useCookies } from "react-cookie";
import { ReactMultiEmail } from "react-multi-email";
import DatePicker from "react-datepicker";
import AddRecipientModal from "./Modals/AddRecipientModal";
import ManageFolderModal from "./Modals/ManageFolderModal";
import DeleteConfirmationModal from "./Modals/DeleteConfirmModal";
import UpdateConfirmModal from "./Modals/UpdateConfirmModal";
import ValidationPopup from "./Modals/ValidationPopup";
import EditReaderModal from "./Modals/EditReaderModal";
import RecipientsModal from "./Modals/RecipientsModal";
import MoveFolderPopup from "./Modals/MoveFolderPopup";
import Level3Popup from "./Modals/Level3Popup";
import Level3AddUserModal from "./Modals/Level3AddUserModal";
import ManageUserModal from "./Modals/ManageUserModal";
import IsActiveModal from "./Modals/IsActiveModal";
import MoveConfirmModal from "./Modals/MoveConfirmModal";
import CreateFolderModal from "./Modals/CreateFolderModal";
import TrackSortingPopup from "./Modals/TrackSortingPopup";
import KillNoteModal from "./Modals/KillNoteModal";
import NotesModal from "./Modals/NotesModal";
import AddUserConfirmationModal from "./Modals/AddUserConfirmationModal";
import PendingReaderConfirmModal from "./Modals/PendingReaderConfirmModal";
import ControlStatusModal from "./Modals/ControlStatusModal";
import PageLevelViewPopup from "./Modals/PageLevelViewPopup";
import DocumentHistoryPopup from "./Modals/DocumentHistoryPopup";
import ControlStatusConfirmationModal from "./Modals/ControlStatusConfirmationModal";
import CustomColumnLayout from "./Modals/CustomColumn/CustomColumnDragAndDrop";
import EditIcon from "../../../assets/img/EditIcon.png";
import Tooltip from "./Modals/ReactTooltip";
import { AppContext } from "../../../AppContext";
import UpdatePopup from "../../Controls/ModalPopUp/UpdatePopup";
import {
  //Select,
  MenuItem,
  Box,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Select from "react-select";
import UserListPopup from "../../Shared/UserListPopup/UserListPopup";
import "react-tooltip/dist/react-tooltip.css";
import shareIcon from "../../../assets/img/shareIcon.png";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
  setDocumentTemplateName
} from "../../../StateManagement/actions";

import { format } from "react-string-format";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Pagination from "../../Controls/Pagination/pagination";
import PendingRequestHeaderBar from "./PendingRequestHeaderBar";
import PageRestrictions from "../../Shared/SendCreate/PageLevelRestrictions/PageRestrictions";
import "../../Shared/SendCreate/countryFlagStyles.css";
import ModalPopUp from "../../Controls/ModalPopUp/ModalPopUp";
import InfoToolTip from "./InfoIconTooltip";
import DOMPurify from "dompurify";
import parse from 'html-react-parser';
import he from "he";
import CanPrintViewPopup from "./Modals/CanPrintViewPopup";
let openLoaderFolder = false;
let isUserPopupopen = false;
let isNewRecipientAdded = false;
let folderViewTabSelected = 0;
let expireToActivePopup = 1;
let approvedRequests = [];
let updatedApprovedRequests = [];
let isPageRestrictionsChanged = false;

function Manage() {
  const searchInputTimeout = useRef(null);
  const trackInteractivityDetailsRef = useRef([]);
  const backupRecords = useRef(true);
  const currTrackDetails = useRef({
    docId: "",
    recipientEmail: "",
  })
  const onSearch = useRef(false);
  const pendingChipUpdate = useRef(null);
  const summaryDetails = useRef([]);
  const searchInputRefForTrackInteractivity = useRef(null);

  const canMoveRPDRecords = useRef([]);

  const verificationCodeRefValue = useRef("");
  const [verificationCode, setVerificationCode] = useState("");
  const changeOfAuthType = useRef(false);
  const emailAuth = useRef(false);
  const multiAuth = useRef(false);
  const inValidAuthType = useRef([]);
  const inValidMsgForBoth = useRef("");
  let verificationOptions = useRef([]);


  let currentPagevalue = 1;
  let currentPageViewCount = 25;
  let isRecordExits = false;
  let start = 0;
  let waitcount = 0;
  const history = useNavigate();
  // let UserName = getCookie("UserName");
  // const [signCookie, settabCookie] = useCookies([""]);
  // settabCookie("TabDocumentHistory", "DocumentHistory");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
  const unSaveWarnModal = useRef();
  const pageLevelBckupDBData = useRef([]);
  const customFilterOptions = useSelector((state) => state.customFilterOptions);
  useEffect(() => {
    const options = customFilterOptions?.customFilterOptions;

    if (!options) return;

    setCustomFilterOptionsArray({
      isDocumentId: options.documentId ?? { visible: false, order: 0 },
      isSubject: options.subjectDescription ?? { visible: false, order: 0 },
      isFileName: options.fileName ?? { visible: false, order: 0 },
      isReaderEmail: options.readerEmail ?? { visible: false, order: 0 },
      isAccessControl: options.accessControl ?? { visible: false, order: 0 },
      isStatus: options.status ?? { visible: false, order: 0 },
      isPages: options.pages ?? { visible: false, order: 0 },
      isDomains: options.domains ?? { visible: false, order: 0 },
      isTemplates: options.templates ?? { visible: false, order: 0 },
      isLaunches: options.launches ?? { visible: false, order: 0 },
      isExpires: options.expires ?? { visible: false, order: 0 },
    });
  }, [customFilterOptions]);

  if (
    // (UserTabCreate == "" &&
    //   UserTabSend == "" &&
    //   UserTabSignIn == "" &&
    //   UserName != null) ||
    // UserName === null ||
    localStorage.getItem("UserName") === undefined ||
    localStorage.getItem("UserName") === "" ||
    localStorage.getItem("UserName") === null
  ) {
    history("/");
  }
  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSignIn", "Referesh");
  //   }
  // }
  const [currentOpenIndex, setCurrentOpenIndex] = useState({
    docId: [],
  });
  const manageItem = localStorage.getItem("ManageItem");
  const [isUpdated, setIsUpdated] = useState(false);
  const trRef = useRef([]);
  const trackRef = useRef([]);
  const l3TabNavigation = useRef([]);
  const dynamicWidthSet = useRef(false);
  const folderView = useRef();
  const allItems = useRef();
  const sortDown = useRef(true);
  const chkReaderSelectionRef = useRef([]);
  const backUpOfConfiguredRestrictions = useRef([]);
  const isSelectAllReaders = useRef(false);
  const [sendVerificationCodeDisable, setSendVerificationCodeDisable] =
    useState(false);
  const [modalIsActivityLogOpen, setModalIsReaderActivityLogOpen] = useState(false);
  const [IsSMS, setIsSMS] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [invalidMobileNumbers, setInvalidMobileNumbers] = useState([]);
  const [unauthorizedCountryCodes, setUnauthorizedCountryCodes] = useState([]);
  const [duplicateMobileNumbers, setDuplicateMobileNumbers] = useState([]);
  const [missingMobileNumbers, setMissingMobileNumbers] = useState([]);
  const [missingCountryCodes, setMissingCountryCodes] = useState([]);
  const [invalidCanPrintValues, setInvalidCanPrintValues] = useState([]);
  const [exceedMaxPrintsPerDoc, setExceedMaxPrintsPerDoc] = useState([]);
  const [maxPrintsWithoutCanPrint, setMaxPrintsWithoutCanPrint] = useState([]);
  const [canPrintNotEnabledAtDocLevel, setCanPrintNotEnabledAtDocLevel] = useState([]);
  const [maxPrintsExceedLimit, setMaxPrintsExceedLimit] = useState([]);
  const [invalidMaxPrintsValues, setInvalidMaxPrintsValues] = useState([]);
  const [countryCodeOptions, setCountryCodeOptions] = useState([]);
  const [countryCodeDrpOptions, setCountryCodedrpOptions] = useState([]);
  const [isSMSAuthentication, setIsSMSAuthentication] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([
    //{ value: "email", label: "Email" },
  ]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [customFilterOptionsArray, setCustomFilterOptionsArray] = useState({
    isDocumentId: { visible: true, order: 1 },
    isSubject: { visible: true, order: 2 },
    isFileName: { visible: true, order: 3 },
    isReaderEmail: { visible: true, order: 4 },
    isAccessControl: { visible: true, order: 5 },
    isStatus: { visible: true, order: 6 },

    isPages: { visible: false, order: 0 },
    isDomains: { visible: false, order: 0 },
    isTemplates: { visible: false, order: 0 },
    isLaunches: { visible: false, order: 0 },
    isExpires: { visible: false, order: 0 }
  });
  const [activeEmail, setActiveEmail] = useState("");
  const [trackDocumentId, setTrackDocumentId] = useState("");
  const [activeOpenId, setActiveOpenId] = useState("");
  const [activityDocumentId, setActivityDocumentId] = useState("");
  const [isReaderStatistics, setIsReaderStatistics] = useState(false);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [ClearSearchcalled, setClearSearchcalled] = useState(false);
  const [timerText, settimertimerText] = useState("You will be logged out in ");
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");
  const [lstKilledDocuments, setLstKilledDocuments] = useState([]);
  const [Reader_Continue, setReader_Continue] = useState("");
  const [lstDocumentsHistory, setLstDocumentsHistory] = useState([]);
  const [lstTrackInteractivityData, setlstTrackInteractivityData] = useState([]);
  const [lstDocumentsHistoryDetails, setlstDocumentsHistoryDetails] = useState(
    []
  );
  // const [timeZoneAbbrevation, setTimeZoneAbbrevation] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const expiryTimeRef = useRef("");
  const [isExpireChangePopup, setIsExpireChangePopup] = useState(false);
  const [changedExpiryDate, setChangedExpiryDate] = useState("");
  const [securityLevl2, setSecurityLevel2] = useState(false);
  const [longReference, setLongReference] = useState([]);
  const [reference, setReference] = useState("");
  const [ownerInput, setOwnerInput] = useState("");
  const [trackInteractivitySortingPopUp, setTrackInteractivitySortingPopUp] = useState(false);
  const [istrackkillHeader, setIsTrackKillHeader] = useState(false);
  const [MainlstDocumentsHistoryDetails, setMainlstDocumentsHistoryDetails] =
    useState([]);
  const [orgLstDocumentsHistory, setOrgLstDocumentsHistory] = useState([]);
  const [orgLstPendingRequestAccess, setOrgLstPendingRequestAccess] = useState(
    []
  );
  const [pendingRequestAccessTabFlag, setPendingRequestAccessTabFlag] =
    useState(false);
  const [docIndexForReaders, setDocIndexForReaders] = useState(0);
  const [senderNotes, setSenderNotes] = useState("");
  const [killNotes, setKillNotes] = useState("");
  const jwtToken = localStorage.getItem("JWtToken");
  const [openLoader, setOpen] = useState(true);
  const [openLoaderSearch, setOpenLoaderSearch] = useState(false);
  const [openSession, setOpenSession] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [masterSelection, setMasterSelection] = useState(false);
  const [masterSelectionRequest, setMasterSelectionRequest] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenKillNote, setModalIsOpenKillNote] = useState(false);
  const [modalIsOpenNotes, setModalIsOpenNotes] = useState(false);
  const [modalIsMoveFolderOpen, setModalIsMoveFolderOpen] = useState(false);
  const [modalIsCreateFolderOpen, setModalIsCreateFolderOpen] = useState(false);
  const [modalIsManageFolderOpen, setModalIsManageFolderOpen] = useState(false);
  const [modalIsDeleteOpen, setModalIsDeleteOpen] = useState(false);
  const [modalIsUpdateconfirmOpen, setModalIsUpdateconfirmOpen] =
    useState(false);
  const [modalIsUserPopupOpen, setModalIsUserPopupOpen] = useState(false);
  const [modalIsMoveConfirmOpen, setmodalIsMoveConfirmOpen] = useState(false);
  const [folderName, setfolderName] = useState("");
  const [folderNameText, setFolderNameText] = useState("");
  const [foldersDetailsLst, setFoldersDetailsLst] = useState([]);
  const [folderId, setFolderId] = useState("");
  const [ddlfolderId, setDDLFolderId] = useState("");
  const [childUserData, setChildUserData] = useState([]);
  const [childUserListData, setChildUserListData] = useState([]);
  const [isSharedFlag, setIsSharedFlag] = useState("0");
  const [ddlSelectedfolderName, setddlSelectedfolderName] = useState("");
  const [defaultSelected, setDefaultSelected] = useState(false);
  const [
    sendingRequestApproveDeclineFlag,
    setSendingRequestApproveDeclineFlag,
  ] = useState();
  const [noRecordsFoundPendingAccess, setNoRecordsFoundPendingAccess] =
    useState(false);
  const [modalActiveIsOpen, setModalActiveIsOpen] = useState(false);
  const [activeIsOpenEvent, setActiveIsOpenEvent] = useState();
  const [activeIsOpenDocId, setActiveIsOpenDocId] = useState();
  const [activeIsOpenHistoryFlag, setActiveIsOpenHistoryFlag] = useState(false);
  const [modalForAddUser, setModalForAddUser] = useState(false);
  const [modalForControlStatus, setModalForControlStatus] = useState(false);
  const [modalForDocumentHistory, setmodalForDocumentHistory] = useState(false);
  const [modalStyle, setmodalStyle] = useState(false);
  const [modalForLevel3Popup, setModalForLevel3Popup] = useState(false);
  const [modalForLevel3AddUser, setModalForLevel3AddUser] = useState(false);
  const [modalForManageUser, setModalForManageUser] = useState(false);
  const [longFirstName, setLongFirstName] = useState([]);
  const [longLastName, setLongLastName] = useState([]);
  const [isModalFnLnOpen, setIsModalFnLnOpen] = useState(false);
  const [modalTermsOfServicePopup, setModalTermsOfServicePopup] = useState(false);
  const [TermsofServiceMessage, setTermsofServiceMessage] = useState("");
  const [currentEmail, setCurrentEmail] = useState(false);
  const [firstName, setFirstName] = useState(false);
  const [lastName, setLastName] = useState(false);
  const [readerPrint, setReaderPrint] = useState(false);
  const [maxPrintsPerIndReader, setMaxPrintsPerIndReader] = useState("");
  const [currentDocument, setCurrentDocument] = useState([]);
  const [recipientPrintData, setRecipientPrintData] = useState([]);
  const [printEnabledType, setPrintEnabledType] = useState("");
  const [currentRecipientId, setCurrentRecipientId] = useState("");
  const [activeTabName, setActiveTabName] = useState("AllItems");
  const [ddlShareFolderSelected, setddlShareFolderSelected] = useState(false);
  const [isFolderViewselected, setIsFolderViewselected] = useState(false);
  const [
    modalForControlStatusConfirmation,
    setModalForControlStatusConfirmation,
  ] = useState(false);
  const [modalForAddUserConfirmation, setModalForAddUserConfirmation] =
    useState(false);
  const [modalForPendingReaderConfirmation, setModalForPendingReaderConfirmation] =
    useState(false);
  const pendingConfirmPayload = useRef(null);
  const pendingConfirmEditFlag = useRef(false);
  const [modalForControlStatusPendingConfirmation, setModalForControlStatusPendingConfirmation] =
    useState(false);
  const controlStatusPendingPayload = useRef(null);
  const [sortColumn, setSortColumn] = useState("Created");
  const [sortBy, setSortBy] = useState("desc");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [searchActivityLog, setSearchActivityLog] = useState("");
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [authorizedEmails, setAuthorizedEmailId] = useState([]);
  const [popupDocumentId, setPopupDocumentId] = useState("");
  const [newReceipentsCount, setNewReceipentsCount] = useState(0);
  const [receipentsError, setReceipentsError] = useState(true);
  const [emails, setEmailId] = useState([]);
  const [fileName, setfileName] = useState("");
  const [duplicateInFile, setDuplicateInFile] = useState([]);
  const [KilledByInput, SetKilledByInput] = useState("");
  const [isKilledOpt, setIsKilledOpt] = useState(false);
  const [isModalAddRecipientOpen, setIsModalAddRecipientOpen] = useState(false);
  const [isValidationPopup, setIsValidationPopup] = useState(false);
  const [duplicateEmails, setDuplicateEmails] = useState([]);
  const [emailLeanghtValidation, setemailLeanghtValidation] = useState([]);
  const [invalidEmailsWithoutDotCom, setInvalidEmailsWithoutDotComValidation] =
    useState([]);
  const [localpartValiadation, setLocalpartValiadation] = useState([]);
  const [longDomainEmails, setLongDomainEmails] = useState([]);
  const [constEmailsFromCSV, setConstEmailsFromCSV] = useState([]);
  const [ReadersinputFields, setReadersinputFields] = useState([]);
  const [constmultipleEmails, setConstMultipleEmails] = useState([]);
  const [AddDragActive, setAddDragActive] = useState(false);
  const [ReadersfileName, setReadersFileName] = useState("");
  const [isPageLevelRestriction, setIsPageLevelRestriction] = useState(false);
  const [isPageLevelRestrictionSetting, setIsPageLevelRestrictionSetting] = useState(false);
  const [isPageLevelData, setIsPageLevelData] = useState(false);
  const [isPageLevelRestrictionChecked, setIsPageLevelRestrictionChecked] =
    useState(false);
  const [isEDisclosureChecked, setIsEDisclosureChecked] =
    useState(false);
  const pageLevelResRef = useRef();
  const EDisclosureResRef = useRef();
  const isPageLevelRestrictionref = useRef(false);
  const isEDisclosureref = useRef(false);
  const isPageLevelRestrictionCheckedref = useRef(false);
  const isEDisclosureCheckedref = useRef(false);
  const pageLevelResModalRef = useRef();
  const [selectionOfRestriction, setSelectionOfRestriction] = useState([]);
  const [deleteSelectionOfRestriction, setDeleteSelectionOfRestriction] =
    useState([]);
  const [chailedToParentRecipients, setChailedToParentRecipients] = useState(
    []
  );
  const [selectedDocIndexes, setSelectedDocIndexes] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [
    selectionOfRestrictionCheckboxMaintanances,
    setSelectionOfRestrictionCheckboxMaintanances,
  ] = useState([]);
  const endRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [inputFields, setInputFields] = useState([
    {
      email: "",
      firstName: "",
      lastName: "",
      authType: "",
      mobileCountryCode: [],
      mobileNumber: "",
      reference: "",
      canPrint: false,
      maxPrintsPerReader: ""
    },
  ]);
  const maxPrintsFields = useRef({});
  const letMePickCancelRef = useRef(false);
  const addInputField = () => {
    const itemDocumentsHistory = lstDocumentsHistory.find((item) => (item.documentId === popupDocumentId));
    const enablePrint = itemDocumentsHistory?.documentOptions?.print && itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone;
    setPrintEnabledType(itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone === true ? "everyone" : "selectedUsers");
    setInputFields([
      ...inputFields,
      {
        email: "",
        firstName: "",
        lastName: "",
        authType: "",
        mobileCountryCode: [],
        mobileNumber: "",
        reference: "",
        canPrint: enablePrint,
        maxPrintsPerReader: enablePrint ? (maxPrintsFields?.current?.maxPrintsPerReader ?? itemDocumentsHistory?.documentOptions?.maxPrintsPerReader ?? "") : ""
      },
    ]);
    setShouldScroll(true);
    if (endRef.current) endRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const [selectedSearchRecords, setSelectedSearchRecords] = useState([
    {
      page: 0,
      docs: [],
    },
  ]);
  const expiryChnagedPopup = useRef(false);
  const isMasterSelection = useRef(false);
  const itemsCheckRef = useRef([]);
  const restoreRestrictions = useRef(false);
  const [isControlClick, setIsControlClick] = useState({
    isSearchOrRefresh: false,
    isClear: false,
    isMoveToFolder: false,
    isKilled: false,
    isBanOrActive: false,
  });
  const [recordsSelectedCount, setRecordsSelectedCount] = useState({
    showRecords: false,
    count: 0,
  });
  const [restrictWarningMsg, setRestrictarningMsg] = useState(false);
  const [dateFormatValueUpper, setDateFormatValueUpper] =
    useState("MM/DD/YYYY");
  const [dateFormatValueLower, setDateFormatValueLower] =
    useState("mm/dd/yyyy");
  const [dateFormatValueOriginal, setDateFormatValueOriginal] =
    useState("MM/dd/yyyy");
  const [defaultTheCompany, setDefaultTheCompany] = useState(false);
  const [showCompanyWhenApply, setShowCompanyWhenApply] = useState("");
  const [showOwnerWhenApply, setShowOwnerWhenApply] = useState("");
  const [trackInteractivityDetails, setTrackInteractivityDetails] = useState(
    []
  );
  const [activityLogDetails, setActivityLogDetails] = useState([]);
  const [
    sortDirectionForTrackInteractivity,
    setSortDirectionForTrackInteractivity,
  ] = useState({});
  const [sortDirectionForActivityLog, setSortDirectionForActivityLog] =
    useState({});
  let counter = 1;
  const handleChange = (index, evnt) => {
    const { name, value, type, checked } = evnt.target;
    const list = [...inputFields];
    if (name === "maxPrintsPerReader") {
      const textValue = value.replace(/[^0-9]/g, "");
      if (textValue === "" || (textValue.length <= 4 && parseInt(textValue, 10) >= 1 && parseInt(textValue, 10) <= 9999)) {
        list[index][name] = textValue === "" ? null : parseInt(textValue, 10);
      } else {
        return;
      }
    }
    else if (name === "canPrint") {
      list[index][name] = checked;
      if (!checked) {
        list[index].previousMaxPrintsPerReader = list[index].maxPrintsPerReader;
        list[index].maxPrintsPerReader = null;
      } else {
        list[index].maxPrintsPerReader = list[index].previousMaxPrintsPerReader ?? null;
      }
    }
    else {
      list[index][name] = type === "checkbox" ? checked : value;
    }
    setInputFields(list);
  };
  const removeInputFields = (index) => {
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  };
  const handleSearchApply = (flag = 0) => {
    if (flag != 1) {
      if (ownerSearch) {
        const strictOwnerEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
        if (!strictOwnerEmailRegex.test(ownerSearch.trim())) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
          setAlertType("warning");
          return;
        }
        pendingChipUpdate.current = { owner: ownerSearch.trim(), company: companySearch };
      } else {
        pendingChipUpdate.current = { owner: null, company: companySearch };
      }
      setSearchFilterPopup(false);
      setShowOwnerCompany(true);
      const userRole = localStorage.getItem("UserRole");
      if (userRole === "RDocsCustomerAdmin") {
        setCompanySearch("");
      }
      setIsFilterChanged(true);
      SearchDocumentData(0);
    }
    else {
      SearchDocumentData(2);
    }
  };
  useEffect(() => {
    dispatch(setDocumentTemplateName(""));
  }, []);
  const [isAccessManagement, setIsAccessManagement] = useState(false);
  const [isAllItems, setIsAllItems] = useState(true);
  const [classNameSticky, setClassNameSticky] = useState("sticky-section");
  const [toggleMenu, setToggleMenu] = useState(false);
  const [customColumnLayoutFlag, setCustomColumnLayoutFlag] = useState(false);
  const timeZoneAbbrevation = useRef("");
  const maxPrintsPerReader = useRef();
  const maxPrintsPerDocument = useRef();
  const orderTrackInteractivityAndActivityLogDetails = (docDetails) => {
    const recipientsList = docDetails.map((item) => {
      const recipients = item.documentOptions.recipients;
      if (
        item.openRecords.filter(
          (emailList) =>
            emailList.email == null &&
            (emailList.event == "Opened" || emailList.event == null)
        ).length > 0
      ) {
        const openedTime = item.openRecords.filter(
          (emailList) =>
            emailList.email == null &&
            (emailList.event == "Opened" || emailList.event == null)
        )[0].opened;

        const totalTime =
          item.openRecords.filter(
            (emailList) =>
              emailList.email == null && emailList.activityTime !== undefined && (emailList.event == "Opened" || emailList.event == null)
          ).length > 0
            ? getTimeFormat(
              item.openRecords
                .filter(
                  (emailList) =>
                    emailList.email == null &&
                    emailList.activityTime !== undefined && (emailList.event == "Opened" || emailList.event == null)
                )
                .map((timeCalc) => timeCalc.activityTime)
                .reduce((accTime, timeCalc) => timeCalc + accTime)
            )
            : "00:00:00";
        const reads =
          item.openRecords.filter(
            (emailList) =>
              emailList.email == null && emailList.activityTime !== undefined && (emailList.event == "Opened" || emailList.event == null)
          ).length > 0
            ? item.openRecords.filter(
              (emailList) =>
                emailList.email == null &&
                emailList.activityTime !== undefined && (emailList.event == "Opened" || emailList.event == null)
            ).length
            : "";
        if (recipients.length > 0) {
          recipients.forEach((recp) => {
            if (recp.email === null) {
              recp.openedTime = openedTime;
              recp.totalTime = totalTime;
              recp.checked = false;
              recp.readCount = reads;
            }
          });
          recipients.push({
            openedTime,
            totalTime,
            readCount: reads,
            checked: false,
          });
        } else {
          recipients.push({
            openedTime,
            totalTime,
            readCount: reads,
            checked: false,
          });
        }
      }
      return recipients.map((recpList) => {
        if (!recpList.openedTime) {
          recpList.openedTime =
            item.openRecords.filter(
              (emailList) =>
                emailList.email != null &&
                (emailList.event == "Opened" || emailList.event == null) &&
                recpList.email != null &&
                emailList.email.toString().toLowerCase() ===
                recpList.email.toString().toLowerCase()
            ).length > 0
              ? item.openRecords.filter(
                (emailList) =>
                  emailList.email != null &&
                  (emailList.event == "Opened" || emailList.event == null) &&
                  recpList.email != null &&
                  emailList.email.toString().toLowerCase() ===
                  recpList.email.toString().toLowerCase()
              )[0].opened != null
                ? item.openRecords.filter(
                  (emailList) =>
                    emailList.email != null &&
                    (emailList.event == "Opened" ||
                      emailList.event == null) &&
                    recpList.email != null &&
                    emailList.email.toString().toLowerCase() ===
                    recpList.email.toString().toLowerCase()
                )[0].opened
                : ""
              : "";
        }
        if (!recpList.totalTime) {
          recpList.totalTime =
            item.openRecords.filter(
              (emailList) =>
                emailList.email != null &&
                (emailList.event == "Opened" || emailList.event == null) &&
                recpList.email != null &&
                emailList.email.toString().toLowerCase() ===
                recpList.email.toString().toLowerCase() &&
                emailList.activityTime !== undefined
            ).length > 0
              ? getTimeFormat(
                item.openRecords
                  .filter(
                    (emailList) =>
                      emailList.email != null &&
                      emailList.activityTime !== undefined &&
                      (emailList.event == "Opened" ||
                        emailList.event == null) &&
                      recpList.email != null &&
                      emailList.email.toString().toLowerCase() ===
                      recpList.email.toString().toLowerCase()
                  )
                  .map((timeCalc) => timeCalc.activityTime)
                  .reduce((accTime, timeCalc) => timeCalc + accTime)
              )
              : "00:00:00";
        }
        if (!recpList.checked) {
          recpList.checked = false;
        }
        return recpList;
      });
    });

    const sortedRecords = recipientsList
      .map((recp) =>
        recp.sort((a, b) => {
          const dateA = a.openedTime ? new Date(a.openedTime) : new Date(0);
          const dateB = b.openedTime ? new Date(b.openedTime) : new Date(0);
          if (dateA && dateB) return dateB - dateA;
          if (dateA && !dateB) return 1;
          if (!dateA && dateB) return -1;
          return 0;
        })
      )
      .map((records, index) => {
        return {
          sortDetails: defaultTrackInteractivitySortOptions,
          records: records,
          docId: docDetails[index].documentId,
          showBanActiveButtons: false,
          selectAllRecipients: false,
        };
      });
    trackInteractivityDetailsRef.current = JSON.parse(JSON.stringify(sortedRecords));
    if (onSearch.current) {
      const docIndex = sortedRecords.findIndex((item) => item.docId === currTrackDetails.current.docId);
      if (docIndex !== -1) {
        const updatedRecipient = sortedRecords[docIndex].records.find((item) => item.email === currTrackDetails.current.recipientEmail);
        if (updatedRecipient) {
          sortedRecords[docIndex].records = [{ ...updatedRecipient }];
        }
      }
    }
    setTrackInteractivityDetails(sortedRecords);

    const openRecords = docDetails.map((item) => {
      return item.openRecords;
    });
    const sortedActivityLog = openRecords
      .map((records) =>
        records.sort((a, b) => {
          const dateA = new Date(a.opened);
          const dateB = new Date(b.opened);
          return dateB - dateA;
        })
      )
      .map((records, index) => {
        return {
          order: "desc",
          records: records,
          docId: docDetails[index].documentId,
        };
      });
    setActivityLogDetails(sortedActivityLog);
    setSortDirectionForTrackInteractivity({});
    setSortDirectionForActivityLog({});
  };
  const onAddNewReaderHandler = (addedReaders) => {
    const totalReaders = [
      ...new Set(
        addedReaders.reduce((acc, current) => acc.concat(current), [])
      ),
    ];
    const readers = chailedToParentRecipients.reduce((acc, i) => {
      return acc.concat(i[0]);
    }, []);
    let addedReader = totalReaders.filter((item) => !readers.includes(item));
    console.log(...addedReader);
    addedReader = addedReader.map((str) => [str, "", "", [], ""]);
    setConstMultipleEmails(() => {
      return [...chailedToParentRecipients, ...addedReader];
    });
  };
  const handleSortDirectionForActivityLog = (docId) => {
    setActivityLogDetails((prevDetails) => {
      return prevDetails.map((detail) => {
        if (detail.docId === docId) {
          const sortedRecords = detail.records.sort((a, b) => {
            return detail.order === "desc"
              ? new Date(a.opened) - new Date(b.opened)
              : new Date(b.opened) - new Date(a.opened);
          }).map((record) => {
            return {
              ...record,
              open: false
            }
          });

          return {
            ...detail,
            records: sortedRecords,
            order: detail.order === "desc" ? "asc" : "desc",
          };
        }
        return detail;
      });
    });
    const currentDirection = sortDirectionForActivityLog[docId] || "desc";
    const newDirection = currentDirection === "asc" ? "desc" : "asc";
    setSortDirectionForActivityLog((prev) => ({
      ...prev,
      [docId]: newDirection,
    }));
  };
  useEffect(() => {
    const userRole = localStorage.getItem("UserRole");
    const loggedInEmail = localStorage.getItem("UserName");
    const companyName = localStorage.getItem("Companyname");

    if (
      userRole === "RDocsSupportAdmin" ||
      userRole === "RDocsCustomerAdmin"
    ) {

      if (loggedInEmail) {
        const owner = loggedInEmail.trim();

        setOwnerSearch(owner);

        setShowOwnerWhenApply((prev) => {
          // guard against duplicate / double-run
          if (!prev || prev !== owner) {
            return owner;
          }
          return prev;
        });
      }

      if (userRole === "RDocsSupportAdmin" && companyName) {
        const company = companyName.trim();

        setCompanySearch(company);

        setShowCompanyWhenApply((prev) => {
          if (!prev || prev !== company) {
            return company;
          }
          return prev;
        });
      }


      setShowOwnerCompany(true);
    }
  }, []);
  const handleSearchPopup = () => {
    const userRole = localStorage.getItem("UserRole");
    const loggedInEmail = localStorage.getItem("UserName");
    const companyName = localStorage.getItem("Companyname");
    if (userRole === "RDocsSupportAdmin")
      setUserRoleBased(true);
    else if (userRole === "RDocsCustomerAdmin")
      setUserRoleBased(false);
    // if (!isFilterChanged) {
    //   if (userRole === "RDocsSupportAdmin") {
    //     setUserRoleBased(true);

    //     if (companyName) {
    //       setCompanySearch(companyName);
    //     }

    //     if (loggedInEmail) {
    //       setOwnerSearch(loggedInEmail);
    //     }

    //   } else if (userRole === "RDocsCustomerAdmin") {
    //     setUserRoleBased(false);

    //     if (loggedInEmail) {
    //       setOwnerSearch(loggedInEmail);
    //     }

    //     setCompanySearch("");
    //   }
    // }
    //setCompanySearch(companySearch);
    setOwnerSearch(showOwnerWhenApply);
    setCompanySearch(showCompanyWhenApply);
    setSearchFilterPopup(true);
    setShowOwnerCompany(true);
  };
  var folderViewKilledFlag = false;
  const clearOwnerSearch = (FodlerId = 0) => {
    if (FodlerId == 1) {
      folderViewTabSelected = 1;
      setClearSearchcalled(true);
      setFolderId(1);
      setfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
      FolderViewSelected();
    }
    setShowOwnerWhenApply("");
    setOwnerSearch("");
    var FoldersList = [];
    if (foldersDetailsLst.length > 0) {
      foldersDetailsLst.map((item, i) =>
        FoldersList.push({
          folderID: item.folderID,
          folderName: item.folderName.trim(),
          isShared: item.isShared,
          isActive: false,
          email: item.email,
        })
      );
      setFoldersDetailsLst(FoldersList);
    }
    handleSearchApply(1);
  };
  const handleSearchClear = () => {
    setOwnerSearch("");
    setCompanySearch("");
  };
  const clearCompanySearch = () => {
    setShowCompanyWhenApply("");
    setCompanySearch("");
    handleSearchApply(1);
  };
  const handleCloseModalSearch = () => {
    setSearchFilterPopup(false);
    setOwnerSearch(showOwnerWhenApply);
    setCompanySearch(showCompanyWhenApply);
  };
  const [domains, setDomains] = useState("");
  const [maxReads, setMaxReads] = useState(0);
  const [maxReadsText, setMaxReadsText] = useState("");
  const [steganography, setSteganography] = useState(false);
  const [voting, setVoting] = useState(false);
  const [voteSharing, setVoteSharing] = useState(false);
  const [canPrint, setPrint] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [expiryTime, setExpiryTime] = useState("");
  const [responseAddress, setResponseAddress] = useState(
    localStorage.getItem("UserName")
  );
  const [distributionList, setDistributionList] = useState(false);
  const [eDisclosure, setEDisclosure] = useState(false);
  const [expirationDaysFlag, setExpirationDaysFlag] = useState(true);
  const [alertClass, setAlertClass] = useState("alertindex");
  const [expirationDays, setExpirationDays] = useState("");
  const [constAllowResFlag, setConstAllowResFlag] = useState(true);
  const [verifyCode, setVerifyCode] = useState(false);
  const [constmultipleips, setConstMultipleIps] = useState("");
  const [constContinents, setConstContinents] = useState("");
  const [constSecurityLevelText, setConstSecurityLevelText] = useState("");
  const [securityLevelTextColor, setSecurityLevelTextColor] = useState("");
  const [constSecurityLevelClass, setConstSecurityLevelClass] = useState("");
  const [maxViewsPerDocument, setMaxViewsPerDocument] = useState(0);
  const [maxViewsPerDocumentText, setMaxViewsPerDocumentText] = useState("");
  const selectedLanguage = useSelector(currentSelectedLanguage);

  const [openRecord, setOpenRecord] = useState(true);
  const [geolocation, setGeolocation] = useState(true);
  const [readTimes, setReadTimes] = useState(false);
  const [readTiming, setReadTiming] = useState(false);
  const [distRestriction, setDistRestriction] = useState(false);
  const [readNotification, setReadNotification] = useState(false);
  const [readerEmail, setReaderEmail] = useState(false);
  const [rpdType, setRpdType] = useState("");
  const [isDatetimeControl, setisDatetimeControl] = useState(
    localStorage.getItem("DateControlFormat")
  );
  const dispatch = useDispatch();
  const editFolderPopup = useRef(false);
  let Index = 0;
  const [continents, setContinents] = useState([
    {
      id: 0,
      continentName: selectedLanguage.LstLanguageCodes.UI_Europe,
    },
    {
      id: 1,
      continentName: selectedLanguage.LstLanguageCodes.UI_Africa,
    },
    {
      id: 2,
      continentName: selectedLanguage.LstLanguageCodes.UI_NorthAmerica,
    },
    {
      id: 3,
      continentName: selectedLanguage.LstLanguageCodes.UI_SouthAmerica,
    },
    {
      id: 4,
      continentName: selectedLanguage.LstLanguageCodes.UI_Asia,
    },
    {
      id: 5,
      continentName: selectedLanguage.LstLanguageCodes.UI_Oceania,
    },
  ]);
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7d13mCRV2f7x7+wuLLvEhYUls+ScQQRRBEFAAVFfMKCCCTMgWVCCIiCCohhe4TWAGABRARERVHJOkvMuOS+wC2ye/v1xen47DDPT1d116j5VdX+u61xw4TjnOTVV1U+f2IOZ5W08sMQgZTywZPPfF2r+7GJADzAKWLj538YCowf873OAac3/9gYws/nvrwCNAf/7q8ALwIvASwPKi83/bWpObTWzkupRB2BWMksBE4GVm//s+/cVmffBP0ITWltmMy8hmNQsk/v9czIhuTCzinICYPZWywPrA2sz74N+5WYZqwurcC8zLxmYBDwK3AvcSUgezKzEnABYnc0PrA5sCqwDrAtsDkxQBlUSLxOSgVuBe5r/fgswQxmUmWXnBMDqYlFgK8IH/PrAhsCqlKO7vixmA/cBdwH/BW4gJAXTlUGZ2eCcAFhVLQu8A9i6+c+N8Ye9whxCMnAtobfgCuBxZUBmFjgBsCoYCazFvA/8dxLG7S1NzwDXEJKCa4DbgV5pRGY15ATAymoVYOdmeTewoDQa68aLwGXAJcClwPPacMzqwQmAlcUChG/32zfLptpwLKJ7gYuAy4ErCXMLzCxnTgAsZasw7wN/J+ZtlGP1MQX4FyEZuBh4ShuOWXU4AbDUrAd8BNgDWFMci6WlAdwMnAOcBzyhDces3JwAWApWBnYDPgVsIo7FyuNe4Czgt8DT4ljMSscJgKmsBOxO+Kb/DnEsVm69wPWEXoFzCasMzKwFJwBWpOWAvQhd/P6mbzHMJUwc/CMhGXhVG46ZWX2NIEziOxeYRRjHdXEpokwn3Hfb4y87Zm/hh8JiWQ74BPBFvCmP6d0P/Ab4JWHfATMzy9FI5n3bn43+G6CLy8AyA/cKmAF+ACwfE4EvAPsAS0sjMcvuQeD/CL0CU8SxmJmVysaEZVj+tu9S5jKDcB973wkzs2H0ELpPL0L/4nZxybPMJdzXXpZqZtbPaMJGPfegf1G7uMQutxDu95GYVZTnAFgr44HPAvsBy4pjMSvao8CPgTOAN8SxmJkVYgJwKuGlp/425uKiLi8Ah+Fjp82swpYAjgGmon/purikVvoSgTGYmVXEwoQX2yvoX7IuLqmX5wjPywKYmZXUgoQX2RT0L1UXl7KVx4H9CZNkzcxKYSzhxfUs+peoi0vZyyRgX2AUZmaJGkGY1f8M+pemi0vVyj3AjpiZJeZthHPT1S9JF5eql8uAdTEzE1uesNVpL/oXo4tLXcos4EfAYpglyLtcVdtY4EDC6Web442fzIo0EtiCMDdgJmF3wYY0IjOrvB5gD2Ay+m9BLi4uodyL5wdYQvyNsHo2BX4CvF0diJkN6nzg68AT6kCs3jwEUB1jgeMJ55uvKI7F5pkEHAe8CGwgqP844BpgHcI9YnrrAJ8DpuFhATPr0nuAh9F3cbrMK3cCH2Zekv1TURxfbtY/tvnvTyZwbVzmlWsJCYGZWVsWA36BZ/enVB4jTPoa2LumTgD6zN+M77kErpVLKLOAE/FugmaW0R54M5+UymvA4YQP2MGkkgD0GdeMaU4C184llLuBLYf4e5mZsRzwV/QvK5d55S/ASsP90UgvAeizGXBzAtfQJZS5wI+BhYb7o5lZ/XwWn9aXUpkCfGzYv9g8qSYAEIYrjiB0RauvqUsojwHbD/dHM7N6WAz4A/qXksu8cjmwwnB/tAFSTgD6rA/cIYrT5a2ll7CToOcGWBQj1AFYS9sTxgY/qg7EgNBF+y1gB6q3jvsuwhj0mepADAj7tOwH3IBXClgETgDSNR9wDHApYdzf9F4C3k9YW98QxxLLdGAfYO/mv5veRsCthOO7vXmbWcWtDdyOvgvSZV65g+42WCrDEMBAW+CVJqmVi4ClhvujmWXlHoC09ABfImT7G4ljKUqDsIQuZf8A3gk8rg6kYDcStpS+Rx1IC6nfP3naBfgvsJM6ECs/JwDpWBK4EPgZMEYcSxGmEr4V70RYi56q04FdCdu21tFjwNbAv9WBDOMJwpyMPxBWMlTd0sDf8QRBs0rYhLBnvLp7sYhyP3AYYSOaHuCSBGIaqpw43B+tTWUcAuhvfuBPojZkKT9oxjmBcH9NTiCmIsqtwMTB/2RmlrrPATPQv0hilrnABcC7B7T9ywnENlQ5/K1/qq6UPQEAGAWcLWpHlntsmwGxfhi4PoHYYpfngW0H/YuZWZJGE7qX1S+PmGUm8EvCpMaBViOM3apjHFh6CUuv8laFBADCsOEZora0Ko8CCw8S8zsJk+eqfGbGbOBgvErALHnLU+1vJlMJ45PLD9H+EcBVCcQ5WDlkiJi7VZUEAMKHTKpJwC+GiXs1wn05PYE4Y5ULgEWHuQZmJrQdoctO/aKIUV4CjgQWaXENDksg1sHKt1rE3Y0qJQAQtg8+R9Sm4UovsHOL2Jej2onAPcCaLa6BmRWoh/Dtcjb6F0TeZQrwTVp/8EPYbjbFOQ8nZYi9G1VLACBsVnWRqF3DlaeAxTPEvxxwGmnej92WV4HdM1wDM4tsDGl+W+q2vAwcRfYuxxHATQnEPbCcSfyx0yomABDu7etEbRuu/KqNNixP+PvMTCDuPEsv8G08L8BMZkmqN97/OvBd2h9rTHHW/2WEb7KxVTUBgHCPPyRq31Cll7B/QTtWBH5NWFGgjj/P8ju8X4BZ4VYDHkD/AsirzAXOpbN1xxMIQwXqNvQvdxNOWixClRMAgFWA5wpqUzt/306Su7UJ97k6/jzLdYREzcwK8C7CpDj1g59XuYQwft+psxJoQ//yLO0d59utqicAAO8gvW70g7poz/bAbQm0Ia9yP7BqF9fDzDL4ONWZWHQn4UXYjXeT1hrsmbTfPdytOiQAAPvmGHseZRpDL0fNYgTwScLEQnVb8ijPE853MLMI9qcaY4gvE5brzd/l9ZifsCxJ3Z7+5QtdtqkTdUkAAH7eRbwxynk5tGks4XjuKiT2M4CP5nBNzKxpPsKud+qHu9syt9mOvI4cPTyBNvUvp+fUrnbVKQGYD7i6w3hjlVZ7A2S1JnBpAu3ptswl7BxoZl1aCPgn+oe623Iz4Qz4vKxEWtv93g4skGP72lGnBADCGvsXMsZYRHmYfP/2H6IaBw79BJ8Ka9axRYFr0T/I3ZTXCd39I3O+Nn9MoG19ZRqwVs7ta0fdEgAI37pTGg77Rs7tG0M4MXJOAm3rpvyecHiSmbVhHHAj+ge4m3IJ4Zt63t5GWhP/PhGhje2oYwIA8D007R6sTCUsR83bRsAtCbSvm3Ihut4xs9JZhrDOWP3gdlqeB/bK/arMc0UCbewr/xexnVnVNQGYD7gB/T3QV34UsZ1HUO7zBf5O6NUws2GsSHo7n7VTfgeMz/2qzLNrAm3sK48Q5mio1TUBAFiddOaCzCRs0BXLGqQ3AbKd8h/SeF7MkrQy4UNF/aB2Ul4mflf4SNLpGZkLbBO3uZnVOQEA+BL6+6GvnBu5rT2E5cBlXTJ4M7BE7lfFrOTWBp5E/4B2Ui4lzMyO7Qui9g1WTojc1nbUPQHoAf6G/p7oK1vFbS4A61LenQRvx1sHm/1/m5DWsqas5TXgixRzIthCwNMFt2+ochdpHYBS9wQAYFnSOQ/iqsht7TOacNR0SqshspZ7CX8zs1rbkHReXO2Umwnjr0U5OlI72i1zyXc/gzw4AQg+i/7+6CsfiNzW/t4FPB6pHTHLA8RZOWFWCmuR3ilnrUovcCrdb+PbjvGEtfbqtjcIbU+NE4CgB/gX+nukQdiiushNcJYALorQjtjlTmDxCNfDLGkrUr7dvl4B9ohwLVo5vsN48y6TSXMWsxOAeVYmnVUBe0Zu60B9EwRTOzWxVbmd4o7ONpNbHngU/YPXTrmeOJv6tLI48GoH8cYoO0Vua6ecALzZYejvlQbh220R82MGehvle79cRTgUyazSJhDOzlY/cO2UUwibkSgcmzHG2OXPsRvaBScAbzY/cB/6e6ZB2NdfYTHgrxljTKVcSlqTa81ytRjlWrozHdg7ypXIZlHSmCD5BjAxblO74gTgrd6D/r5pELq3Fb0ANOs9jHKtErgA3ZcNs2gWAW5C/4BlLY8Dm0W5Etkdhf46NIBvxm5ol5wADO489PdOA9gtdkNb2Jk0Eums5U/kf3iYmcxYwhiX+sHKWi5FPzN3YeAl9Nci76NeY3ACMLgVSGNC4M2xG5rBGoSVCeprkbWcga7nxCw3I4C/oH+gspbvkUb2fTj6a9EAPhi7oTlwAjC0o9HfQw3gfbEbmsHClOtddGycy2BWnB+if5CylNmEXf1SsCBp7I9wHeX4FuIEYGhjSGOTnBtiNzSjHuAY9NcjS+kF9olxEcyK8DX0D1GWMgXYNtI16MR+6K9JL7B57IbmxAnA8D6D/n5qAO+O3M527EtI+tXXpFWZBWwX6RqYRfN+YA76B6hVeYRwEFEqRhDG3dXX5ezYDc2RE4DhjQBuRX9PXRC7oW3annCKp/q6tCqvAhtEugZmuduMNCYftSrXkN6pXB9Ef11moNn0qFNOAFp7L/r7ai6wWuyGtmldYBL6a9OqTAaWjnMJzPKzHPAE+gemVbmQMD6amhRWS/w4eivz5QQgm/+gv7dOi97K9i1N2K9AfW1alVsI84PMkrQI8F/0D0qrciYwKtI16Mam6K/NdEISVyZOALJ5B/r763X0S2wHsxhpJN+tyt9IY5WS2ZvMB1yO/gFpVU4k3Zntv0V/fU6K3sr8OQHI7u/o77GDo7eyM2MI8xTU16dVKVsPndWA6iWctfQCh0ZrffeWRX+K2TRgqdgNjcAJQHabEp4F5X32BOludzuSsAmP+n3Vqnw+1gUwa9en0D8Qw5U5aPf0zyKFI3+Pi97KOJwAtCeFQ3KKPiq4HT3Ayeiv0XBlBuVZpmsVtiFhXE/9QAxV5gCfiNb6fIwFXkR7nV4nvRURWTkBaM/m6J/Lm6K3snupnMQ5VHmc8j6zVgGLk/a527OAPaK1Pj+fQ3+tfhi9lfE4AWjfP9Hfc2X4Bpt6EvAvPCnQBEaQxoSiocosdGeRt0t9SuIMyjfzvz8nAO3bFv0z+ovorczHYeiv1XCljBN3reSOQ3/jD1VmArvHa3quNkB/vf43eivjcgLQmWvQ3nfTCAf0lMHB6J/ToUovac+psIr5APqZxEOVWcCu8Zqeu9PQXq/ZwCrRWxmXE4DO7IL+ef1c9FbmJ+WegKmktaW5VdQawCvob/jByhzKlQmPIRxEpLxmv43eyvicAHSmB7gD7f2XyimBWX0H/XtuqHIfYTM2syjGAHehv9EHK2U8OvOT6K/bxtFbGZ8TgM6lsIS3bAfdpHzE+Z8itttqLuXNfg6M2O5Y1FuP/id+EwvhBKBz8wPPoL0Py7azXQ9h3oz6nTdUKdOwipXETqQ77n94xHbHsib661mWiZKtOAHoztFo78OXCXthlMkI4Hfo332DldcI7xezXEwAnkN/Yw9WyroE5vtor9sjVGf9sBOA7ixFWAqqvB9T36xrMPOR7lLom0l3u2UrkR7Svcl/R7oH+wxnfuB5tNfu69FbWRwnAN37Fdr78cr4TYxiIcKHrfpdOFg5IWK7rSb2Q38jD1b+A4yO2O6Ydkd77aYCi0ZvZXGcAHRvPbRDUr3AytFbGcd44AH078SBZS6wXcR22zBGqAPIwXrA99RBDOJOwofoTHUgHfqouP5fA6+KY7C03I32W3gP+ueiUy8S9lR4QR3IACOA3wDjxHFYCY1Gv0Z4sPIksELEdse2IGGSjvIarhu9lcVyD0A+Pob2vrwnfhOj2hz9sz1Y8dJAa1uKa12nEnolyuwTaK/h1fGbWDgnAPkYjX5uyvrRWxnXBwld7+p35cCyd8xG21uVeQhgO2B/dRAD9AJ7Eboqy+xj4vpPF9dv6ZoJnCmOQf18dOsvwFHqIAZxGrCiOghL3xjgIfQZ68ByaMxGF2RJwlkFqmtYxvXWWbgHID9roJ0M+BjlXNnTXw9p7hHw95iNtjcraw/At4HV1EEM8FvKu96/vz3Rrs09E3hDWL+l70G0kwFXBLYS1p+HBvBZ4EZ1IAPsDHxcHYSla0O031AHK9dR3uV+A6mPX63a5L8+7gHI18fR3qc/id/EQiwDPIH+Hdq/vEDoiTR7k1HA7ehv0P7lKWDpmI0u0Epou1avid9EGScA+RpNWNqmulefI7yPqmBz9LssDixnRW2xAeUbAjgY2EgdRD+zgY8Az6oDyclH0Y5tVuHYXyvGTOAcYf1LAdsL68/TzaQ3ofqTwI7qICwdqxPGhtWZaf9Spa1qAW5Bdy1nAkvEb6KMewDytyXa5/+M+E0slHqr5YFlMmEbY6u5HuBy9Ddk//JXyj8TuL/l0Hb/V30jECcAcdyP7p59juocVgWwAHAr+ndr//KDqC2uubIMAXweeI86iH4eAj5FuEGr4oO4+9/K5/fCupcC3i6sP28zCEOar6gD6Wd/yr/iIlllSAAmkNbyujeADxF2/KuSXYV1vwRcIqzfyutstIn4B4R1x/Aw8GnS+XIzAvg51ZlwmZQyJADfJa1T4b5O+Xf6G2hR4N3C+s8hLO00a9ejwLXC+j8orDuWvxI+dFOxAbCvOggr3saktWf1+XGbK6M+YGXL+E2U8xyAePZFe/+uE7+JhRsD3IX+ndtXXsAnBuYu9R6AU0knxiepbha6u7DuJ4AbhPVb+Z0PzBHWr3x+YplOWBY8XR1I03jgaHUQVZPKh+tg9gTepQ6iqZdwUtVL6kAiGA3sJKz/XEKGb9apl4D/COuv2jyAPvcAh6mD6OcrlP+kVctgDDAJfbdTX/l23OZK7Yz22m4Rv4lJ8BBAXMphgF5g+fhNlOgBLkD/Du4rl8Vtbr2k2gNwEDBRHUTTLVQ7AdhNWPcTwE3C+q06/oJuGKAH7SqamBqEZdgvqANp2h54vzqIqkgxAVgOOFwdRNNMwpIY5fhibLsI6/4T4QVj1q0XgKuE9Vc1AQB4HviqOoh+TkF7YmllpJgAnAgsqA6i6Viqt+Svv3XRdl2eJ6zbqkd5P21DdU4EHcy5pPO8rklaCYnlZAu029H2LzdR/c0nDkB3fZ+gWlspt+I5APFNIPTWqe7p7eI3UWpJQm+A+t3cAF7GRwZ3LbUegBNI40OhDl3/AO8V1v1XwoNslpfngOuE9SufpyK8QJiJn4LFSGeouLRSSgC2A7ZVB9F0LGEJTJWNJnRbqvxNWLdVl/K+qnoCAGEYIJWhgC8By6qDsHxcib5bqUHY/aoOE0zeg+4aT6Pa46WD8RBAMdZGd1/3Eg4IqrqlCV3w6nd1AzgtclsrLZUegJ1JY9OfXuCLwGx1IAXYQVj3pYRhFrO83Uc4rVOhh7BMreqeBb6pDqJpX2BldRBllUoCcIw6gKb/Q3uwSJGU3ZXu/reYLhbWrUysi/Rz4Hp1EMD8wDfUQVjndkffjdQgTHAZH7mtqRiP7pCluYTZ2nXjIYDiKIe3niKNicxF2IBwiqf63T0LWDVyWytJ3QPQQzrf/r8OvKgOoiA7ovvb30SYrW0Wy1XAK6K6lyXsr1EHdwI/UQdBmLN1lDqIMlInAHsAG4pjALgC+J06iAIpuymV3bNWD7PR7hlfh9UAfY4m9Hqo7QWspQ6ibJQJwEjS+PY/l3kb4tSFcsOSS4V1W30o77NUljMXYRpwhDoI0vk8sYz2Qj921ABOj93QxKyE7lq/iL7XScVzAIq1Irr7fAr1us97gBvRv8vn4uOC26K8SQ8W1t1nGvUbO3qnsO5/EZZamsX2OPCgqO5xwDqiuhUawP7NfyqNIJwkaxmpEoD3AhuJ6u7v24Q1rXWiTAB8lrcVSXm/KZ8zhRuA36uDIPQsKw84KxVVApBClvYI9dxFSt0DYFYUJwDFOgx4XRzDfKRzXkHyFAnA+qSxWcZh1G83uvHoZso+BEwS1W31dAW6A73qmAA8BfxAHQRhN9eF1UGUgSIBOAj9Rhk3A38Wx6CwNbpr/09RvVZfrxL2nVBYHpgoqlvpJMKRwUqLAZ8Vx1AKRScAywIfK7jOwRyBfsKKwtbCut39bwqXC+uuYy/Aa8D31UEQJiWOUgeRuqITgK8R9m5WugztS0FJ9UJqANeI6rZ6u0pYtzLhVvoJ8IQ4honA/4hjsH4WJKwDV64T7QW2iN3QRI0lzHlQXPe7C2hf6rwPgIbyvr+3gPal6vNo3/UN4JborSy5InsAPgcsUWB9gzmfsGFFHW2JrvdF+S3M6u0N4FZR3WsBS4rqVvsVcL84hk2Bd4tjSFpRCcAIYL+C6hpKL/XeKnJLYd3u/jclVQLaA7xdVLfaXOA4dRCEQ95sCEUlADsAqxRU11D+DNwjjkFpc2HdVwvrNlPef5sK61b7I7rdGPu8n7AttA2iqATg8wXVM5wT1QGIbSaq91H0E4Ks3q4hfCNVUD13KZhLWBaoNBLYWxxDsopIACYAuxVQz3AuRjcOmIKlCUswFfzt39ReJZxdr/A2Ub2pOAuYLI7h84REwAYoIgHYh7A9o9J3xfWrKbv/Pf5vKVAloksCK4jqTsFs9PsCrEAau88mJ3YC0IN+R6Z/AdeLY1BTdkPW/dpbGpSrf5QJeAp+CTwtjuFz4vqTFDsB2BZYPXIdrdR97B90CcA09EuBzECbANR5IiCEfRh+KI5hN8JwtPUTOwFQT/67G29BC7oE4GZ0k6/M+nsE3R71dZ4I2Od0YKqw/vnwZMC3iJkALAHsHvH3Z3EKYUeoOlsRWEpUd103XbI0qXaG2wz9AWhqU4EzxTHsi/8ObxIzAdgbWCDi72/lecI61LpTjj86AbCUqO7HxYGVRXWn5IdoewRXBbYR1p+cmAmAevLfz4AZ4hhSsImwbtVRrGaDUSakHgaAScBF4hjUw9JJiZUAbAysE+l3ZzED+Lmw/pSoJiA9DjwjqttsMDehGxKs+0TAPqeK6/8A4WA6I14CsGek35vV79FN+EnN+qJ6/e3fUvMy8JCobtVzmJorgduF9S9I2B7YiJcA7BHp92b1v+L6UzEO3Q6At4nqNRuO6sNnXVG9KfqFuP6PiOtPRowE4G2EyRYqdxKWnxmsJ6z7DmHdZkP5r6jeFYBFRXWn5ndolwS+D1hEWH8yYiQA6u5/f/ufR5kAKLv5zIaiui970M6LSslraFdoLQDsKqw/GXknAD3A/+T8O9vxOiG7tEDV7fg88KyobrPhKIemPAwwz8/E9au/qCYh7wRgS2ClnH9nO/6AtmspNaoXjsf/LVXK5NQJwDz/RbcxE8BOhDlStZZ3AqCe/HeGuP7UqF44qnFWsyxU81O8EuDNlJMB50d/TL1cngnACLQJwH146Vl/EwhHkSp4/N9S5pUAaTgXeENYf+1XA+SZALwDWC7H39eu3wrrTpHyZeMeAEuZ6v5cGhgvqjtFU9HuDLg9YZvm2sozAfhgjr+rXQ3C5j82jyoBmAk8LKrbLIu7hXW7F+DNzhbWPR+wi7B+uTwTgPfl+LvadRXwmLD+FKmWAD4AzBHVbZbFQ+juUeXS3BT9A+2urTsL65bLKwFYGVgzp9/VCWUWmaq1RfXeJ6rXLKtZ6HqpVM9lquYA5wnrfy8wUli/VF4JgDKLmgH8SVh/qlYX1XuvqF6zdqgS1dVE9aZMuXfL4oTda2sprwRgp5x+TycuAV4R1p+iBQmrABScAFgZqO5TJwBvdQPwqLD+2g4D5JEAjAa2zeH3dOp8Yd2pWo2wK6OCEwArA1UPwEqEyWc2TwP4s7B+5RdYqTwSgHcBC+XwezoxG/i7qO6UqQ5jmo1XAFg5qBLVUcCKorpT9hdh3ZsCSwnrl8kjAVB2n1xOOOPb3kzVzfgQYYKVWeruA+aK6laelpqq64EnRXWPIEwGrJ08EgBl98lfhXWnTPWCeUBUr1m7ZgCPi+r2PIC3agAXCuuv5TyAbhOAFdAta+lFe8OkTNkDYFYWj4jqdQ/A4JTzAN5L/mfjJK/bBr8/lyg6cw0+cnYoqheMciavWbtU81XcAzC4K4GXRHWPBzYX1S3TbQLw7jyC6NDFwrpTNhpYXlS3JwBambgHIC1zgEuF9b9bWLdEtwnAVrlE0ZlLhHWnbBV0O1s5AbAyUd2vq1DD7uaMlAnAO4R1S3RzE65EmAOg8AzaAz1Spvp2MQvdLF6zTqgSgDHAMqK6U3cJYX6XwjuoWWLWTWPV3/4bwvpTtrKo3knollWZdeIRdO8RDwMM7gXgdlHdi6M906Zw3SQAW+cWRfv+Iaw7dapeGXf/W9lMB54W1a2ap1MGHgYoSBl7AOYQNgCywS0nqtcrAKyMVImr6jktA+UXPCcAGSwMrJ9nIG24Ce/+NxzVi+UxUb1m3VDdt+4BGNr1wFRR3U4AMtgS3UzzK0T1loVqCMAJgJWRajdA9wAMbQ5wraju1YGlRXUXrtMEQJklXS2sO3U9wLKiup8Q1WvWDdV96x6A4V0lrFs5wb1QZUsA5hK6h2xwSwALiOpWfZMy64YTgDQpE4DaDAN0kgCMBN6WdyAZ3QG8Kqq7DFTdirOA50R1m3VDlbguTTga2AZ3C/CGqG4nAMNYnTAJUOFKUb1lofpW8SS6zTvMuqFKAEZSo7HmDswCbhDVvQG6OW6F6iQB2CD3KLLz+P/wVAmAu/+trKah61X0MMDwVMMAY6jJgU2dJACq5X+gmxlaFp4AaNY+rwRI0zXCupWfc4UpUwIwmbBNpA1NOQRgVlaq+9c9AMO7Fd1Wzcqe7sKUaQjgZlG9ZaL6RvGsqF6zPKjuX/cADO8V4CFR3e4BGMQiwMQIcWThBKC1pUT1OgGwMlPdv0uK6i0T1XvfPQCD2ICw2YyCE4DWxovqdQJgZaZawqp6XsvkFlG9KxO+8FZaJwmAQi9wm6juMlG9ULwHgJWZKoF1AtCaKgHoAdYV1V2YdhMA1bjIA+gOhyiLBQnLVxTcA2Bl5gQgXbcRzgZQqPwwQFkS/zUIJgAAIABJREFUgDtE9ZbJEqJ6Z+DdGa3cnACk6w08ETCadhKAHnQX5F5RvWWiSgDc/W9lp0oAFgXmE9VdJveI6nUC0M9S6CZF3C2qt0xUM4rd/W9l9yowXVBvD7C4oN6yUSUAq4vqLUw7CcDEWEFk4B6A1lQ9AN6cyapAdR97GKA1VQKwNLp5VYVoJwFYOVoUw5sBPCKqu0xUPQAvieo1y9MUUb1OAFpTJQA9wIqiugtRhh6A+4G5orrLRNUDoHpxmuXJCUC6HgRmiupWffEtRBkSAFX2VzaqBOAVUb1meXICkK45hCRAwQlAk+pCqP7wZeMhALPOOQFIm2op4ERRvYUoQw/AJFG9ZTNOVO/LonrN8qS6j1XPbdk8KqrXPQBoJ0Oo/vBls5CoXvcAWBWoegBUz23ZqL4IOgEAlgUWiBnIMJwAZLOwqF5PArQqcAKQNtXnwERRvYXImgAolwB6o5lsVC8SJwBWBar7WJW4l42qB2A8Ff4bZU0AJsYMYhiPAg1R3WWjSgB8SJNVgeo+dg9ANpMJp8IqTBTVG107QwAKngCYnepF8pqoXrM8TRPVW9lvlzmbCTwlqns5Ub3RZU0AVEtVnhDVWzaj0MzRmItmD3WzvKkSWfcAZPekqN7KLtVMPQHw+H82/vZv1h0nAOl7RlSvapO16LImAKoL4AQgG1U3ohMAqwrVvewhgOxUnwe1TwDcA5A29wCYdUc1B8A9ANmpPg9qPwTgHoC0OQEw686sZimaav5OGbkHIGfuAagGJwBm3fMwQNpUcwBq3QMwAlgsdiBDeE5Ub9moEoDXRfWaxeCJgGlzD0DOejL8zBLAi7EDMTMzS9BTwPLqIGLI0gNQ2e4PMzOzFirbA+AEwMzMbGgLUNFhmiwJgGr838zMLAXj1AHEkCUB8BIVMzOrs9HqAGLIkgBUsuFmZmYZVfJzMEsCMH/0KMzMzNJVyc9BJwBmZmbDq20PQCUbbmZmllElPwfdA2BmZja8Sn4OugfAzMxseJX8HHQPgJmZ2fAq+TnoBMDMzGx47gEwMzOroUp+DjoBMDMzG15tewCyHBlsZmZWVVk+K0snS6NmR4/CzMwsXXPUAcTgBMDMzGx4tU0AZkWPwszMLF21TQDcA2BmZnU2Vx1ADE4AzMzMhlfbHgAPAZiZWZ1V8nMwSwJQyczHzMwso9fVAcTgHgAzM7Ph1TYBmBk9CjMzs3S9oQ4ghiwJwNToUZiZmaWrtj0Ar0SPwszMLF21TQBejh6FmZlZumqbALgHwMzM6moOME0dRAxOAMzMzIY2BWiog1AZBfQSLkDRZeEC2lcF70Pz9/lHEY2riJ+i+Rt9uYjGtWk+4F4016PTMhu4CzgT2A/YDtgQWAlYlHBs+jhgFWATYCfgMOBc4OEE4m+3/GXIv57OFmiuxf1FNE5hVIafmQO8hubDeGkq2vWSM9U1coJmnfgqsLY6iAzmAjcAZwHnAK+2+PmXefOcqf4J8nhCov5JQvKQ+vnyuwM7ApeqA+lnaVG9L4nqjS7rTagaBlD9wctGlQAsIqrXyms88C11EC08DRwALAlsDZxO6w//Vl4kJBI7EHoNjif9JdYnk+1LYlGWEtVb2YnwTgCqwQmAlcV3CF3lKXqS0DuxKvAj4r34nwSOBFYmXI9uk4tY1gO+oA6iH/cA5CxrAvB81CiGtoyo3rLxEICVwbrA59RBDKJB+Ja/FmGuxoyC6p0CHAWsAfypoDrb9R1gCXUQTaoE4BlRvdFlTQCeihrF0CaI6i0bJwBWBj8krS5lgEcJY/JfQLfW+3lgD2BP4AVRDEMZBxytDqJJ9XnwrKje6FJPADwEkM10NKc2jgLGCuq18vkQYfw7JX8F1geuEMfR5zxgI+A2dSADfInQe6O2rKheJwBRoxjaCqJ6y+g1Ub3uBbBWRgPfUwcxwBmEb92pHfLyNPAu4GJ1IP2MAn6sDgKYKKr3aVG90WVNAFQXYBVRvWWkmlHsiYDWykHAauog+jkM2BdNr1kWrxOW4f1GHEd/2wG7CesfjW4I4DlRvdGl3gOwIjBSVHfZeCWApWhZ4BvqIPo5HjhJHUQGcwgTJi9QB9LPKYQPYoUV0e2dUPseAFUCMB+wvKjusvEQgKXoRGAhdRBN5wDfVAfRhrnAx4Dr1YE0rQbsL6p7oqjel6nwZnRZE4BnCTejwqqiesvGQwCWmi2AT6iDaLoa2Juw5K9MphOGAx5TB9J0JJrJ2SsK6gSYLKq3EFkTgLnoZkKuLKq3bDwEYCnpIWym06MOhPBsfAqYqQ6kQ88DnyGN5GUR4LuCelXzwSaL6i1EO2MqT0SLYnieCJiN9wKwlHyC0AOQgkMp/4v838DP1UE07QNsWnCdaxVcX59JonoL0U4C8GC0KIa3pqjeslElAEuK6rV0LUQY+0/Bv4FfqIPIyaGEkwXVRgCnUWzvjioBmCyqtxBlSABS2ICiDKaI6lUd0GHp+ga6TVv6mwV8kTS6zvPwOuGQohRsCXy0oLpGoZsLNllUbyHaSQAeihbF8FZDt/SkTFRbiHq7ZutvZeBAdRBNp6J7b8VyMXCJOoimk4AFC6hnZXSfAaovvoUoQw/AKGB1Ud1lotqswj0A1t/JwALqIAgT545XBxHJgcBsdRCEJdqHFFCPqvt/Dp4D8P89hK4rbT1RvWWiOrHRPQDWZ1vCnv8pOIJ0j9nt1v2EUwtTcAjxl+itHfn3D+VRwjBSZbWTALyObkekdUT1lokTAFMaSTjtLwW3A79WBxHZsaRxcuBY4p/zsFHk3z+UB0T1FqbdrRVVwwDuAWhNlQAsiudoGHwe2FAdBKGXcj+gVx1IZK8AR6mDaPoIsHXE36+6r5wADKBKADYR1VsmU9CMC/bgeQB1txjwHXUQTecA16iDKMgZwH/VQTBv06cYe/WPQbcUvNITAKH9P9j9UaJobSW83ryVBrouQScA9XY0MF4dBOFo38PUQRRoLuksC9wE+HSE37s+ugPh7hbVW5h2EwBltrm5sO6y8DwAK9rawFfUQTSdBDyuDqJgVwDnq4NoOp4wJJinjXP+fVk1gHtEdRem3QTgDnQrATYT1VsmqgTAPQD19QPCqZ1qTwDfVwchcggwQx0E4T2Q92mLqgmAj6I7YK0w7SYAL6M7lcoJQGvuAbAi7QLspA6i6VDCEEAdTQJOUQfRtB+wRo6/b6scf1c7UphbEV0nkzbuyD2KbDwE0Jp7AKwo8xM2/UnBdYTJf3V2PGkMf+R5XyyMbiv4O0X1FqqTBOD23KPIZml0Z0KXhSoBWEZUr+l8lTQO6uolfOusyn7/nXqD/LvfO7Ur8N4cfs/m6CYA3iWqt1BlSgAg7lrTKlAlACuJ6jWNpUhnDfqvgVvVQSTibOBadRBNp9L93JAt8wikQ7W4p8o0BADwLmHdZaA6D2CiqF7TOI78Z3t3YirpfOtNQQM4iDR6Q9YGvtTl73h7HoF04Hl0c90K1UkC8ATwYt6BZPROUb1l8ZSo3qVJ4wAYi29j4DPqIJqOA55VB5GYG4HfqoNoOgZYosP/7wh0PQA3i+otXKc7N6mGAdbGGwINZ7Ko3hF4fkZdnIpuXLa/hwm7z9lbfQN4TR0EMA74dof/3w3oPHnolhOAFq7LNYrsenAvwHBeRXcCmucBVN9HSGcY7kAqflJbF54GTlAH0fQFwod5u7bNO5A23CSsu1CdJgDKiSZOAIY3WVTvRFG9VowxwInqIJr+BVykDiJxJxN6SdRGEnqN2qVMAG4R1l2oThOAG4A5eQbShu1E9ZbFZFG9E0X1WjEOJo2/8Rxgf3UQJTCLdM5F2Bb4YBs/PxLdF72HSeOY5UJ0mgBMQ7dT0vrAsqK6y0A1e9VDANW1HOl8mPyMGuzRnpM/A5epg2g6mewThTchnDCpcJWoXolujm9UHbnZA+woqrsMJovqnSiq1+L7HrCgOgjgJeBYdRAlczDh1EC1Vch+cuF7YgbSwtXCugvXTQKgnAfgBGBo7gGwPG0JfFwdRNNRwBR1ECVzJ3C6OoimI8nWe/v+2IEMo1Y9AN1YmrDhhKJMIY2lSCnaFM3fZC4wuoD2ldVP0fxdvtxFzCMI68pVz3n/cg8wqou21NnihL1b1H/DBvCbFrGOA2aLYnu69aWslm56AJ4lHJmoMA4fDjSUyaJ6RwAriOq2OPYB3qYOounr6CYel90U4DvqIJo+xfD31I7oEr0rRfXKdJMAgHa8JJVjSFPzEmGSpsLKonotfwsTdtpLwV+Bf6qDKLmfAfepgyDM4Tq1+c/B7FxgLAM5AWjT5blE0ZkPCOtOnepY0BROh7N8HEkapzzOAg5VB1EBswmnJqZgS2CvQf77CLTzu1JZMVGYbhOAfxKO41TYCH/jHMpkUb3riOq1fK1K9hnbsf0QeEgdREVcDvxNHUTTibx1ZcnbgQmCWAAmAY+I6pbpNgF4Hu3pgO1sLlEnqpUAa4vqtXydQhoTOp8DjlcHUTEHADPVQRD2ljh8wH/7sCKQptp9+4fuEwCAS3P4HZ1yAjC4SaJ6nQCU3/akM7x2OOHIX8vPI8BP1EE0HcSb9w9Rvs//Jay71LZBt6RkLmmMU6ZmF3R/E9UJXqkrwzLAkYR146p7p3+5lXy+oNhbLQw8g/5v3ADObcakWr7cIHyO1PKU2TwesOvQzTofAewqqjtl9wrrdi9AeX2RsNW2WgP4Grr5RVU3jbCpUgr2IHyJ/JAwhluo0f7//eWRAMwG/p3D7+nUHsK6UzUZmC6q2wlAOS1OOtvs/h7dkeN18UvgdnUQTaeiHf9PZWJk4fLqYlOu0d2OMKHE5ukFHhTV7QSgnI4ljeGbN4Aj1EHUQC/wVUJvi9pGaJcQOwHo0iU5/Z5OjAA+Iqw/VaphAC8FLJ91Cd3/KTgR3T4WdXMdcJ46CLGn0K5kk8orAZiE9iIOtqlE3d0vqtc9AOVzCmnss/8EIRYrzsGEXpe6+htp9IJI5DnL9vwcf1e7NsHfPAdS9QCsQJhlbOWwG+mcrln3DyOFJ4CT1UEIXawOQCnPBODPOf6uTrgX4M1U+373AGuJ6rb2zA98Xx1E07W4O1rlRHSbhym9hnY7e7k8E4B70XU7Q0gAvG54nofQnZ7m3phyOABYQx0EYR3216hxV6zYdOo58fLv6FZLJSHvD0zlMMBKwHuE9admFrrjmjcW1WvZTSCdl35KS9Lq6g9oT3dV+JM6ALW8EwD1MMDnxfWnRjUPYDNRvZbdCcCi6iAIW/0erQ6iaSRhWKTokkLPZYPQI1SXzZemo129VlmPoNvScRawdPwmlsbxaP4OrxNepjZPSlsBb0zodlc9p/3Lge1eyIh+Rjp/I5Vfob8niijK3upkxMg8/xLhd2Y1H/ApYf2pUU0EHIsnAqaqBziNNL51Pkg6B9NYcAS6rd2LpO6tTkKMl8C5rX8kqs8RXnKmPRNgU2HdNrSPAu9QB9F0IKHXztLxLPBddRCRvQFcqA4iBTESgJvQrgZYHXi3sP6U3EM4q0HBCUB6xgLfUwfR9A9qvgY7YacShnKr6gLq0cvRUqxuwLMj/d6sviKuPxUzCEmAghOA9BxG2KhJbQ5h0x9L00yq/fdRfz4lI1YCcCZhkpHK7sAqwvpTcquo3o1JY3tZC5YnnZf6aegSU8vmr8Cl6iAieAG4TB1EKmIlAE8CV0b63VmMxL0AfVQJwFi0J3zZm51M+JuoTQGOUwdhmRyIbggxlj9SvTZ1LOZM4LMi/u4sPov3pAddAgAeBkjF1sCe6iCajiQkAZa+e4HT1UHk7HfqAFISMwH4E2GvZZVFgU8L60/FnXgiYJ31AD8kjZUx9wD/pw7C2vIt4EV1EDm5H7hRHURKYiYArxPGkZS+RhrrnZU8EbDe9iGdnRm/hu58CuvMy8Cx6iByUrXejK7F/nBUDwOsRpgQWHfKiYDzieq2IJUP//OB/6iDsI78L+WftDkLz/5/i9gJwOWE3b6Uvkka3Z9KyomA7gWwGcAh6iCsY3OA/dRBdOkCwgoA6yd2AtBA3+2yMfBecQxqyomA7xLWbWk4GZikDsK68m/Ch2hZ/VIdQIqKGB//Nfozl48U16+mnAjoBKDeniad3QetOwcTNgkqm8l47f+gikgAphDWXiq9s1nqSjkRcGt8MmCdHYZ2NZDl52HgR+ogOvBz6nPMcVuKmiF/WkH1DKfuvQCqYYBFgfVFdZvWDXjdddUcBzyjDqINM4HfqINIVVEJwO3AzQXVNZQdgS3EMSh5HoAVqQEc0PynVcc0yvVl6g/A8+ogUlXkGvmfFVjXUOo8FnmdsO46D7/U1Vl405WqOpNw6msZ/FQdQMqKTADOAV4qsL7BbAO8RxyDyl3otmDdBi/FrJPXgCPUQVg0vZSjd+d64BZ1ECkrMgGYDpxRYH1D+S71/DDqBa4V1b0kPhioTk4gzP636roe/eTuVlKYe5a0orfJPZUwI11pC2A3cQwqVwvr9jyAepgE/EAdhBXiUMKW7yl6DDhPHUTqik4AngN+W3CdgzmOep4RcJWwbs8DqIeD0Sf5Vownge+rgxjCqfjciZYUH4Ino1+TuR7wSXEMCreiW5O9jaheK85/gD+rg7BCnQQ8rg5igFfwzn+ZKBKAB9GfEghwPLCgOoiCzSGM3SmsAKwtqtvim0uYGGb1Mp0wFJCSXxCWK1oLqm7wk0T19rcs6d24RVAOA7xPWLfFdQZhy2mrn3PRzi8a6BfqAMpClQDcCFwhqru/Q4CV1EEUTPmg7iys2+J5GfiWOgiTaQD7E3qBUvBhdQBloZwIl0IvwBjCssA6uQHdJK13AguL6rZ4jgVeVAdhUrcTDn5LwVHAMuogykCZAPwDuENYf5+PU68tgmei25Z5fmA7Ud0Wx32kscun6X0TeFUdBOFLxrfVQZSBMgFoAEcL6+/TQ9gwok7LApXzADwMUC0Hojtq2tLyHGGJdQo+A2ysDiJ16g+9C0ljv/DNgS+ogyiQch6AJwJWx0WEnjyzPj8GHlAHQfhs+wn13PU1M3UCAGn0AkBYFjhBHURBrgVmiepeAVhXVLflZxZh0x+z/lK6L7YC9lQHkbIUEoBL0XZJ91kMOEUdREFeQ3cuAMBOwrotHz8m7OlhNtDfSKdn6GTqt99LZikkABAmj6RgL+pzWuAlwro9D6DcniedsV5LUypzQ5YHDlIHkapUEoCrgX+pg2j6KTBaHUQB/i6s28sByy2V2d6WrvuAn6uDaDqMMPRoA6SSAEBYu5mCNUknlpjuQbeH9/zUp6elam7H+6xbNseQxv4QY4ET1UGkKKUE4DrgYnUQTYcCm6qDKIBynM67dZXTAegP87JyeJl0vkx9DHiHOojUpJQAQJg9msK40SjCscVVHwpQzgP4ALCAsH5r3zmkMWHXyuN00jgjoo77vbSU2sW4n3DDpGBt4Ah1EJFdTtgZUGFhYEdR3da+6cDh6iCsdFI6JXJjYG91EClJLQGA0GU0RR1E0xFUeyhAvRxwD2Hd1p6TgMnqIKyU/gP8WR1E0wnAouogUpFiAjCFsClPCkYRJjxVeShAOQywKx4GKIMnge+rg7BSOwTdIWT9TaD6PbuZpZgAQBireUgdRNOGpJOQxKBMABbBwwBlcCjwujoIK7VHgR+qg2g6AFhDHUQKUk0AZpHWeOPXqe4e9vcAjwnr9zBA2q4H/qgOwirheOBpdRCEZcgpHEcvl2oCAGHMKJXNgXqAX1HdswIuFda9GzBGWL8NrZfwbamhDsQq4TXS6X7/AO59TDoBgDBuNFcdRNMEwgqFKp4updx/wasB0nUmcJM6CKuUs0jnnjqFMM+rtlJPAG4nHOmYit2AL6qDiOCfwFRh/R4GSM800vm2ZtXRAPYnjV6ldanm+zyz1BMAgG8RZiGn4gdUb2ngDMLZ7iq74mGA1BwHPKsOwirpBuB36iCavg2MVwehUoYEYBrpbCQBYdnaOYTjg6vkPGHdCwPvF9Zvb/YI8CN1EFZph5PGypJxwNHqIFTKkAAAnI/2G+pAqxK2Cq7SfIB/oD3h7dPCuu3NDkK3Q6TVw1Okc0DPl4D11UEolCUBAPgqaWSMfXYhnF1QFTPRJlk74iM7U/Bv4AJ1EFYLJwOT1EEAI4FT1UEolCkBeJwwLpmS44F3qYPIkXIYYCSwl7B+S2vfdqu+GYRNplKwHWFpoCVsPuBuwgzSVMrTwHIxG12gBQjDAKpr+QDVGlbp76fo79VWJaUVNwo/Q3Pdv1xE4xL2H/T3foOw+2yVt31/izL1AEA4Knhv0jgyuM8ywIXAWHUgOZhBaIvKGsBWwvrr7GXgGHUQVktfBeaogwBWo2Y9YGVLAABuJWzgkJJNCJumVOHbq3IYADwZUOUo4EV1EFZL9xAOXUvBkYQvdZaw0cCd6LuMBpaUzi/o1GjgFXTXcBqwUPRWFi/lIYB7CMNrdechAJ3FgZfQPwsNwrbvtVDGHgAIM9b3Ia2hAIDvEnYLLDP1aoCFgA8L66+jA0jvWbJ6mUI6k7z3BjZTB1GEsiYAALcRPnBTMgI4G9hAHUiXzhXXX+vtOQt2IXCZOggzwiTU+9VBEN7jP6IaQ7rDKnMCAGEZ3m3qIAZYGPg75V7T/k9CRq7ydmBzYf11MZOw6Y9ZCmYDB6qDaNoK+Jg6iNjKngDMBj5BmL2ekuUIO+uNUwfSoZnoz4D/mrj+OjgVeFgdhFk/lxC+QKXgJGBBdRAxlT0BALiPNPdyXoewhXFZ15X+Rlz/noQjmC2OZwk9aGapOZA05qQsRzobFUVRhQQAwpaSKY5jbktYHljG63wzcJew/tHAvsL6q+4ItEdAmw3lAeA0dRBNhwAT1UHEUsYPpsH0Ap8EnlMHMoiPAN9TB9Gh34rr/yJenhbDrYTE1CxV3wFeUAdBOKa8rO/vlqqSAED48P8kIRlIzcGEDSbK5my0O3QtS3WWBI5UB9DUAPYnzefErM8rwDfVQTTtAbxTHYRlcwL6jSSGKmWccX0x2mt2bfwmRjeO8G1Gff81gN9FbmuZeSOgtIwAbkH/zDSA20knibdhjAKuQ3/DDFZ6CRsYlcke6K/bFtFbGdeP0F/DBuE47TIvT43NCUB6tkH/3PSVz0Vuq+VkBdLZVnJgmUOYF1AW8xNmjCuv2V+itzKetYFZ6O+7BmG/fxuaE4A0nYv+2WkQhpkXjdxWy8mHCN+41TfNYGUmsEu8pufueLTXqxdYL3or4/gH+vutATxGmNBkQ3MCkKaJwBvon6EGYcWZlcRJ6G+YocpMYPd4Tc/VioSeC+X1Uq9I6MSu6O+zvrJn5LZWgROAdH0H/TPU995eM3JbLScjCLtKqW+aocosQk9FGagnA84hnNddFvMT1jOr77EGYSJl5fc1z4ETgHSNJfRiqZ+lBtrD0qxNixO2O1XfNEOVOcDHo7U+P7ugv1Y/j97K/ByC/no1gLnU5GSzHDgBSNsn0D9PfWXnyG21HG0AvIb+phmqzAH2itb6fIwAJqG9TjMIewOkbinCOmb1fdUATo/c1ipxApC2HuBq9M9Ug7AFfek3KavSRkDDuRP4vDqIYYwk7L2/jzaMYfUCZ4hjGE06p4UN57ukMVt4KvAtdRBmOWkQ9lJJYROrtXDiVjono88chyu9pP0BN4HwLVx5jaaR9iFBmxC63dX3UoOwA6Vl5x6AcvgN+merQTgyfXzcplqeRgGXo79xWpXvku6krV+hvz6pHBQyUA9wFfrr0wAeJExEtOycAJTDMoTeLfUz1qBc85KM0DV7F/obp1X5NSFhSc166PdXmAWsGruhHfgo+vumr5Rpn4lUOAEoj2+gf8YahPlbG0Zuq+VsZfS722Up5xLGvVOTwuY2Z0dvZXvGkM4ypX9EbmtVOQEoj9HAI+iftQbw78httQg2I+2VAX3lesKs8pS8F/11mQtsHLuhbTgG/TVpALMp766Jak4AyuWD6J+3vlKW/Vysn13Q73CXpTxCmHWakjvQX5eLo7cym+VJJ5n8YeS2VpkTgPK5FP0z1wAeBRaI3FaL4Ovob54s5SXCyVip+DT6a9IAto3d0Az+gP469N0jS0Rua5U5ASifdQi9XupnrwEcEbmtFslp6G+eLGUG6ewaOBp4Gv01uQ7tiol3oJ8U2Ve+FLmtVecEoJx+iv7ZaxCWKJdhozIbYCRwAfobKEvpJSwTTGETp4PQX48G8MnYDR3CCODmjDHGLncS7mPrnBOAclqCsCZf/Qw2gDMjt9UiGQP8B/0NlLVcAoyLciWyWxB4Hv21eBbNznuf7TDeGGWHyG2tAycA5bUf+mewQfiCtkXktlokCxJOTlPfRFnLQ+hnfB+B/jo0gFNiN3SAhUljCKQB/ClyW+vCCUB5jSL0gqmfxQZwC2n00FoHFgNuR38TZS3TgA9HuRLZLEIa3W+zCYc+FeWkSO1ot8ykXMckp8wJQLm9B/3z2FdUw5KWg2VJZ5OJLKUXOB7dzoHHtIivqFLUhhyroT8Toa8cH7mtdeIEoPwuRP9MNoAngYUit9UiWpF0dnbLWm4EJka4Fq0sCrzcZqyxykcitxXSmTD6LKEHxvLhBKD8ViWd5Py4yG21yNYBXkB/I7VTXgB2jnExWvhuh/HmXZ4k7ofiDgm0sa/sHbGddeQEoBq+j/7ZbADTCdvOW4ltSthgRX0ztVN6gRMpdkhgHGnMBWgAp0dq4yjg7gTa1yD09qR6YmRZOQGohkVI56wXT9CtgI2BF9HfTO2Wa4FVIlyPoRwWqR3tll7CeQV5+2oCbetr39sjtK/unABUR0pLdN8dt6lWhLWBZ9DfTO2W14H9Kebb4hjgiYLbN1R5krCiIy/jSCcJPCvHdtk8TgCqYwRwE/pntUHoNUzxaHdr01qks/a73XIJxWxT+UVR+wYrZ+TYrp8k0J4GIaFbMcd22TxOAKplK9LZpvuLkdtqBVkTeAr9DdVJeR7YPf9L8iajgPvxl8FKAAAPDElEQVQTaGtfyWNCZEoHjhyZQ3tscE4AqscHdVnuypwENAj7Vce8GT+WQBv7yuN0v03wZQm0owFMIgyzWBxOAKpnRUKvmfrZbeCjuitldcq3T0D/8izx1syndEhOg/AtoFMfSCD+vvI/XbTDWnMCUE3HoH92G8AswjCyVcQywB3ob6xuysXACnlfGGBL0hl/awBf6KAN8wMPJhB7A7gaL/uLzQlANY0BJqN/hhuE3kSrkHHANehvrG7Kq4RJKnkfYHF2Am3rK9MJyznbkcqyxjnAhm3Gbu1zAlBdKQ1Lvj9yW61gowkbPqhvrG7LreS7vnw5wmFF6nb1lYfIPh9gAiExUsfcAH6eMWbrzo8J3bRFl056p6x9V6J/lvveQ6Mjt9UKNpKwA5365uq29BLWmS+Z03X5ZgJt6l/OzRj3rxOItUE4YyGvv4VZnW0MzEX/TDeAgyK31QR6SGfCSbdlCmEDoZFdXpMFgEcTaE//8pUWMW9COi+KA1rEambZ/RL9M90ApgJLR26riRxAOh8g3ZZb6X4ryw8l0I7+ZeYwbeohbKGsjrEB3AfMl+H6mlk2KQ3txTqzxBKwM+ncaHmUy4ANurgeqRyh21deIuznMNBeCcTWVxSnOppV3aHon+0G4UviZpHbakLrEzZvUd9oed6wZxGWP7ZrRUK3l7oN/cujwFL9YhxDOns7/K3dC2xmmcwPPID+GW8QVpB5eW+FTQCuQ3+j5VleA46l/R32Dkgg9oHlaubNyD02gXgahJnhg/VOmFk+dkP/nPeVPSK31cRGE7bfVd9oeZepwIlkP3VvBHB9AnEPLOeQ1pahJ2e8nmbWuUvQP+sNwnblYyO31cR6gCNIa3e8vMpLzbYtnOE6bEw6B+v0L08mEEODcGBTnscYm9ng1iWdd9G3IrfVEvEh0hsLz6u8CBwOLNLiGpyUQKypln1bXDszy8+P0T/zDcKw6vKR22qJWAO4E/1NF6tMBX7E0Df06Iq3v9NyO93vu2Bm2Y0DXkD/7DcIW6dbTYwhnU0pYpWZhFUD6w7S/o2a/7s6xpTKNoNcJzOL6yvon/0GYXj4nZHbaon5EjAD/c0Xs8wl7AOw7YC2H5lAbKmU8zAzhVHAXejfAQ3gJvI/lM0StwnpbZcbqzxAOGVvHOFGvyqBmNRlOjARM1PZDv17oK/sE7eplqIlgL+jv/mKKlOBXwAfIK0TAxXl25iZ2l/QvwsawLO0nkhtFTQCOIR6jY33Am8kEIeqPAksiJmprUo6w7EnRm6rJWw94L/ob0KX+GUvzCwVJ6B/JzQIXwJXj9xWS9gChKV0Vdw4yCWU6/A+4GYpWQh4Cv27oUEYkrCaey/wNPqb0SXf0gu8DTNLzT7o3w995b1xm2plsBRwIfqb0SW/8mvMLEUjgBvRvyMawD2EZYpWcz3AF4FX0d+ULt2VqXR2pLKZFWMr0hl+/UrktlqJLEM6y1VcOiuHv+WvamapORv9u6IBTCEsEzf7//YgnBynvjld2iuPECZ4mlnaliMc0qN+ZzQIhxaZvck4wmY66pvTJXvZfdC/pJml6Fvo3xkNYA6wfuS2Wkm9D3gc/U3qMnz511B/QDNL0hhgEvp3h98fNqxFCd1Es9HfqC5vLc7gzcppT/Tvj76yW+S2WsmtBfwT/Y3q8ubyk+H+aGaWtCvQv0MawMPA6LhNtSrYFXgM/Q3rEmbxjh/+z2VmCduI0Iunfpc0gEMjt9UqYixwDOkccFHX8rUWfyczS9/p6N8lDbyPiLVpTeBS9DduHcs9wHyt/0RmlrilgFfQv1MawC8jt9UqaCfgdvQ3b53Kjpn+MpaCkcD8gjKiiMZZLg5E/05pAHOBTSO31Sqoh7CJ0MPob+Kqlwsy/k0sDT9Dc598uYjGWS7mA+5H/25pAFd22xhnnvXTAM4D1ga+ADynDaeyZgGHqIMws1zNBg5SB9H0LrrsYXQCUF+zCZNaViPsTT9NG07lnAo8qA7CzHJ3MXCJOoimk/DnuOVgGcKH1uvou7bKXp4FFmnv8lsCPARgWa1F6OVTv2sawEc6bYQzB+vzDHAAMBE4lnDssHXmSMJSHTOrpvuBn6qDaPoGYW6XWW6WIOwhMAV9hlumchtOrMvKPQDWjsVI50TW7TppgF9UNpSXCAnASoSeAU8WzOYAoFcdhJlF9wpwlDqIplQmJlpFLUxYA/so+mw31fLHjq+upcA9ANaukcAd6N89vYQJ3W1xD4BlNQ34AeEm2w24XBtOcqYDh6mDMLNCzQW+SvgQVuoBPtXu/8kJgLWrF7gI2AHYmLCUcLo0ojScRDh8yczq5Rrgz+oggE8TeiTMCrU0YeXAc+i7whTlccLBS1ZuHgKwTq1M+CKkfhft0E7Q7gGwPDwLHA2sQBgeOI/QNVYXhwJvqIMwM5lJwCnqIID/UQdgBrAcYUy86pMGr8VrcKvCPQDWjbGEYUDl++hp2ngfuQfAYnkK+B5h0uAOwG+p3lyBXsKyv4Y6EDOTewP4pjiGZYDNs/6wEwCLrZewYuBTzNtT4Aaq8aH5G+BmdRBmloyzgRvFMewirt+spRWA/QkzaHvRd+W3W2YSEhqrDg8BWB62Q/tuuiJ6C81ytBLzkgH1B3vWkso+4JYfJwCWl6vQvZumA6PjN9Esf+sC3yJ0o81F/0E/WJlJ6MGwanECYHnZAe07aqssQXoOgKXmHuA7wBbAssBngPMJOxGm4rfAE+ogzCxZl6GdH/T2LD/kBMBS9hzwa8La1nHAOwkrC+5TBgWcJa7fzNJ3trDu9YR1m0XVQ1hyo+haewonzlXlIQDL0zLohjEzrUTwi8zKaGlgjKju8/Bxv2bW2jOEyYAK65BhQyAnAFZGE4V1XySs28zK5UJRvQsRvigNywmAldHKonobwK2ius2sfG4R1r1sqx9wAmBlpEoAHgZeEdVtZuVzO7ohw2Va/YATACujCaJ6bxPVa2bl9BrwgKhu9wBYJY0V1fuQqF4zKy/Ve2PxVj/gBMDKSJUATBHVa2bl9bKo3gVa/YATACsjVQLg8X8za1eyCcCoIqIwy5kTAIthDjBbUO9cQZ1WHFUC0PI96QTAymikqF73mFXbfs1ilifVe6PR6gf8QrMyel1U72Kies2svFpOxotkeqsfcAJgZfSaqN5xonrNrLxU7w0nAFZJqqOBnQCYWbtUPYczWv2AEwArI1UPwJqies2svNYW1ftCqx9wAmBlpFqPv6moXjMrp8WAVUR1P9vqB5wAWBlNEtU7EVhSVLeZlc8mZDiWN5KnWv2AEwAro0eEdW8mrNvMymVzYd3PtPoBJwBWRo8K695dWLeZlcsHRfW+AjwvqtssulcJG10UXV4A5iugfWZWbisSjgJWvKeuyRKgewCsrFRHbI4HthPVbWbl8RF04//3ZvkhJwBWVjcK6/6UsG4zS18P2vfEXcK6zaL7OJqutQbh0BjvCWBmQ/kguvdTAy9ZtopbGe0D9pvoLTSzsroZ3btpGj7oz2rgKbS9AGvEb6KZlcyuaL+c/DNroJ4DYGV2rbDukcAPhfWbWXrGAN8Xx3CluH6zQuyFNtNuAPvEbqSZlcYP0L+T1o/eSrMELArMRPuwvQKsELuhZpa8LQlDg8r30eTYjTRLySXoM+7L8eZAZnW2BPAw+nfRj2I31Cwln0f/0DWAX8VuqJklaQHCznvqd1ADeEfktpolZUn0wwB95ajIbTWztIwAzkX/7mkQdkdV7TxoJvN79A9fg7Dv9/6R22pmaRgJ/AL9e6evHBG3uWZp2hr9w9e/nIKX2JpV2YLAhejfNX1lDrB81BabJewO9A9h/3IuYU2wmVXLBOAm9O+Yge8bs9raF/1DOLA8DLwrZqPNrFC7AE+jf7cMLG+P2Wiz1C0IPIv+QRxY5gAnEWYKm1k5jQf+iP59Mli5KmK7zUpjf/QP41BlMvAlYHSsxptZ7hYDjgamoH+HDFXeH631ZiUyGngM/QM5XHkC+BowLtI1MLPuLQ98h7DTp/qdMVy5OtYFMCujz6F/KLOUOcBlwKcIWxqbmdYShOfxIvRb+mYt23TTYG8aYFUzCriHch3VOxe4D7gNuJUQ/0vAy4RvIK/qQjOrjB5Cl/64ZplAODhnU2ATYFVdaB35G+Ho4Y45AbAq2olwRoCZWRXNBDYC7u/ml3izEquifwDnq4MwM4vkBLr88Af3AFh1LUPoVvf4uplVyYPAhsCMbn/RyO5jMUvSa8BUvETGzKqjF/gw8Egev8wJgFXZLYTJPWuqAzEzy8GJ5Hj0uIcArOqWBP5LGBIwMyurW4GtgFl5/UJPArSqewH4NKHrzMysjKYCHyPHD3/wEIDVwyPAbOA96kDMzNrUC+wJXJ/3L3YCYHVxLbA6YeMPM7OyOBL4ZYxf7DkAVidjCCdnbaYOxMwsgz8AexG2/c2dEwCrm/GEJGBtdSBmZsO4HNiFsOtfFE4ArI6WA64BJorjMDMbzI3A9oT9TKLxKgCro6eAHYFn1IGYmQ1wO7AzkT/8wQmA1deDhDW1D6sDMTNrugnYgXASaHROAKzOJgPvBO4Sx2Fm9m/CUuWXiqrQCYDV3bPAdoSJgWZmCmdRULd/f94HwAzeAM4GFgfeJo7FzOpjLnAEcHDz3wvlBMAs6AUuIXS/7YCfDTOL6xVgD+A3qgC8DNDsrTYFfg+soQ7EzCrpBsIGP48qg/AcALO3uhXYCPixOhAzq5Q5wLHA1og//ME9AGatbAv8L+4NMLPu3AZ8AbhFHUgfj3OaDW8y4SCOOYR9A/zMmFk7XgUOBz5P2IQsGX6ZmbU2B7gCOA9YmnCOgHvPzGw4s4CfE47y/ReRDvTphl9iZu3bHDiBsGmHmVl/vYRT/I4igXH+4TgBMOvcxsDXgY8Bo8SxmJnWTOBc4HjgfnEsmTgBMOveRODLwCcJQwRmVh8PAr8GzqDAbXzz4ATALD+jCKcM7g28HxirDcfMIpkC/Ak4E7hOHEvHnACYxTGWcJ73rsAuuGfArOweBi4ELgKuIUwOLjUnAGbFWJOwjHBr4O2EfQU8b8AsTTOAuwnf7q8DrgWelEYUgRMAM435CUnA2oTkYBlgOWApYAKhB2F0v3+aWffeIEzWewN4HXgeeKZZniJM3ruHsP9H4YfzFO3/AW9A+NRgof1gAAAAAElFTkSuQmCC"
  );

  const [activeSelectList, setActiveSelectList] = useState([]);
  const [inActiveSelectList, setInActiveSelectList] = useState([]);
  const [fullSelectList, setFullSelectList] = useState([]);
  const [orgRecipientList, setOrgRecipientList] = useState([]);

  const [temSelectedLeftList, setTemSelectedLeftList] = useState([]);
  const [temSelectedRightList, setTemSelectedRightList] = useState([]);

  const [leftSearchValue, setLeftSearchValue] = useState([]);
  const [rightSearchValue, setRightSearchValue] = useState([]);
  const [JsonStatistics, setJsonStatistics] = useState([]);
  const [ownerSearch, setOwnerSearch] = useState((localStorage.getItem("UserRole") === "RDocsSupportAdmin" || localStorage.getItem("UserRole") === "RDocsCustomerAdmin") ? localStorage.getItem("UserName") : "");

  const [showOwnerCompany, setShowOwnerCompany] = useState(false);
  const [userRoleBased, setUserRoleBased] = useState(false);
  const [userfilterDisbale, setUserFilterDisable] = useState(false);
  const [accessControlDrp, setAccessControlDrp] = useState("");
  const [documentIdInput, setDocumentIdInput] = useState("");
  const [receipentInput, setRecepientInput] = useState("");
  const [domainSearch, setDomainSearch] = useState("");
  const [subjectInput, setSubjectInput] = useState("");
  const [docNameSearch, setDocNameSearch] = useState("");
  const [selectedExpiryDate, setSelectedExpiryDate] = useState("");
  const [selectedLaunchDate, setSelectedLaunchDate] = useState("");
  const [company, setCompany] = useState("");
  const [accessControl, setAccessControll] = useState("");
  const [searchFilterPopup, setSearchFilterPopup] = useState(false);
  const [status, setStatus] = useState("");
  const [recipientsViewMorePopup, setRecipientsViewMorePopup] = useState(false);
  const [recipientToEmails, setRecipientToEmails] = useState("");
  const [recipientCcEmails, setRecipientCcEmails] = useState("");
  const [recipientBccEmails, setRecipientBccEmails] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPagesCount, setTotalPagesCount] = useState(0);
  const [docTemplateOptions, setDocTemplateOptions] = useState([])
  const [pageView, setPageView] = useState(25);
  const [isDisablePrev, setisDisablePrev] = useState(false);
  const [isDisableNext, setisDisableNext] = useState(false);
  const [isHistoryIconExists, setisHistoryIconExists] = useState(false);
  const [isSearchClicked, setisSearchClicked] = useState(0);
  const [PageLevelVersionHistory, setPageLevelVersionHistory] = useState([]);
  const [pageLevelFilteredArr, setPageLevelFilteredArr] = useState([]);
  const [latestUpdatedTime, setLatestUpdatedTime] = useState(null);
  const [isPageLevelViewPopup, setIsPageLevelViewPopup] = useState(false);
  const [isCanPrintViewPopup, setIsCanPrintViewPopup] = useState(false);
  const [canPrintFilteredArr, setCanPrintFilteredArr] = useState([]);
  const [latestCanPrintUpdatedTime, setLatestCanPrintUpdatedTime] = useState("");
  const [approvedAccessRequestsForPopup, setApprovedAccessRequestsForPopup] = useState([]);
  const allApprovedAccessRequests = React.useRef([]);
  const [isFilterChanged, setIsFilterChanged] = useState(false);
  const [SCriteria, setSCriteria] = useState({
    order: "",
    documentid: "",
    subject: "",
    receipent: "",
    accessControl: "",
    status: "",
    company: "",
    owner: "",
  });
  const [companySearch, setCompanySearch] = useState(() => {
    const storedUserRole = localStorage.getItem("UserRole");
    if (storedUserRole === "RDocsSupportAdmin") {
      return localStorage.getItem("Companyname");
    } else {
      return "";
    }
  });
  const defaultTrackInteractivitySortOptions = [
    { label: selectedLanguage.LstLanguageCodes.UI_FirstRead, value: "first_read", order: "desc", active: "true" },
    { label: selectedLanguage.LstLanguageCodes.UI_TotalMinutes, value: "total_time", order: "asc", active: "false" },
    { label: selectedLanguage.LstLanguageCodes.UI_Reads, value: "reads", order: "asc", active: "false" },

    { label: selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstAuthorized, value: "days_since_firstAuth", order: "asc", active: "false" },
    { label: selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstSActivity, value: "days_since_first", order: "asc", active: "false" },
    { label: selectedLanguage.LstLanguageCodes.UI_DaysSinceLastActivity, value: "days_since_last", order: "asc", active: "false" },
  ]
  const timeZoneRef = useRef("");
  const [sortOptions, setSortOptions] = useState(defaultTrackInteractivitySortOptions);
  const toggleSortOrder = (event, value) => {
    console.log("testing" + event.target.id);
    if (event.target.id == "chkNopleakers" || event.target.id == "sortOptionsDivLabel" || event.target.id == "sortOptionsDiv") {
      setSortOptions((prevOptions) =>
        prevOptions.map((option) =>
          option.value === value
            ? { ...option, active: "true" }
            : { ...option, order: "asc", active: "false" }
        )
      );
    }
    else {
      setSortOptions((prevOptions) =>
        prevOptions.map((option) =>
          option.value === value
            ? { ...option, order: option.order === "asc" ? "desc" : "asc", active: "true" }
            : { ...option, order: "asc", active: "false" }
        )
      );
    }
  };
  useEffect(() => { }, [chkReaderSelectionRef.current]);
  useEffect(() => {
    if (shouldScroll && endRef.current) {
      endRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScroll(false);
    }
  }, [inputFields, shouldScroll]);

  function handlerSelectAllRecipents(e, docIndex, docId) {
    let count = 0;
    const isChecked = e.target.checked;
    setTrackInteractivityDetails((prevDetails) => {
      const updatedDetails = prevDetails.map((detail) => {
        if (detail.docId === docId) {
          const updatedRecords = detail.records.map((record) => {
            if (record.email)
              return { ...record, checked: isChecked };
            else
              return { ...record };
          });
          //count = updatedRecords.filter((record) => record.checked).length;

          const selectedEmails = updatedRecords.map(record => record.email)

          const refDetailIndex = trackInteractivityDetailsRef.current.findIndex(d => d.docId === docId);
          if (refDetailIndex !== -1) {
            const updatedRef = [...trackInteractivityDetailsRef.current];
            updatedRef[refDetailIndex].records.map((record) => {
              if (selectedEmails.includes(record.email)) {
                record.checked = isChecked;
              }
            })
            count = updatedRef[refDetailIndex].records.filter((record) => record.checked).length;
            trackInteractivityDetailsRef.current = updatedRef;
          }

          return {
            ...detail,
            records: updatedRecords,
            showBanActiveButtons: count > 0 ? true : false,
            selectAllRecipients: isChecked,
          };
        }
        return detail;
      });

      return updatedDetails;
    });
    setDocIndexForReaders(docIndex);
    setSelectedDocIndexes((prevSelectedDocIndexes) => {
      if (!prevSelectedDocIndexes.includes(docIndex)) {
        return [...prevSelectedDocIndexes, docIndex];
      }
      return prevSelectedDocIndexes;
    });
  }
  useEffect(() => {
    if (manageItem !== "Folder View") {
      let leftsideBar = document.querySelector(".commontableft-section");
      // let rightsideBar = document.querySelector(".commontabright-section");
      leftsideBar.style.display = "none";
    }
    // RDocsDefaultSettingsData();
  }, []);
  async function handlerReaderSelection(
    event,
    docIndex,
    recipientIndex,
    docId
  ) {
    if (countryCodeOptions.length == 0) {
      await fetchCountryCodes();
    }
    let count = 0;
    setTrackInteractivityDetails((prevDetails) => {
      let email = "";
      const newDetails = prevDetails.map((detail) => {
        if (detail.docId === docId) {
          const updatedRecords = detail.records.map((record, index) => {
            if (index === recipientIndex) {
              email = record.email;
              return { ...record, checked: !record.checked };
            }
            return record;
          });

          const count = updatedRecords.filter(r => r.checked).length;
          const selectAll = count === updatedRecords.filter(r => r.email).length;

          currTrackDetails.current = {
            docId,
            recipientEmail: email,
          };

          return {
            ...detail,
            records: updatedRecords,
            showBanActiveButtons: count > 0,
            selectAllRecipients: selectAll,
          };
        }
        return detail;
      });

      return newDetails;
    });

    //currTrackDetails.current={docId,recipientEmail: recpEmail};
    backupRecords.current = true;
    console.log(count);
    setDocIndexForReaders(docIndex);
    setSelectedDocIndexes((prevSelectedDocIndexes) => {
      if (!prevSelectedDocIndexes.includes(docIndex)) {
        return [...prevSelectedDocIndexes, docIndex];
      }
      return prevSelectedDocIndexes;
    });
  }
  function handletemplatechange(e) {
    setSelectedTemplate(e);
  }

  async function onSummaryClickHandler(docId) {
    setOpen(true);
    try {
      const url =
        `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_GetSummaryData
        }` +
        "/" +
        docId;
      var summaryData = await APIRequest.GET("", url);

      if (summaryData && summaryData === "Server maintenance") {
        history("/maintenance");
        return;
      }

      if (summaryData?.errorMessage) {
        setAlertMsg(summaryData.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      }
      //printSummary.current = summaryData.totalPrints;
      const sd = summaryDetails.current;
      const entry = { docId, openRecords: [...summaryData.openRecords], printCount: summaryData.totalPrints };
      const idx = sd.findIndex(record => record.docId === docId);
      if (idx >= 0) sd[idx] = { ...entry };
      else sd.push(entry);


      setOpen(false);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setAlertMsg("Failed to load summary data");
      setAlertType("warning");
      setOpen(false);
    }

  }
  async function handlerMultiUserActiveInactive(documentId, uStatus, docIndex) {
    const email = null;
    currentPagevalue = currentPage;
    let selectedReadersList = [];
    let FinalSelectedReadersList = [];
    const selectedRecords = trackInteractivityDetails.filter((record) => {
      if (record.docId === documentId) {
        return record;
      }
    });
    console.log(selectedRecords);

    const checkedEmails = selectedRecords.flatMap((record) =>
      record.records
        .filter((r) => r.checked && r.status)
        .map((r) => {
          return { email: r.email, status: r.status };
        })
    );
    console.log(checkedEmails);
    if (uStatus) {
      checkedEmails.map((element) => {
        if (element.status === "Banned") {
          FinalSelectedReadersList.push({
            docId: element.docId,
            email: element.email,
          });
        }
      });
    } else {
      checkedEmails.map((element) => {
        if (element.status === "Active") {
          FinalSelectedReadersList.push({
            docId: element.docId,
            email: element.email,
          });
        }
      });
    }
    const url =
      `${process.env.REACT_APP_API +
      process.env.REACT_APP_API_RecipientActiveInactive
      }` +
      "/" +
      documentId +
      "/" +
      uStatus +
      "/" +
      email;
    if (FinalSelectedReadersList.length != 0) {
      var jsonDocs = await APIRequest.POSTSaveSettings(
        JSON.stringify(FinalSelectedReadersList),
        url
      );
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (jsonDocs == 200) {
        documentsList("", documentId);
      }
    }
    setTrackInteractivityDetails((prevDetails) => {
      return prevDetails.map((detail) => {
        if (detail.docId === documentId) {
          const updatedRecords = detail.records.map((record, index) => {
            return { ...record, checked: false };
          });
          return {
            ...detail,
            records: updatedRecords,
            selectAllRecipients: false,
            showBanActiveButtons: false,
          };
        }
        return detail;
      });
    });
  }
  const setParentAlertMsg = (msg) => {
    setAlertMsg(msg);
    setAlertType("warning");
    return;
  }
  const handleReceiptsAdding = async () => {
    setIsModalAddRecipientOpen(true);
    await fetchCountryCodes();
  };

  var resetKilledFlag = false;
  const handleCloseModal = () => {
    setIsModalAddRecipientOpen(false);
    resetUpload();
  };
  const handleCloseValidationModal = () => {
    setIsValidationPopup(false);
    setIsModalAddRecipientOpen(true);
    resetUpload();
  };
  const resetUpload = () => {
    setSelectedFiles([]);
    setDuplicateEmails([]);
    setemailLeanghtValidation([]);
    setLongDomainEmails([]);
    setInvalidEmailsWithoutDotComValidation([]);
    setLocalpartValiadation([]);
    setDuplicateInFile([]);
    setAlertMsg("");
    setAlertType("");
    setLongFirstName([]);
    setLongLastName([]);
    setLongReference([]);
    setInvalidCanPrintValues([]);
    setExceedMaxPrintsPerDoc([]);
    setMaxPrintsWithoutCanPrint([]);
    setCanPrintNotEnabledAtDocLevel([]);
    setMaxPrintsExceedLimit([]);
    setInvalidMaxPrintsValues([]);
  };
  function handlerBackToHistory() {
    setPendingRequestAccessTabFlag(false);
    handleRefreshAll();
  }

  useEffect(() => {
    var pendingrequest = localStorage.getItem("PendingRequest");
    if (
      pendingrequest != null &&
      pendingrequest != "" &&
      pendingrequest == "true"
    ) {
      if (l3TabNavigation != null) l3TabNavigation.current.click();
      localStorage.setItem("PendingRequest", "false");
    } else {
      var AIpendingrequest = localStorage.getItem("AIPendingRequest");
      if (
        AIpendingrequest != null &&
        AIpendingrequest != "" &&
        AIpendingrequest == "true"
      ) {
        if (l3TabNavigation != null) l3TabNavigation.current.click();
      }
    }
  }, []);
  useEffect(() => {
    if (manageItem === "Access Management") {
      var pendingrequest = localStorage.getItem("PendingRequest");
      if (
        pendingrequest != null &&
        pendingrequest != "" &&
        pendingrequest == "true"
      ) {
        if (l3TabNavigation != null) l3TabNavigation.current.click();
        localStorage.setItem("PendingRequest", "false");
      } else {
        var AIpendingrequest = localStorage.getItem("AIPendingRequest");
        if (
          AIpendingrequest != null &&
          AIpendingrequest != "" &&
          AIpendingrequest == "true"
        ) {
          if (l3TabNavigation != null) l3TabNavigation.current.click();
        }
      }
      l3TabNavigation.current.click();
    } else if (manageItem === "Folder View") {
      folderView.current.click();
    } else if (manageItem === "All Items") {
      allItems.current.click();
    }

    localStorage.setItem("ManageItem", "");
  }, []);
  function DownloadReaderXLS(e) {
    let workbook = null;

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        selectedLanguage.LstLanguageCodes.UI_EmailAdress,
        selectedLanguage.LstLanguageCodes.UI_FirstName,
        selectedLanguage.LstLanguageCodes.UI_LastName,
        selectedLanguage.LstLanguageCodes.UI_SendVerificationCode,
        selectedLanguage.LstLanguageCodes.UI_CountryCode,
        selectedLanguage.LstLanguageCodes.UI_MobileNumber,
        selectedLanguage.LstLanguageCodes.UI_ReferenceTxt,
        selectedLanguage.LstLanguageCodes.UI_CanPrint,
        selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,
      ],
    ]);

    workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    const blob = XLSX.writeFile(workbook, "ReadersList.xlsx");

    saveAs(blob, "ReadersList.xls");
  }
  function DownloadReaderCSV(e) {
    const csvContent = [
      selectedLanguage.LstLanguageCodes.UI_EmailAdress,
      selectedLanguage.LstLanguageCodes.UI_FirstName,
      selectedLanguage.LstLanguageCodes.UI_LastName,
      selectedLanguage.LstLanguageCodes.UI_SendVerificationCode,
      selectedLanguage.LstLanguageCodes.UI_CountryCode,
      selectedLanguage.LstLanguageCodes.UI_MobileNumber,
      selectedLanguage.LstLanguageCodes.UI_ReferenceTxt,
      selectedLanguage.LstLanguageCodes.UI_CanPrint,
      selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,
    ];
    const safeCSVValue = (value) => {
      if (value == null || value === undefined) return value;
      const strValue = String(value);
      return `\t${strValue}`;
    };
    const csvRows = csvContent.map((row) => {
      const values = typeof row === "string" ? row.split(",") : row;
      const sanitized = values.map(safeCSVValue);
      return sanitized.join(",");
    });
    downloadCSV(csvRows, "ReadersList.csv");
  }

  function downloadCSV(lstCsvRecipients, Download) {

    const csvContent = lstCsvRecipients.join("\n");
    const csvContentWithBOM = "\uFEFF" + csvContent;
    const blob = new Blob([csvContentWithBOM], {
      type: "text/csv;charset=utf-8;",
    });
    //const blob = new Blob([lstCsvRecipients.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = Download || "data.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  }
  const [fileNames, setFileNames] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  // var selectedFiles;
  function ReadersfileSelection(event) {
    if (event.target != undefined) {
      const newFiles = event.target.files;

      // Check if the selected file type is supported
      const supportedFileTypes = ["xls", "xlsx", "csv"];

      for (let index = 0; index < newFiles.length; index++) {
        const objFile = newFiles[index];

        if (
          !supportedFileTypes.includes(
            objFile.name?.split(".").pop().toLowerCase()
          )
        ) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_IncorrectFileType);
          setAlertType("warning");
          return;
        }
      }

      // Proceed with setting the new files
      setAlertMsg("");
      setAlertType("");
      const fileNames = Array.from(newFiles)
        .map((file) => file.name)
        .join(", ");
      setFileNames(fileNames);

      // Set the selected files
      setSelectedFiles(newFiles);
      AddReadersInputFiled(newFiles);
    }
  }

  function ReadersfileSelectionClick(event) {
    event.target.value = null;
  }
  function AddReadersInputFiled(files, source = 0) {
    const arrayTemp = [];
    var index = 0;
    var validationFlag = false;
    if (ReadersinputFields.length > 0) {
      arrayTemp.push(...ReadersinputFields);
      index = ReadersinputFields.length;
      ReadersinputFields.some((oldfile) => {
        files.some((newfile) => {
          if (oldfile.orgFileName == newfile.name && validationFlag == false)
            validationFlag = true;
        });
      });
    }
    if (validationFlag == true) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_DuplicateFilesAreNotallowed
      );
      setAlertType("warning");
      return;
    }
  }

  const handleFileChange = () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectFileUpload);
      setAlertType("warning");
    }
    const file = selectedFiles[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = e.target.result;
      const fileExtension = file.name?.split(".").pop().toLowerCase();
      let validationFlag = false;
      if (fileExtension === "csv") {
        var emailsFromFile = parseCSVcreate(data);
      } else if (fileExtension === "xlsx") {
        var emailsFromFile = await parseXLSXcreate(file);
      }
      const specificText = selectedLanguage.LstLanguageCodes.UI_EmailAdress;
      const specificFn = selectedLanguage.LstLanguageCodes.UI_FirstName;
      const specificLn = selectedLanguage.LstLanguageCodes.UI_LastName;
      if (fileExtension === "xlsx") {
        let containsSpecificTextXLS = jsonData.some((row) =>
          row.includes(specificText)
        );
        if (containsSpecificTextXLS == true) {
          containsSpecificTextXLS = jsonData.some((row) =>
            row.includes(specificFn)
          );
        }
        if (containsSpecificTextXLS == true) {
          containsSpecificTextXLS = jsonData.some((row) =>
            row.includes(specificLn)
          );
        }
        if (!containsSpecificTextXLS) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile
          );
          setAlertType("warning");
          setSelectedFiles([]);
          return;
        }
      }
      if (fileExtension === "csv") {
        let containsSpecificTextCSV = lines.some((row) =>
          row.includes(specificText)
        );

        if (containsSpecificTextCSV == true) {
          containsSpecificTextCSV = lines.some((row) =>
            row.includes(specificFn)
          );
        }
        if (containsSpecificTextCSV == true) {
          containsSpecificTextCSV = lines.some((row) =>
            row.includes(specificLn)
          );
        }
        if (!containsSpecificTextCSV) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile
          );
          setAlertType("warning");
          setSelectedFiles([]);
          return;
        }
      }
      resetUpload();
      const rows = [...inputFields];
      const emailNullIndex = rows.filter((email) => email.email != "");
      const mergedEmails = [...emailNullIndex, ...emailsFromFile];
      var emailFromFile = [];

      const emailSet = new Set();
      const uniqueEmails = [];
      let duplicateCount = 0;
      emailsFromFile.forEach((email) => {
        if (
          !emailSet.has(email.email) &&
          !emailNullIndex.filter((item) => item.email == email.email).length > 0
        ) {
          emailSet.add(email.email);
          emailFromFile.push(email);
        } else {
          duplicateCount++;
        }
      });
      const invalidEmailsWithoutDotCom = emailFromFile.filter(
        (email) =>
          email.email.trim() !== "" &&
          !/^[\w.\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,63}$/.test(email.email)
      );
      if (invalidEmailsWithoutDotCom.length > 0) {
        setInvalidEmailsWithoutDotComValidation(invalidEmailsWithoutDotCom);
        setIsValidationPopup(true);
        validationFlag = true;
      } else if (validationFlag == false) setIsValidationPopup(false);
      if (emailsFromFile.length === 0) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_EmailAdressCannotBeEmpty
        );
        setAlertType("warning");
        validationFlag = true;
      } else if (!validationFlag) {
        setIsValidationPopup(false);
      }
      const longDomainEmails = emailFromFile.filter((email) => {
        const domain = email.email?.split("@")[1];
        return domain && domain.length > 190;
      });
      if (longDomainEmails.length > 0) {
        setLongDomainEmails(longDomainEmails);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else if (!validationFlag) {
        setIsValidationPopup(false);
      }
      const longFirstName = emailFromFile.filter((email) => {
        return email.firstName && email.firstName.trim().length > 50;
      });
      if (longFirstName.length > 0) {
        setLongFirstName(longFirstName);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else if (validationFlag == false) {
        setIsValidationPopup(false);
      }
      const longLastName = emailFromFile.filter((email) => {
        return email.lastName && email.lastName.trim().length > 50;
      });
      if (longLastName.length > 0) {
        setLongLastName(longLastName);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else if (validationFlag == false) {
        setIsValidationPopup(false);
      }
      const longReference = emailFromFile.filter((email) => {
        return email.reference && email.reference.trim().length > 50;
      });
      if (longReference.length > 0) {
        setLongReference(longReference);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else if (validationFlag == false) {
        setIsValidationPopup(false);
      }
      const invalidLocalPart = emailFromFile.filter(
        (email) => email.email?.split("@")[0].length > 64
      );
      if (invalidLocalPart.length > 0) {
        setLocalpartValiadation(invalidLocalPart);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else if (!validationFlag) {
        setIsValidationPopup(false);
      }
      let authOptions = selectedOptions.map((option) => option.value);
      if (authOptions.includes('text') && authOptions.includes('email')) {
        authOptions.push('both');
      }
      if (authOptions.includes('text') && !authOptions.includes('email')) {
        inValidMsgForBoth.current = selectedLanguage.LstLanguageCodes.UI_PleaseEnterText;
      }
      if (!authOptions.includes('text') && authOptions.includes('email')) {
        inValidMsgForBoth.current = selectedLanguage.LstLanguageCodes.UI_PleaseEnterEmail;
      }

      const enteredVerificationTypes = emailFromFile.filter((recp) => recp.sendVerificationCode).map((recp) => { return recp.sendVerificationCode });
      let invalidVerificationTypes = enteredVerificationTypes.filter(
        (recp) => !authOptions.includes(recp.toLowerCase()));
      console.log(invalidVerificationTypes);
      if (invalidVerificationTypes.length > 0) {
        inValidAuthType.current = [...new Set(invalidVerificationTypes)];
        setIsValidationPopup(true);
        validationFlag = true;
      } else if (!validationFlag) {
        setIsValidationPopup(false);
      }



      const countryDialCodes = countryCodeDrpOptions.map(
        (option) => option.value
      );
      const unauthorizedCountryCodes = emailsFromFile.filter((email) => {
        const countryCode = email.mobileCountryCode;
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          // Assign trimmed value from the `value` property
          countryCodeVlaue = countryCode.value.trim();
        } else {
          // Assign countryCode directly if `value` property is not present
          countryCodeVlaue = countryCode;
        }
        if (countryCodeVlaue.length == 0) {
          return false;
        }
        return countryCodeVlaue && !countryDialCodes.includes(countryCodeVlaue);
      });
      if (unauthorizedCountryCodes.length > 0) {
        setUnauthorizedCountryCodes(unauthorizedCountryCodes);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setUnauthorizedCountryCodes([]);
      }
      const countryDialCodeMap = countryCodeDrpOptions.reduce((acc, option) => {
        acc[option.value] = option.mobileMaxLeng; // Example: { "+1": 10, "+91": 10 }
        return acc;
      }, {});
      // Validate mobile numbers against country codes
      const invalidMobileNumbers = emailsFromFile.filter((email) => {
        const countryCode = email.mobileCountryCode;
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          countryCodeVlaue = countryCode.value.trim();
        } else {
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email.mobileNumber?.trim();
        const maxLength = countryDialCodeMap[countryCodeVlaue];
        // Validate mobile number length
        return maxLength && mobileNumber && mobileNumber.length !== maxLength;
      });
      if (invalidMobileNumbers.length > 0) {
        setInvalidMobileNumbers(invalidMobileNumbers);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setInvalidMobileNumbers([]);
      }
      const mobileNumberSet = new Set();
      const duplicateMobileNumbers = [];
      // Filter for duplicate mobile numbers
      const duplicateMobileNumberRows = emailFromFile.filter((email) => {
        const mobileNumber = email.mobileNumber?.trim();
        const countryCode = email.mobileCountryCode?.value ?? email.mobileCountryCode ?? "";
        const compositeKey = `${countryCode}-${mobileNumber}`;
        if (mobileNumber && mobileNumberSet.has(compositeKey)) {
          duplicateMobileNumbers.push(email);
          return true;
        } else {
          if (mobileNumber) mobileNumberSet.add(compositeKey);
          return false;
        }
      });
      if (duplicateMobileNumberRows.length > 0) {
        setDuplicateMobileNumbers(duplicateMobileNumbers);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setDuplicateMobileNumbers([]);
      }
      // Check for missing mobile numbers when a country code is provided
      const missingMobileNumbers = [];
      // Check for missing mobile numbers when a country code is provided
      const rowsWithMissingMobileNumbers = emailsFromFile.filter((email) => {
        const countryCode = email.mobileCountryCode;
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          // Assign trimmed value from the `value` property
          countryCodeVlaue = countryCode.value.trim();
        } else {
          // Assign countryCode directly if `value` property is not present
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email.mobileNumber?.trim();
        if (countryCodeVlaue.length != 0 && !mobileNumber) {
          missingMobileNumbers.push(email);
          return true;
        }
        return false;
      });
      if (rowsWithMissingMobileNumbers.length > 0) {
        setMissingMobileNumbers(missingMobileNumbers);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setMissingMobileNumbers([]);
      }
      const missingCountryCodes = [];

      // Check for missing country codes when a mobile number is provided
      const rowsWithMissingCountryCodes = emailsFromFile.filter((email) => {
        const countryCode = email.mobileCountryCode;
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          countryCodeVlaue = countryCode.value.trim();
        } else {
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email.mobileNumber?.trim();
        if (countryCodeVlaue.length == 0 && mobileNumber) {
          missingCountryCodes.push(email);
          return true;
        }
        return false;
      });

      if (rowsWithMissingCountryCodes.length > 0) {
        setMissingCountryCodes(missingCountryCodes);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setMissingCountryCodes([]);
      }

      const invalidCanPrintRows = emailFromFile.filter((email) => email.invalidCanPrint);
      if (invalidCanPrintRows.length > 0) {
        setInvalidCanPrintValues(invalidCanPrintRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setInvalidCanPrintValues([]);
      }

      // Always derive doc-level print settings directly from the document data
      // so validations work correctly before "content edit" is clicked
      const currentDoc = lstDocumentsHistory.find((doc) => doc.documentId == popupDocumentId);
      const docLevelCanPrint = currentDoc?.documentOptions?.print ?? false;
      const effectiveMaxPrintsPerDoc = currentDoc?.documentOptions?.maxPrintsPerDocument ?? maxPrintsPerDocument.current;

      const exceedMaxPrintsRows = emailFromFile.filter((email) => {
        return effectiveMaxPrintsPerDoc !== "" &&
          effectiveMaxPrintsPerDoc != null &&
          effectiveMaxPrintsPerDoc !== 0 &&
          email.canPrint === true &&
          email.maxPrintsPerReader !== "" &&
          email.maxPrintsPerReader != null &&
          parseInt(email.maxPrintsPerReader) > parseInt(effectiveMaxPrintsPerDoc);
      });
      if (exceedMaxPrintsRows.length > 0) {
        setExceedMaxPrintsPerDoc(exceedMaxPrintsRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setExceedMaxPrintsPerDoc([]);
      }

      const maxPrintsWithoutCanPrintRows = docLevelCanPrint
        ? emailFromFile.filter((email) => {
          return email.canPrint !== true &&
            email.maxPrintsPerReader !== "" &&
            email.maxPrintsPerReader != null;
        })
        : [];
      if (maxPrintsWithoutCanPrintRows.length > 0) {
        setMaxPrintsWithoutCanPrint(maxPrintsWithoutCanPrintRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setMaxPrintsWithoutCanPrint([]);
      }

      const canPrintNotEnabledAtDocLevelRows = !docLevelCanPrint
        ? emailFromFile.filter((email) => {
          return email.canPrint === true || (email.maxPrintsPerReader !== "" && email.maxPrintsPerReader != null);
        })
        : [];
      if (canPrintNotEnabledAtDocLevelRows.length > 0) {
        setCanPrintNotEnabledAtDocLevel(canPrintNotEnabledAtDocLevelRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setCanPrintNotEnabledAtDocLevel([]);
      }

      const maxPrintsExceedLimitRows = emailFromFile.filter((email) => {
        return email.maxPrintsPerReader !== "" && email.maxPrintsPerReader != null && parseInt(email.maxPrintsPerReader) > 9999;
      });
      if (maxPrintsExceedLimitRows.length > 0) {
        setMaxPrintsExceedLimit(maxPrintsExceedLimitRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setMaxPrintsExceedLimit([]);
      }

      const invalidMaxPrintsRows = emailFromFile.filter((email) => {
        return email.invalidMaxPrints != null;
      });
      if (invalidMaxPrintsRows.length > 0) {
        setInvalidMaxPrintsValues(invalidMaxPrintsRows);
        setIsValidationPopup(true);
        validationFlag = true;
        duplicateCount = 0;
      } else {
        setInvalidMaxPrintsValues([]);
      }

      const emailvar = inputFields.map((item) => item.email);

      const emailLeanghtValidation = emailFromFile.filter(
        (email) => email.email && email.email.trim().length > 255
      );
      if (emailLeanghtValidation.length > 0) {
        setemailLeanghtValidation(emailLeanghtValidation);
        setIsValidationPopup(true);
        // setLongDomainEmails([]);
        // setLocalpartValiadation([]);
        validationFlag = true;
        duplicateCount = 0;
      } else if (validationFlag == false) setIsValidationPopup(false);
      if (validationFlag == false) {
        if (emailNullIndex.length > 0) {
          setInputFields([
            ...emailNullIndex,
            ...emailFromFile.map((email) => ({
              email: email.email,
              firstName: email.firstName.trim(),
              lastName: email.lastName.trim(),
              mobileCountryCode: email.mobileCountryCode,
              mobileNumber: email.mobileNumber.trim(),
              reference: email.reference.trim(),
              authType: email.sendVerificationCode ? email.sendVerificationCode.trim() : "",
              canPrint: email.canPrint,
              maxPrintsPerReader: email.maxPrintsPerReader,
            })),
          ]);
        } else {
          setInputFields([
            ...emailFromFile.map((email) => ({
              email: email.email,
              firstName: email.firstName.trim(),
              lastName: email.lastName.trim(),
              mobileCountryCode: email.mobileCountryCode,
              mobileNumber: email.mobileNumber.trim(),
              reference: email.reference.trim(),
              authType: email.sendVerificationCode ? email.sendVerificationCode.trim() : "",
              canPrint: email.canPrint,
              maxPrintsPerReader: email.maxPrintsPerReader,
            })),
          ]);
        }
        resetUpload();
      }
      if (duplicateCount > 0) {
        setAlertMsg(
          duplicateCount +
          " " +
          selectedLanguage.LstLanguageCodes.UI_DeDuplicateMsg
        );
        setAlertType("warning");
      }
    };
    reader.readAsText(file);
    setIsModalAddRecipientOpen(false);
  };

  var jsonData;
  var lines;
  const parseCSVcreate = (data) => {
    lines = data?.split("\n");
    const emails = lines
      .slice(1) // Skip the first line (header)
      .map((line, index) => {
        const values = line?.split(",");
        const emailValue = values[0];
        const fnValue = values.length > 0 ? values[1] : "";
        const lnValue = values.length > 1 ? values[2] : "";
        const verificationCode = values.length > 3 ? values[3] : ""; // Verification code
        const mobileCountryCode = values.length > 4 ? values[4] : ""; // Country Code
        const mobileNumber = values.length > 5 ? values[5] : ""; // Mobile Number
        const referenceText = values.length > 6 ? values[6] : "";
        const canPrintRaw = values.length > 7 ? (values[7] ? values[7].trim() : "") : ""; // CanPrint
        const maxPrintsRaw = values.length > 8 ? (values[8] ? values[8].trim() : "") : ""; // MaxAllowedPrints
        const filteredEmail = emailValue
          ? emailValue.trim().toLowerCase()
          : null;
        const filteredFn = fnValue ? fnValue.trim() : "";
        const filteredLn = lnValue ? lnValue.trim() : "";
        const filteredCountryCode = mobileCountryCode
          ? mobileCountryCode.trim()
          : "";
        const filteredMobileNumber = mobileNumber ? mobileNumber.trim() : "";
        const filteredReferenceText = referenceText ? referenceText.trim() : "";

        const validCanPrintLookup = ["true", "yes", "1"];
        const validCanPrintAll = ["", "true", "false", "yes", "no", "1", "0"];
        const isValidCanPrint = validCanPrintAll.includes(canPrintRaw.toLowerCase());
        const parsedCanPrint = canPrintRaw !== ""
          ? (validCanPrintLookup.includes(canPrintRaw.toLowerCase()) ? true : false)
          : false;
        const isValidMaxPrints = maxPrintsRaw === "" || /^\d+$/.test(maxPrintsRaw);
        const parsedMaxPrints = maxPrintsRaw !== ""
          ? (isValidMaxPrints ? (parseInt(maxPrintsRaw, 10) || "") : "")
          : "";

        if (filteredEmail === null) return null;
        const rowObj = {
          email: filteredEmail,
          firstName: filteredFn,
          lastName: filteredLn,
          sendVerificationCode: verificationCode ? verificationCode.trim() : "",
          mobileCountryCode:
            filteredCountryCode != ""
              ? countryCodeDrpOptions.find(
                (cc) => cc.value === filteredCountryCode
              ) || filteredCountryCode
              : [],
          mobileNumber: filteredMobileNumber,
          reference: filteredReferenceText,
          canPrint: parsedCanPrint,
          maxPrintsPerReader: parsedMaxPrints,
        };
        if (!isValidCanPrint && canPrintRaw !== "") {
          rowObj.invalidCanPrint = canPrintRaw;
        }
        if (!isValidMaxPrints) {
          rowObj.invalidMaxPrints = maxPrintsRaw;
        }
        return rowObj;
      })
      .filter((email) => email !== null);

    return emails;
  };
  const parseXLSXcreate = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data, { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      jsonData = XLSX.utils.sheet_to_json(ws, {
        header: 1,
        raw: false,
      });
      const emails = jsonData
        .slice(1)
        .map((row) => {
          const emailValue = row[0];
          const fnValue = row[1];
          const lnValue = row[2];
          const verificationCode = row[3]; // Verification code
          const mobileCountryCode = row[4];
          const mobileNumber = row[5]; // Mobile number
          const referenceText = row[6];
          const canPrintRaw = row[7] != null ? String(row[7]).trim() : ""; // CanPrint
          const maxPrintsRaw = row[8] != null ? String(row[8]).trim() : ""; // MaxAllowedPrints
          const trimmedEmail =
            typeof emailValue === "string"
              ? emailValue.trim().toLowerCase()
              : null;
          const trimmedFn = typeof fnValue === "string" ? fnValue.trim() : "";
          const trimmedLn = typeof lnValue === "string" ? lnValue.trim() : "";
          const trimmedReferenceText =
            typeof referenceText === "string" ? referenceText.trim() : "";
          const trimmedCountryCode =
            typeof mobileCountryCode === "string"
              ? mobileCountryCode.trim()
              : "";
          const trimmedMobileNumber =
            typeof mobileNumber === "string" ? mobileNumber.trim() : "";
          const trimmedVerificationCode =
            typeof verificationCode === "string" ? verificationCode.trim() : "";
          const countryCodeDetailsObj =
            trimmedCountryCode != ""
              ? countryCodeDrpOptions.find(
                (cc) => cc.value === trimmedCountryCode
              ) || trimmedCountryCode
              : [];

          const validCanPrintLookup = ["true", "yes", "1"];
          const validCanPrintAll = ["", "true", "false", "yes", "no", "1", "0"];
          const isValidCanPrint = validCanPrintAll.includes(canPrintRaw.toLowerCase());
          const parsedCanPrint = canPrintRaw !== ""
            ? (validCanPrintLookup.includes(canPrintRaw.toLowerCase()) ? true : false)
            : false;
          const isValidMaxPrints = maxPrintsRaw === "" || /^\d+$/.test(maxPrintsRaw);
          const parsedMaxPrints = maxPrintsRaw !== ""
            ? (isValidMaxPrints ? (parseInt(maxPrintsRaw, 10) || "") : "")
            : "";

          if (trimmedEmail === null) return null;
          const rowObj = {
            email: trimmedEmail,
            firstName: trimmedFn,
            lastName: trimmedLn,
            sendVerificationCode: trimmedVerificationCode,
            mobileCountryCode: countryCodeDetailsObj,
            mobileNumber: trimmedMobileNumber,
            reference: trimmedReferenceText,
            canPrint: parsedCanPrint,
            maxPrintsPerReader: parsedMaxPrints,
          };
          if (!isValidCanPrint && canPrintRaw !== "") {
            rowObj.invalidCanPrint = canPrintRaw;
          }
          if (!isValidMaxPrints) {
            rowObj.invalidMaxPrints = maxPrintsRaw;
          }
          return rowObj;
        })
        .filter((email) => email !== null);

      return emails;
    } catch (error) {
      console.error("Error parsing XLSX file:", error);
      return [];
    }
  };
  function findDuplicates(arr) {
    const duplicates = {};
    const result = [];
    for (const email of arr) {
      // Exclude empty emails from duplicates check
      if (email.trim() !== "") {
        if (!duplicates[email]) {
          duplicates[email] = true;
        } else {
          result.push(email);
        }
      }
    }
    return result;
  }
  const handleStatusChange = (e) => {
    const selectedValue = e.target.value;
    setStatus(selectedValue);

    if (selectedValue === "Killed") {
      setIsKilledOpt(true);
    } else {
      setIsKilledOpt(false);
    }
  };

  const moveSelectedValueRight = () => {
    const divLeftListSelected = Array.from(
      document.getElementsByClassName("inActiveUserSelected")
    );
    if (divLeftListSelected.length == 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    } else {
      var list = fullSelectList.map((element) => {
        if (
          divLeftListSelected.filter(
            (localItem) => localItem.textContent.indexOf(element.email) >= 0
          ).length == 1
        )
          return { ...element, enabled: true, status: "Active" };
        else return { ...element };
      });
      setActiveSelectList(
        list.filter((localItem) => localItem.enabled == false)
      );
      setTemSelectedLeftList(
        list.filter((localItem) => localItem.enabled == false)
      );
      setInActiveSelectList(
        list.filter((localItem) => localItem.enabled == true)
      );
      setTemSelectedRightList(
        list.filter((localItem) => localItem.enabled == true)
      );
      setFullSelectList(list);
      setLeftSearchValue("");
      setRightSearchValue("");
    }
  };
  const moveSelectedValueLeft = () => {
    const divRightListSelected = Array.from(
      document.getElementsByClassName("activeUserSelected")
    );
    if (divRightListSelected.length == 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    } else {
      var list = fullSelectList.map((element) => {
        if (
          divRightListSelected.filter(
            (localItem) => localItem.textContent.indexOf(element.email) >= 0
          ).length == 1
        )
          return { ...element, enabled: false, status: "Banned" };
        else return { ...element };
      });
      setActiveSelectList(
        list.filter((localItem) => localItem.enabled == false)
      );
      setTemSelectedLeftList(
        list.filter((localItem) => localItem.enabled == false)
      );
      setInActiveSelectList(
        list.filter((localItem) => localItem.enabled == true)
      );
      setTemSelectedRightList(
        list.filter((localItem) => localItem.enabled == true)
      );
      setFullSelectList(list);
      setLeftSearchValue("");
      setRightSearchValue("");
    }
  };
  function handleCustomColumnsLayout() {
    setCustomColumnLayoutFlag(true);
  }
  function handleRefreshAll(e, Defaultfolder = 0) {
    if (searchInputRefForTrackInteractivity?.current) {
      searchInputRefForTrackInteractivity.current.value = "";
    }
    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setIsControlClick(() => {
      return { isSearchOrRefresh: true, isClear: false, isMoveToFolder: false };
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    RefreshGridCtrl();
    setDefaultSelected(true);
    setfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
    var FoldersList = [];
    if (foldersDetailsLst.length > 0) {
      foldersDetailsLst.map((item, i) =>
        FoldersList.push({
          folderID: item.folderID,
          folderName: item.folderName.trim(),
          isShared: item.isShared,
          isActive: false,
        })
      );
    }
    setFoldersDetailsLst(FoldersList);
    setCurrentPage(1);
    currentPagevalue = 1;
    if (Defaultfolder == 1) {
      folderViewTabSelected = 1;
    }
    setSelectedDocIndexes([]);
    setSortDirectionForTrackInteractivity({});
    setSortDirectionForActivityLog({});
  }

  function handleRefresh(updatedDocumentID, e, docIndexValue) {
    var pSortBy, searchInputValue;
    try {
      const startDocFetching = async () => {
        setOpen(true);
        if (searchInputRefForTrackInteractivity.current) {
          searchInputRefForTrackInteractivity.current.value = "";
        }
        try {
          var Statisticlogoctrl = document.getElementById(
            "StatisTextlogo" + updatedDocumentID
          );
          var StatisTextLink = document.getElementById(
            "StatisTextLink" + updatedDocumentID
          );
          var collapseStatisticstable = document.getElementById(
            "collapseStatistics" + updatedDocumentID
          );
          if (Statisticlogoctrl &&
            Statisticlogoctrl.ariaExpanded !== null &&
            Statisticlogoctrl.ariaExpanded == "true"
          ) {
            Statisticlogoctrl.className =
              "Statictextlogo material-icons material-icons-custom collapsed";
            Statisticlogoctrl.ariaExpanded = "false";
            StatisTextLink.className =
              "StaticTextLink arrow_circle_text_class collapsed";
            StatisTextLink.ariaExpanded = "false";
            collapseStatisticstable.className =
              "CollapseStaticTable inertable mb-2 box-shadow-light bg-white collapse tblStatistics";
          }

          var url =
            searchInputValue != "" && searchInputValue != undefined
              ? `${process.env.REACT_APP_API +
              process.env.REACT_APP_API_DocumentsSearch
              }`
              : `${process.env.REACT_APP_API +
              process.env.REACT_APP_API_GetDocumentById
              }` +
              "\\" +
              updatedDocumentID +
              "\\UI";
          var jsonDoc = await APIRequest.GET(
            "",
            url +
            "?order=" +
            sortColumn +
            "&by=" +
            (pSortBy == "undefine d" ? sortBy : pSortBy) +
            "&searchinfo=" +
            searchInputValue
          );
          if (jsonDoc && jsonDoc === "Server maintenance") {
            history("/maintenance");
            return;
          }
          if (jsonDoc.length <= 0) {
            if (currentPagevalue == 1) {
              setNoRecordsFound(true);
            } else if (currentPagevalue > 1) {
              setCurrentPage(1);
              currentPagevalue = 1;
              handleRefresh(updatedDocumentID, e);
            }
          } else {
            setNoRecordsFound(false);
          }
          setDocTemplateOptions(
            jsonDoc?.docTemplates && jsonDoc?.docTemplates?.map((item) => ({
              value: item.templateName || item.TemplateName,
              label: item.templateName || item.TemplateName
            }))
          );
          jsonDoc.securityLevel = jsonDoc.documentOptions.distRestriction
            ? 3
            : jsonDoc.documentOptions.readerEmail
              ? 2
              : 1;
          jsonDoc.chailedClass = jsonDoc.documentOptions.distRestriction
            ? "text-danger"
            : jsonDoc.documentOptions.readerEmail
              ? "text-warning "
              : "text-success";

          // jsonDoc.selection = false;
          lstDocumentsHistory.filter((item) => {
            if (item.selection && item.documentId === updatedDocumentID) {
              jsonDoc.docSelected = true;
              jsonDoc.selection = true;
            }
          });

          var staticRegions = continents,
            savedRegions = jsonDoc.documentOptions.regions,
            resRegions = staticRegions.filter(
              (item) => !savedRegions?.includes(item.id)
            );
          var strRegions = "";
          resRegions.forEach((region) => {
            if (strRegions === "") strRegions = region.continentName;
            else strRegions += ", " + region.continentName;
          });
          jsonDoc.regions = savedRegions?.length == 0 ? "" : strRegions;

          jsonDoc.Time = 0;
          var jsonOpenRecords = jsonDoc.openRecords.filter(
            (records) =>
              records.activityTime !== undefined &&
              (records.event == "Opened" || records.event == null)
          );
          jsonOpenRecords
            .map((timeCalc) => timeCalc.activityTime)
            .reduce((accTime, timeCalc) => {
              return (jsonDoc.Time = timeCalc + accTime);
            }, 0);

          jsonDoc.activityTimess = 0;
          var jsonOpenRecordsTrackActivity = [];
          if (
            jsonDoc.documentOptions.recipients.length > 0 &&
            jsonDoc.openRecords.length > 0
          ) {
            jsonDoc.documentOptions.recipients.map(
              (recpList, j) =>
              (jsonOpenRecordsTrackActivity = jsonDoc.openRecords.filter(
                (records) =>
                  records.email !== null &&
                  records.activityTime !== undefined &&
                  (records.event == "Opened" || records.event == null) &&
                  recpList.email != null &&
                  records.email.toString().toLowerCase() ===
                  recpList.email.toString().toLowerCase()
              ))
            );
            jsonOpenRecordsTrackActivity
              .map((timeCalc) => timeCalc.activityTime)
              .reduce((accTime, timeCalc) => {
                return (jsonDoc.activityTimess = timeCalc + accTime);
              }, 0);
          }

          //Updated the document with the new documentId
          const updatedJsonDocs = [];
          lstDocumentsHistory.forEach((item) => {
            if (item.documentId === jsonDoc.documentId) {
              jsonDoc.activeTabName = item.activeTabName;
              jsonDoc.statistics = item.statistics
              updatedJsonDocs.push(jsonDoc);
            } else {
              updatedJsonDocs.push({ ...item });
            }
          });
          setIsSMSAuthentication(jsonDoc.smsAuthentication);
          // setEDisclosure(jsonDoc.documentOptions.eDisclosure);
          var isHistory = await ShowHistoryIconToAllRecords(jsonDoc.documentId);
          //setLstDocumentsHistory(updatedJsonDocs);
          setLstDocumentsHistory(
            updatedJsonDocs.map((element, i) => {
              if (element.documentId == jsonDoc.documentId) {
                element.isHistoryRecordsExists = isHistory;
                element.documentOptions.recipients =
                  jsonDoc.documentOptions.recipients;
                return { ...element };
              } else {
                return { ...element };
              }
            })
          );

          const orgupdatedJsonDocs = [];
          orgLstDocumentsHistory.forEach((item) => {
            if (item.documentId === updatedJsonDocs.documentId) {
              orgupdatedJsonDocs.push(updatedJsonDocs);
            } else {
              orgupdatedJsonDocs.push({ ...item });
            }
          });

          setOrgLstDocumentsHistory(
            orgupdatedJsonDocs.map((element, i) => {
              if (element.documentId == jsonDoc.documentId) {
                element.isHistoryRecordsExists = isHistory;
                element.documentOptions.recipients =
                  jsonDoc.documentOptions.recipients;
                return { ...element };
              } else {
                return { ...element };
              }
            })
          );

          let itemDocumentsHistory = updatedJsonDocs.find(
            (element) => element.documentId == updatedDocumentID
          );
          let lstReceipientslet = {
            ...itemDocumentsHistory.documentOptions.recipients,
          };
          let lstOpenrecordslet = { ...itemDocumentsHistory.openRecords.filter((record) => record.event !== "Restricted") };
          let lstReceipients = Object.values(lstReceipientslet);
          let lstOpenrecords = Object.values(lstOpenrecordslet);
          const updatedDetails = trackInteractivityDetails.map((record) => ({
            ...record,         // Create a new object to prevent mutation
            open: false,       // Set open to false
            sortDetails: defaultTrackInteractivitySortOptions, // ✅ Update sortDetails as well
          }));

          setTrackInteractivityDetails(updatedDetails);
          const Receipients = lstReceipients.map((lstreceipient) => {
            return {
              email: lstreceipient.email,
              firstName: lstreceipient.firstName.trim(),
              lastName: lstreceipient.lastName.trim(),
              mobileCountryCode: lstreceipient.mobileCountryCode.trim(),
              mobileNumber: lstreceipient.mobileNumber.trim(),
              openedTime:
                lstOpenrecords.filter(
                  (lstopenrecord) =>
                    lstopenrecord.email != null &&
                    lstopenrecord.email.toLowerCase() ==
                    lstreceipient.email.toLowerCase() &&
                    (!lstopenrecord.event || lstopenrecord.event === "Opened")
                ).length > 0
                  ? lstOpenrecords.filter(
                    (lstopenrecord) =>
                      lstopenrecord.email != null &&
                      lstopenrecord.email.toLowerCase() ==
                      lstreceipient.email.toLowerCase() &&
                      (!lstopenrecord.event ||
                        lstopenrecord.event === "Opened")
                  )[0].opened
                  : "",
              readCount: lstreceipient.readCount,

              totalTime:
                lstOpenrecords.filter(
                  (emailList) =>
                    emailList.email != null &&
                    lstreceipient.email != null &&
                    emailList.email.toString().toLowerCase() ===
                    lstreceipient.email.toString().toLowerCase()
                    && (emailList.event == "Opened" || emailList.event == null) &&
                    emailList.activityTime !== undefined
                ).length > 0
                  ? getTimeFormat(
                    lstOpenrecords
                      .filter(
                        (emailList) =>
                          emailList.email != null &&
                          lstreceipient.email != null
                          && (emailList.event == "Opened" || emailList.event == null)
                          && emailList.email.toString().toLowerCase() ===
                          lstreceipient.email.toString().toLowerCase()
                      )
                      .map((timeCalc) => timeCalc.activityTime)
                      .reduce((accTime, timeCalc) => timeCalc + accTime)
                  )
                  : "00:00:00",
              vote:
                lstreceipient.vote == -1
                  ? ""
                  : lstreceipient.vote == 0
                    ? "Dislike"
                    : "Like",
              status: lstreceipient.status,
              checked: false,
              ...lstreceipient,
            };
          });

          if (
            lstOpenrecords.filter(
              (lstopenrecord) => lstopenrecord.email == null
            ).length > 0
          ) {
            Receipients.push({
              email: "",
              firstName: "",
              lastName: "",
              openedTime:
                lstOpenrecords.filter(
                  (lstopenrecord) => lstopenrecord.email == null
                ).length > 0
                  ? lstOpenrecords.filter(
                    (lstopenrecord) => lstopenrecord.email == null
                  )[0].opened
                  : "",
              readCount:
                lstOpenrecords.filter(
                  (emailList) =>
                    emailList.email == null &&
                    emailList.activityTime !== undefined && (emailList.event == null || emailList.event == "Opened")
                ).length > 0
                  ? lstOpenrecords.filter(
                    (emailList) =>
                      emailList.email == null &&
                      emailList.activityTime !== undefined && (emailList.event == null || emailList.event == "Opened")
                  ).length
                  : "",
              totalTime:
                lstOpenrecords.filter(
                  (emailList) =>
                    emailList.email == null &&
                    emailList.activityTime !== undefined && (emailList.event == null || emailList.event == "Opened")
                ).length > 0
                  ? getTimeFormat(
                    lstOpenrecords
                      .filter(
                        (emailList) =>
                          emailList.email == null &&
                          emailList.activityTime !== undefined && (emailList.event == null || emailList.event == "Opened")
                      )
                      .map((timeCalc) => timeCalc.activityTime)
                      .reduce((accTime, timeCalc) => timeCalc + accTime)
                  )
                  : "00:00:00",
              vote: "",
              status: "",
            });
          }
          console.log(Receipients);
          const sortedRecipients = Receipients.sort((a, b) => {
            const dateA = a.openedTime ? new Date(a.openedTime) : "";
            const dateB = b.openedTime ? new Date(b.openedTime) : "";
            if (dateA === "" && dateB === "") return 0;
            if (dateA === "") return 1;
            if (dateB === "") return -1;
            return dateB - dateA;
          });


          const updatedSortedRecipients = sortedRecipients.map((recipient) => {
            if (recipient.email === "") {

              const matchedRecord = trackInteractivityDetails
                .find((detail) => detail.docId === updatedDocumentID)
                ?.records?.find((record) => !("email" in record) || record.email === "");

              return matchedRecord
                ? { ...recipient, printCount: matchedRecord.printCount }
                : recipient;
            }

            const matchedRecord = trackInteractivityDetails
              .find((detail) => detail.docId === updatedDocumentID)
              ?.records?.find((record) => record.email === recipient.email);

            return matchedRecord
              ? { ...recipient, printCount: matchedRecord.printCount }
              : recipient;
          });

          console.log(updatedSortedRecipients);

          setTrackInteractivityDetails((prev) => {
            return prev.map((detail) => {
              if (detail.docId === updatedDocumentID) {
                return {
                  ...detail,
                  records: updatedSortedRecipients,
                  selectAllRecipients: false,
                  showBanActiveButtons: false,
                };
              }
              return detail;
            });
          });
          trackInteractivityDetailsRef.current = trackInteractivityDetailsRef.current.map((detail) => {
            if (detail.docId === updatedDocumentID) {
              return {
                ...detail,
                records: sortedRecipients,
                selectAllRecipients: false,
                showBanActiveButtons: false,
              };
            }
            return detail;
          });


          setActivityLogDetails((prevDetails) => {
            return prevDetails.map((detail) => {
              if (detail.docId === updatedDocumentID) {
                const updatedOpenRecords = updatedJsonDocs
                  .filter((doc) => doc.documentId === updatedDocumentID)
                  .map((doc) => {
                    return doc.openRecords;
                  });

                const sortedRecords = updatedOpenRecords.flat().sort((a, b) => {
                  return new Date(b.opened) - new Date(a.opened);
                });
                return {
                  ...detail,
                  records: sortedRecords,
                  order: "desc",
                };
              }
              return detail;
            });
          });

          setSortDirectionForTrackInteractivity((prev) => {
            return {
              ...prev,
              [updatedDocumentID]: "desc",
            };
          });

          setSortDirectionForActivityLog((prev) => {
            return {
              ...prev,
              [updatedDocumentID]: "desc",
            };
          });
          if (jsonDoc.activeTabName == "Statistics") {
            handleToShowStaticData(updatedDocumentID);
          }
          setOpen(false);
          setOpenLoaderSearch(false);
          //handleClearRecordCount();
        } catch (error) {
          setOpen(false);
          setOpenLoaderSearch(false);
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_FailedtoLoadDoc + "."
          );
          setAlertType("warning");
          return;
        }
        //setSortDirectionForTrackInteractivity({});
        //setSortDirectionForActivityLog({});
      };
      startDocFetching();
      onSummaryClickHandler(updatedDocumentID);
    } catch (error) {
      console.log("error: " + error);
    }
  }

  function ChangeMaxReadsTexts(textValue) {
    if (textValue == "" || textValue == "0") {
      setMaxReads(0);
      setMaxReadsText("");
    } else if (parseInt(textValue) >= 1 && textValue.toString().length <= 10) {
      setMaxReadsText(parseInt(textValue));
      setMaxReads(parseInt(textValue));
    }
  }

  function ChangeMaxViewsPerDocumentTexts(textValue) {
    if (textValue == "" || textValue == "0") {
      setMaxViewsPerDocument(0);
      setMaxViewsPerDocumentText("");
    }
    else if (parseInt(textValue) > 100000) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_TheMaximumLimitForMaxViewsPerDoc
      );
      setAlertType("warning");
      return;
    } else if (parseInt(textValue) >= 1 && parseInt(textValue) <= 2147483647) {
      setMaxViewsPerDocumentText(parseInt(textValue));
      setMaxViewsPerDocument(parseInt(textValue));
    }
  }

  function handlerExpirationDaysStartTime(e, eflag) {
    var event = "";
    if (e != null) {
      event = e;
    }
    calcExpirationDays(
      event != "" && event != null
        ? moment(event).format("YYYY-MM-DDTHH:mm")
        : "",
      moment(expiryTime).format("YYYY-MM-DDTHH:mm"),
      expirationDaysFlag
    );
    if (isDatetimeControl == "false") {
      if (event != "" && expiryTime != "" && event > expiryTime) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchDate);
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setStartTime(event);
    } else {
      if (event != "" && event != undefined) {
        const [startHour, startMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (
          event != "" &&
          expiryTime != "" &&
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0] >
          moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchDate);
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          expiryTime != "" &&
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0] ==
          moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [endHour, endMinute] = moment(expiryTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_TheLaunchtime);
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setStartTime(e);
    }
  }
  function handlerExpirationDaysExpiryTime(e, eflag) {
    var tempStartDate = moment(startTime).format("YYYY-MM-DD");
    var event = "";
    if (e != null) {
      event = e;
    }
    const utcDate = new Date(Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds()
    ));

    setChangedExpiryDate(utcDate);
    if (isDatetimeControl == "false") {
      if (startTime == "") tempStartDate = moment().utc().format("YYYY-MM-DD");
      //event = moment(event).format("YYYY-MM-DD");

      if (event != "" && tempStartDate > moment(event).format("YYYY-MM-DD")) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
        );
        setAlertType("warning");
        setAlertClass("alerthist-ip");
      }
      setExpiryTime(event);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    } else {
      if (event != "") {
        const [endHour, endMinute] = moment(event)
          .format("YYYY-MM-DDTHH:mm")
          .split("T")[1]
          .split(":")
          .map(Number);
        if (startTime == "" || startTime == null)
          tempStartDate = moment().utc().format("YYYY-MM-DDTHH:mm");

        if (
          event != "" &&
          tempStartDate.split("T")[0] >
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
          );
          setAlertType("warning");
          setAlertClass("alerthist-ip");
        }
        if (
          event != "" &&
          tempStartDate ==
          moment(event).format("YYYY-MM-DDTHH:mm").split("T")[0]
        ) {
          const [startHour, startMinute] = moment(startTime)
            .format("YYYY-MM-DDTHH:mm")
            .split("T")[1]
            .split(":")
            .map(Number);
          if (
            startHour > endHour ||
            (startHour === endHour && startMinute > endMinute)
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
          }
        }
      }
      setExpiryTime(e);
      calcExpirationDays(
        startTime != "" && startTime != null
          ? moment(startTime).format("YYYY-MM-DDTHH:mm")
          : "",
        event != "" && event != null
          ? moment(event).format("YYYY-MM-DDTHH:mm")
          : "",
        expirationDaysFlag
      );
    }
  }

  function IntiateTime(e, flag) {
    if (document.getElementById("dthstart") != null) {
      document
        .getElementById("dthstart")
        .addEventListener("keydown", (event) => {
          if (event.keyCode != 8) {
            event.preventDefault();
          } else {
            document.getElementById("dthstart").value = "";
            setStartTime("");
          }
        });
    }
    if (document.getElementById("dthstart1") != null) {
      document
        .getElementById("dthstart1")
        .addEventListener("keydown", (event) => {
          if (event.keyCode != 8) {
            event.preventDefault();
          } else {
            document.getElementById("dthstart1").value = "";
            setStartTime("");
          }
        });
    }
    if (document.getElementById("dthexpiry") != null) {
      document
        .getElementById("dthexpiry")
        .addEventListener("keydown", (event) => {
          if (event.keyCode != 8) {
            event.preventDefault();
          } else {
            document.getElementById("dthexpiry").value = "";
            setExpiryTime("");
          }
        });
    }
    if (document.getElementById("dthexpiry1") != null) {
      document
        .getElementById("dthexpiry1")
        .addEventListener("keydown", (event) => {
          if (event.keyCode != 8) {
            event.preventDefault();
          } else {
            document.getElementById("dthexpiry1").value = "";
            setExpiryTime("");
          }
        });
    }
    if (isDatetimeControl == "true") {
      if ((expiryTime == "" || expiryTime == null) && flag == 1) {
        setExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
      } else if ((startTime == null || startTime == "") && flag == 0) {
        setStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes()
          )
        );
      }
    } else {
      if (expiryTime == "" || (expiryTime == null && flag == 1)) {
        setExpiryTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
      } else if (startTime == "" || (startTime == null && flag == 0)) {
        setStartTime(
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          )
        );
      }
    }
  }
  function calcExpirationDays(vStartTime, vExpiryTime, vExpirationDaysFlag) {
    if (vExpirationDaysFlag) {
      var diffDays = moment(vExpiryTime).diff(
        moment(vStartTime !== "" ? vStartTime : Date()),
        "days"
      );
      var diffSeconds = moment(vExpiryTime).diff(
        moment(vStartTime !== "" ? vStartTime : Date()),
        "seconds"
      );
      var diffTime = secondsToHms(diffSeconds);
      setExpirationDays(
        diffDays > 1
          ? diffDays + " Days"
          : diffDays === 1
            ? diffDays + " Day"
            : diffSeconds > 0
              ? diffTime
              : ""
      );
    } else {
      setExpirationDays("");
    }
  }
  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 9 ? h : "0" + h;
    var mDisplay = m > 9 ? m : "0" + m;
    var sDisplay = s > 9 ? s : "0" + s;
    return hDisplay + ":" + mDisplay + ":" + sDisplay;
  }
  function handlerAllowResFlag(value) {
    if (value) setResponseAddress(localStorage.getItem("UserName"));
    else setResponseAddress("");
    setConstAllowResFlag(value);
  }
  function handleSetVoting(value) {
    setVoting(value);
    if (value == false) {
      setVoteSharing(false);
    }
  }
  function handleRegions(lstRegions) {
    var mapContinets = document.getElementsByClassName(
      "map-selected gContinent"
    );
    var arrMapContinents = lstRegions;
    if (mapContinets.length === 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_AtleastOneRegionShouldbePermitted +
        "."
      );
      setAlertType("warning");
      return;
    }
    for (let item of mapContinets) {
      arrMapContinents.push(item.id);
    }
  }
  function handlerMasterSelectionRequest(event) {
    setOrgLstPendingRequestAccess(
      orgLstPendingRequestAccess.map((element) => {
        return { ...element, selection: event.target.checked };
      })
    );
    setMasterSelectionRequest(event.target.checked);
  }
  function handlerSelectionRequest(event, index) {
    setOrgLstPendingRequestAccess(
      orgLstPendingRequestAccess.map((element, i) => {
        if (index === i) return { ...element, selection: event.target.checked };
        else return { ...element };
      })
    );
    if (
      orgLstPendingRequestAccess.length ===
      orgLstPendingRequestAccess.filter((element) => element.selection === true)
        .length +
      (event.target.checked ? 1 : -1)
    )
      setMasterSelectionRequest(true);
    else setMasterSelectionRequest(false);
  }
  function handlerMasterSelection(event) {
    setLstDocumentsHistory(
      lstDocumentsHistory.map((element) => {

        return { ...element, selection: (element?.canEditRPDRecords === false) ? false : event.target.checked };
      })
    );
    isMasterSelection.current = event.target.checked;
    itemsCheckRef.current = itemsCheckRef.current.filter(
      (item) => item != null
    );
    if (!event.target.checked)
      itemsCheckRef.current.map((item) => {
        if (item != null) {
          item.checked = false;
        }
      });
    if (lstDocumentsHistory.length > 0) {
      setMasterSelection(event.target.checked);
    } else {
      setMasterSelection(false);
    }
    selectionOfRecords();
  }

  function handlerSelection(event, index) {
    isMasterSelection.current = false;
    setLstDocumentsHistory(
      lstDocumentsHistory.map((element, i) => {
        if (index === i) return { ...element, selection: event.target.checked };
        else return { ...element };
      })
    );

    let length = lstDocumentsHistory.length;
    const disabledRecords = lstDocumentsHistory.filter((element) => element?.canEditRPDRecords === false).length;
    if (disabledRecords > 0) {
      length = length - disabledRecords;
    }

    if (
      length ===
      lstDocumentsHistory.filter((element) => element.selection === true)
        .length +
      (event.target.checked ? 1 : -1)
    )
      setMasterSelection(true);
    else setMasterSelection(false);
    selectionOfRecords();
  }

  const handleClearRecordCount = () => {
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setSelectedSearchRecords((prev) => {
      return [{ page: 0, docs: [] }];
    });
    setLstDocumentsHistory((prev) => {
      return prev.map((element) => {
        return { ...element, selection: false };
      });
    });
    setMasterSelection(false);
  };

  const selectionOfRecords = () => {
    let selectedDocIds = [];
    let unSelectedIds = [];
    if (isMasterSelection.current === true) {
      lstDocumentsHistory.filter((element) => {
        if (!(element?.canEditRPDRecords == false)) {
          selectedDocIds.push(element.documentId)
        }
      }
      );
    } else {
      lstDocumentsHistory.filter((element, i) => {
        if (itemsCheckRef.current[i].checked) {
          selectedDocIds.push(element.documentId);
        } else {
          unSelectedIds.push(element.documentId);
        }
      });
    }
    const filteredSelectedRecords = selectedSearchRecords[0].docs.filter(
      (element) => !unSelectedIds.includes(element)
    );
    setSelectedSearchRecords((prev) => {
      const existingPage = prev.find((record) => record.page === 0);
      if (existingPage) {
        const docIds = selectedDocIds.filter(
          (id) => !existingPage.docs.includes(id)
        );

        return prev.map((record) =>
          record.page === 0
            ? {
              ...record,
              docs: [...filteredSelectedRecords, ...docIds],
            }
            : record
        );
      }
    });
  };

  useEffect(() => {
    let totalDocsCount = 0;
    const allDocs = selectedSearchRecords.reduce((accumulator, item) => {
      return accumulator.concat(item.docs);
    }, []);

    totalDocsCount = allDocs.length;

    //console.log(totalDocsCount);
    setRecordsSelectedCount((prev) => {
      return {
        showRecords: totalDocsCount != 0 ? true : false,
        count: totalDocsCount,
      };
    });
  }, [selectedSearchRecords]);

  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie?.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }
  useEffect(() => {
    if (isUpdated) {
      lstDocumentsHistory.forEach((item, index) => {
        if (
          item.docSelected
          &&
          (!trRef.current[index].classList.contains("open"))
        ) {
          trRef.current[index].click();
        }
        else if (
          !item.docSelected
          &&
          trRef.current[index].classList.contains("open")
        ) {
          trRef.current[index].click();
        }
      });
      trRef.current.map((item) => {
        if (item != null && item.nextElementSibling.classList.contains("open")) {
          item.nextElementSibling.classList.remove("open");
        }
      })
      setIsUpdated(false);
    }

  }, [isUpdated]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    folderViewTabSelected = 0;
    const storedUserRole = localStorage.getItem("UserRole");
    setDefaultTheCompany(true);
    setShowCompanyWhenApply(companySearch);
    if (storedUserRole === "RDocsUser") {
      setUserFilterDisable(true);
    }
    dispatch(languageChange(localStorage.getItem("language")));
    const userRole = localStorage.getItem("UserRole");
    const loggedInEmail = localStorage.getItem("UserName");
    const companyName = localStorage.getItem("Companyname");
    if (userRole === "RDocsSupportAdmin") {
      setUserRoleBased(true);

      if (companyName) {
        setCompanySearch(companyName);
      }

      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
      }

    } else if (userRole === "RDocsCustomerAdmin") {
      setUserRoleBased(false);

      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
      }

      setCompanySearch("");
    }
    documentsList("");
  }, []);
  var timer;
  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);

  useEffect(() => {
    if (ClearSearchcalled == true) {
      setfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
    }
  }, [lstDocumentsHistory]);
  useEffect(() => { }, [masterSelection]);
  useEffect(() => { }, [activeTabName]);
  useEffect(() => {
    window.addEventListener("online", () => setOnlineStatus(true));
    window.addEventListener(
      "offline",
      () => setOnlineStatus(false)
      //setOpen(false)
    );
  }, []);

  useEffect(() => {
    refreshToken();
  }, []);
  async function refreshToken() {
    var response = await APIRequest.POSTREFRESH(
      `${process.env.REACT_APP_API + process.env.REACT_APP_API_RefreshToken}`
    );
    if (response && response === "Server maintenance") {
      history("/maintenance");
      return;
    }
    if (response && response !== "Failed to fetch") {
      if (response.errorMessage == undefined || response.errorMessage == "") {
      } else {
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        return;
      }
    } else {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_SessionExpired);
      setAlertType("warning");
      return;
    }
  }
  function clearFilters() {
    setDocumentIdInput("");
    setSubjectInput("");
    setRecepientInput("");
    setAccessControlDrp("");
    setStatus("");
    setOwnerSearch("");
    setOwnerInput("");
    SetKilledByInput("");
    setDocNameSearch("");
    setDomainSearch("");
    setSelectedExpiryDate("");
    setSelectedLaunchDate("");
    setSelectedTemplate("");
  }

  function clearFiltersForLayout() {
    setDocumentIdInput("");
    setSubjectInput("");
    setRecepientInput("");
    setAccessControlDrp("");
    setStatus("");
    setOwnerInput("");
    SetKilledByInput("");
    setDocNameSearch("");
    setDomainSearch("");
    setSelectedExpiryDate("");
    setSelectedLaunchDate("");
    setSelectedTemplate("");
  }
  const paginationAttributes = {
    currentPage,
    totalPages: totalPagesCount,
    DisableNext: isDisableNext,
    DisablePrev: isDisablePrev,
  };




  useEffect(() => {
    if (isControlClick.isClear) {
      sortDown.current = true;
      setSortBy("desc");
      setSortColumn("Created");
      setShowOwnerCompany(false);
      setShowCompanyWhenApply("");
      documentsList("desc", 0, 1, folderView, "Created");
    }
    if (isControlClick.isSearchOrRefresh) {
      if (isFolderViewselected) {
        if (folderId === "") GetDefaultDocuments();
        else {
          folderViewTabSelected = folderId;
          sortDown.current = true;
          setSortColumn("Created");
          setSortBy("desc");
          documentsList("desc", 0, 0, 0, "Created");
        }
      } else {
        currentPageViewCount = pageView;
        sortDown.current = true;
        setSortColumn("Created");
        setSortBy("desc");
        documentsList("desc", 0, 0, 0, "Created");
      }
    }
    if (isControlClick.isMoveToFolder) {
      if (folderId != "" && folderId != 1) {
        GetDocumentByFolderId(folderId);
      } else {
        GetDefaultDocuments(25, true);
      }
    }
    if (isControlClick.isKilled) {
      if (sortDown.current) {
        setSortBy("desc");
        if (folderId != "") {
          GetDocumentByFolderId(folderId);
        } else {
          documentsList("desc");
        }
      } else {
        if (folderId != "") {
          GetDocumentByFolderId(folderId);
        } else {
          documentsList("asc");
        }
        setSortBy("asc");
      }
    }
    if (isControlClick.isBanOrActive) {
      if (sortDown.current) {
        setSortBy("desc");
        if (folderId != "") {
          GetDocumentByFolderId(folderId);
        } else {
          documentsList("desc");
        }
      } else {
        if (folderId != "") {
          GetDocumentByFolderId(folderId);
        } else {
          documentsList("asc");
        }
        setSortBy("asc");
      }

    }
  }, [isControlClick]);

  function RetainDocumentList(folderView = 0) {
    pendingChipUpdate.current = null;
    setIsControlClick(() => {
      return { isClear: true, isSearchOrRefresh: false, isMoveToFolder: false };
    });
    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });

    setCurrentPage(1);
    setPageView(25);
    currentPagevalue = 1;
    setisSearchClicked(0);
    if (isKilledOpt == true) {
      resetKilledFlag = true;
      setIsKilledOpt(false);
    } else {
      resetKilledFlag = false;
    }
    setIsTrackKillHeader(false);
    getCustomColumns(false);
    currentPageViewCount = 25;
    if (folderView == 1) {
      folderViewTabSelected = folderView;
      clearFilters();
      setFolderId(folderView);
      setfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
      setDefaultSelected(true);
      GetFoldersLists(folderView);
      setRestrictarningMsg(true);
    }

    var litems = lstDocumentsHistory.filter(
      (element) => element.selection === true
    );
    for (const item of litems) {
      item.selection = false;
    }
    setMasterSelection(false);
  }
  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    currentPagevalue = pageNumber;
    currentPageViewCount = pageView;
    if (folderId != "") {
      folderViewTabSelected = folderId;
    }
    if (pageNumber === totalPagesCount) {
      setisDisableNext(true);
      setisDisablePrev(false);
    } else if (pageNumber === 1) {
      setisDisablePrev(true);
      setisDisableNext(false);
    } else {
      setisDisablePrev(false);
      setisDisableNext(false);
    }
    if (sortDown.current) {
      setSortBy("desc");
      //documentsList("desc", isSearchClicked == 0 ? 0 : 1);
      documentsList("desc");
    } else {
      //documentsList("asc", isSearchClicked == 0 ? 0 : 1);
      documentsList("asc");
      setSortBy("asc");
    }
  };
  const onPrevClick = () => {
    setCurrentPage(currentPage - 1);
    currentPagevalue = currentPage - 1;
    currentPageViewCount = pageView;
    if (folderId != "") {
      folderViewTabSelected = folderId;
    }
    if (currentPage === 1) {
      setisDisablePrev(true);
      setisDisableNext(false);
    } else {
      setisDisablePrev(false);
      setisDisableNext(false);
    }
    if (sortDown.current) {
      setSortBy("desc");
      //documentsList("desc", isSearchClicked == 0 ? 0 : 1);
      documentsList("desc");
    } else {
      //documentsList("asc", isSearchClicked == 0 ? 0 : 1);
      documentsList("asc");
      setSortBy("asc");
    }
  };

  const onNextClick = () => {
    setCurrentPage(currentPage + 1);
    currentPagevalue = currentPage + 1;
    currentPageViewCount = pageView;
    if (folderId != "") {
      folderViewTabSelected = folderId;
    }
    if (currentPage === totalPagesCount) {
      setisDisableNext(true);
      setisDisablePrev(false);
    } else {
      setisDisablePrev(false);
      setisDisableNext(false);
    }
    if (sortDown.current) {
      setSortBy("desc");
      //documentsList("desc", isSearchClicked == 0 ? 0 : 1);
      documentsList("desc");
    } else {
      //documentsList("asc", isSearchClicked == 0 ? 0 : 1);
      documentsList("asc");
      setSortBy("asc");
    }
  };
  const setpageViewDrp = (e, folderview = 0) => {
    currentPageViewCount = e;
    setCurrentPage(1);
    currentPagevalue = 1;
    setPageView(e);
    setisDisableNext(false);
    setisDisablePrev(false);
    if (folderview !== 0) {
      folderViewTabSelected = folderId;
    }
    if (sortDown.current) {
      setSortBy("desc");
      //documentsList("desc", isSearchClicked == 0 ? 0 : 1);
      documentsList("desc");
    } else {
      //documentsList("asc", isSearchClicked == 0 ? 0 : 1);
      documentsList("asc");
      setSortBy("asc");
    }
  };

  function SearchDocumentData(flag) {
    setisSearchClicked(1);
    if (flag != 2) {
      if (flag == 1) {
        setShowOwnerWhenApply("");
        setShowCompanyWhenApply("");
      }
      else {
        if (ownerSearch) {
          const strictOwnerEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
          if (!strictOwnerEmailRegex.test(ownerSearch.trim())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
            setAlertType("warning");
            return;
          }
        }
        pendingChipUpdate.current = { owner: ownerSearch, company: companySearch };
      }
    }
    if (ownerSearch != "" || companySearch != "") {
      setShowOwnerCompany(true);
    }
    setIsControlClick(() => {
      return { isSearchOrRefresh: true, isClear: false, isMoveToFolder: false };
    });

    resetKilledFlag = false;
    currentPageViewCount = pageView;
    setCurrentPage(1);
    currentPagevalue = 1;
    if (folderName != "") {
      folderViewTabSelected =
        folderName != selectedLanguage.LstLanguageCodes.UI_Default
          ? folderId
          : 1;
    }
  }
  async function pendingRequestAccess() {
    setOpen(true);
    setOpenLoaderSearch(true);
    try {
      var url = `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_PendingRequestAccess
        }`;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setOpen(false);
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        return;
      }
      if (jsonDocs.rpdaccessdetails != "") {
        jsonDocs.rpdaccessdetails.map((item, i) => (item.selection = false));
        setNoRecordsFoundPendingAccess(false);
      } else {
        setNoRecordsFoundPendingAccess(true);
      }
      setOrgLstPendingRequestAccess(
        JSON.parse(JSON.stringify(jsonDocs.rpdaccessdetails))
      );

      setOpen(false);
      setOpenLoaderSearch(false);
    } catch (error) {
      setOpen(false);
      setOpenLoaderSearch(false);
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FailedtoLoadDoc + ".");
      setAlertType("warning");
      return;
    }
  }
  function handlerClickPendingRequest() {
    setPendingRequestAccessTabFlag(true);
    pendingRequestAccess();
    setMasterSelectionRequest(false);
  }
  function handlerApprovePendingRequest(event) {
    if (
      orgLstPendingRequestAccess != null &&
      orgLstPendingRequestAccess != "" &&
      orgLstPendingRequestAccess.filter((element) => element.selection === true)
        .length > 0
    ) {
      setModalIsOpenNotes(true);
      setSenderNotes("");
      setKillNotes("");
      setSendingRequestApproveDeclineFlag("Approved");
    } else {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    }
  }
  function handlerOpenNotesClosed() {
    setModalIsOpenNotes(false);
    setSenderNotes("");
  }
  function handlerOpenKillNotesClosed() {
    setModalIsOpenKillNote(false);
    setKillNotes("");
  }
  function handlerDeclinePendingRequest(event) {
    if (
      orgLstPendingRequestAccess != null &&
      orgLstPendingRequestAccess != "" &&
      orgLstPendingRequestAccess.filter((element) => element.selection === true)
        .length > 0
    ) {
      setModalIsOpenNotes(true);
      setSenderNotes("");
      setKillNotes("");
      setSendingRequestApproveDeclineFlag("Declined");
    } else {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    }
  }

  async function handleToContinue() {
    var items = orgLstPendingRequestAccess.filter(
      (element) => element.selection === true
    );
    for (const item of items) {
      var requestAccessUpdate = {
        id: item.id,
        documentId: item.documentId,
        senderNotes: senderNotes,
        status: sendingRequestApproveDeclineFlag,
      };
      var response = await APIRequest.PUT(
        JSON.stringify(requestAccessUpdate),
        `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_PendingRequestAccessUpdate
        }`
      );
      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      }
    }
    setModalIsOpenNotes(false);
    setModalIsOpen(false);
    setModalIsOpenKillNote(false);
    pendingRequestAccess();
    setMasterSelectionRequest(false);
  }
  function documentsList(
    pSortBy,
    otherAction = 0,
    tabChanged = 0,
    reset = 0,
    sortedColumn
  ) {
    try {
      var languagecodeForSearch = localStorage.getItem("language");
      var usernameforsearch = localStorage.getItem("UserName");
      var userRole = localStorage.getItem("UserRole");

      document
        .getElementById("clearFiltersButton")
        .addEventListener("click", function RetainDocumentList() {
          clearFilters();
          setCompanySearch("");
          setShowCompanyWhenApply("");
          setShowOwnerWhenApply("");
          setOwnerSearch("");
          setRestrictarningMsg(true);
        });
      // If the advanced search popup is still open, its owner/company
      // edits are unapplied — refreshes triggered while it is open
      // (control status save, ban/active, kill, paging, sort) must use
      // the last successfully applied values instead
      const effOwnerSearch = searchFilterPopup ? showOwnerWhenApply : ownerSearch;
      const effCompanySearch = searchFilterPopup ? showCompanyWhenApply : companySearch;
      if (searchFilterPopup) {
        setOwnerSearch(effOwnerSearch);
        setCompanySearch(effCompanySearch);
      }
      setSearchFilterPopup(false);
      setDocNameSearch(docNameSearch.trim());
      const startFetching = async () => {
        if (openLoaderFolder == false) {
          setOpen(true);
        }
        let dataUpdated;
        var calstarttime = "";
        var calexpiryTime = "";
        if (isDatetimeControl == "false") {
          calstarttime =
            moment(selectedLaunchDate).format("YYYY-MM-DDTHH:mm");
        } else {
          //calstarttime=startTime;
          calstarttime = moment(selectedLaunchDate).format("YYYY-MM-DDTHH:mm");
        }
        if (isDatetimeControl == "false") {
          calexpiryTime =
            moment(selectedExpiryDate).format("YYYY-MM-DDTHH:mm");
        } else {
          //calstarttime=startTime;
          calexpiryTime = moment(selectedExpiryDate).format("YYYY-MM-DDTHH:mm");
        }
        try {
          var url = `${process.env.REACT_APP_API +
            process.env.REACT_APP_API_DocumentsSearch
            }`;
          var jsonDocs = await APIRequest.GET(
            "",
            url +
            "?language=" +
            languagecodeForSearch +
            "&sender=" +
            usernameforsearch +
            "&order=" +
            (sortedColumn != null &&
              sortedColumn != undefined &&
              sortedColumn != ""
              ? sortedColumn
              : sortColumn) +
            "&by=" +
            (!pSortBy || pSortBy === "" ? sortBy : pSortBy) +
            "&DocumentId=" +
            (tabChanged == 1 ? "" : documentIdInput) +
            "&Subject=" +
            (tabChanged == 1 ? "" : subjectInput) +
            "&Recipient=" +
            (tabChanged == 1 ? "" : receipentInput) +
            "&KilledBy=" +
            (tabChanged == 1 ? "" : KilledByInput) +
            "&AccessControl=" +
            (tabChanged == 1 ? "" : accessControlDrp) +
            "&DocumentStatus=" +
            (tabChanged == 1 ? "" : status) +
            "&CompanyName=" +
            (reset == 1 ? "" : effCompanySearch) +
            "&owner=" +
            (isKilledOpt != true
              ? reset == 1
                ? ""
                : effOwnerSearch
              : tabChanged == 1
                ? ""
                : (ownerInput == '' ? effOwnerSearch : ownerInput)) +
            "&folderId=" +
            (folderViewTabSelected != 0 ? folderViewTabSelected : "") +
            "&currentPage=" +
            currentPagevalue +
            "&pageSize=" +
            currentPageViewCount +
            "&DocumentName=" + docNameSearch.trim() +
            "&TemplateName=" + selectedTemplate +
            "&ExpiryDate=" + calexpiryTime +
            "&LaunchDate=" + calstarttime +
            "&Domain=" + domainSearch
          );
          if (
            isKilledOpt == true &&
            resetKilledFlag == false &&
            folderViewKilledFlag == false
          ) {
            setIsTrackKillHeader(true);
            getCustomColumns(true);
          } else {
            setIsTrackKillHeader(false);
            RDocsDefaultSettingsData();
            getCustomColumns(false);
          }
          if (jsonDocs && jsonDocs === "Server maintenance") {
            history("/maintenance");
            return;
          } else if (
            jsonDocs.errorMessage != undefined &&
            jsonDocs.errorMessage != ""
          ) {
            pendingChipUpdate.current = null;
            setOpen(false);
            setAlertMsg(jsonDocs.errorMessage);
            const exemptCodes = ["RD011", "RD012", "RD013", "RD014"];
            if (jsonDocs.messageCode && exemptCodes.includes(jsonDocs.messageCode)) {
              setOwnerSearch(showOwnerWhenApply);
              setCompanySearch(showCompanyWhenApply);
            } else if (jsonDocs.messageCode) {
              setNoRecordsFound(true);
              setLstDocumentsHistory([]);
              setLstKilledDocuments([]);
              setTotalPagesCount(0);
            }
            setAlertType("warning");
            return;
          }
          if (pendingChipUpdate.current) {
            if (pendingChipUpdate.current.owner !== null) {
              setShowOwnerWhenApply(pendingChipUpdate.current.owner);
            }
            setShowCompanyWhenApply(pendingChipUpdate.current.company);
            pendingChipUpdate.current = null;
          }
          setDocTemplateOptions(
            jsonDocs?.docTemplates && jsonDocs?.docTemplates?.map((item) => ({
              value: item.templateName || item.TemplateName,
              label: item.templateName || item.TemplateName
            }))
          );
          const options = jsonDocs?.customFilterList;
          const normalize = (field, prevValue) => {
            // If already new structure
            if (field && typeof field === "object" && field.visible !== undefined) {
              return field;
            }

            // If old boolean structure
            if (typeof field === "boolean") {
              return {
                visible: field,
                order: field ? 1 : 0
              };
            }

            return prevValue;
          };

          setCustomFilterOptionsArray((prev) => ({
            isDocumentId: normalize(options?.documentId, prev.isDocumentId),
            isSubject: normalize(options?.subjectDescription, prev.isSubject),
            isFileName: normalize(options?.fileName, prev.isFileName),
            isReaderEmail: normalize(options?.readerEmail, prev.isReaderEmail),
            isAccessControl: normalize(options?.accessControl, prev.isAccessControl),
            isStatus: normalize(options?.status, prev.isStatus),
            isDomains: normalize(options?.domains, prev.isDomains),
            isTemplates: normalize(options?.templates, prev.isTemplates),
            isLaunches: normalize(options?.launches, prev.isLaunches),
            isExpires: normalize(options?.expires, prev.isExpires),
          }));

          if (otherAction == 0) {
            setOrgLstDocumentsHistory(
              JSON.parse(JSON.stringify(jsonDocs.documentDto))
            );
          } else {
            var isHistory = await ShowHistoryIconToAllRecords(otherAction);
            setOrgLstDocumentsHistory(
              jsonDocs.documentDto.map((element, i) => {
                if (element.documentId == otherAction) {
                  element.isHistoryRecordsExists = isHistory;
                  return { ...element };
                } else {
                  return { ...element };
                }
              })
            );
          }

          setTotalPagesCount(jsonDocs.totalCount);


          if (jsonDocs?.sharedUserId) {
            jsonDocs.documentDto.map((item) => {
              if (item.ownerId !== jsonDocs.sharedUserId.sharedUserId && jsonDocs.sharedUserId.isEdit) {
                item.canEditRPDRecords = jsonDocs.sharedUserId.isEdit === "0" ? false : true;
                if (!canMoveRPDRecords.current.includes(item.ownerId)) {
                  canMoveRPDRecords.current.push(item.ownerId);
                }
              }
            })
          }

          if (jsonDocs.documentDto.length <= 0) {
            if (currentPagevalue == 1) {
              setNoRecordsFound(true);
            } else if (currentPagevalue > 1) {
              setCurrentPage(1);
              currentPagevalue = 1;
              documentsList(pSortBy, otherAction);
            }
          } else {
            setNoRecordsFound(false);
          }
          jsonDocs.documentDto.map(
            (item, i) =>
            (item.securityLevel = item.documentOptions.distRestriction
              ? 3
              : item.documentOptions.readerEmail
                ? 2
                : 1)
          );
          jsonDocs.documentDto.map(
            (item, i) =>
            (item.chailedClass = item.documentOptions.distRestriction
              ? "text-danger"
              : item.documentOptions.readerEmail
                ? "text-warning "
                : "text-success")
          );
          jsonDocs.documentDto.map(
            (item, i) =>
              (item.activeTabName = "Control_Status")
          );

          const allDocs = selectedSearchRecords.reduce((accumulator, item) => {
            return accumulator.concat(item.docs);
          }, []);

          //console.log(allDocs);

          let recordCount = 0;

          jsonDocs.documentDto.map((item, i) => {
            let selectedCount = false;
            if (chkReaderSelectionRef.current[i]) {
              chkReaderSelectionRef.current[i].forEach((inputElement) => {
                if (
                  inputElement != null &&
                  inputElement.checked &&
                  !selectedCount
                )
                  selectedCount = true;
              });
            }
            item.showBanActiveButtons = selectedCount;
            if (allDocs && allDocs.includes(item.documentId)) {
              item.selection = true;
              recordCount++;
            } else {
              item.selection = false;
            }
          });
          if (
            jsonDocs.documentDto.length != 0 &&
            recordCount === jsonDocs.documentDto.length
          ) {
            setMasterSelection(true);
          } else {
            setMasterSelection(false);
          }

          const docsSelected = [];
          lstDocumentsHistory.filter((item) => {
            if (item.docSelected) docsSelected.push(item.documentId);
          });

          jsonDocs.documentDto.map((item, i) => {
            item.docSelected =
              docsSelected.length > 0 && docsSelected.includes(item.documentId)
                ? true
                : false;
          });

          jsonDocs.documentDto.forEach((document) => {
            var staticRegions = continents,
              savedRegions = document.documentOptions.regions,
              resRegions = staticRegions.filter(
                (item) => savedRegions && !savedRegions.includes(item.id)
              );
            var strRegions = "";
            resRegions.forEach((region) => {
              if (strRegions === "") strRegions = region.continentName;
              else strRegions += ", " + region.continentName;
            });
            document.regions =
              savedRegions && savedRegions.length == 0 ? "" : strRegions;
          });

          jsonDocs.documentDto.forEach((item) => {
            item.Time = 0;
            var jsonOpenRecords = item.openRecords.filter(
              (records) =>
                records.activityTime !== undefined &&
                (records.event == "Opened" || records.event == null)
            );
            jsonOpenRecords
              .map((timeCalc) => timeCalc.activityTime)
              .reduce((accTime, timeCalc) => {
                return (item.Time = timeCalc + accTime);
              }, 0);
          });

          jsonDocs.documentDto.forEach((item) => {
            item.activityTimess = 0;
            var jsonOpenRecordsTrackActivity = [];
            if (
              item.documentOptions.recipients.length > 0 &&
              item.openRecords.length > 0
            ) {
              item.documentOptions.recipients.map(
                (recpList, j) =>
                (jsonOpenRecordsTrackActivity = item.openRecords.filter(
                  (records) =>
                    records.email !== null &&
                    records.activityTime !== undefined &&
                    (records.event == "Opened" || records.event == null) &&
                    recpList.email != null &&
                    records.email.toString().toLowerCase() ===
                    recpList.email.toString().toLowerCase()
                ))
              );
              jsonOpenRecordsTrackActivity
                .map((timeCalc) => timeCalc.activityTime)
                .reduce((accTime, timeCalc) => {
                  return (item.activityTimess = timeCalc + accTime);
                }, 0);
            }
          });

          if (
            lstDocumentsHistory.length > 0 &&
            jsonDocs.documentDto.length > 0 &&
            jsonDocs.documentDto[0].documentId !==
            lstDocumentsHistory[0].documentId
          ) {
            dataUpdated = true;
          }
          const updatedList = jsonDocs.documentDto.map(itemB => {
            const match = lstDocumentsHistory.find(itemA => itemA.documentId === itemB.documentId);
            return {
              ...itemB,
              activeTabName: (match && otherAction != 0) ? match.activeTabName : "Control_Status"
            };
          });

          if (jsonDocs.iskilledVar === true) {
            if (jsonDocs.totalCount > 0) {
              setLstKilledDocuments(updatedList);
              setLstDocumentsHistory([]);
            } else {
              setNoRecordsFound(true);
              setLstDocumentsHistory([]);
              setLstKilledDocuments([]);
            }
          } else {
            setLstDocumentsHistory(updatedList);
            setLstKilledDocuments([]);
            const docDetails = JSON.parse(JSON.stringify(updatedList));
            orderTrackInteractivityAndActivityLogDetails(docDetails);
          }
          setOpen(false);
          setOpenLoaderSearch(false);
          if (dataUpdated) {
            setIsUpdated(true);
          } else {
            setIsUpdated(false);
          }
        } catch (error) {
          setOpen(false);
          setOpenLoaderSearch(false);
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_FailedtoLoadDoc + "."
          );
          setAlertType("warning");
          return;
        }
      };
      startFetching();
    } catch (error) {
      console.log("error: " + error);
    }
  }
  async function ShowHistoryIconToAllRecords(Docid) {
    try {
      const url =
        `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_HandleToShowHistoryIcon
        }` +
        "/" +
        Docid;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        return jsonDocs.isHistoryRecordsExists;
      }
    } catch (error) {
      setOpen(false);
      console.log("error: " + error);
    }
  }

  async function handleToShowHistoryIcon(event, Docid) {
    try {
      if (event.target.closest("tr").className == "view open") {
        //setOpen(true);
        const url =
          `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_HandleToShowHistoryIcon
          }` +
          "/" +
          Docid;
        var jsonDocs = await APIRequest.GET("", url);
        if (jsonDocs && jsonDocs === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (
          jsonDocs.errorMessage != undefined &&
          jsonDocs.errorMessage != ""
        ) {
          setAlertMsg(jsonDocs.errorMessage);
          setAlertType("warning");
          setOpen(false);
          return;
        } else {
          setLstDocumentsHistory(
            lstDocumentsHistory.map((element, i) => {
              if (element.documentId == Docid) {
                element.isHistoryRecordsExists =
                  jsonDocs.isHistoryRecordsExists;

                return { ...element };
              } else {
                return { ...element };
              }
            })
          );
        }
      }
    } catch (error) {
      setOpen(false);
      console.log("error: " + error);
    }
  }
  //  let results = trackInteractivityDetails?.trackInteractivityData.map((item)=>item.pageNumber).filter((reader) =>
  //   JSON.stringify(reader).toLowerCase().includes(search.toLowerCase())
  // );
  const ReadertrackInteractivityDetails = useRef([]);
  const activityLogDetailsRef = useRef([]);
  useEffect(() => {
    if (search === "") {
      // If search is cleared, restore original data
      setTrackInteractivityDetails((prev) =>
        prev.map((doc) => ({
          ...doc,
          records: doc.records.map((reader) => ({
            ...reader,
            trackInteractivityData: ReadertrackInteractivityDetails.current,
          })),
        }))
      );
    } else {
      // Filter by page number
      setTrackInteractivityDetails((prev) =>
        prev.map((doc) => ({
          ...doc,
          records: doc.records.map((reader) => ({
            ...reader,
            trackInteractivityData: ReadertrackInteractivityDetails.current.filter(
              (item) =>
                item.pageNumber
                  ?.toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())
            ),
          })),
        }))
      );
    }
  }, [search]);

  useEffect(() => {
    if (searchActivityLog === "") {
      setActivityLogDetails((prev) =>
        prev.map((doc) => ({
          ...doc,
          records: doc.records.map((reader) => ({
            ...reader,
            activityLogData: activityLogDetailsRef.current,
          })),
        }))
      );
    } else {
      setActivityLogDetails((prev) =>
        prev.map((doc) => ({
          ...doc,
          records: doc.records.map((reader) => ({
            ...reader,
            activityLogData: activityLogDetailsRef.current.filter(
              (item) =>
                item.pageNumber
                  ?.toString()
                  .toLowerCase()
                  .includes(searchActivityLog.toLowerCase())
            ),
          })),
        }))
      );
    }
  }, [searchActivityLog]);


  async function GetActivityLogRowData(DocId, openId) {
    if (AppContext.IsReaderStatsEnabled == true) {
      setOpen(true);
      const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${DocId}`;
      const params = new URLSearchParams();

      if (openId) params.append("openRecordId", openId);
      params.append("IsStats", "false");
      const url = `${baseUrl}?${params.toString()}`;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        const uniquePages = new Set(jsonDocs.map(item => item.pageNumber));
        const totalPages = uniquePages.size;
        const totalSeconds = jsonDocs.reduce((total, item) => {
          const hours = (item.totalHours || 0) * 3600;
          const minutes = (item.totalMinutes || 0) * 60;
          const seconds = item.totalSeconds || 0;
          return total + hours + minutes + seconds;
        }, 0);
        const totalDuration = convertToHHMMSS(totalSeconds);
        activityLogDetailsRef.current = jsonDocs;

        console.log(activityLogDetails);

        setActivityLogDetails(prev =>
          prev.map(doc =>
            doc.docId === DocId
              ? {
                ...doc,
                records: doc.records.map(reader =>
                  reader.id === openId
                    ? {
                      ...reader,
                      activityLogData: jsonDocs,
                      TotalPagesviewed: (reader.event !== "Auto Lock" && reader.event !== "Restricted") ? totalPages : 0,
                      timeFormatted: (reader.event !== "Auto Lock" && reader.event !== "Restricted") ? totalDuration : 0,
                      totalPageViewed: (reader.event !== "Auto Lock" && reader.event !== "Restricted") ? totalPages : 0,
                      open: true
                    }
                    : reader
                ),
              }
              : doc
          )
        );
        setOpen(false);
      }
    }
  }

  async function TrackIntereactivityrowclickDta(DocId, Email) {
    if (AppContext.IsReaderStatsEnabled == true) {
      setOpen(true);
      const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${DocId}`;
      const params = new URLSearchParams();

      if (Email) params.append("emailAdress", Email);
      params.append("IsStats", "false");
      const url = `${baseUrl}?${params.toString()}`;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        setTrackInteractivityDetails((prev) =>
          prev.map((doc) => {
            if (doc.docId === DocId) {
              return {
                ...doc,
                records: doc.records.map((reader) => {
                  if (reader.email && Email && reader.email.toLowerCase() === Email.toLowerCase()) {
                    ReadertrackInteractivityDetails.current = jsonDocs;

                    let totalHours = 0;
                    let totalMinutes = 0;
                    let totalSeconds = 0;

                    if (Array.isArray(jsonDocs)) {
                      jsonDocs.forEach((item) => {
                        totalHours += Number(item.totalHours) || 0;
                        totalMinutes += Number(item.totalMinutes) || 0;
                        totalSeconds += Number(item.totalSeconds) || 0;
                      });

                      totalMinutes += Math.floor(totalSeconds / 60);
                      totalSeconds %= 60;

                      totalHours += Math.floor(totalMinutes / 60);
                      totalMinutes %= 60;
                    }

                    const totalTimeFormatted = `${String(totalHours).padStart(2, "0")}:${String(totalMinutes).padStart(2, "0")}:${String(totalSeconds).padStart(2, "0")}`;

                    return {
                      ...reader,
                      trackInteractivityData: jsonDocs,
                      totalTime: totalTimeFormatted,
                    };
                  }
                  return reader;
                }),
              };
            }
            return doc;
          })
        );

        setOpen(false);
      }
    }
  }

  function killedrowclick(event, DocId) {
    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
    if (
      event.target.className !== "cr-icon material-icons" &&
      event.target.className !== "p-0 mb-0" &&
      event.target.type !== "checkbox"
    ) {
      for (let i = 0; i < lstKilledDocuments.length; i++) {
        if (lstKilledDocuments[i].documentId === DocId) {
          setLstKilledDocuments(
            lstKilledDocuments.map((element) => {
              if (element.documentId == DocId) {
                element.open = element.open == true ? false : true;
              }
              return element;
            })
          );
          lstKilledDocuments[i].docSelected = true;
          break;
        }
      }
    }
  }

  function rowclick(event, DocId) {

    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
    if (
      event.target.className !== "cr-icon material-icons" &&
      event.target.className !== "p-0 mb-0" &&
      event.target.type !== "checkbox"
    ) {
      handleToShowHistoryIcon(event, DocId);
      for (let i = 0; i < lstDocumentsHistory.length; i++) {
        if (
          lstDocumentsHistory[i].documentId === DocId &&
          trRef.current[i].classList.contains("open")
        ) {
          lstDocumentsHistory[i].docSelected = true;
          // setSecurityLevel2((lstDocumentsHistory[i].documentOptions.distRestriction==false && lstDocumentsHistory[i].documentOptions.readerEmail == true) ? true : false);
          break;
        } else if (
          lstDocumentsHistory[i].documentId === DocId &&
          !trRef.current[i].classList.contains("open")
        ) {
          lstDocumentsHistory[i].docSelected = false;
          // setSecurityLevel2((lstDocumentsHistory[i].documentOptions.distRestriction==false && lstDocumentsHistory[i].documentOptions.readerEmail == true) ? true : false);
          break;
        }
      }
    }
  }
  const orderedFilters = Object.entries(customFilterOptionsArray)
    .filter(([_, value]) => value?.visible)
    .sort((a, b) => a[1].order - b[1].order);
  const killedFilterComponents = {
    documentId: (
      <input
        className="res-controls SearchFiledsFileAndDocId manage-control height-42p"
        type="text"
        autoComplete="none"
        value={documentIdInput}
        title={documentIdInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_DocumentID}
        onChange={(e) => setDocumentIdInput(e.target.value)}
      />
    ),

    owner: (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={ownerInput}
        title={ownerInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_Owner}
        onChange={(e) => setOwnerInput(e.target.value)}
      />
    ),

    fileName: (
      <input
        className="res-controls SearchFiledsFileAndDocId height-42p"
        type="text"
        autoComplete="none"
        value={docNameSearch}
        title={
          docNameSearch !== ""
            ? docNameSearch
            : `${selectedLanguage.LstLanguageCodes.UI_File}/${selectedLanguage.LstLanguageCodes.UI_DocumentName}/${selectedLanguage.LstLanguageCodes.UI_SizeKB}`
        }
        placeholder={`${selectedLanguage.LstLanguageCodes.UI_File}/${selectedLanguage.LstLanguageCodes.UI_DocumentName}/${selectedLanguage.LstLanguageCodes.UI_SizeKB}`}
        onChange={(e) => setDocNameSearch(e.target.value)}
      />
    ),

    killedBy: (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={KilledByInput}
        title={KilledByInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_KilledBy}
        onChange={(e) => SetKilledByInput(e.target.value)}
      />
    ),

    accessControl: (
      <div className="SearchFiels-select">
        <select
          className="form-select form-control res-controls custom-inputBorder"
          value={accessControlDrp}
          onChange={(e) => setAccessControlDrp(e.target.value)}
        >
          <option value="">
            {selectedLanguage.LstLanguageCodes.UI_AccessControl}
          </option>
          <option value="Track Views">
            {selectedLanguage.LstLanguageCodes.UI_TrackViews}
          </option>
          <option value="Track Readers">
            {selectedLanguage.LstLanguageCodes.UI_TrackReaders}
          </option>
          <option value="Limit Readers">
            {selectedLanguage.LstLanguageCodes.UI_LimitReaders}
          </option>
        </select>
      </div>
    ),

    status: (
      <div className="SearchFiels-select">
        <select
          className="form-select form-control res-controls custom-inputBorder"
          value={status}
          onChange={handleStatusChange}
        >
          <option value="">
            {selectedLanguage.LstLanguageCodes.UI_Status}
          </option>
          <option value="Active">
            {selectedLanguage.LstLanguageCodes.UI_Active}
          </option>
          <option value="Expired">
            {selectedLanguage.LstLanguageCodes.UI_Expired}
          </option>
          {!isFolderViewselected && (
            <option value="Killed">
              {selectedLanguage.LstLanguageCodes.UI_Killed}
            </option>
          )}
        </select>
      </div>
    ),
  };


  const filterComponents = {
    isDocumentId: (
      <input
        className="res-controls SearchFiledsFileAndDocId manage-control height-42p"
        type="text"
        autoComplete="none"
        value={documentIdInput}
        title={documentIdInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_DocumentID}
        onChange={(e) => setDocumentIdInput(e.target.value)}
      />
    ),

    isOwner: isKilledOpt === true && (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={ownerInput}
        title={ownerInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_Owner}
        onChange={(e) => setOwnerInput(e.target.value)}
      />
    ),

    isSubject: isKilledOpt !== true && (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={subjectInput}
        title={
          subjectInput !== ""
            ? subjectInput
            : `${selectedLanguage.LstLanguageCodes.UI_Subject}/${selectedLanguage.LstLanguageCodes.UI_Description}`
        }
        placeholder={`${selectedLanguage.LstLanguageCodes.UI_Subject}/${selectedLanguage.LstLanguageCodes.UI_Description}`}
        onChange={(e) => setSubjectInput(e.target.value)}
      />
    ),

    isFileName: (
      <input
        className="res-controls SearchFiledsFileAndDocId height-42p"
        type="text"
        autoComplete="none"
        value={docNameSearch}
        title={
          docNameSearch !== ""
            ? docNameSearch
            : `${selectedLanguage.LstLanguageCodes.UI_File}/${selectedLanguage.LstLanguageCodes.UI_DocumentName}/${selectedLanguage.LstLanguageCodes.UI_SizeKB}`
        }
        placeholder={`${selectedLanguage.LstLanguageCodes.UI_File}/${selectedLanguage.LstLanguageCodes.UI_DocumentName}/${selectedLanguage.LstLanguageCodes.UI_SizeKB}`}
        onChange={(e) => setDocNameSearch(e.target.value)}
      />
    ),

    isKilledBy: isKilledOpt === true && (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={KilledByInput}
        title={KilledByInput}
        placeholder={selectedLanguage.LstLanguageCodes.UI_KilledBy}
        onChange={(e) => SetKilledByInput(e.target.value)}
      />
    ),

    isReaderEmail: isKilledOpt !== true && (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={receipentInput}
        title={
          receipentInput ||
          selectedLanguage.LstLanguageCodes.UI_ReaderEmail
        }
        placeholder={selectedLanguage.LstLanguageCodes.UI_ReaderEmail}
        onChange={(e) => setRecepientInput(e.target.value)}
      />
    ),

    isDomains: isKilledOpt !== true && (
      <input
        className="res-controls SearchFiels height-42p"
        type="text"
        autoComplete="none"
        value={domainSearch}
        title={selectedLanguage.LstLanguageCodes.UI_Domains}
        placeholder={selectedLanguage.LstLanguageCodes.UI_Domains}
        onChange={(e) => setDomainSearch(e.target.value)}
      />
    ),

    isAccessControl: (
      <div className="SearchFiels-select">
        <select
          className="form-select form-control res-controls custom-inputBorder"
          value={accessControlDrp}
          onChange={(e) => setAccessControlDrp(e.target.value)}
        >
          <option value="">
            {selectedLanguage.LstLanguageCodes.UI_AccessControl}
          </option>
          <option value="Track Views">
            {selectedLanguage.LstLanguageCodes.UI_TrackViews}
          </option>
          <option value="Track Readers">
            {selectedLanguage.LstLanguageCodes.UI_TrackReaders}
          </option>
          <option value="Limit Readers">
            {selectedLanguage.LstLanguageCodes.UI_LimitReaders}
          </option>
        </select>
      </div>
    ),

    isTemplates: isKilledOpt !== true && (
      <div className="SearchFiels-select">
        <select
          className="form-select form-control res-controls  custom-inputBorder"
          value={selectedTemplate}
          onChange={(e) => handletemplatechange(e.target.value)}
        >
          <option value="">
            {selectedLanguage.LstLanguageCodes.UI_ApplyTemplate}
          </option>
          {docTemplateOptions?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    ),

    isLaunches: isKilledOpt !== true && (
      <div
        className="SearchFiels-select custom-date-wrapper"
        style={{ position: "relative", marginTop: "-15px" }}
      >
        <DatePicker
          selected={selectedLaunchDate}
          onChange={(date) => handleLaunchChange(date)}
          dateFormat={dateFormatValueOriginal}   // date only
          placeholderText={selectedLanguage.LstLanguageCodes.UI_Launches}
          title={selectedLanguage.LstLanguageCodes.UI_Launches}
          className="form-control DatePickerCusror custom-inputBorder"
          popperPlacement="bottom-start"
          onKeyDown={(e) => {
            if (e.key === "Backspace" || e.key === "Delete") {
              e.preventDefault();
              handleLaunchChange(null);
            } else {
              e.preventDefault();
            }
          }}
        />
      </div>
    ),

    isExpires: isKilledOpt !== true && (
      <div
        className="SearchFiels-select custom-date-wrapper expiresDateWrapper"
        style={{ position: "relative", marginTop: "-15px" }}
      >
        <DatePicker
          selected={selectedExpiryDate}
          onChange={(date) => handleExpiryChange(date)}
          dateFormat={dateFormatValueOriginal}   // date only
          placeholderText={selectedLanguage.LstLanguageCodes.UI_Expires}
          title={selectedLanguage.LstLanguageCodes.UI_Expires}
          className="form-control DatePickerCusror custom-inputBorder"
          popperPlacement="bottom-start"
          onKeyDown={(e) => {
            if (e.key === "Backspace" || e.key === "Delete") {
              e.preventDefault();
              handleExpiryChange(null);
            } else {
              e.preventDefault();
            }
          }}
        />
      </div>
    ),

    isStatus: (
      <div className="SearchFiels-select">
        <select
          className="form-select form-control res-controls custom-inputBorder"
          value={status}
          onChange={handleStatusChange}
        >
          <option value="">
            {selectedLanguage.LstLanguageCodes.UI_Status}
          </option>
          <option value="Active">
            {selectedLanguage.LstLanguageCodes.UI_Active}
          </option>
          <option value="Expired">
            {selectedLanguage.LstLanguageCodes.UI_Expired}
          </option>
          {!isFolderViewselected && (
            <option value="Killed">
              {selectedLanguage.LstLanguageCodes.UI_Killed}
            </option>
          )}
        </select>
      </div>
    ),
  };


  const handleAccessManagement = () => {
    openLoaderFolder = false;
    sortDown.current = true;
    setSortBy("desc");
    setIsAccessManagement(true);
    setIsAllItems(false);
    setIsFolderViewselected(false);
    setActiveTabName("AccessManagement");
    setIsTrackKillHeader(false);
    getCustomColumns(false);
    setIsKilledOpt(false);
    resetKilledFlag = false;
  };
  function sorting(event, sortedColumn) {
    setSortColumn(sortedColumn);
    setCurrentPage(1);
    setSortBy("desc");
    if (sortColumn.toLowerCase() == sortedColumn) sortDown.current = !sortDown.current;
    else sortDown.current = true;
    if (sortDown.current) {
      setSortBy("desc");
      documentsList("desc", 0, 0, 0, sortedColumn);
    } else {
      setSortBy("asc");
      documentsList("asc", 0, 0, 0, sortedColumn);
    }
  }
  const borderleft = {
    borderLeft: "0.1rem solid #e7e5e570",
  };

  const borderLeftBottom = {
    borderLeft: "0.1rem solid #e7e5e570",
    borderBottom: "0.1rem solid #e7e5e570",
  };
  function handlerClickKill(event) {
    if (killNotes == null || killNotes.trim() == "") {
      setAlertMsg("Please enter reason to continue.");
      setAlertType("warning");
      return;
    }
    if (
      lstDocumentsHistory.filter((element) => element.selection === true)
        .length > 0
    ) {
      setModalIsOpen(true);
      setModalIsOpenKillNote(false);
    } else {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
      return;
    }
  }
  function handlerClickKillNote(event) {
    if (
      lstDocumentsHistory.filter((element) => element.selection === true)
        .length > 0
    ) {
      setModalIsOpenKillNote(true);
      setKillNotes("");
    } else {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    }
  }
  function handlerMoveModelCancel() {
    setModalIsMoveFolderOpen(false);
    setDDLFolderId("");
    document.body.style.overflowY = "visible";
  }
  function handlerMoveConfirmOpen() {
    if (ddlfolderId == 0 || ddlfolderId == "") {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FolderSelection + ".");
      setAlertType("warning");
      return;
    }
    setmodalIsMoveConfirmOpen(true);
  }

  function OpenMoveModalPopUp() {
    let isMoveRPDRecords = true;
    lstDocumentsHistory.map((item) => {
      if (canMoveRPDRecords.current.includes(item.ownerId) && item.selection) {
        isMoveRPDRecords = false;
      }
    });
    if (!isMoveRPDRecords) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_OnlyOwnerCanMoveRPDs);
      setAlertType("warning");
      return;
    }
    setddlSelectedfolderName("");
    if (
      lstDocumentsHistory.filter((element) => element.selection === true)
        .length > 0 &&
      foldersDetailsLst.length > 0
    ) {
      setModalIsMoveFolderOpen(true);
      document.body.style.overflowY = "hidden";
    } else {
      if (foldersDetailsLst.length == 0) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FailedToMoveRPDsInFolder + "."
        );
        setAlertType("warning");
      } else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FailedToMoveRPDs + "."
        );
        setAlertType("warning");
      }
    }
  }
  function OpenCreateFolderModalPopUp() {
    setModalIsCreateFolderOpen(true);
    setfolderName("");
    setFolderNameText("");
    setSelectedOption("0");
    setChildUserData([]);
    setFolderId("");
    document.body.style.overflowY = "hidden";
  }
  function handlerDeleteModelCancel() {
    setModalIsDeleteOpen(false);
    setModalIsManageFolderOpen(false);
    document.body.style.overflowY = "visible";
  }
  const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true
  };
  function handlerUpdateModelCancel() {
    setModalIsUpdateconfirmOpen(false);
    setModalIsManageFolderOpen(false);
    isUserPopupopen = false;
    document.body.style.overflowY = "visible";
  }
  function handlerConfirmMoveModelCancel() {
    setModalIsMoveFolderOpen(false);
    setmodalIsMoveConfirmOpen(false);
    setDDLFolderId("");
    document.body.style.overflowY = "visible";
  }
  const handleManageCloseModal = () => {
    setModalIsManageFolderOpen(false);
    document.body.style.overflowY = "visible";
  };
  const handleTermofServiceCloseModal = () => {
    setModalTermsOfServicePopup(false);
    document.body.style.overflowY = "visible";
  };
  function handlerCreatefolderModelCancel() {
    setModalIsCreateFolderOpen(false);
    setfolderName("");
    setFolderNameText("");
    document.body.style.overflowY = "visible";
  }
  function handleCreatefolderChange(event) {
    if (event.target.value == "" || event.target.value == "0") {
      //setfolderName("");
      setFolderNameText("");
    } else if (event.target.value.length > 20) {
      event.preventDefault();
    } else {
      //setfolderName(event.target.value);
      setFolderNameText(event.target.value);
    }
  }
  function handlerUserModelCancel() {
    setModalIsUserPopupOpen(false);
  }
  function handlerModelCancel() {
    setModalIsOpen(false);
  }
  function handlerModelCancelActive() {
    setModalActiveIsOpen(false);
  }
  function handlerModelCancelForAddUser() {
    setModalForAddUser(false);
    setPopupDocumentId("");
    setInputFields([
      {
        email: "",
        firstName: "",
        lastName: "",
        mobileCountryCode: [],
        mobileNumber: "",
      },
    ]);
  }
  function handlerModelCancelForManageUser() {
    letMePickCancelRef.current = true;
    setModalForManageUser(false);
  }
  function handlerCustomColumnLayoutCancel() {
    setCustomColumnLayoutFlag(false);
  }
  const getLabelWithTimeZone = (label, selectedLanguage, timeZoneAbbrevation) => {
    const tz = timeZoneAbbrevation?.current
      ? ` (${timeZoneAbbrevation.current})`
      : "";

    if (label === selectedLanguage.LstLanguageCodes.UI_Created)
      return selectedLanguage.LstLanguageCodes.UI_Created + tz;

    if (label === selectedLanguage.LstLanguageCodes.UI_Launches)
      return selectedLanguage.LstLanguageCodes.UI_Launches + tz;

    if (label === selectedLanguage.LstLanguageCodes.UI_Expires)
      return selectedLanguage.LstLanguageCodes.UI_Expires + tz;

    return label;
  };
  async function getCustomColumns(isKill) {
    try {
      if (!isKill) {
        const url =
          `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetCustomColumnSettings
          }` +
          "?userEmail=" +
          localStorage.getItem("UserName");
        var jsonDocs = await APIRequest.GET("", url);
        if (jsonDocs && jsonDocs === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (
          jsonDocs.errorMessage != undefined &&
          jsonDocs.errorMessage != ""
        ) {
          setAlertMsg(jsonDocs.errorMessage);
          setAlertType("warning");
          setOpen(false);
          return;
        } else {
          let gridColumns;
          if (jsonDocs.lstCustomColumns) {
            gridColumns = jsonDocs.lstCustomColumns.columns;
            let updatedSortedColumns = defaultGridColumns.map(ele => {
              let gridColumn = gridColumns.find(x => x.name === ele.name);
              if (gridColumn) {
                return {
                  ...ele,
                  label: getLabelWithTimeZone(
                    ele.label,
                    selectedLanguage,
                    timeZoneAbbrevation
                  ),
                  active: gridColumn.isHeaderColumn,
                  order: gridColumn.order
                };
              }
              return { ...ele };
            }).sort((a, b) => a.order - b.order);
            setSortedColumns(updatedSortedColumns);
          }
          else {
            const updatedDefaultColumns = defaultGridColumns.map(ele => ({
              ...ele,
              label: getLabelWithTimeZone(
                ele.label,
                selectedLanguage,
                timeZoneAbbrevation
              )
            }));
            setSortedColumns(updatedDefaultColumns);
          }
        }
      }
      else {
        setSortedColumns(killGridColumns);
      }
    }
    catch (error) {
      console.log("error: " + error);
    }
    finally {

    }
  }
  async function handlerCustomColumnLayoutConfirm(list, hasChange) {
    try {
      if (hasChange) {
        const url =
          `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_AddorUpdateCustomColumnSettings
          }`;
        let lstTableColumnSettings = {};
        lstTableColumnSettings.TableName = "ManageList";
        lstTableColumnSettings.Columns = [];

        console.log(list);
        list.map(ele => {
          if (ele.name != "checkbox" && ele.name != "type")
            lstTableColumnSettings.Columns.push({
              Name: ele.name,
              Order: ele.order,
              IsHeaderColumn: ele.active
            })
        }
        );
        var jsonDocs = await APIRequest.POSTSave(
          lstTableColumnSettings,
          url
        );
        if (jsonDocs && jsonDocs === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (
          jsonDocs.errorMessage != undefined &&
          jsonDocs.errorMessage != ""
        ) {
          setAlertMsg(jsonDocs.errorMessage);
          setAlertType("warning");
          setOpen(false);
          return;
        } else {
          let gridColumns;
          if (jsonDocs.lstCustomColumns)
            gridColumns = jsonDocs.lstCustomColumns.columns;
          const updatedSortedColumns = sortedColumns?.map(ele => {
            const gridColumn = gridColumns.find(x => x.name === ele.name);
            return gridColumn
              ? { ...ele, active: gridColumn.isHeaderColumn, order: gridColumn.order }
              : ele;
          }).sort((a, b) => a.order - b.order);

          setSortedColumns(updatedSortedColumns);
          setCustomColumnLayoutFlag(false);
        }
      }
      else {
        setCustomColumnLayoutFlag(false);
      }
    }
    catch (error) {
      console.log("error: " + error);
    }
    finally {

    }

  }

  function handlerModelCancelForControlStatus() {
    let itemDocumentsHistory = lstDocumentsHistory.find((element) => element.documentId == popupDocumentId);
    setRecipientPrintData(JSON.parse(JSON.stringify(itemDocumentsHistory.documentOptions.recipients)));
    setModalForControlStatus(false);
    setPopupDocumentId("");
    setSelectionOfRestriction([]);
    setDeleteSelectionOfRestriction([]);
  }
  function handlerIntialRecipient(e) {
    e.stopPropagation();
  }
  async function handleReceiptsAdd(e) {
    setModalForAddUser(true);
    setPopupDocumentId(e);
    const itemDocumentsHistory = lstDocumentsHistory.find((item) => (item.documentId === e));
    const enablePrint = itemDocumentsHistory?.documentOptions?.print && itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone;
    setPrintEnabledType(itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone === true ? "everyone" : "selectedUsers");
    setPrint(itemDocumentsHistory?.documentOptions?.print ?? false);
    setInputFields([
      {
        email: "",
        firstName: "",
        lastName: "",
        authType: "",
        mobileCountryCode: [],
        mobileNumber: "",
        reference: "",
        canPrint: enablePrint,
        maxPrintsPerReader: enablePrint ? (itemDocumentsHistory?.documentOptions?.maxPrintsPerReader ?? "") : ""
      }
    ]);
    if (itemDocumentsHistory) {
      if (itemDocumentsHistory.documentOptions.isBoth || (itemDocumentsHistory.documentOptions.isEmail === true && itemDocumentsHistory.documentOptions.isSMS === true)) {
        const emailOption = [
          { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
        ];

        const newOption = {
          value: "text",
          label: selectedLanguage.LstLanguageCodes.UI_Text,
        };

        // Add only if it doesn't already exist
        const newSelected = emailOption.some(
          (option) => option.value === newOption.value
        )
          ? emailOption
          : [...emailOption, newOption];

        setSelectedOptions(newSelected);
        verificationOptions.current = [
          { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
          { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
          { value: "both", label: selectedLanguage.LstLanguageCodes.UI_Both },
        ];
      } else if (itemDocumentsHistory.documentOptions.isSMS) {
        const textOption = {
          value: "text",
          label: selectedLanguage.LstLanguageCodes.UI_Text,
        };
        setSelectedOptions([textOption]);
        verificationOptions.current = [
          { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
        ];

      } else {
        const emailOption = [
          { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
        ];
        setSelectedOptions(emailOption);
        verificationOptions.current = [
          { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
        ];
      }
    }
    await fetchCountryCodes(e);
  }

  function handlermodalForDocumentHistory() {
    document.body.style.overflow = "unset";
    setmodalForDocumentHistory(false);
  }
  async function handleDocumentHistory(e) {
    setOpen(true);
    const url =
      `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetDocumentHistory
      }` +
      "/" +
      e;
    // PageLevelVersionHistoryData(e);`
    var jsonDocs = await APIRequest.GET("", url);
    if (jsonDocs && jsonDocs === "Server maintenance") {
      history("/maintenance");
      return;
    } else if (
      jsonDocs.errorMessage != undefined &&
      jsonDocs.errorMessage != ""
    ) {
      setAlertMsg(jsonDocs.errorMessage);
      setAlertType("warning");
      setOpen(false);
      return;
    }
    setPageLevelVersionHistory(
      jsonDocs.objPageLevelRestrictionsHistoryDtoWrapper
    );
    allApprovedAccessRequests.current = jsonDocs.pageLevelRequestAccessHistory || [];
    setApprovedAccessRequestsForPopup(jsonDocs.pageLevelRequestAccessHistory || []);
    jsonDocs.documentDto.map(
      (item, i) =>
      (item.securityLevel = item.documentOptions.distRestriction
        ? 3
        : item.documentOptions.readerEmail
          ? 2
          : 1)
    );
    jsonDocs.documentDto.forEach((item) => {
      var staticRegions = continents,
        savedRegions = item.documentOptions.regions,
        resRegions = staticRegions && staticRegions.filter(
          (item) => savedRegions && !savedRegions.includes(item.id)
        );
      var strRegions = "";
      resRegions && resRegions.forEach((region) => {
        if (strRegions === "") strRegions = region.continentName;
        else strRegions += ", " + region.continentName;
      });
      item.regions = savedRegions && savedRegions.length == 0 ? "" : strRegions;
    });
    document.body.style.overflow = "hidden";

    setlstDocumentsHistoryDetails(jsonDocs.documentDto);
    setfileName(
      jsonDocs.documentDto[0].fileName.indexOf(".") > -1
        ? jsonDocs.documentDto[0].fileName?.split(".").slice(0, -1)
        : jsonDocs.documentDto[0].fileName
    );
    setmodalForDocumentHistory(true);
    setOpen(false);
  }


  const handleTermOfservicePopup = (htmlString) => {
    setTermsofServiceMessage(parse(
      DOMPurify.sanitize(he.decode(DOMPurify.sanitize(he.decode(htmlString))))
    ));
    setModalTermsOfServicePopup(true);
    document.body.style.overflowY = "hidden";
  }
  const handleVersionHisrtyPageLevel = (historyId) => {
    // Normalize so that null / undefined / "" all compare equal. The current (live) version
    // carries a null id on both the document version and its live access requests.
    const normalizeId = (value) =>
      value === undefined || value === null || value === "" ? null : value;
    const targetHistoryId = normalizeId(historyId);

    setIsPageLevelViewPopup(true);
    setmodalForDocumentHistory(false);

    // Page-level restriction history for the selected version.
    let filteredRecord = (PageLevelVersionHistory || []).filter(
      (item) => normalizeId(item.documentHistoryId) === targetHistoryId
    );
    let displayDate = filteredRecord[0]?.updatedDate;

    // Some document versions are created by access-request approvals (not restriction edits),
    // so they have no restriction wrapper of their own and the match above is empty. The
    // restriction config did not change at those versions - carry forward the most recent PRIOR
    // version's restriction state (change flags cleared) so the row shows the active restrictions
    // instead of going blank. The live/current version (null id) keeps its own wrapper.
    if (filteredRecord.length === 0) {
      const versions = lstDocumentsHistoryDetails || []; // ordered newest -> oldest
      const idx = versions.findIndex(
        (v) => normalizeId(v.id) === targetHistoryId
      );
      if (idx !== -1) {
        for (let j = idx + 1; j < versions.length; j++) {
          const priorId = normalizeId(versions[j].id);
          if (priorId === null) continue; // skip the live/current snapshot
          const priorWrapper = (PageLevelVersionHistory || []).filter(
            (item) => normalizeId(item.documentHistoryId) === priorId
          );
          if (priorWrapper.length > 0) {
            filteredRecord = priorWrapper.map((w) => ({
              ...w,
              pageLevelRestrictionHistoryDto: (
                w.pageLevelRestrictionHistoryDto || []
              ).map((d) => ({ ...d, isChanged: false, isDeleted: false })),
            }));
            const clickedVersion = versions[idx];
            displayDate =
              clickedVersion?.modified ||
              clickedVersion?.created ||
              filteredRecord[0]?.updatedDate;
            break;
          }
        }
      }
    }

    setPageLevelFilteredArr(filteredRecord);
    setLatestUpdatedTime(displayDate);

    // Approved access-request history for the selected version.
    // Historical snapshots carry a documentHistoryId; live/current requests have a null
    // documentHistoryId and belong to the current version (its id is also null), so we match
    // strictly on the normalized id instead of always including nulls on every version.
    // Filter from the full unmodified ref list — never from state, which gets overwritten.
    const filteredApproved = (allApprovedAccessRequests.current || []).filter((req) => {
      const reqHistId = normalizeId(req.documentHistoryId ?? req.DocumentHistoryId);
      const status = req.status || req.Status || "";
      const isApproved =
        status === "Approved" || status === "Partially Approved";
      return isApproved && reqHistId === targetHistoryId;
    });
    setApprovedAccessRequestsForPopup(filteredApproved);
  };

  const handleVersionHistoryCanPrint = (historyId) => {
    if (lstDocumentsHistoryDetails.length > 0) {
      setIsCanPrintViewPopup(true);
      setmodalForDocumentHistory(false);
      const filteredRecord = lstDocumentsHistoryDetails.filter(item => item.id === historyId);
      setCanPrintFilteredArr(filteredRecord || []);
      setLatestCanPrintUpdatedTime(filteredRecord[0]?.modified);
    }
  };

  const handleCloseCanPrintViewPopup = () => {
    setIsCanPrintViewPopup(false);
    setmodalForDocumentHistory(true);
  };

  const handleCloseVersionHisrtyPageLevel = () => {
    setIsPageLevelViewPopup(false);
    setmodalForDocumentHistory(true);
  };
  async function PageLevelVersionHistoryData(doccmentId) {
    try {
      const PagelevelVersionVar = null;
      const url = `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_GetPageRestrictionDetailsById
        }/${doccmentId}?PagelevelVersionVar=true`;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        setPageLevelVersionHistory(jsonDocs);
      }
    } catch (error) {
      console.log("error: " + error);
    }
  }
  function TrackIntereactivityrowclick(
    event,
    DocId,
    RecipientEmail,
    RecpIndex
  ) {
    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
    // setModalIsReaderActivityLogOpen(false);
    setIsReaderStatistics(false);
    if (
      event.target.className !== "cr-icon material-icons" &&
      event.target.className !== "p-0 mb-0" &&
      event.target.type !== "checkbox"
    ) {
      const updatedDetails = trackInteractivityDetails.map((record) => {
        if (record.docId === DocId) {
          record.records = record.records.map((rec) => {
            if (rec.email === RecipientEmail) {
              rec.open = rec.open === true ? false : true;
            }
            return rec;
          });
        }
        return record;
      });

      setTrackInteractivityDetails(updatedDetails);

      for (let i = 0; i < lstDocumentsHistory.length; i++) {
        if (lstDocumentsHistory[i].documentId === DocId) {
          lstDocumentsHistory[i].docSelected = true;
          break;
        }
      }
      if (RecipientEmail != null && RecipientEmail != undefined && RecipientEmail != "")
        TrackIntereactivityrowclickDta(DocId, RecipientEmail);
    }
  }
  function ActivityLogrowclick(event, DocId, OpenId, openIndex) {
    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
    // setModalIsReaderActivityLogOpen(false);
    if (
      event.target.className !== "cr-icon material-icons" &&
      event.target.className !== "p-0 mb-0" &&
      event.target.type !== "checkbox"
    ) {


      for (let i = 0; i < lstDocumentsHistory.length; i++) {
        if (lstDocumentsHistory[i].documentId === DocId) {
          lstDocumentsHistory[i].docSelected = true;
          break;
        }
      }
    }
    if (event.currentTarget.classList.contains('open') && OpenId != null && OpenId != undefined && OpenId != "") {
      GetActivityLogRowData(DocId, OpenId);
    }

  }
  function handleTimeZoneConversion(date, mode, offsetString) {
    if (!date) return "";

    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });

    switch (mode) {
      case "utcToLocal":
        return timeZoneConverter({
          mode: "utcToLocal",
          value: date,
          offsetString
        });

      case "localToFinal":
        return timeZoneConverter({
          mode: "localToFinal",
          value: date,
          offsetString
        });

      case "finalToUtc":
        return timeZoneConverter({
          mode: "finalToUtc",
          value: date,
          offsetString
        });

      default:
        return date;
    }
  }
  function timeZoneConverter({
    mode,            // "parseOffset" | "utcToLocal" | "localToFinal" | "finalToUtc"
    value,           // string (UTC) or Date object
    offsetString,    // "+05:30"
  }) {
    // --- Parse offset (always needed) ---
    let offsetMinutes = 0;
    if (offsetString) {
      const m = offsetString.match(/([+-])(\d{2}):(\d{2})/);
      if (m) {
        const sign = m[1] === "-" ? -1 : 1;
        const hh = parseInt(m[2], 10);
        const mm = parseInt(m[3], 10);
        offsetMinutes = sign * (hh * 60 + mm);
      }
    }

    // Return offsetMinutes directly
    if (mode === "parseOffset") return offsetMinutes;

    // Convert UTC → Local UI Date
    if (mode === "utcToLocal") {
      if (!value) return "";
      const utcDate = new Date(value);
      return new Date(utcDate.getTime() + offsetMinutes * 60000);
    }

    // Convert Local UI Date → FinalLocal
    if (mode === "localToFinal") {
      if (!value) return "";
      const localDate = value; // Date object
      return new Date(localDate.getTime() - offsetMinutes * 60000);
    }

    // Convert FinalLocal → UTC for backend
    if (mode === "finalToUtc") {
      if (!value) return "";
      const finalLocal = value; // Date object
      return new Date(finalLocal.getTime() + offsetMinutes * 60000).toISOString();
    }

    return "";
  }
  function handlecloseReaderStats() {
    setIsReaderStatistics(false);
  }
  const ReaderStatsClick = (localDocId, email) => {
    setIsReaderStatistics(true);
    setActiveEmail(email);
    setTrackDocumentId(localDocId);
  }
  const convertToHHMMSS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };
  async function handleEditReaderDetails(event, docid, recid) {
    event.stopPropagation();
    let countryCodes = countryCodeDrpOptions;
    if (countryCodeDrpOptions.length === 0) {
      countryCodes = await fetchCountryCodes();
    }
    setIsModalFnLnOpen(true);
    setPopupDocumentId(docid);
    let itemDocumentsHistory = lstDocumentsHistory.find(
      (element) => element.documentId == docid
    );
    setCurrentDocument(itemDocumentsHistory);
    setPrintEnabledType(itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone ? "everyone" : "selectedUsers");
    setPrint(itemDocumentsHistory?.documentOptions?.print ?? false);
    let filteredRecipient =
      itemDocumentsHistory.documentOptions.recipients.find(
        (localItem) => localItem.id == recid
      );
    if (filteredRecipient != undefined && filteredRecipient != null) {
      setFirstName(filteredRecipient.firstName.trim());
      setCurrentEmail(filteredRecipient.email);
      setLastName(filteredRecipient.lastName.trim());
      setCurrentRecipientId(filteredRecipient.id);
      setMobileNumber(filteredRecipient.mobileNumber);
      setReference(filteredRecipient.reference);
      setReaderPrint(filteredRecipient.canPrint);
      setMaxPrintsPerIndReader(filteredRecipient.maxPrintsPerReader);
      const filteredCountryCode =
        filteredRecipient.mobileCountryCode != "" &&
        countryCodes.find(
          (cc) => cc.value === filteredRecipient.mobileCountryCode
        );
      setSelectedCode(filteredCountryCode);
      const options = [
        { value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email },
        { value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text }
      ]
      if (itemDocumentsHistory.documentOptions.isBoth || (itemDocumentsHistory.documentOptions.isEmail && itemDocumentsHistory.documentOptions.isSMS)) {
        setSelectedOptions(options)
      } else if (itemDocumentsHistory.documentOptions.isEmail) {
        setSelectedOptions([{ value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email }])
      } else if (itemDocumentsHistory.documentOptions.isSMS) {
        setSelectedOptions([{ value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text }])
      }
      //verificationCodeRefValue.current = filteredRecipient.authType;
      setVerificationCode(filteredRecipient.authType);
    }
  }
  const handlePageLevelRestrictionCheck = async () => {
    {
      if (pageLevelResRef.current.checked) {
        setIsPageLevelRestrictionChecked(true);
        handlePageLevelRestrictionEdit();
      } else {
        setIsPageLevelRestrictionChecked(false);
        //setSelectionOfRestriction([]);
      }
    }
  };
  const handleEDisclosure = async () => {
    {
      if (EDisclosureResRef.current.checked) {
        setIsEDisclosureChecked(true);
        //handlePageLevelRestrictionEdit();
      } else {
        setIsEDisclosureChecked(false);
        //setSelectionOfRestriction([]);
      }
    }
  };
  const onCancelPageLevelRestriction = () => {
    pageLevelResModalRef.current.handleModal(false, [], [], []);
    selectionOfRestrictionCheckboxMaintanances.length == 0
      ? setIsPageLevelRestrictionChecked(false)
      : setIsPageLevelRestrictionChecked(true);
  };
  const onSavePageLevelRestriction = (
    restrictionData,
    deleteSelectionOfRestriction,
    updatedRequests
  ) => {
    isPageRestrictionsChanged = true;
    if (updatedRequests) {
      updatedApprovedRequests = updatedRequests;
    }
    if (restrictionData.length > 0 || deleteSelectionOfRestriction.length > 0) {
      pageLevelResModalRef.current.handleModal(false, [], [], []);
      // if (!restoreRestrictions.current){
      setSelectionOfRestriction(restrictionData);
      setDeleteSelectionOfRestriction(deleteSelectionOfRestriction);
      selectionOfRestrictionCheckboxMaintanances(deleteSelectionOfRestriction);
      // }
      const totalReaders = [
        ...new Set(
          restrictionData.reduce(
            (acc, current) => acc.concat(current.readers),
            []
          )
        ),
      ];
      recipientDetailsFromChaild(totalReaders);
    } else {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Atleastonerule);
      setAlertType("warning");
      return;
    }
  };

  function recipientDetailsFromChaild(data) {
    setChailedToParentRecipients(data);
    const readers = data.reduce((acc, i) => {
      return acc.concat(i);
    }, []);
  }

  async function GetPageLevelData(popupDocumentId) {
    let pagelevelDetails = [];
    const url =
      `${process.env.REACT_APP_API +
      process.env.REACT_APP_API_GetPageRestrictionDetailsById
      }` +
      "/" +
      popupDocumentId;
    var jsonDocs = await APIRequest.GET("", url);
    if (jsonDocs && jsonDocs === "Server maintenance") {
      history("/maintenance");
      return;
    } else if (
      jsonDocs.errorMessage != undefined &&
      jsonDocs.errorMessage != ""
    ) {
      setAlertMsg(jsonDocs.errorMessage);
      setAlertType("warning");
      setOpen(false);
      return;
    } else {
      //setChailedToParentRecipients(readers);
      pagelevelDetails.push(...jsonDocs?.objRestrictedReaders);
      approvedRequests = jsonDocs?.approvedAccessRequests || [];
      updatedApprovedRequests = [];
      isPageRestrictionsChanged = false;
      setSelectionOfRestrictionCheckboxMaintanances(pagelevelDetails);
      setSelectionOfRestriction(pagelevelDetails);
      pageLevelBckupDBData.current = pagelevelDetails;
      return {
        pagelevelDetails,
        approvedRequests
      };
    }
  }
  const handlePageLevelRestrictionEdit = async (IsEdit = false) => {
    setOpen(true);
    try {
      if (pageLevelResRef.current.checked) {
        let pageDetails = [];
        let pagelevelDetails = [];
        let itemDocumentsHistory = orgLstDocumentsHistory.find(
          (element) => element.documentId == popupDocumentId
        );
        let readers = itemDocumentsHistory.documentOptions.recipients.reduce(
          (acc, record) => {
            return acc.concat(record.email);
          },
          []
        );
        let recievers = [];
        if (constmultipleEmails.length == 0) {
          recievers = readers;
        } else {
          recievers = constmultipleEmails.reduce((acc, i) => {
            return acc.concat(i[0]);
          }, []);
        }
        const recipientsData =
          itemDocumentsHistory.documentOptions.recipients.reduce(
            (acc, record) => {
              return acc.concat(record);
            },
            []
          );
        pageDetails.push({
          DocumentName: itemDocumentsHistory.fileName,
          PageCount: pageCount,
          Documentid: popupDocumentId,
          RecipientList: recipientsData,
        });
        if (deleteSelectionOfRestriction.length > 0) {
          setSelectionOfRestrictionCheckboxMaintanances(
            deleteSelectionOfRestriction
          );
          pageLevelResModalRef.current.handleModal(
            pageLevelResRef.current.checked,
            chailedToParentRecipients.length > 0 && !IsEdit
              ? chailedToParentRecipients
              : readers,
            pageDetails ? pageDetails : [],

            selectionOfRestriction.length > 0
              ? (securityLevelTextColor === "level1") ? selectionOfRestriction.filter((item) => {
                if (item.category === "No Readers") {
                  return { ...item };
                }
              }) : selectionOfRestriction
              : (securityLevelTextColor === "level1") ? pagelevelDetails.filter((item) => {
                if (item.category === "No Readers") {
                  return { ...item };
                }
              }) : pagelevelDetails, approvedRequests,
            securityLevelTextColor == "level1" ? true : false
          );
        } else if (selectionOfRestriction.length > 0) {
          setSelectionOfRestrictionCheckboxMaintanances(selectionOfRestriction);
          pageLevelResModalRef.current.handleModal(
            pageLevelResRef.current.checked,
            chailedToParentRecipients.length > 0 && !IsEdit
              ? chailedToParentRecipients
              : recievers,
            pageDetails ? pageDetails : [],
            selectionOfRestriction.length > 0
              ? (securityLevelTextColor === "level1") ? selectionOfRestriction.filter((item) => {
                if (item.category === "No Readers") {
                  return { ...item };
                }
              }) : selectionOfRestriction
              : (securityLevelTextColor === "level1") ? pagelevelDetails.filter((item) => {
                if (item.category === "No Readers") {
                  return { ...item };
                }
              }) : pagelevelDetails, approvedRequests,
            securityLevelTextColor == "level1" ? true : false
          );
        } else {

          const url =
            `${process.env.REACT_APP_API +
            process.env.REACT_APP_API_GetPageRestrictionDetailsById
            }` +
            "/" +
            popupDocumentId;
          var jsonDocs = await APIRequest.GET("", url);
          if (jsonDocs && jsonDocs === "Server maintenance") {
            history("/maintenance");
            return;
          } else if (
            jsonDocs.errorMessage != undefined &&
            jsonDocs.errorMessage != ""
          ) {
            setAlertMsg(jsonDocs.errorMessage);
            setAlertType("warning");
            setOpen(false);
            return;
          } else {
            //setChailedToParentRecipients(readers);
            pagelevelDetails.push(...(jsonDocs?.objRestrictedReaders || []));
            approvedRequests = jsonDocs?.approvedAccessRequests || [];
            updatedApprovedRequests = [];
            isPageRestrictionsChanged = false;
            if (restoreRestrictions.current) {
              pagelevelDetails = [];
            }
            if (selectionOfRestriction.length > 0) {
              setSelectionOfRestrictionCheckboxMaintanances(
                selectionOfRestriction
              );
            } else if (deleteSelectionOfRestriction.length > 0) {
              setSelectionOfRestrictionCheckboxMaintanances(
                deleteSelectionOfRestriction
              );
            } else {
              setSelectionOfRestrictionCheckboxMaintanances(pagelevelDetails);
              setSelectionOfRestriction(pagelevelDetails);

            }
            if ((jsonDocs?.objRestrictedReaders || []).length == 0) {
              pageLevelResModalRef.current.handleModal(
                pageLevelResRef.current.checked,
                readers,
                pageDetails,
                selectionOfRestriction,
                approvedRequests,
                securityLevelTextColor == "level1" ? true : false
              );
            } else {
              pageLevelResModalRef.current.handleModal(
                pageLevelResRef.current.checked,
                chailedToParentRecipients.length > 0 && !IsEdit
                  ? chailedToParentRecipients
                  : recievers,
                pageDetails ? pageDetails : [],

                selectionOfRestriction.length > 0
                  ? (restoreRestrictions.current && securityLevelTextColor === "level1") ? selectionOfRestriction.filter((item) => {
                    if (item.category === "No Readers") {
                      return { ...item };
                    }
                  }) : selectionOfRestriction
                  : (restoreRestrictions.current && securityLevelTextColor === "level1") ? pagelevelDetails.filter((item) => {
                    if (item.category === "No Readers") {
                      return { ...item };
                    }
                  }) : pagelevelDetails, approvedRequests,
                securityLevelTextColor == "level1" ? true : false
              );
            }

          }
        }
      } else pageLevelResModalRef.current.handleModal(false, [], [], []);
      // restoreRestrictions.current = false;
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.log("error: " + error);
    }
  };
  function handleCloseFnLnModal() {
    setIsModalFnLnOpen(false);
  }
  function handleAddFnLn() {
    handlerModelConfirmForAddUser(true);
  }
  function handleControlStatus(e) {
    expireToActivePopup = 1;
    setModalForControlStatus(true);
    setPopupDocumentId(e);
    setConstMultipleEmails([]);
    GetPageLevelData(e);
    setSelectionOfRestriction([]);
    setDeleteSelectionOfRestriction([]);
    let itemDocumentsHistory = lstDocumentsHistory.find(
      (element) => element.documentId == e
    );
    setCurrentDocument(itemDocumentsHistory);
    var dtStartTime =
      itemDocumentsHistory.documentOptions.startTime != null
        ? new Date(itemDocumentsHistory.documentOptions.startTime)
        : null;
    var dtexpiryTime =
      itemDocumentsHistory.documentOptions.expiryTime != null
        ? new Date(itemDocumentsHistory.documentOptions.expiryTime)
        : null;
    let expTime = null;
    let strtTime = null;
    if (isDatetimeControl == "false") {
      strtTime = itemDocumentsHistory.documentOptions.startTime != null
        ? new Date(
          dtStartTime.getUTCFullYear(),
          dtStartTime.getUTCMonth(),
          dtStartTime.getUTCDate(),
          dtStartTime.getUTCHours(),
          dtStartTime.getUTCMinutes()
        )
        : null;
      expTime = itemDocumentsHistory.documentOptions.expiryTime != null
        ? new Date(
          dtexpiryTime.getUTCFullYear(),
          dtexpiryTime.getUTCMonth(),
          dtexpiryTime.getUTCDate(),
          dtexpiryTime.getUTCHours(),
          dtexpiryTime.getUTCMinutes()
        )
        : null;
      const localExpiryTime = handleTimeZoneConversion(expTime, "utcToLocal", timeZoneRef.current);
      const localStartTime = handleTimeZoneConversion(strtTime, "utcToLocal", timeZoneRef.current);
      setStartTime(localStartTime);
      setExpiryTime(localExpiryTime);
    } else {
      strtTime = itemDocumentsHistory.documentOptions.startTime != null
        ? new Date(
          dtStartTime.getUTCFullYear(),
          dtStartTime.getUTCMonth(),
          dtStartTime.getUTCDate(),
          dtStartTime.getUTCHours(),
          dtStartTime.getUTCMinutes()
        )
        : null;
      expTime = itemDocumentsHistory.documentOptions.expiryTime != null
        ? new Date(
          dtexpiryTime.getUTCFullYear(),
          dtexpiryTime.getUTCMonth(),
          dtexpiryTime.getUTCDate(),
          dtexpiryTime.getUTCHours(),
          dtexpiryTime.getUTCMinutes()
        )
        : null;
      const localExpiryTime = handleTimeZoneConversion(expTime, "utcToLocal", timeZoneRef.current);
      const localStartTime = handleTimeZoneConversion(strtTime, "utcToLocal", timeZoneRef.current);
      setStartTime(localStartTime);
      setExpiryTime(localExpiryTime);
    }
    setIsEnabled(itemDocumentsHistory.documentOptions.enabled);
    const expiryUTCString = itemDocumentsHistory.documentOptions.expiryTime;
    const expiryUTC = new Date(expiryUTCString);
    expiryTimeRef.current = expiryUTC;
    setPageCount(itemDocumentsHistory.pages);
    setDomains(itemDocumentsHistory.documentOptions.domains);
    setMaxReads(itemDocumentsHistory.documentOptions.maxReads);
    setMaxViewsPerDocument(
      itemDocumentsHistory.documentOptions.maxViewsPerDocument
    );
    ChangeMaxReadsTexts(itemDocumentsHistory.documentOptions.maxReads);
    ChangeMaxViewsPerDocumentTexts(
      itemDocumentsHistory.documentOptions.maxViewsPerDocument
    );
    setRpdType(itemDocumentsHistory.rpdType);
    setResponseAddress(itemDocumentsHistory.documentOptions.allowResponsesTo);
    setSteganography(itemDocumentsHistory.documentOptions.steganography);
    setPrint(itemDocumentsHistory.documentOptions.print);
    handleSetVoting(itemDocumentsHistory.documentOptions.voting);
    setVoteSharing(itemDocumentsHistory.documentOptions.voteSharing);
    setDistributionList(itemDocumentsHistory.documentOptions.distributionList);

    setConstMultipleIps(itemDocumentsHistory.documentOptions.ips);
    setConstContinents(itemDocumentsHistory.documentOptions.regions);
    setConstSecurityLevelText(
      itemDocumentsHistory.securityLevel == 3
        ? "Limit Readers"
        : itemDocumentsHistory.securityLevel == 2
          ? "Track Readers"
          : "Track Views"
    );
    setOpenRecord(itemDocumentsHistory.documentOptions.openRecord);
    setGeolocation(itemDocumentsHistory.documentOptions.geolocation);
    setVerifyCode(itemDocumentsHistory.documentOptions.verifyCode);
    setReadTimes(itemDocumentsHistory.documentOptions.readTimes);
    setReadTiming(itemDocumentsHistory.documentOptions.readTiming);
    setReaderEmail(itemDocumentsHistory.documentOptions.readerEmail);
    setDistRestriction(itemDocumentsHistory.documentOptions.distRestriction);
    setReadNotification(itemDocumentsHistory.documentOptions.readNotification);
    setVoting(itemDocumentsHistory.documentOptions.voting);
    setVoteSharing(itemDocumentsHistory.documentOptions.voteSharing);
    setIsPageLevelRestriction(itemDocumentsHistory.pageLevelRestrictionSetting);
    setIsPageLevelData(itemDocumentsHistory.documentOptions.pageLevelRestriction);
    isPageLevelRestrictionref.current =
      itemDocumentsHistory.pageLevelRestrictionSetting;
    isPageLevelRestrictionCheckedref.current =
      itemDocumentsHistory.documentOptions.pageLevelRestriction;
    setIsPageLevelRestrictionChecked(
      itemDocumentsHistory.documentOptions.pageLevelRestriction
    );

    isEDisclosureref.current = itemDocumentsHistory.eDisclosureSettings;
    isEDisclosureCheckedref.current = itemDocumentsHistory.documentOptions.eDisclosure;
    setEDisclosure(itemDocumentsHistory.eDisclosureSettings);
    setIsEDisclosureChecked(itemDocumentsHistory.documentOptions.eDisclosure);

    setIsSMSAuthentication(itemDocumentsHistory.smsAuthentication);
    setIsSMS(itemDocumentsHistory.documentOptions.isSMS);
    maxPrintsPerReader.current = itemDocumentsHistory.documentOptions.maxPrintsPerReader;
    maxPrintsPerDocument.current = itemDocumentsHistory.documentOptions.maxPrintsPerDocument;
    //setEDisclosure()
    if (itemDocumentsHistory.documentOptions.isBoth || (itemDocumentsHistory.documentOptions.isEmail && itemDocumentsHistory.documentOptions.isSMS)) {
      // const emailOption = [
      //   { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
      // ];

      // const newOption = {
      //   value: "text",
      //   label: selectedLanguage.LstLanguageCodes.UI_Text,
      // };

      // // Add only if it doesn't already exist
      // const newSelected = emailOption.some(
      //   (option) => option.value === newOption.value
      // )
      //   ? emailOption
      //   : [...emailOption, newOption];
      emailAuth.current = false;
      setIsSMS(false);
      multiAuth.current = true;
      const options = [
        { value: 'email', label: selectedLanguage.LstLanguageCodes.UI_Email },
        { value: 'text', label: selectedLanguage.LstLanguageCodes.UI_Text }
      ]

      setSelectedOptions(options);
    } else if (itemDocumentsHistory.documentOptions.isSMS) {
      const textOption = {
        value: "text",
        label: selectedLanguage.LstLanguageCodes.UI_Text,
      };
      setSelectedOptions([textOption]);
      emailAuth.current = false;
      setIsSMS(true);
      multiAuth.current = false;
    } else {
      const emailOption = [
        { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
      ];
      setSelectedOptions(emailOption);
      emailAuth.current = true;
      setIsSMS(false);
      multiAuth.current = false;
    }
    if (itemDocumentsHistory.securityLevel == 1) {
      setSecurityLevelTextColor("level1");
      setSendVerificationCodeDisable(true);
      // setEDisclosure(false);
    } else if (itemDocumentsHistory.securityLevel == 2) {
      setSecurityLevelTextColor("level2");
      setSendVerificationCodeDisable(false);
    } else {
      setSecurityLevelTextColor("");
      setSendVerificationCodeDisable(false);
    }
    setConstSecurityLevelClass(
      itemDocumentsHistory.securityLevel == 1 ? " disable_sectionChailed" : ""
    );
    if (
      itemDocumentsHistory.documentOptions.recipients.filter(
        (localItem) => localItem.enabled == false
      ).length > 0
    ) {
      setActiveSelectList(
        itemDocumentsHistory.documentOptions.recipients.filter(
          (localItem) => localItem.enabled == false
        )
      );
      setTemSelectedLeftList(
        itemDocumentsHistory.documentOptions.recipients.filter(
          (localItem) => localItem.enabled == false
        )
      );
    }
    if (
      itemDocumentsHistory.documentOptions.recipients.filter(
        (localItem) => localItem.enabled == true
      ).length > 0
    ) {
      setInActiveSelectList(
        itemDocumentsHistory.documentOptions.recipients.filter(
          (localItem) => localItem.enabled == true
        )
      );
      setTemSelectedRightList(
        itemDocumentsHistory.documentOptions.recipients.filter(
          (localItem) => localItem.enabled == true
        )
      );
    }
    setFullSelectList(itemDocumentsHistory.documentOptions.recipients);
    setOrgRecipientList(itemDocumentsHistory.documentOptions.recipients);
  }
  let MianStatistcObj = [];
  async function handleToShowStaticData(Docid) {
    try {
      // if (e.target.getAttribute("aria-expanded") == "true") {
      setOpen(true);
      const url =
        `${process.env.REACT_APP_API +
        process.env.REACT_APP_API_GetStatisticsData
        }` +
        "/" +
        Docid;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return;
      } else {
        setLstDocumentsHistory(
          lstDocumentsHistory.map((element, i) => {
            if (element.documentId == Docid) {
              element.statistics = jsonDocs;
              element.activeTabName = "Statistics";
              setOpen(false);
              return { ...element };
            } else {
              setOpen(false);
              return { ...element };
            }
          })
        );
      }
      // }
    } catch (error) {
      setOpen(false);
      console.log("error: " + error);
    }
  }
  async function DownloadActivityLog(e) {
    let ActivityDocumentsHistory = lstDocumentsHistory.find(
      (element) => element.documentId == e
    );
    let lstReceipientsativitylet = {
      ...ActivityDocumentsHistory.documentOptions.recipients,
    };
    let lstOpenrecordsactivitylet = { ...ActivityDocumentsHistory.openRecords };
    let lstOpenrecords = Object.values(lstOpenrecordsactivitylet);
    const openRecordIdList = lstOpenrecords
      .filter(record => record.id)
      .map(record => record.id)
      .join(',');
    const jsonDocs = await fetchStatistics(e, openRecordIdList);
    const lstCsvReceipients = lstOpenrecords.map((lstreceipient) => ({
      id: lstreceipient.id,
      Event: lstreceipient.event == null ? selectedLanguage.LstLanguageCodes.UI_opened : (lstreceipient.event == 'Auto Lock' ? "Auto locked" : "Restricted"),
      Reader: lstreceipient.securityLevel != 1 ? lstreceipient.email : "",
      TimeUTC: lstreceipient.opened,
      IP: lstreceipient.ip,
      Location:
        lstreceipient.geolocation != null &&
          lstreceipient.geolocation.city != null
          ? '"' +
          lstreceipient.geolocation.city +
          ", " +
          lstreceipient.geolocation.region_code +
          '"'
          : "",
      Country:
        lstreceipient.geolocation != null &&
          lstreceipient.geolocation.country_name != null
          ? lstreceipient.geolocation.country_name
          : "",
      Network:
        lstreceipient.geolocation != null &&
          lstreceipient.geolocation.org != null
          ? lstreceipient.geolocation.org
          : "",
      ViewDuration:
        lstreceipient.totalViewDuration >= 1 &&
          (lstreceipient.event != "Auto Lock" && lstreceipient.event != "Restricted")
          ? convertToHHMMSS(lstreceipient.totalViewDuration)
          : 0,
      PagesViewed:
        lstreceipient.totalPageViewed >= 1 && (lstreceipient.event != "Auto Lock" && lstreceipient.event != "Restricted")
          ? lstreceipient.totalPageViewed
          : 0,
    }));
    let consolidatedCSVData = "";
    const currentDirection =
      sortDirectionForActivityLog[ActivityDocumentsHistory.documentId] ||
      "desc";
    const sortedLstCsvReceipients = lstCsvReceipients.sort((a, b) => {
      const dateA = new Date(a.TimeUTC);
      const dateB = new Date(b.TimeUTC);
      return currentDirection === "asc" ? dateA - dateB : dateB - dateA;
    });

    if (ActivityDocumentsHistory.securityLevel !== 1) {
      sortedLstCsvReceipients.map((csvreceipient) => {
        const localizedEvent1 =
          csvreceipient.Event === "Opened"
            ? selectedLanguage.LstLanguageCodes.UI_opened
            : csvreceipient.Event;
        consolidatedCSVData +=
          localizedEvent1 +
          "," +
          (csvreceipient.Reader && csvreceipient.Reader !== ""
            ? csvreceipient.Reader
            : ""
          ) +
          "," +
          moment
            .utc(applyTimeZoneToDisplay(new Date(csvreceipient.TimeUTC), timeZoneRef.current))
            .format(dateFormatValueUpper + " HH:mm") +
          "," +
          csvreceipient.IP +
          "," +
          csvreceipient.Location +
          "," +
          csvreceipient.Country +
          "," +
          csvreceipient.Network +
          "," +
          csvreceipient.ViewDuration +
          "," +
          csvreceipient.PagesViewed + "\n";

        consolidatedCSVData += (selectedLanguage.LstLanguageCodes.UI_PageNumber + "," + selectedLanguage.LstLanguageCodes.UI_TimeStarted + "," + selectedLanguage.LstLanguageCodes.UI_TotalTimeViewed) + "\n";

        const readerStats = jsonDocs != null && jsonDocs.filter(
          stat =>
            stat.openRecordId ===
            csvreceipient.id
        );
        console.log(readerStats)

        readerStats.forEach(stat => {
          const totalTime =
            String(stat.totalHours).padStart(2, '0') + ":" +
            String(stat.totalMinutes).padStart(2, '0') + ":" +
            String(stat.totalSeconds).padStart(2, '0');

          consolidatedCSVData += "" + stat.pageNumber + "," + moment.utc(applyTimeZoneToDisplay(new Date(stat.timeStarted), timeZoneRef.current)).format(dateFormatValueUpper + " HH:mm") + "," + totalTime + "\n";
        });
        consolidatedCSVData += "\n";
      });
      const downloadDateLabel =
        selectedLanguage === "ja-jp"
          ? [timeZoneAbbrevation.current, selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC].join(" ")
          : [selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC, timeZoneAbbrevation.current].join(" ");
      const csvContent = [
        selectedLanguage.LstLanguageCodes.UI_DocumentID,
        ActivityDocumentsHistory.documentId +
        "\n" +
        selectedLanguage.LstLanguageCodes.UI_DocumentName,
        ActivityDocumentsHistory.fileName +
        "\n" + downloadDateLabel,
        moment.utc(
          applyTimeZoneToDisplay(
            new Date(),
            timeZoneRef.current
          )
        ).format(dateFormatValueUpper + " HH:mm") +
        "\n" +
        "\n" +
        selectedLanguage.LstLanguageCodes.UI_Event,
        ActivityDocumentsHistory.securityLevel != 1 ? selectedLanguage.LstLanguageCodes.UI_Raeder : "",

        selectedLanguage.LstLanguageCodes.UI_TimeUTC + " " + "(" + timeZoneAbbrevation.current + ")",
        selectedLanguage.LstLanguageCodes.UI_IP,
        selectedLanguage.LstLanguageCodes.UI_Loaction,
        selectedLanguage.LstLanguageCodes.UI_Country,
        selectedLanguage.LstLanguageCodes.UI_Network,
        selectedLanguage.LstLanguageCodes.UI_ViewDuration,
        selectedLanguage.LstLanguageCodes.UI_PagesViewed +
        "\n" +
        consolidatedCSVData,
      ];

      downloadCSV(
        csvContent,
        ActivityDocumentsHistory.fileName + "_Readers Activity Log.csv"
      );
    }
    else {
      sortedLstCsvReceipients.map((csvreceipient) => {
        const localizedEvent =
          csvreceipient.Event === "Opened"
            ? selectedLanguage.LstLanguageCodes.UI_opened
            : csvreceipient.Event;

        consolidatedCSVData +=
          localizedEvent +
          "," +
          moment.utc(
            applyTimeZoneToDisplay(new Date(csvreceipient.TimeUTC), timeZoneRef.current
            )
          ).format(dateFormatValueUpper + " HH:mm") +
          "," +
          "," +
          csvreceipient.IP +
          "," +
          csvreceipient.Location +
          "," +
          csvreceipient.Country +
          "," +
          csvreceipient.Network +
          "," +
          csvreceipient.ViewDuration +
          "," +
          csvreceipient.PagesViewed +
          "," +
          "\n";

        consolidatedCSVData += (selectedLanguage.LstLanguageCodes.UI_PageNumber + "," + selectedLanguage.LstLanguageCodes.UI_TimeStarted + "," + selectedLanguage.LstLanguageCodes.UI_TotalTimeViewed) + "\n";

        const readerStats = jsonDocs != null && jsonDocs.filter(
          stat =>
            stat.openRecordId ===
            csvreceipient.id
        );
        console.log(readerStats)

        readerStats.forEach(stat => {
          const totalTime =
            String(stat.totalHours).padStart(2, '0') + ":" +
            String(stat.totalMinutes).padStart(2, '0') + ":" +
            String(stat.totalSeconds).padStart(2, '0');

          consolidatedCSVData += "" + stat.pageNumber + "," + moment.utc(new Date(stat.timeStarted)).format(dateFormatValueUpper + " HH:mm") + "," + totalTime + "\n";
        });
        consolidatedCSVData += "\n";
      });
      const downloadDateLabel =
        selectedLanguage === "ja-jp"
          ? [timeZoneAbbrevation.current, selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC].join(" ")
          : [selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC, timeZoneAbbrevation.current].join(" ");
      const csvContent = [
        selectedLanguage.LstLanguageCodes.UI_DocumentID,
        ActivityDocumentsHistory.documentId +
        "\n" +
        selectedLanguage.LstLanguageCodes.UI_DocumentName,
        ActivityDocumentsHistory.fileName +
        "\n" + downloadDateLabel,
        moment.utc(
          applyTimeZoneToDisplay(
            new Date(),
            timeZoneRef.current
          )
        ).format(dateFormatValueUpper + " HH:mm") +
        "\n" +
        "\n" +
        selectedLanguage.LstLanguageCodes.UI_Event,
        selectedLanguage.LstLanguageCodes.UI_TimeUTC + " " + "(" + timeZoneAbbrevation.current + ")",
        selectedLanguage.LstLanguageCodes.UI_IP,
        selectedLanguage.LstLanguageCodes.UI_Loaction,
        selectedLanguage.LstLanguageCodes.UI_Country,
        selectedLanguage.LstLanguageCodes.UI_Network,
        selectedLanguage.LstLanguageCodes.UI_ViewDuration,
        selectedLanguage.LstLanguageCodes.UI_PagesViewed +
        "\n" +
        consolidatedCSVData,
      ];

      downloadCSV(
        csvContent,
        ActivityDocumentsHistory.fileName + "_Readers Activity Log.csv"
      );
    }
  }
  const onSearchHandler = (event) => {
    setSearch(event.target.value);
    // console.log(checkPages);
  };

  const onSearchActivityLogHandler = (event) => {
    setSearchActivityLog(event.target.value);
  };

  function convertArrayToCSV(array) {
    if (array.length === 0) {
      console.error("Array is empty.");
      return;
    }
    const headers = Object.keys(array[0]);
    const csvContent = [
      headers.join(","),
      ...array.map((row) => headers.map((header) => row[header]).join(",")),
    ].join("\n");

    return csvContent;
  }
  function downloadCSV(lstCsvReceipients, Download) {

    const csvContent = lstCsvReceipients;
    const csvContentWithBOM = "\uFEFF" + csvContent;
    const blob = new Blob([csvContentWithBOM], {
      type: "text/csv;charset=utf-8;",
    });
    //const blob = new Blob([lstCsvReceipients], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = Download || "data.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  }
  function SortingOptionsPopupOpen(docid) {
    setTrackInteractivitySortingPopUp(true);
    setPopupDocumentId(docid);
    const record = trackInteractivityDetails.find(x => x.docId == docid);
    const updatedOptions = Array.isArray(record?.sortDetails)
      ? record.sortDetails.map(opt => {
        if (opt.label === selectedLanguage.LstLanguageCodes.UI_FirstRead) {
          return {
            ...opt,
            label: `${selectedLanguage.LstLanguageCodes.UI_FirstRead} (${timeZoneAbbrevation.current})`,
          };
        }
        return opt;
      })
      : [];
    setSortOptions(
      updatedOptions
    );
  }
  function applyTimeZoneToDisplay(date, offsetString) {
    if (!date || !offsetString) return date;
    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });
    let adjustedDate;
    if (offsetMinutes > 0) {
      adjustedDate = new Date(date.getTime() + offsetMinutes * 60000);
    } else {
      adjustedDate = new Date(date.getTime() + offsetMinutes * 60000);
    }
    return adjustedDate;
  }

  function handlerModelCancelSorting() {
    setPopupDocumentId("");
    setTrackInteractivitySortingPopUp(false);
  }
  function handlerModelOkSorting(docId, prewDetail1) {
    setTrackInteractivitySortingPopUp(false);
    setTrackInteractivityDetails((prevDetails) => {
      let previousDetails2;
      if (prewDetail1) {
        previousDetails2 = prewDetail1;
      }
      else {
        previousDetails2 = prevDetails;

      }

      const updatedDetails = previousDetails2.map((detail) => {
        if (!detail || detail.docId !== popupDocumentId) return detail;

        let sortedRecords = [...detail.records]; // Clone array before sorting

        // First, sort based on other columns except the clicked one
        sortOptions
          .filter((option) => option.active == "true") // Exclude clicked column
          .forEach((option) => {
            sortedRecords.sort((a, b) => {
              if (option.value === "first_read") {
                const dateA = a.openedTime ? new Date(a.openedTime) : null;
                const dateB = b.openedTime ? new Date(b.openedTime) : null;

                if (!dateA && !dateB) return 0;
                if (!dateA) return option.order === "desc" ? 1 : -1;
                if (!dateB) return option.order === "desc" ? -1 : 1;

                return option.order === "desc" ? dateB - dateA : dateA - dateB;
              } else if (option.value === "total_time") {
                const getTimeInMilliseconds = (timeStr) => {
                  if (!timeStr || timeStr === "00:00:00") return 0;
                  const [hours, minutes, seconds] = timeStr
                    .split(":")
                    .map(Number);
                  return (hours * 3600 + minutes * 60 + seconds) * 1000;
                };

                return option.order === "desc"
                  ? getTimeInMilliseconds(b.totalTime) -
                  getTimeInMilliseconds(a.totalTime)
                  : getTimeInMilliseconds(a.totalTime) -
                  getTimeInMilliseconds(b.totalTime);
              } else if (option.value === "reads") {
                return option.order === "desc"
                  ? b.readCount - a.readCount
                  : a.readCount - b.readCount;
              } else if (option.value === "days_since_firstAuth") {
                return option.order === "desc"
                  ? b.daysFirstAuthrized - a.daysFirstAuthrized
                  : a.daysFirstAuthrized - b.daysFirstAuthrized;
              } else if (option.value === "days_since_first") {
                return option.order === "desc"
                  ? b.daysSinceFirstView - a.daysSinceFirstView
                  : a.daysSinceFirstView - b.daysSinceFirstView;
              } else if (option.value === "days_since_last") {
                return option.order === "desc"
                  ? b.daysSinceLastView - a.daysSinceLastView
                  : a.daysSinceLastView - b.daysSinceLastView;
              }
              return 0;
            });
          });

        // Finally, apply sorting for the clicked column
        const clickedOption = sortOptions.find(
          (option) => option.active == "true"
        );
        if (clickedOption) {
          sortedRecords.sort((a, b) => {
            if (clickedOption.value === "first_read") {
              const dateA = a.openedTime ? new Date(a.openedTime) : null;
              const dateB = b.openedTime ? new Date(b.openedTime) : null;

              if (!dateA && !dateB) return 0;
              if (!dateA) return clickedOption.order === "desc" ? 1 : -1;
              if (!dateB) return clickedOption.order === "desc" ? -1 : 1;

              return clickedOption.order === "desc"
                ? dateB - dateA
                : dateA - dateB;
            } else if (clickedOption.value === "total_time") {
              const getTimeInMilliseconds = (timeStr) => {
                if (!timeStr || timeStr === "00:00:00") return 0;
                const [hours, minutes, seconds] = timeStr
                  .split(":")
                  .map(Number);
                return (hours * 3600 + minutes * 60 + seconds) * 1000;
              };

              return clickedOption.order === "desc"
                ? getTimeInMilliseconds(b.totalTime) -
                getTimeInMilliseconds(a.totalTime)
                : getTimeInMilliseconds(a.totalTime) -
                getTimeInMilliseconds(b.totalTime);
            } else if (clickedOption.value === "reads") {
              return clickedOption.order === "desc"
                ? b.readCount - a.readCount
                : a.readCount - b.readCount;
            } else if (clickedOption.value === "days_since_firstAuth") {
              return clickedOption.order === "desc"
                ? b.daysFirstAuthrized - a.daysFirstAuthrized
                : a.daysFirstAuthrized - b.daysFirstAuthrized;
            } else if (clickedOption.value === "days_since_first") {
              return clickedOption.order === "desc"
                ? b.daysSinceFirstView - a.daysSinceFirstView
                : a.daysSinceFirstView - b.daysSinceFirstView;
            } else if (clickedOption.value === "days_since_last") {
              return clickedOption.order === "desc"
                ? b.daysSinceLastView - a.daysSinceLastView
                : a.daysSinceLastView - b.daysSinceLastView;
            }
            return 0;
          });
        }
        return {
          ...detail,
          records: sortedRecords,
          sortDetails: sortOptions,
        };
      });


      trackInteractivityDetailsRef.current = updatedDetails;
      return updatedDetails;
    });
  }

  async function fetchStatistics(docId, openRecordIdList) {
    try {
      const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${docId}`;
      const params = new URLSearchParams();

      params.append("openRecordId", openRecordIdList);
      params.append("IsStats", "false");

      const url = `${baseUrl}?${params.toString()}`;
      const jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return [];
      } else {
        setOpen(false);
        return jsonDocs;
      }
    }
    catch (err) {
      setOpen(false);
      return [];
    }
  }
  const formatEDisclosureStatus = (status) => {
    if (!status) return status;

    const match = status.match(/^(.*)\[(.*)\s+\(UTC\)\]$/);
    if (!match) return status;

    const text = match[1].trim();
    const datePart = match[2].trim();

    const adjustedDate = applyTimeZoneToDisplay(
      new Date(datePart),
      timeZoneRef.current
    );

    return `${text} [${moment(adjustedDate).format(
      dateFormatValueUpper + " HH:mm"
    )} ${timeZoneAbbrevation.current}]`;
  };

  async function Downloaduserstatus(e) {
    let itemDocumentsHistory = lstDocumentsHistory.find(
      (element) => element.documentId == e
    );
    // let lstReceipientslet = {
    //   ...itemDocumentsHistory.documentOptions.recipients,
    // };
    let itemDocumentsHistory1 = trackInteractivityDetails.find(
      (element) => element.docId == e
    );

    let lstOpenrecordslet = { ...itemDocumentsHistory.openRecords };
    let lstReceipients = Object.values([...itemDocumentsHistory1.records]);
    let lstOpenrecords = Object.values(lstOpenrecordslet);
    const emailList = lstReceipients
      .map(item => item.email?.toLowerCase().trim() || "")
      .filter(email => email !== "")
      .join(',');

    const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetStatisticsData}/${itemDocumentsHistory1.docId}`;
    const params = new URLSearchParams();

    params.append("emailAdress", "");
    params.append("IsStats", "");
    params.append("EmailIDs", emailList);  // ✅ correct format

    const url = `${baseUrl}?${params.toString()}`;
    const jsonDocs = await APIRequest.GET("", url);
    if (jsonDocs && jsonDocs === "Server maintenance") {
      history("/maintenance");
      return;
    } else if (
      jsonDocs.errorMessage != undefined &&
      jsonDocs.errorMessage != ""
    ) {
      setAlertMsg(jsonDocs.errorMessage);
      setAlertType("warning");
      setOpen(false);
      return;
    } else {
      setOpen(false);
    }
    const lstCsvReceipients = lstReceipients.filter((lstopenrecord) => lstopenrecord.email != undefined).map((lstreceipient) => {

      return {
        Address: lstreceipient.email ? lstreceipient.email : "",
        FirstName: '"' + (lstreceipient.firstName ? lstreceipient.firstName.trim() : "") + '"',
        LastName: '"' + (lstreceipient.lastName ? lstreceipient.lastName.trim() : "") + '"',
        MobileNumber: `${lstreceipient.mobileCountryCode ? lstreceipient.mobileCountryCode : ""
          } ${lstreceipient.mobileNumber ? lstreceipient.mobileNumber : ""}`,
        FirstRead:
          lstOpenrecords.filter(
            (lstopenrecord) =>
              lstopenrecord.email == lstreceipient.email &&
              (!lstopenrecord.event || lstopenrecord.event === "Opened")
          ).length > 0
            ? lstOpenrecords.filter(
              (lstopenrecord) =>
                lstopenrecord.email == lstreceipient.email &&
                (!lstopenrecord.event || lstopenrecord.event === "Opened")
            )[0].opened
            : "",
        Read: lstreceipient.readCount,

        TotalMinutes:
          lstOpenrecords.filter(
            (emailList) =>
              emailList.email != null &&
              lstreceipient.email != null &&
              emailList.email.toString().toLowerCase() ===
              lstreceipient.email.toString().toLowerCase() &&
              emailList.activityTime !== undefined
          ).length > 0
            ? getTimeFormat(
              lstOpenrecords
                .filter(
                  (emailList) =>
                    emailList.email != null &&
                    lstreceipient.email != null &&
                    emailList.email.toString().toLowerCase() ===
                    lstreceipient.email.toString().toLowerCase()
                )
                .map((timeCalc) => timeCalc.activityTime)
                .reduce((accTime, timeCalc) => timeCalc + accTime)
            )
            : "00:00:00",
        Vote:
          lstreceipient.vote == -1
            ? ""
            : lstreceipient.vote == 0
              ? "Dislike"
              : "Like",
        ActiveBanned: lstreceipient.status,
        DaysFirstAuthrized: lstreceipient.daysFirstAuthrized ? lstreceipient.daysFirstAuthrized : "0",
        DaysSinceFirstView: lstreceipient.daysSinceFirstView ? lstreceipient.daysSinceFirstView : "0",
        DaysSinceLastView: lstreceipient.daysSinceLastView ? lstreceipient.daysSinceLastView : "0",
        EDisclosurStatus: lstreceipient.eDisclosureAgreed != null ? `${lstreceipient.eDisclosureAgreed == true ? selectedLanguage.LstLanguageCodes.UI_Agreed : selectedLanguage.LstLanguageCodes.UI_DisAgreed} [${moment(lstreceipient.eDisclosureTime).tz("UTC").format(dateFormatValueUpper + " HH:mm")} (UTC)]` : "",
        Reference: lstreceipient.reference != "" ? lstreceipient.reference : "",
        SendVerificationCode: lstreceipient?.authType ?? "",
      };
    });

    if (
      lstOpenrecords.filter((lstopenrecord) => lstopenrecord.email == null)
        .length > 0
    ) {
      lstCsvReceipients.push({
        Address: "",
        FirstName: "",
        LastName: "",
        CountryCode: "",
        MobileNumber: "",
        FirstRead:
          lstOpenrecords.filter((lstopenrecord) => lstopenrecord.email == null)
            .length > 0
            ? lstOpenrecords.filter(
              (lstopenrecord) => lstopenrecord.email == null
            )[0].opened
            : "",
        Read:
          lstOpenrecords.filter(
            (emailList) =>
              emailList.email == null && emailList.activityTime !== undefined
          ).length > 0
            ? lstOpenrecords.filter(
              (emailList) =>
                emailList.email == null &&
                emailList.activityTime !== undefined
            ).length
            : "",
        TotalMinutes:
          lstOpenrecords.filter(
            (emailList) =>
              emailList.email == null && emailList.activityTime !== undefined
          ).length > 0
            ? getTimeFormat(
              lstOpenrecords
                .filter(
                  (emailList) =>
                    emailList.email == null &&
                    emailList.activityTime !== undefined
                )
                .map((timeCalc) => timeCalc.activityTime)
                .reduce((accTime, timeCalc) => timeCalc + accTime)
            )
            : "00:00:00",
        Vote: "",
        ActiveBanned: "",
        DaysFirstAuthrized: lstOpenrecords.daysFirstAuthrized ? lstOpenrecords.daysFirstAuthrized : "0",
        DaysSinceFirstView: lstOpenrecords.daysSinceFirstView ? lstOpenrecords.daysSinceFirstView : "0",
        DaysSinceLastView: lstOpenrecords.daysSinceLastView ? lstOpenrecords.daysSinceLastView : "0",
        EDisclosurStatus: "",
        Reference: ""
        , SendVerificationCode: "",
      });
    }
    let consolidatedCSVData = "";
    let sortedLstCsvReceipients = [...lstCsvReceipients];
    const currentDirection =
      sortDirectionForTrackInteractivity[itemDocumentsHistory.documentId] ||
      "desc";
    sortOptions
      .filter((option) => option.active == "true")
      .forEach((option) => {
        sortedLstCsvReceipients.sort((a, b) => {
          if (option.value === "first_read") {
            const dateA = a.FirstRead ? new Date(a.FirstRead) : null;
            const dateB = b.FirstRead ? new Date(b.FirstRead) : null;

            if (!dateA && !dateB) return 0;
            if (!dateA) return option.order === "desc" ? 1 : -1;
            if (!dateB) return option.order === "desc" ? -1 : 1;

            return option.order === "desc" ? dateB - dateA : dateA - dateB;
          } else if (option.value === "total_time") {
            const getTimeInMilliseconds = (timeStr) => {
              if (!timeStr || timeStr === "00:00:00") return 0;
              const [hours, minutes, seconds] = timeStr
                .split(":")
                .map(Number);
              return (hours * 3600 + minutes * 60 + seconds) * 1000;
            };

            return option.order === "desc"
              ? getTimeInMilliseconds(b.TotalMinutes) -
              getTimeInMilliseconds(a.TotalMinutes)
              : getTimeInMilliseconds(a.TotalMinutes) -
              getTimeInMilliseconds(b.TotalMinutes);
          } else if (option.value === "reads") {
            return option.order === "desc"
              ? b.Read - a.Read
              : a.Read - b.Read;
          } else if (option.value === "days_since_firstAuth") {
            return option.order === "desc"
              ? b.DaysFirstAuthrized - a.DaysFirstAuthrized
              : a.DaysFirstAuthrized - b.DaysFirstAuthrized;
          } else if (option.value === "days_since_first") {
            return option.order === "desc"
              ? b.DaysSinceFirstView - a.DaysSinceFirstView
              : a.DaysSinceFirstView - b.DaysSinceFirstView;
          } else if (option.value === "days_since_last") {
            return option.order === "desc"
              ? b.DaysSinceLastView - a.DaysSinceLastView
              : a.DaysSinceLastView - b.DaysSinceLastView;
          }
          return 0;
        }
        )
        const clickedOption = sortOptions.find(
          (option) => option.active == "true"
        );
        if (clickedOption) {
          sortedLstCsvReceipients.sort((a, b) => {
            if (clickedOption.value === "first_read") {
              const dateA = a.FirstRead ? new Date(a.FirstRead) : null;
              const dateB = b.FirstRead ? new Date(b.FirstRead) : null;

              if (!dateA && !dateB) return 0;
              if (!dateA) return clickedOption.order === "desc" ? 1 : -1;
              if (!dateB) return clickedOption.order === "desc" ? -1 : 1;

              return clickedOption.order === "desc"
                ? dateB - dateA
                : dateA - dateB;
            } else if (clickedOption.value === "total_time") {
              const getTimeInMilliseconds = (timeStr) => {
                if (!timeStr || timeStr === "00:00:00") return 0;
                const [hours, minutes, seconds] = timeStr
                  .split(":")
                  .map(Number);
                return (hours * 3600 + minutes * 60 + seconds) * 1000;
              };

              return clickedOption.order === "desc"
                ? getTimeInMilliseconds(b.TotalMinutes) -
                getTimeInMilliseconds(a.TotalMinutes)
                : getTimeInMilliseconds(a.TotalMinutes) -
                getTimeInMilliseconds(b.TotalMinutes);
            } else if (clickedOption.value === "reads") {
              return clickedOption.order === "desc"
                ? b.Read - a.Read
                : a.Read - b.Read;
            } else if (clickedOption.value === "days_since_firstAuth") {
              return clickedOption.order === "desc"
                ? b.DaysFirstAuthrized - a.DaysFirstAuthrized
                : a.DaysFirstAuthrized - b.DaysFirstAuthrized;
            } else if (clickedOption.value === "days_since_first") {
              return clickedOption.order === "desc"
                ? b.DaysSinceFirstView - a.DaysSinceFirstView
                : a.DaysSinceFirstView - b.DaysSinceFirstView;
            } else if (clickedOption.value === "days_since_last") {
              return clickedOption.order === "desc"
                ? b.DaysSinceLastView - a.DaysSinceLastView
                : a.DaysSinceLastView - b.DaysSinceLastView;
            }
            return 0;
          });
        }

      });

    sortedLstCsvReceipients.forEach((csvreceipient) => {
      consolidatedCSVData +=
        (csvreceipient.Address) + "," +
        csvreceipient.FirstName + "," +
        csvreceipient.LastName + "," +
        csvreceipient.MobileNumber + "," +
        (
          csvreceipient.FirstRead !== ""
            ? moment.utc(
              applyTimeZoneToDisplay(
                new Date(csvreceipient.FirstRead),
                timeZoneRef.current
              )
            ).format(dateFormatValueUpper + " HH:mm")
            : csvreceipient.FirstRead
        ) + "," +
        csvreceipient.Read + "," +
        csvreceipient.TotalMinutes + "," +
        csvreceipient.Vote + "," +
        csvreceipient.ActiveBanned + "," +
        csvreceipient.DaysFirstAuthrized + "," +
        csvreceipient.DaysSinceFirstView + "," +
        csvreceipient.DaysSinceLastView + "," +
        formatEDisclosureStatus(csvreceipient.EDisclosurStatus) + "," +
        (csvreceipient.Reference !== undefined ? csvreceipient.Reference : "") + "," +
        (csvreceipient.SendVerificationCode.charAt(0).toUpperCase() + csvreceipient.SendVerificationCode.slice(1)) + "\n";
      if (csvreceipient.Address != null && csvreceipient.Address != "" && csvreceipient.Address != undefined)
        consolidatedCSVData += (selectedLanguage.LstLanguageCodes.UI_PageNumber + "," + selectedLanguage.LstLanguageCodes.UI_NumberOfUniqueReads + "," + selectedLanguage.LstLanguageCodes.UI_TotalTimeViewed) + "\n";

      const readerStats = jsonDocs != null && jsonDocs.filter(
        stat =>
          stat.email?.toLowerCase().trim() ===
          csvreceipient.Address?.toLowerCase().trim()
      );

      readerStats.forEach(stat => {
        const totalTime =
          String(stat.totalHours).padStart(2, '0') + ":" +
          String(stat.totalMinutes).padStart(2, '0') + ":" +
          String(stat.totalSeconds).padStart(2, '0');

        consolidatedCSVData += "" + stat.pageNumber + "," + stat.totalCount + "," + totalTime + "\n";
      });

      consolidatedCSVData += "\n";
    });
    const downloadDateLabel =
      selectedLanguage === "ja-jp"
        ? [timeZoneAbbrevation.current, selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC].join(" ")
        : [selectedLanguage.LstLanguageCodes.UI_DownloadDateTimeUTC, timeZoneAbbrevation.current].join(" ");
    const csvContent = [
      selectedLanguage.LstLanguageCodes.UI_DocumentID,
      itemDocumentsHistory.documentId +
      "\n" +
      selectedLanguage.LstLanguageCodes.UI_DocumentName,
      itemDocumentsHistory.fileName +
      "\n" +
      downloadDateLabel,
      moment.utc(
        applyTimeZoneToDisplay(new Date(), timeZoneRef.current)
      )
        .format(dateFormatValueUpper + " HH:mm") +
      "\n" +
      "\n" +
      selectedLanguage.LstLanguageCodes.UI_Adress,
      selectedLanguage.LstLanguageCodes.UI_FirstName,
      selectedLanguage.LstLanguageCodes.UI_LastName,
      selectedLanguage.LstLanguageCodes.UI_Mobile,
      selectedLanguage.LstLanguageCodes.UI_FirstRead + " " + "(" + timeZoneAbbrevation.current + ")",
      selectedLanguage.LstLanguageCodes.UI_Reads,
      selectedLanguage.LstLanguageCodes.UI_TotalMinutes,
      selectedLanguage.LstLanguageCodes.UI_Vote,
      selectedLanguage.LstLanguageCodes.UI_Status,
      selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstAuthorized,
      selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstSActivity,
      selectedLanguage.LstLanguageCodes.UI_DaysSinceLastActivity,
      selectedLanguage.LstLanguageCodes.UI_EDisclosureStatus,
      selectedLanguage.LstLanguageCodes.UI_ReferenceTxt,
      selectedLanguage.LstLanguageCodes.UI_SendVerificationCode +
      "\n" +
      consolidatedCSVData,
    ];

    downloadCSV(
      csvContent,
      itemDocumentsHistory.fileName + "_Readers Data List.csv"
    );
  }

  function convertArrayToCSV(array) {
    if (array.length === 0) {
      console.error("Array is empty.");
      return;
    }

    const headers = Object.keys(array[0]);
    const csvContent = [
      headers.join(","),
      ...array.map((row) => headers.map((header) => row[header]).join(",")),
    ].join("\n");

    return csvContent;
  }
  function downloadCSV(lstCsvReceipients, Download) {

    const csvContent = lstCsvReceipients;
    const csvContentWithBOM = "\uFEFF" + csvContent;
    const blob = new Blob([csvContentWithBOM], {
      type: "text/csv;charset=utf-8;",
    });
    //const blob = new Blob([lstCsvReceipients], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = Download || "data.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  function handlerSetDatesControlStatus() {
    let itemDocumentsHistory = lstDocumentsHistory.find(
      (element) => element.documentId == popupDocumentId
    );
    var dtStartTime =
      itemDocumentsHistory.documentOptions.startTime != null
        ? new Date(itemDocumentsHistory.documentOptions.startTime)
        : null;

    var dtexpiryTime =
      itemDocumentsHistory.documentOptions.expiryTime != null
        ? new Date(itemDocumentsHistory.documentOptions.expiryTime)
        : null;
    let strtTime = null;
    let expTime = null;
    if (isDatetimeControl == "false") {
      strtTime = dtStartTime && new Date(
        dtStartTime.getUTCFullYear(),
        dtStartTime.getUTCMonth(),
        dtStartTime.getUTCDate(),
        dtStartTime.getUTCHours(),
        dtStartTime.getUTCMinutes()
      );
      expTime = dtexpiryTime && new Date(
        dtexpiryTime.getUTCFullYear(),
        dtexpiryTime.getUTCMonth(),
        dtexpiryTime.getUTCDate(),
        dtStartTime.getUTCHours(),
        dtStartTime.getUTCMinutes()
      );
      const localStartTime = handleTimeZoneConversion(strtTime, "utcToLocal", timeZoneRef.current);
      const localExpiryTime = handleTimeZoneConversion(expTime, "utcToLocal", timeZoneRef.current);
      setStartTime(localStartTime);
      setExpiryTime(localExpiryTime);
    } else {
      strtTime = dtStartTime && new Date(
        dtStartTime.getUTCFullYear(),
        dtStartTime.getUTCMonth(),
        dtStartTime.getUTCDate(),
        dtStartTime.getUTCHours(),
        dtStartTime.getUTCMinutes()
      );
      expTime = dtexpiryTime && new Date(
        dtexpiryTime.getUTCFullYear(),
        dtexpiryTime.getUTCMonth(),
        dtexpiryTime.getUTCDate(),
        dtexpiryTime.getUTCHours(),
        dtexpiryTime.getUTCMinutes()
      );
      const localStartTime = handleTimeZoneConversion(strtTime, "utcToLocal", timeZoneRef.current);
      const localExpiryTime = handleTimeZoneConversion(expTime, "utcToLocal", timeZoneRef.current);
      setStartTime(localStartTime);
      setExpiryTime(localExpiryTime);
    }
  }
  const ReaderActivityLogClick = (localDocId, openId) => {
    setModalIsReaderActivityLogOpen(true);
    setActiveOpenId(openId);
    setActivityDocumentId(localDocId)
  }
  function rollbackFinalToLocal(finalDate, offsetString) {
    if (!finalDate) return "";

    const offsetMinutes = timeZoneConverter({
      mode: "parseOffset",
      offsetString
    });

    // Explicit logic:
    if (offsetMinutes > 0) {
      // +14:00 → subtract
      return new Date(finalDate.getTime() - offsetMinutes * 60000);
    } else {
      // -14:00 → add
      return new Date(finalDate.getTime() + Math.abs(offsetMinutes) * 60000);
    }
  }
  function handlerModelConfirmForControlStatus(saveFlag, recipientListPass, maxPrints = {}) {
    var flag = true;
    if (maxPrints && Object.keys(maxPrints).length > 0) {
      maxPrintsFields.current = { ...maxPrints };
    }
    const currentMaxReadsPerReader = parseInt(maxReadsText, 10) || 0;
    const currentMaxViewsPerDocument = parseInt(maxViewsPerDocumentText, 10) || 0;
    const currentMaxPrintsPerReader = parseInt(maxPrints.maxPrintsPerReader, 10) || 0;
    const currentMaxPrintsPerDocument = parseInt(maxPrints.maxPrintsPerDocument, 10) || 0;
    maxPrints.maxPrintsPerReader = currentMaxPrintsPerReader;
    maxPrints.maxPrintsPerDocument = currentMaxPrintsPerDocument;
    if (currentMaxReadsPerReader > 0 && currentMaxViewsPerDocument > 0 && currentMaxReadsPerReader > currentMaxViewsPerDocument) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument);
      setAlertType("warning");
      return;
    }
    if (currentMaxPrintsPerReader > 0 && currentMaxPrintsPerDocument > 0 && currentMaxPrintsPerReader > currentMaxPrintsPerDocument) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
      setAlertType("warning");
      return;
    }
    const toDateOnlyUTC = (d) => {
      const date = new Date(d);
      date.setHours(0, 0, 0, 0);
      return date;
    };

    try {
      if (
        isDatetimeControl === "false" &&
        expireToActivePopup === 1 &&
        !isEnabled &&
        toDateOnlyUTC(expiryTimeRef.current).getTime() <= toDateOnlyUTC(new Date()).getTime() &&
        toDateOnlyUTC(changedExpiryDate).getTime() >= toDateOnlyUTC(new Date()).getTime()
      ) {
        setIsExpireChangePopup(true);
        expireToActivePopup = 2;
        expiryChnagedPopup.current = true;
        return;
      }
      function toUTCDate(dateInput) {
        const date = new Date(dateInput);
        return new Date(Date.UTC(
          date.getUTCFullYear(),
          date.getUTCMonth(),
          date.getUTCDate(),
          date.getUTCHours(),
          date.getUTCMinutes(),
          date.getUTCSeconds()
        ));
      }
      if (
        isDatetimeControl === "true" &&
        expireToActivePopup === 1 &&
        !isEnabled
      ) {
        const expiryUTC = toUTCDate(expiryTimeRef.current);
        const changedUTC = toUTCDate(changedExpiryDate);
        const nowUTC = new Date();
        if (expiryUTC.getTime() <= nowUTC.getTime() && changedUTC.getTime() >= nowUTC.getTime()) {
          setIsExpireChangePopup(true);
          expiryChnagedPopup.current = true;
          expireToActivePopup = 2;
          return;
        }
      }
      if (expiryTime == "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ExpiresDateisRequired);
        setAlertType("warning");
        return;
      }
      let tempItemDocumentHistory = orgLstDocumentsHistory.find(
        (element) => element.documentId == popupDocumentId
      );
      var itemDocumentsHistory = JSON.parse(
        JSON.stringify(tempItemDocumentHistory)
      );
      if (selectionOfRestriction && constSecurityLevelText != "Track Views") {
        selectionOfRestriction.forEach((item) => {
          item.readers.forEach((reader) => {
            // Ensure reader.email is defined
            if (reader) {
              // Check if the email already exists in recipients
              const exists = fullSelectList.some(
                (element) =>
                  element.email &&
                  element.email.toLowerCase() === reader.toLowerCase()
              );
              // If the email doesn't exist, add it to recipients
              if (!exists) {
                isNewRecipientAdded = true;
                fullSelectList.push({
                  email: reader,
                  firstName: "",
                  lastName: "",
                  mobileCountryCode: "",
                  mobileNumber: "",
                  reference: "",
                  enabled: true,
                  status: "Active",
                });
              }
            }
          });
        });
      }
      if (
        constSecurityLevelText == "Limit Readers" &&
        (itemDocumentsHistory.documentOptions.distRestriction == false ||
          itemDocumentsHistory.documentOptions.readerEmail == false) &&
        saveFlag == false
      ) {
        if (itemDocumentsHistory.documentOptions.recipients.length > 0) {
          setModalForLevel3Popup(true);
        } else {
          const enablePrint = canPrint && (printEnabledType === "everyone" || printEnabledType === "");
          const defaultMaxPrints = maxPrints?.maxPrintsPerReader !== undefined ? maxPrints.maxPrintsPerReader : maxPrintsPerReader.current;
          setInputFields([
            {
              email: "",
              firstName: "",
              lastName: "",
              authType: "",
              mobileCountryCode: [],
              mobileNumber: "",
              reference: "",
              canPrint: enablePrint,
              maxPrintsPerReader: enablePrint ? (defaultMaxPrints ?? "") : ""
            }
          ]);
          setModalForLevel3AddUser(true);
        }
        if (
          countryCodeDrpOptions.length == 0 ||
          countryCodeOptions.length == 0
        ) {
          fetchCountryCodes();
        }
        setOpen(false);
      } else {
        var arrCidrs = [];
        for (let item of document
          .getElementById("multipleips")
          .attributes["constmultipleips"].value?.split(",")) {
          arrCidrs.push(item);
        }
        var mapContinets = document.getElementsByClassName(
          "map-selected gContinent"
        );
        var arrMapContinents = [];
        if (mapContinets.length === 0) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes
              .UI_AtleastOneRegionShouldbePermitted
          );
          setAlertType("warning");
          handlerSetDatesControlStatus();
          flag = false;
          return false;
        }
        for (let item of mapContinets) {
          arrMapContinents.push(parseInt(item.id));
        }
        var calstarttime = "";
        var calexpiryTime = "";
        var tempStarttime = rollbackFinalToLocal(startTime, timeZoneRef.current);
        var tempExpiryTime = rollbackFinalToLocal(expiryTime, timeZoneRef.current);
        if (
          tempStarttime != "" &&
          tempStarttime != null &&
          tempStarttime != "Invalid date"
        ) {
          if (isDatetimeControl == "false") {
            calstarttime =
              moment(tempStarttime).format("YYYY-MM-DDTHH:mm");
          } else {
            //calstarttime=startTime;
            calstarttime = moment(tempStarttime).format("YYYY-MM-DDTHH:mm");
          }
        }
        if (
          tempExpiryTime != "" &&
          tempExpiryTime != null &&
          tempExpiryTime != "Invalid date"
        ) {
          if (isDatetimeControl == "false") {
            calexpiryTime =
              moment(tempExpiryTime).format("YYYY-MM-DD") + "T23:59:59Z";
          } else {
            //calexpiryTime=expiryTime;
            calexpiryTime = moment(tempExpiryTime).format("YYYY-MM-DDTHH:mm");
          }
        }
        if (isDatetimeControl == "false") {
          if (
            startTime != "" &&
            startTime != null &&
            startTime != "Invalid date" &&
            expiryTime != "" &&
            expiryTime != null &&
            expiryTime != "Invalid date" &&
            startTime > expiryTime
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
            handlerSetDatesControlStatus();
            flag = false;
            return false;
          }
        } else {
          if (
            startTime != "" &&
            startTime != null &&
            moment(startTime).format("YYYY-MM-DDTHH:mm") != "Invalid date" &&
            expiryTime != "" &&
            expiryTime != null &&
            moment(expiryTime).format("YYYY-MM-DDTHH:mm") != "Invalid date" &&
            moment(startTime).format("YYYY-MM-DDTHH:mm").split("T")[0] >
            moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
          ) {
            setAlertMsg(
              selectedLanguage.LstLanguageCodes.UI_TheExpirydateCannotBefore
            );
            setAlertType("warning");
            setAlertClass("alerthist-ip");
            handlerSetDatesControlStatus();
            flag = false;
            return false;
          }
          if (
            expiryTime != "" &&
            expiryTime != null &&
            moment(startTime).format("YYYY-MM-DDTHH:mm").split("T")[0] ==
            moment(expiryTime).format("YYYY-MM-DDTHH:mm").split("T")[0]
          ) {
            const [endHour, endMinute] = moment(expiryTime)
              .format("YYYY-MM-DDTHH:mm")
              .split("T")[1]
              .split(":")
              .map(Number);
            const [startHour, startMinute] = moment(startTime)
              .format("YYYY-MM-DDTHH:mm")
              .split("T")[1]
              .split(":")
              .map(Number);
            if (
              startHour > endHour ||
              (startHour === endHour && startMinute > endMinute)
            ) {
              setAlertMsg(
                selectedLanguage.LstLanguageCodes.UI_TheExpirytimeCannotBefore
              );
              setAlertType("warning");
              setAlertClass("alerthist-ip");
              flag = false;
              return false;
            }
          }
        }

        if (
          domains !== "" &&
          domains?.split(",").length == 1 &&
          domains.length > 190
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum
          );
          setAlertType("warning");
          handlerSetDatesControlStatus();
          flag = false;
          return false;
        }
        var domainvalidation = false;
        if (domains !== "" && domains?.split(",").length > 1) {
          domains?.split(",").forEach((element) => {
            if (element.length > 190 && !domainvalidation) {
              domainvalidation = true;
            }
          });
        }
        if (domainvalidation) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum
          );
          setAlertType("warning");
          handlerSetDatesControlStatus();
          flag = false;
          return false;
        }
        const restrictToDomains = domains !== "" ? domains.split(",").map(d => d.trim()) : [];
        if (restrictToDomains.length >= 1) {
          const uniqueDomains = new Set();
          for (let domain of restrictToDomains) {
            if (uniqueDomains.has(domain.toLowerCase())) {
              setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateDomain);
              setAlertType("warning");
              return;
            }
            uniqueDomains.add(domain.toLowerCase());
            const regex = /^[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/;
            if (!regex.test(domain)) {
              setAlertMsg(selectedLanguage.LstLanguageCodes.UI_InvalidDomain);
              setAlertType("warning");
              return;
            }
          }
        }
        if (flag == true) {
          itemDocumentsHistory.documentOptions.openRecord = openRecord;
          itemDocumentsHistory.documentOptions.geolocation = geolocation;
          itemDocumentsHistory.documentOptions.readTimes = readTimes;
          itemDocumentsHistory.documentOptions.readTiming = readTiming;
          itemDocumentsHistory.documentOptions.distRestriction =
            distRestriction;
          itemDocumentsHistory.documentOptions.readNotification =
            readNotification;
          itemDocumentsHistory.documentOptions.readerEmail = readerEmail;

          if (startTime === "" || startTime === null)
            itemDocumentsHistory.documentOptions.startTime = null;
          else itemDocumentsHistory.documentOptions.startTime = calstarttime;
          if (expiryTime === "" || expiryTime === null)
            itemDocumentsHistory.documentOptions.expiryTime = null;
          else if (
            moment(expiryTime).format("YYYY-MM-DDTHH:mm") == "Invalid date"
          )
            itemDocumentsHistory.documentOptions.expiryTime = null;
          else itemDocumentsHistory.documentOptions.expiryTime = calexpiryTime;
          itemDocumentsHistory.documentOptions.domains = domains;
          itemDocumentsHistory.documentOptions.maxReads = maxReads;
          itemDocumentsHistory.documentOptions.maxViewsPerDocument =
            maxViewsPerDocument;
          const responseAddressEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
          if (constAllowResFlag && responseAddress && !responseAddressEmailRegex.test(responseAddress.trim())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
            setAlertType("warning");
            flag = false;
            return false;
          }
          itemDocumentsHistory.documentOptions.allowResponsesTo =
            responseAddress;
          itemDocumentsHistory.documentOptions.steganography = steganography;
          itemDocumentsHistory.documentOptions.print = canPrint;
          itemDocumentsHistory.documentOptions.maxPrintsPerReader = maxPrintsFields.current?.maxPrintsPerReader == "" ? 0 : maxPrintsFields.current?.maxPrintsPerReader;
          itemDocumentsHistory.documentOptions.maxPrintsPerDocument = maxPrintsFields.current?.maxPrintsPerDocument == "" ? 0 : maxPrintsFields.current?.maxPrintsPerDocument;
          itemDocumentsHistory.documentOptions.isPrintEnabledForEveryone = (printEnabledType === "everyone" || printEnabledType === "");
          itemDocumentsHistory.documentOptions.voting = voting;
          itemDocumentsHistory.documentOptions.voteSharing = voteSharing;
          itemDocumentsHistory.documentOptions.distributionList =
            distributionList;
          if (expiryChnagedPopup.current == true)
            itemDocumentsHistory.documentOptions.enabled = true;
          itemDocumentsHistory.documentOptions.ips = arrCidrs;
          itemDocumentsHistory.documentOptions.regions = arrMapContinents;
          itemDocumentsHistory.documentOptions.verifyCode = verifyCode;
          const hasExceededDocumentLimit = (recipientPrintData).some((reader) => reader.canPrint === true && Number(reader.maxPrintsPerReader || 0) > Number(currentMaxPrintsPerDocument || 0));
          if (currentMaxPrintsPerDocument != "" && hasExceededDocumentLimit) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocumentLessThanReaderPrintLimit);
            setAlertType("warning");
            flag = false;
            return false;
          }
          if (letMePickCancelRef.current === false) {
            const recipientsToSave = (recipientListPass ?? fullSelectList).map(recipient => {
              const updated = recipientPrintData.find(r => r.email.toLowerCase() === recipient.email.toLowerCase());
              const value = updated?.maxPrintsPerReader ? parseInt(updated?.maxPrintsPerReader, 10) : null;
              if (!updated) {
                if (!itemDocumentsHistory.documentOptions.print) {
                  return { ...recipient, canPrint: false, maxPrintsPerReader: null };
                }
                return recipient;
              }
              return { ...recipient, canPrint: (itemDocumentsHistory.documentOptions.print && updated.canPrint), maxPrintsPerReader: itemDocumentsHistory.documentOptions.print ? ((updated.maxPrintsPerReader == null) ? (null) : value) : null };
            });
            itemDocumentsHistory.documentOptions.recipients = recipientsToSave;
            setRecipientPrintData(JSON.parse(JSON.stringify(recipientsToSave)));
          }
          itemDocumentsHistory.documentOptions.pageLevelRestriction =
            pageLevelResRef.current.checked;
          itemDocumentsHistory.documentOptions.eDisclosure =
            EDisclosureResRef?.current?.checked;
          if (emailAuth.current) {
            itemDocumentsHistory.documentOptions.isSMS = false;
            itemDocumentsHistory.documentOptions.isEmail = true;
            itemDocumentsHistory.documentOptions.isBoth = false;
          }
          if (IsSMS) {
            itemDocumentsHistory.documentOptions.isEmail = false;
            itemDocumentsHistory.documentOptions.isSMS = true;
            itemDocumentsHistory.documentOptions.isBoth = false;
          }
          if (multiAuth.current) {
            itemDocumentsHistory.documentOptions.isEmail = true;
            itemDocumentsHistory.documentOptions.isSMS = true;
            itemDocumentsHistory.documentOptions.isBoth = true;
          }
          if (changeOfAuthType.current) {
            itemDocumentsHistory.documentOptions.recipients.forEach(
              (recipient) => {
                recipient.authType = selectedOptions[0].value;
              }
            );
            changeOfAuthType.current = false;
          }

          delete itemDocumentsHistory.documentId;
          delete itemDocumentsHistory.pages;
          delete itemDocumentsHistory.rpdType;

          controlStatusAPICall(itemDocumentsHistory);

        }
      }
      restoreRestrictions.current = false;
      letMePickCancelRef.current = false;
      backUpOfConfiguredRestrictions.current = [];
      setIsExpireChangePopup(false);
    } catch (error) {
      setOpen(false);
      console.error(error);
    }
  }
  async function controlStatusAPICall(itemDocumentsHistory) {
    setOpen(true);
    const formData = new FormData();
    const deletedata = deleteSelectionOfRestriction.filter(
      (id) => id != "undefined"
    ); // Filter even numbers
    itemDocumentsHistory.documentOptions.pageRestrictions =
      restoreRestrictions.current && securityLevelTextColor === "level1" ? selectionOfRestriction.filter((item) => {
        if (item.category === "No Readers") {
          return { ...item };
        }
      }) : selectionOfRestriction;
    itemDocumentsHistory.deletedata =
      Array.isArray(deletedata) && deletedata.length > 0 ? deletedata : null;
    itemDocumentsHistory.isNewRecipientAdded = isNewRecipientAdded;
    if (isPageRestrictionsChanged) {
      try {
        for (const origReq of approvedRequests) {
          const matchingUpdatedRows = updatedApprovedRequests.filter(
            (upReq) => upReq.originalRequestId === origReq.id
          );

          const updatedPages = [
            ...new Set(
              matchingUpdatedRows.reduce(
                (acc, row) => acc.concat(row.approvedPages || []),
                []
              )
            )
          ].sort((a, b) => a - b);

          const origPages = (origReq.approvedPages || []).sort((a, b) => a - b);

          const isSame =
            updatedPages.length === origPages.length &&
            updatedPages.every((page, idx) => page === origPages[idx]);

          const requestedPages = origReq.requestedPages || [];
          const totalRequested = requestedPages.length;
          const totalApproved = origPages.length;
          let status = "";
          if (totalApproved === totalRequested)
            status = "Approved";
          else if (totalApproved > 0)
            status = "Partially Approved";
          else
            status = updatedPages.length === 0 ? "Declined" : "Approved";

          if (!isSame) {
            const requestAccessUpdate = {
              id: origReq.id,
              documentId: origReq.documentId,
              status: status,
              senderNotes: "Updated due to restriction changes",
              NotifyReader: false,
              approvedPages: updatedPages,
            };
            await APIRequest.PUT(
              JSON.stringify(requestAccessUpdate),
              `${process.env.REACT_APP_API +
              process.env.REACT_APP_API_PendingPageLevelRequestAccessUpdate
              }`
            );
          }
        }
      } catch (err) {
        console.error("Error syncing approved access requests on save:", err);
      }
      isPageRestrictionsChanged = false;
    }

    var response = await APIRequest.PUT(
      JSON.stringify(itemDocumentsHistory),
      `${process.env.REACT_APP_API +
      process.env.REACT_APP_API_PutDocumentRoleBased
      }` +
      "/" +
      popupDocumentId
    );
    if (response && response === "Server maintenance") {
      history("/maintenance");
      return;
    } else if (response.hasPendingReaders === true) {
      // One or more readers have pending/declined requests — close any open sub-modals
      // and show the pending confirmation popup
      controlStatusPendingPayload.current = itemDocumentsHistory;
      setModalForLevel3AddUser(false);
      setModalForControlStatusPendingConfirmation(true);
      setOpen(false);
      return;
    } else if (response.status == 200) {
      if (response.errorMessage != undefined && response.errorMessage != "") {
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return false;
      }
      setModalForControlStatus(false);
      //setPopupDocumentId("");
      setModalForControlStatusConfirmation(true);
    } else {
      if (response.errorMessage != undefined && response.errorMessage != "") {
        if (response.readerEmail) {
          if (response.readerEmail.length > 0) {
            const readerrecipients =
              itemDocumentsHistory.documentOptions.recipients.filter(
                (item) =>
                  !response.readerEmail.some(
                    (reader) => reader.readerEmail === item.email
                  )
              );
            setLstDocumentsHistory(
              lstDocumentsHistory.map((item) => {
                //console.log(item.documentId);
                if (item.documentId == popupDocumentId) {
                  return {
                    ...item,
                    documentOptions: {
                      ...item.documentOptions,
                      recipients: readerrecipients,
                    },
                  };
                } else return { ...item };
              })
            );
          }
        }
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        setOpen(false);
        return false;
      }
    }
    setOpen(false);
    setModalForLevel3AddUser(false);
    setModalForControlStatus(false);
    isNewRecipientAdded = false;
    // setSelectionOfRestriction([]);
    setDeleteSelectionOfRestriction([]);
    setInputFields([
      {
        email: "",
        firstName: "",
        lastName: "",
        mobileCountryCode: [],
        mobileNumber: "",
        reference: "",
      },
    ]);
  }
  const ControlStatusConfirmation = () => {
    currentPageViewCount = pageView;
    currentPagevalue = currentPage;
    if (sortDown.current) {
      setSortBy("desc");
      documentsList("desc", popupDocumentId);
    } else {
      documentsList("asc", popupDocumentId);
      setSortBy("asc");
    }
    setModalForControlStatusConfirmation(false);
  };

  async function handlerModelConfirmKill() {
    // var items = lstDocumentsHistory.filter(
    //   (element) => element.selection === true
    // );

    const allDocs = selectedSearchRecords.reduce((accumulator, item) => {
      return accumulator.concat(item.docs);
    }, []);
    //console.log(allDocs);
    for (const documentId of allDocs) {
      var response = await APIRequest.DELETE(
        `${process.env.REACT_APP_API + process.env.REACT_APP_API_DeleteDocument
        }` +
        "\\" +
        documentId +
        "\\" +
        killNotes
      );
      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      }
      setMasterSelection(false);
    }

    setModalIsOpen(false);
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setSelectedSearchRecords((prev) => {
      return [{ page: 0, docs: [] }];
    });
    setIsControlClick((prev) => {
      return { ...prev, isKilled: true };
    });
  }

  async function handlerModelConfirmForAddUser(editRecipient) {
    try {

      var documentid = popupDocumentId;
      let itemDocumentsHistory = lstDocumentsHistory.find((element) => element.documentId == documentid);
      maxPrintsPerDocument.current = itemDocumentsHistory?.documentOptions?.maxPrintsPerDocument;
      var recipientdata = [];
      var validateFn = false;
      var validateLn = false;
      var validReference = false;
      var validation = 0;
      // const mobileSet = new Set();
      const numberCounts = {};
      inputFields.map((item, i) => {
        if (item.firstName != null && item.firstName.trim().length > 50) {
          validateFn = true;
        }
        if (item.lastName != null && item.lastName.trim().length > 50) {
          validateLn = true;
        }
        if (item.reference != null && item.reference.trim().length > 50) {
          validReference = true;
        }
        if (
          item.mobileCountryCode?.value != null &&
          item.mobileCountryCode?.value !== "+Code" &&
          (item.mobileNumber === "" || item.mobileNumber === undefined)
        ) {
          validation = 1; // Validation message: "Please enter mobile number."
        } else if (
          item.mobileNumber !== "" &&
          item.mobileNumber !== undefined &&
          (item.mobileCountryCode == undefined ||
            item.mobileCountryCode.length == 0 ||
            item.mobileCountryCode?.value == "+Code")
        ) {
          validation = 2; // Validation message: "Please select country code."
        } else if (
          item.mobileNumber &&
          item.mobileCountryCode?.mobileMaxLeng &&
          item.mobileNumber.length !== item.mobileCountryCode?.mobileMaxLeng
        ) {
          validation = 3; // Validation message: "Please enter a valid mobile number."
        } else if (item.mobileNumber) {
          const code = item.mobileCountryCode?.value ?? "";
          const fullNumber = `${code}${item.mobileNumber}`.trim();
          if (fullNumber !== "" && code !== "+Code") {
            numberCounts[fullNumber] = (numberCounts[fullNumber] || 0) + 1;
            if (numberCounts[fullNumber] > 1) {
              validation = 4;
            }
          }
        } else if ((readerPrint && (maxPrintsPerDocument?.current !== 0 && (maxPrintsPerIndReader > maxPrintsPerDocument?.current))) || (maxPrintsPerDocument?.current !== 0 && (item.maxPrintsPerReader > maxPrintsPerDocument?.current))) {
          validation = 5;
        }
      });
      if (editRecipient == true) {
        if (firstName && firstName.trim().length > 50) validateFn = true;
        if (lastName && lastName.trim().length > 50) validateLn = true;
        if (reference && reference.trim().length > 50) validReference = true;
      }
      if (validateFn == true) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FirstNameMoreThanFifty);
        setAlertType("warning");
        return;
      }
      if (validateLn == true) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_LastNameMoreThanFifty);
        setAlertType("warning");
        return;
      }
      if (validReference == true) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ReferenceMoreThanFifty);
        setAlertType("warning");
        return;
      }

      if (validation == 1) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterMobileNumber);
        setAlertType("warning");
        return;
      } else if (validation == 2) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode);
        setAlertType("warning");
        return;
      } else if (validation == 3) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidNumber);
        setAlertType("warning");
        return;
      } else if (validation === 4) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum);
        setAlertType("warning");
        return;
      } else if (validation === 5) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
        setAlertType("warning");
        return;
      }

      inputFields.map((item, i) => {
        if (item.email != null && item.email != "") {
          recipientdata.push({
            email: item.email,
            firstName: item.firstName?.trim(),
            lastName: item.lastName?.trim(),
            mobileCountryCode:
              item.mobileCountryCode &&
                item.mobileCountryCode?.value?.length > 0 &&
                item.mobileCountryCode?.value != "+Code"
                ? item.mobileCountryCode?.value.trim()
                : "",
            mobileNumber: item.mobileNumber?.trim(),
            reference: item.reference?.trim(),
            authType: item.authType,
            canPrint: item.canPrint,
            maxPrintsPerReader: ((item.canPrint && item.maxPrintsPerReader) ? item.maxPrintsPerReader : null)
          });
        } else if (
          item.email == "" &&
          (item.firstName?.trim() != "" ||
            item.lastName?.trim() ||
            (item.mobileCountryCode &&
              item.mobileCountryCode.value?.length > 0 &&
              item.mobileCountryCode.value != "+Code") ||
            item.mobileNumber?.trim() != "" ||
            item.reference?.trim() != "") &&
          !editRecipient
        ) {
          validation = 5;
        }
      });
      if (validation === 5) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
        setAlertType("warning");
        return;
      }
      if (editRecipient == true) {
        if (
          (selectedCode == undefined || selectedCode == "") &&
          mobileNumber != "" &&
          mobileNumber != undefined
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode
          );
          setAlertType("warning");
          return;
        } else if (
          selectedCode &&
          (selectedCode.value == "+Code" || selectedCode.value == null) &&
          mobileNumber != "" &&
          mobileNumber != undefined
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode
          );
          setAlertType("warning");
          return;
        } else if (
          selectedCode &&
          selectedCode.value != "+Code" &&
          selectedCode.length != 0 &&
          (mobileNumber == "" || mobileNumber == undefined)
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseEnterMobileNumber
          );
          setAlertType("warning");
          return;
        } else if (
          selectedCode &&
          mobileNumber &&
          selectedCode.mobileMaxLeng != mobileNumber.length
        ) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidNumber
          );
          setAlertType("warning");
          return;
        }
        recipientdata.push({
          id: currentRecipientId,
          email: currentEmail,
          firstName: firstName?.trim(),
          lastName: lastName?.trim(),
          MobileCountryCode:
            selectedCode && selectedCode.value != "+Code" ? selectedCode?.value : "",
          MobileNumber: mobileNumber,
          reference: reference?.trim(),
          authType: verificationCode,
          canPrint: readerPrint,
          maxPrintsPerReader: ((readerPrint && maxPrintsPerIndReader) ? maxPrintsPerIndReader : null)
        });
      }
      var invalidEmail = false;
      if (!editRecipient && inputFields.some((item) => item.email === "")) {
        invalidEmail = true;
      }
      const strictEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
      recipientdata.forEach((element) => {
        if ((!strictEmailRegex.test(element.email) || element.email === "") && !invalidEmail) {
          invalidEmail = true;
        }
      });
      if (invalidEmail == true) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
        setAlertType("warning");
        return;
      }
      setNewReceipentsCount(recipientdata.length);
      if (recipientdata.length == 0) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_RequiredAuthorized);
        setAlertType("warning");
        return;
      }
      let tempItemDocumentHistory = orgLstDocumentsHistory.find(
        (element) => element.documentId == popupDocumentId
      );

      var addRecipient = {
        id: popupDocumentId,
        isEdit: editRecipient,
        confirmPending: false,
        recipients: recipientdata,
      };
      setRecipientPrintData(JSON.parse(JSON.stringify(recipientdata)));
      setOpen(true);
      var jsonDocs = await APIRequest.PUT(
        JSON.stringify(addRecipient),
        `${process.env.REACT_APP_API + process.env.REACT_APP_API_AddRecipients}`
      );
      if (jsonDocs != "") {
        if (jsonDocs && jsonDocs === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (jsonDocs.hasPendingReaders === true) {
          pendingConfirmPayload.current = addRecipient;
          pendingConfirmEditFlag.current = editRecipient;
          setModalForPendingReaderConfirmation(true);
          setOpen(false);
          return;
        } else if (
          jsonDocs.errorMessage != undefined &&
          jsonDocs.errorMessage != ""
        ) {
          setAlertMsg(jsonDocs.errorMessage);
          setAlertType("warning");
          setOpen(false);
          return;
        }
        if (editRecipient != true) {
          setModalForAddUserConfirmation(true);
          setModalForAddUser(false);
          //setPopupDocumentId("");
          setInputFields([
            {
              email: "",
              firstName: "",
              lastName: "",
              mobileCountryCode: [],
              mobileNumber: "",
            },
          ]);
          setOpen(false);
        } else {
          if (sortDown.current) {
            setSortBy("desc");
            documentsList("desc", popupDocumentId);
          } else {
            documentsList("asc", popupDocumentId);
            setSortBy("asc");
          }
          setPopupDocumentId("");
          setIsModalFnLnOpen(false);
        }
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const AddUserConfirmation = () => {
    if (sortDown.current) {
      setSortBy("desc");
      documentsList("desc", popupDocumentId);
    } else {
      documentsList("asc", popupDocumentId);
      setSortBy("asc");
    }
    setPopupDocumentId("");
    setModalForAddUserConfirmation(false);
  };

  const handlePendingReaderCancel = () => {
    pendingConfirmPayload.current = null;
    pendingConfirmEditFlag.current = false;
    setModalForPendingReaderConfirmation(false);
  };

  const handlePendingReaderConfirm = async () => {
    setModalForPendingReaderConfirmation(false);
    try {
      const payload = { ...pendingConfirmPayload.current, confirmPending: true };
      const editRecipient = pendingConfirmEditFlag.current;
      pendingConfirmPayload.current = null;
      pendingConfirmEditFlag.current = false;
      setOpen(true);
      var jsonDocs = await APIRequest.PUT(
        JSON.stringify(payload),
        `${process.env.REACT_APP_API + process.env.REACT_APP_API_AddRecipients}`
      );
      if (jsonDocs != "") {
        if (jsonDocs && jsonDocs === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (
          jsonDocs.errorMessage != undefined &&
          jsonDocs.errorMessage != ""
        ) {
          setAlertMsg(jsonDocs.errorMessage);
          setAlertType("warning");
          setOpen(false);
          return;
        }
        if (editRecipient != true) {
          setModalForAddUserConfirmation(true);
          setModalForAddUser(false);
          setInputFields([
            {
              email: "",
              firstName: "",
              lastName: "",
              mobileCountryCode: [],
              mobileNumber: "",
            },
          ]);
          setOpen(false);
        } else {
          if (sortDown.current) {
            setSortBy("desc");
            documentsList("desc", popupDocumentId);
          } else {
            documentsList("asc", popupDocumentId);
            setSortBy("asc");
          }
          setPopupDocumentId("");
          setIsModalFnLnOpen(false);
        }
      }
    } catch (error) {
      console.error("Error confirming pending readers:", error);
    }
  };


  const handleControlStatusPendingCancel = () => {
    controlStatusPendingPayload.current = null;
    setModalForControlStatusPendingConfirmation(false);
    setModalForLevel3AddUser(true);
  };

  const handleControlStatusPendingConfirm = async () => {
    setModalForControlStatusPendingConfirmation(false);
    const payload = { ...controlStatusPendingPayload.current, confirmPending: true };
    controlStatusPendingPayload.current = null;
    await controlStatusAPICall(payload);
  };

  async function RDocsDefaultSettingsData() {
    var url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetSettingDetails
      }`;
    var userEmailID = localStorage.getItem("UserName");
    try {
      var response = await APIRequest.GET(
        "",
        url +
        "?SettingFor=User&Lang=" +
        localStorage.getItem("language") +
        "&userEmail=" +
        userEmailID
      );

      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      }
      if (response && response.setting) {
        var securitylevelvalue = 0;
        response.setting.forEach((item) => {
          if (item.type === "DateFormat") {
            const colonIndex = item.keyValue.indexOf(":");
            if (colonIndex !== -1) {
              const dateFormat = item.keyValue.substr(colonIndex + 1).trim();
              setDateFormatValueUpper(dateFormat.toUpperCase());
              setDateFormatValueLower(dateFormat.toLowerCase());
              setDateFormatValueOriginal(dateFormat);
            }
          }
          if (item.type === "PageLevelRestrictions") {
            setIsPageLevelRestrictionSetting(item.keyValue);
          } else if (item.type === "TimeZone") {
            const tzString = item.keyValue;
            const match = tzString && tzString.match(/([+-]\d{2}:\d{2})/);
            const timeZoneValue = match && match[1] ? match[1] : "+00:00";
            timeZoneRef.current = timeZoneValue;

            const abbrevation = item.keyValue.match(/_(.*)$/);
            timeZoneAbbrevation.current = abbrevation ? abbrevation[1] : "UTC";

            localStorage.setItem("timeZoneAbbrevation", timeZoneAbbrevation.current);
            setSortedColumns(prevColumns =>
              prevColumns?.map(col => ({
                ...col,
                label: getLabelWithTimeZone(
                  col.label,
                  selectedLanguage,
                  timeZoneAbbrevation
                )
              }))
            );
          }

        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async function handlerActiveInactive(
    e,
    enabled,
    documentId,
    isHistoryExits,
    confirmationFlag
  ) {
    if (e !== '')
      e.stopPropagation();
    var confirmation = true;
    let expiryTimes = [];
    let documentIds = documentId
      ? [documentId]
      : [...selectedSearchRecords[0].docs];

    if (documentId !== "") {
      let tempItemDocumentHistory = orgLstDocumentsHistory.find(
        (element) => element.documentId == documentId
      );
      if (enabled == true && confirmationFlag == false) {
        if (
          tempItemDocumentHistory.documentOptions.expiryTime != null &&
          moment(tempItemDocumentHistory.documentOptions.expiryTime).tz("UTC") <
          moment(new Date()).tz("UTC")
        ) {
          confirmation = false;
          setModalActiveIsOpen(true);
          setActiveIsOpenEvent(e);
          setActiveIsOpenDocId(documentId);
          setActiveIsOpenHistoryFlag(isHistoryExits);
        }
      }
    }
    if (confirmation) {
      setOpen(true);
      const url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_ActiveInactive
        }`;
      let documentStatus = {
        documentId: documentIds,
        status: enabled,
      };
      const jwtToken = localStorage.getItem("JWtToken");
      const jsonDocs = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(documentStatus),
      })
        .then((responce) => {
          if (responce.status == 502) {
            return "Server maintenance";
          } else {
            return responce.json();
          }
        })
        .then((data) => {
          //console.log(data);
          return data;
        })
        .catch((err) => {
          console.log("error" + err);
          setOpen(false);
          setOpenLoaderSearch(false);
          return err.message;
        });

      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (jsonDocs == 200) {
        currentPagevalue = currentPage;
        setTrackInteractivityDetails((prevDetails) => {
          return prevDetails.map((detail) => {
            if (documentIds.includes(detail.docId)) {
              const updatedRecords = detail.records.map((record, index) => {
                return {
                  ...record,
                  status:
                    (record.enabled == false &&
                      record.status == "Pause" &&
                      enabled == true)
                      ? "Active"
                      : (record.enabled == true &&
                        record.status == "Active" &&
                        enabled == false)
                        ? "Pause"
                        : "Banned",
                  enabled:
                    record.status == "Banned" ? record.enabled : enabled,
                };
              });
              return {
                ...detail,
                records: updatedRecords,
              };
            }
            return detail;
          });
        });
        backupRecords.current = true;
        setLstDocumentsHistory(
          lstDocumentsHistory.map((element, i) => {
            if (documentIds.includes(element.documentId)) {
              element.isHistoryRecordsExists = isHistoryExits;
              return {
                ...element,
                documentOptions: {
                  ...element.documentOptions,
                  enabled: enabled,
                  expiryTime:
                    confirmationFlag == true &&
                      enabled &&
                      element.documentOptions.expiryTime != null &&
                      moment(element.documentOptions.expiryTime).tz("UTC") <
                      moment(new Date()).tz("UTC")
                      ? null
                      : element.documentOptions.expiryTime,
                  recipients: element.documentOptions.recipients.map(
                    (email) => ({
                      email: email.email,
                      id: email.id,
                      code: email.code,
                      readCount: email.readCount,
                      status:
                        (email.enabled == false &&
                          email.status == "Pause" &&
                          enabled == true)
                          ? "Active"
                          : (email.enabled == true &&
                            email.status == "Active" &&
                            enabled == false)
                            ? "Pause"
                            : "Banned",
                      vote: email.vote,
                      enabled:
                        email.status == "Banned" ? email.enabled : enabled,
                      firstName: email.firstName,
                      lastName: email.lastName,
                      recipientType: email.recipientType,
                    })
                  ),
                },
              };
            } else return { ...element };
          })
        );
        setOrgLstDocumentsHistory(
          orgLstDocumentsHistory.map((item) => {
            if (documentIds.includes(item.documentId)) {
              item.isHistoryRecordsExists = isHistoryExits;
              return {
                ...item,
                documentOptions: {
                  ...item.documentOptions,
                  enabled: enabled,
                  expiryTime:
                    confirmationFlag == true &&
                      enabled &&
                      item.documentOptions.expiryTime != null &&
                      moment(item.documentOptions.expiryTime).tz("UTC") <
                      moment(new Date()).tz("UTC")
                      ? null
                      : item.documentOptions.expiryTime,
                  recipients: item.documentOptions.recipients.map((email) => ({
                    email: email.email,
                    id: email.id,
                    code: email.code,
                    readCount: email.readCount,
                    status:
                      email.enabled == false &&
                        email.status == "Pause" &&
                        enabled == true
                        ? "Active"
                        : email.enabled == true &&
                          email.status == "Active" &&
                          enabled == false
                          ? "Pause"
                          : "Banned",
                    vote: email.vote,
                    enabled: email.status == "Banned" ? email.enabled : enabled,
                    firstName: email.firstName,
                    lastName: email.lastName,
                  })),
                },
              };
            } else return { ...item };
          })
        );
        // setIsControlClick((prev) => {
        //   return { ...prev, isBanOrActive: true };
        // });
        if (!documentId) {
          handleClearRecordCount();
        }
        setIsExpireChangePopup(false);
        setOpen(false);
        setOpenLoaderSearch(false);
        setModalActiveIsOpen(false);
      }
    }
  }
  async function handlerUserActiveInactive(e, uStatus, documentId, email) {
    e.stopPropagation();
    currentPagevalue = currentPage;
    const url =
      `${process.env.REACT_APP_API +
      process.env.REACT_APP_API_RecipientActiveInactive
      }` +
      "/" +
      documentId +
      "/" +
      uStatus +
      "/" +
      email;
    var jsonDocs = await APIRequest.POSTSaveSettings("", url);
    if (jsonDocs && jsonDocs === "Server maintenance") {
      history("/maintenance");
      return;
    } else if (jsonDocs == 200) {
      currTrackDetails.current = { docId: documentId, recipientEmail: email };
      documentsList("", documentId);
    }
  }
  function clearPageLevelRestrictions() {
    pageLevelResRef.current.checked = false;
    setIsPageLevelRestrictionChecked(false);
    setSelectionOfRestriction([]);
  }
  const handleLevelChange = (e, maxPrints = {}) => {
    maxPrintsFields.current = { ...maxPrints };
    setConstSecurityLevelText(e.target.value);
    //  setSecurityLevelTextColor("level1");
    const previousSelectedValue = constSecurityLevelText;
    if (e.target.value === "Track Views") {
      setSecurityLevelTextColor("level1");
      if (selectionOfRestriction.length > 0) {
        backUpOfConfiguredRestrictions.current = [...selectionOfRestriction];
        const includesNoReaders = selectionOfRestriction.some((item) => item.category === "No Readers") && (selectionOfRestriction.some((item) => item.category === "Selected Readers") || selectionOfRestriction.some((item) => item.category === "Everyone Except Selected Readers"));
        const exceptNoReaders = selectionOfRestriction.some((item) => item.category !== "No Readers") && (selectionOfRestriction.some((item) => item.category === "Selected Readers") || selectionOfRestriction.some((item) => item.category === "Everyone Except Selected Readers"))
        if (includesNoReaders) {
          const msg = selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemovedExceptNoReaders;
          unSaveWarnModal.current.open(
            msg,
            () => {
              setIsPageLevelRestrictionChecked(true);
              restoreRestrictions.current = true;
              const removedData = selectionOfRestriction.filter(item => item.category !== "No Readers").map(item => item.id).filter(id => id !== undefined);
              setDeleteSelectionOfRestriction(removedData);
              level1();
              setConstSecurityLevelText(e.target.value);
            },
            () => {
              setIsPageLevelRestrictionChecked(true);
              pageLevelResRef.current.checked = true;
              setSecurityLevelTextColor(previousSelectedValue == "Track Readers" ? "level2" : "");
              setConstSecurityLevelText(previousSelectedValue);
              return;
            }
          );
        } else if (exceptNoReaders) {
          const msg = selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
          unSaveWarnModal.current.open(
            msg,
            () => {
              setSelectionOfRestriction([]);
              clearPageLevelRestrictions();
              level1();
              setConstSecurityLevelText(e.target.value);
              restoreRestrictions.current = true;

              const deleteData = pageLevelBckupDBData.current.filter((item) => {
                return selectionOfRestriction.filter((record) => {
                  return record.id !== item.id;
                })
              }).map((item) => item.id);
              setDeleteSelectionOfRestriction([...deleteData]);
              console.log(pageLevelBckupDBData.current);


            },
            () => {
              setSecurityLevelTextColor(previousSelectedValue == "Track Readers" ? "level2" : "");
              setConstSecurityLevelText(previousSelectedValue);
              pageLevelResRef.current.checked = true;

            }
          );
        }
        else {
          level1();
          setConstSecurityLevelText(e.target.value);
        }
      }
      else {
        level1();
      }

      function level1() {
        var firstone = document.getElementsByClassName("user_register");
        for (let i = 0; i < firstone.length; i++) {
          firstone[i].classList.add("disable_sectionChailed");
        }

        document.getElementById("distribution").checked = false;
        document.getElementById("voting").checked = false;
        document.getElementById("voteShare").checked = false;
        document.getElementById("txtRestrictDomains").disabled = true;
        document.getElementById("maxReads").disabled = true;
        document.getElementById("chkIdentifyLeakers").checked = false;
        document
          .getElementById("chkIdentifyLeakersDiv")
          .classList.add("disable_sectionChailed");
        setMaxReads(0);
        setMaxReadsText("");
        setDomains("");
        setOpenRecord(true);
        setGeolocation(true);
        setVerifyCode(false);
        setReadTimes(true);
        setReadTiming(true);
        setReaderEmail(false);
        setDistRestriction(false);
        setReadNotification(false);
        setDistributionList(false);
        setVoting(false);
        setVoteSharing(false);
        setSteganography(false);
        setIsPageLevelRestriction(true);
        // setIsEDisclosureChecked(false);
        setSendVerificationCodeDisable(true);
        setIsSMS(false);
      }
    } else if (
      e.target.value === "Track Readers"
    ) {
      setSecurityLevelTextColor("level2");
      pageLevelResRef.current.disabled = false;
      EDisclosureResRef.current.disabled = false;
      setEDisclosure(isEDisclosureref.current);
      setIsEDisclosureChecked(isEDisclosureCheckedref.current);
      if (
        selectionOfRestriction.length > 0 ||
        deleteSelectionOfRestriction.length > 0
      ) {
        setIsPageLevelRestrictionChecked(true);
      } else {
        setIsPageLevelRestrictionChecked(
          isPageLevelRestrictionCheckedref.current
        );
      }
      setIsPageLevelRestriction(true);
      if (backUpOfConfiguredRestrictions.current.length > 0) {

        if (previousSelectedValue === "Track Views") {
          let msg =
            selectedLanguage.LstLanguageCodes.UI_IsToRetainNoReadersRestrictions;
          const exceptNoReadersRestrictions =
            backUpOfConfiguredRestrictions.current.filter((item) => {
              if (
                item.category ===
                "Selected Readers" ||
                item.category ===
                "Everyone Except Selected Readers"
              ) {
                return { ...item };
              }
            });
          setDeleteSelectionOfRestriction([]);
          setSelectionOfRestrictionCheckboxMaintanances([]);
          unSaveWarnModal.current.open(
            msg,
            () => {
              pageLevelResRef.current.checked = true;
              setIsPageLevelRestrictionChecked(true);

              const backUpId = backUpOfConfiguredRestrictions.current.map(
                (item) => item.id
              );

              const newFilteredRecords = selectionOfRestriction
                .filter((item) => !backUpId.includes(item.id))
                .map((item) => {
                  const filteredPages = item.pages.filter(
                    (page) =>
                      !backUpOfConfiguredRestrictions.current.some(
                        (restriction) => restriction.pages.includes(page)
                      )
                  );

                  console.log(filteredPages);

                  return filteredPages.length > 0
                    ? { ...item, pages: filteredPages }
                    : null;
                })
                .filter((item) => item !== null);

              console.log(newFilteredRecords);

              const records = [
                ...newFilteredRecords,
                ...backUpOfConfiguredRestrictions.current,
              ];

              setSelectionOfRestriction(records);
            },
            () => {
              setSelectionOfRestriction((prev) => {
                const backUpId = backUpOfConfiguredRestrictions.current
                  .filter(
                    (item) =>
                      item.category ===
                      "No Readers"
                  )
                  .map((item) => item.id);
                const filteredPrevRecords = prev.filter(
                  (item) =>
                    item.category ===
                    "No Readers" &&
                    !backUpId.includes(item.id)
                );
                console.log(filteredPrevRecords);
                return [
                  ...backUpOfConfiguredRestrictions.current.filter(
                    (item) =>
                      item.category ===
                      "No Readers"
                  ),
                  ...filteredPrevRecords,
                ];
              });
              setDeleteSelectionOfRestriction(() => {
                return [...backUpOfConfiguredRestrictions.current.filter((item) => item.category !== "No Readers").map(item => item.id)];
              })
            }
          );
        }
      }
      document.getElementById("voting").disabled = false;
      document.getElementById("maxReads").disabled = false;
      document.getElementById("txtRestrictDomains").disabled = false;
      document
        .getElementById("chkIdentifyLeakersDiv")
        .classList.remove("disable_sectionChailed");
      // if (rpdType === "send") {
      //   document.getElementById("emailVerify").checked = true;
      // }
      var second2 = document.getElementsByClassName("user_register");
      for (let t = 0; t < second2.length; t++) {
        //second2[t].classList.remove("disable_section");
        second2[t].classList.remove("disable_sectionChailed");
      }
      setOpenRecord(true);
      setGeolocation(true);
      setVerifyCode(true);
      setReaderEmail(true);
      setDistRestriction(false);
      setReadTimes(true);
      setReadTiming(true);
      setSendVerificationCodeDisable(false);
      //setIsSMS(true);
    } else {
      if (backUpOfConfiguredRestrictions.current.length > 0) {

        if (previousSelectedValue === "Track Views") {
          let msg =
            selectedLanguage.LstLanguageCodes.UI_IsToRetainNoReadersRestrictions;
          const exceptNoReadersRestrictions =
            backUpOfConfiguredRestrictions.current.filter((item) => {
              if (
                item.category ===
                "Selected Readers" ||
                item.category ===
                "Everyone Except Selected Readers"
              ) {
                return { ...item };
              }
            });
          if (exceptNoReadersRestrictions.length === 0) return;
          setDeleteSelectionOfRestriction([]);
          // setSelectionOfRestrictionCheckboxMaintanances([]);
          unSaveWarnModal.current.open(
            msg,
            () => {
              // restoreRestrictions.current = false;
              pageLevelResRef.current.checked = true;
              setIsPageLevelRestrictionChecked(true);

              const backUpId = backUpOfConfiguredRestrictions.current.map(
                (item) => item.id
              );

              const newFilteredRecords = selectionOfRestriction
                .filter((item) => !backUpId.includes(item.id))
                .map((item) => {
                  const filteredPages = item.pages.filter(
                    (page) =>
                      !backUpOfConfiguredRestrictions.current.some(
                        (restriction) => restriction.pages.includes(page)
                      )
                  );

                  console.log(filteredPages);

                  return filteredPages.length > 0
                    ? { ...item, pages: filteredPages }
                    : null;
                })
                .filter((item) => item !== null);

              console.log(newFilteredRecords);
              const records = [
                ...newFilteredRecords,
                ...backUpOfConfiguredRestrictions.current,
              ];

              setSelectionOfRestriction(records);
            },
            () => {
              setSelectionOfRestriction((prev) => {
                const backUpId = backUpOfConfiguredRestrictions.current
                  .filter(
                    (item) =>
                      item.category ===
                      "No Readers"
                  )
                  .map((item) => item.id);
                const filteredPrevRecords = prev.filter(
                  (item) =>
                    item.category ===
                    "No Readers" &&
                    !backUpId.includes(item.id)
                );
                console.log(filteredPrevRecords);
                return [
                  ...backUpOfConfiguredRestrictions.current.filter(
                    (item) =>
                      item.category ===
                      "No Readers"
                  ),
                  ...filteredPrevRecords,
                ];
              });
              setDeleteSelectionOfRestriction(() => {
                return [...backUpOfConfiguredRestrictions.current.filter((item) => item.category !== "No Readers").map(item => item.id)];
              })
            }
          );
        }
      }
      setSecurityLevelTextColor("");
      pageLevelResRef.current.disabled = isPageLevelRestrictionref.current
        ? false
        : true;

      EDisclosureResRef.current.disabled = isEDisclosureref.current
        ? false
        : true;
      setIsPageLevelRestriction(true);
      setEDisclosure(isEDisclosureref.current);
      setIsEDisclosureChecked(isEDisclosureCheckedref.current);
      if (
        selectionOfRestriction.length > 0 ||
        deleteSelectionOfRestriction.length > 0
      ) {
        setIsPageLevelRestrictionChecked(true);
      } else {
        setIsPageLevelRestrictionChecked(
          isPageLevelRestrictionCheckedref.current
        );
      }
      //setEDisclosure(isEDisclosureCheckedref.current);
      var second2 = document.getElementsByClassName("user_register");
      for (let t = 0; t < second2.length; t++) {
        //second2[t].classList.remove("disable_section");
        second2[t].classList.remove("disable_sectionChailed");
      }
      setOpenRecord(true);
      setGeolocation(true);
      setVerifyCode(true);
      setReaderEmail(true);
      setReadTimes(true);
      setReadTiming(true);
      setAuthorizedEmailId([]);
      setDistRestriction(true);
      setSendVerificationCodeDisable(false);
      //setIsSMS(true);
      document.getElementById("maxReads").disabled = false;
      document.getElementById("txtRestrictDomains").disabled = false;
      document.getElementById("voting").disabled = false;
      document
        .getElementById("chkIdentifyLeakersDiv")
        .classList.remove("disable_sectionChailed");
    }
  };
  function handlerModelCancelForLeve3Popup() {
    setModalForLevel3Popup(false);
  }
  function handlerModelNoForLeve3Popup() {
    const enablePrint = canPrint && (printEnabledType === "everyone" || printEnabledType === "");
    const defaultMaxPrints = maxPrintsFields.current?.maxPrintsPerReader !== undefined ? maxPrintsFields.current.maxPrintsPerReader : maxPrintsPerReader.current;
    setInputFields([
      {
        email: "",
        firstName: "",
        lastName: "",
        authType: "",
        mobileCountryCode: [],
        mobileNumber: "",
        reference: "",
        canPrint: enablePrint,
        maxPrintsPerReader: enablePrint ? (defaultMaxPrints ?? "") : ""
      }
    ]);
    setModalForLevel3AddUser(true);
    setModalForLevel3Popup(false);
  }
  function handlerModelCancelForLeve3AddUser() {
    setModalForLevel3AddUser(false);
    setInputFields([
      {
        email: "",
        firstName: "",
        lastName: "",
        mobileCountryCode: [],
        mobileNumber: "",
      },
    ]);
    let tempItemDocumentHistory = orgLstDocumentsHistory.find(
      (element) => element.documentId == popupDocumentId
    );
    var itemDocumentsHistory = JSON.parse(
      JSON.stringify(tempItemDocumentHistory)
    );
    if (itemDocumentsHistory.documentOptions.recipients.length > 0)
      setModalForLevel3Popup(true);
    setFullSelectList(orgRecipientList);
  }
  function handlerModelYesForLeve3Popup() {
    setModalForLevel3Popup(false);
    handlerModelConfirmForControlStatus(true);
  }
  async function handlerModelConfirmLevel3ForAddUser() {
    var documentid = popupDocumentId;
    var recipientdata = [];
    // const mobileSet = new Set();
    var duplicateMobileNumber = false;
    const numberCounts = {};
    inputFields.map((item, i) =>
      recipientdata.push({
        email: item.email,
        firstName: item.firstName?.trim(),
        lastName: item.lastName?.trim(),
        mobileCountryCode:
          item.mobileCountryCode && item.mobileCountryCode?.value?.length > 0
            ? item.mobileCountryCode?.value == "+Code" ? "" : item.mobileCountryCode?.value?.trim()
            : "",
        mobileNumber: item.mobileNumber?.trim(),
        reference: item.reference?.trim(),
        authType: item.authType?.trim(),
        canPrint: item.canPrint,
        maxPrintsPerReader: ((item.canPrint && item.maxPrintsPerReader) ? item.maxPrintsPerReader : null)
      })
    );
    var invalidEmail = false;
    var invalidMobileNumber = false;
    var invalidMobileCountryCode = false;
    var duplicateMobileNumber = false;
    if (inputFields.some((item) => item.email === "")) {
      invalidEmail = true;
    }
    const strictEmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    recipientdata.forEach((element) => {
      if ((!strictEmailRegex.test(element.email) || element.email == "") && invalidEmail == false) {
        invalidEmail = true;
      }
      if (
        element.mobileCountryCode != "" &&
        element.mobileNumber == "" &&
        invalidMobileNumber == false
      ) {
        invalidMobileNumber = true;
      }
      if (
        element.mobileCountryCode == "" &&
        element.mobileNumber != "" &&
        invalidMobileCountryCode == false
      ) {
        invalidMobileCountryCode = true;
      }
      if (element.mobileNumber != "") {
        const fullNumber = `${element.mobileCountryCode}${element.mobileNumber}`.trim();
        numberCounts[fullNumber] = (numberCounts[fullNumber] || 0) + 1;
        if (numberCounts[fullNumber] > 1 && duplicateMobileNumber == false) {
          duplicateMobileNumber = true;
        }
      }
    });
    if (invalidEmail == true) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
      setAlertType("warning");
      return;
    }
    if (invalidMobileNumber == true) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterMobileNumber);
      setAlertType("warning");
      return;
    }
    if (invalidMobileCountryCode == true) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode);
      setAlertType("warning");
      return;
    }
    if (recipientdata.length == 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_RequiredAuthorized);
      setAlertType("warning");
      return;
    }
    if (duplicateMobileNumber) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum);
      setAlertType("warning");
      return;
    }
    var list = orgRecipientList.map((element) => {
      return { ...element, enabled: false };
    });

    inputFields.map((item, i) =>
      list.push({
        email: item.email,
        firstName: item.firstName?.trim(),
        lastName: item.lastName?.trim(),
        mobileCountryCode:
          item.mobileCountryCode && item.mobileCountryCode.value?.length > 0
            ? item.mobileCountryCode?.value == "+Code" ? "" : item.mobileCountryCode?.value?.trim()
            : "",
        mobileNumber: item.mobileNumber?.trim(),
        reference: item.reference?.trim(),
        recipientCreateDate: item.recipientCreateDate,
        authType: item.authType?.trim(),
        canPrint: item.canPrint,
        maxPrintsPerReader: ((item.canPrint && item.maxPrintsPerReader) ? item.maxPrintsPerReader : null)
      })
    );
    isNewRecipientAdded = true;
    handlerModelConfirmForControlStatus(true, list);
  }
  function handlerModelIWillPickForLeve3Popup() {
    var list = orgRecipientList.map((element) => {
      return { ...element, enabled: false, status: "Banned" };
    });
    setFullSelectList(list);
    setActiveSelectList(list.filter((localItem) => localItem.enabled == false));
    setTemSelectedLeftList(
      list.filter((localItem) => localItem.enabled == false)
    );
    setInActiveSelectList(
      list.filter((localItem) => localItem.enabled == true)
    );
    setTemSelectedRightList(
      list.filter((localItem) => localItem.enabled == true)
    );
    setModalForManageUser(true);
  }
  async function onConfirmUpdatePopup() {
    // await handlerActiveInactive("", true, popupDocumentId, true, true);
    handlerModelConfirmForControlStatus(true);
    // expiryChnagedPopup.current = true;
  }
  const onCancelUpdatePopup = () => {
    setIsExpireChangePopup(false);
    expiryChnagedPopup.current = false;
    handlerModelConfirmForControlStatus(true);
  }
  function handleManageReceipts() {
    setModalForManageUser(true);
  }
  function handlerModelConfirmForManageUser() {
    if (
      fullSelectList.filter((localItem) => localItem.enabled == true).length ==
      0
    ) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setAlertType("warning");
    } else {
      handlerModelConfirmForControlStatus(true);
      setModalForManageUser(false);
      setModalForLevel3Popup(false);
    }
  }
  function handleToggleClass(e) {
    if (e.target.className == "activeUserUnSelected") {
      e.target.className = "activeUserSelected";
    } else if (e.target.className == "activeUserSelected") {
      e.target.className = "activeUserUnSelected";
    }
    if (e.target.className == "inActiveUserUnSelected") {
      e.target.className = "inActiveUserSelected";
    } else if (e.target.className == "inActiveUserSelected") {
      e.target.className = "inActiveUserUnSelected";
    }
  }
  async function fetchCountryCodes() {
    try {
      const url = `${process.env.REACT_APP_API}/docs/GetAllCountryCodedes`;
      const response = await fetch(url);
      const data = await response.json();
      if (data != null) {
        const formattedOptions = [
          {
            value: "+Code", // Use an empty string or any value to represent "default"
            label: selectedLanguage.LstLanguageCodes.UI_CountryCode, // Placeholder text for the default option
            languageCode: "+Code", // Optional: Add a default language code if needed
            mobileMaxLeng: 0, // Optional: Default value for max length
            name: "mobileCountryCode",
          },
          ...data.map((item) => ({
            value: `${item.dialCode}-${item.countryCode}`,
            label: `${item.countryName} (${item.dialCode})`,
            languageCode: item.countryCode.toLowerCase(), // Ensure lowercase
            mobileMaxLeng: item.mobileMaxLeng,
            name: "mobileCountryCode",
          })),
        ];
        const transformedOptions = formattedOptions.map((option) => {
          if (option.value && option.value.includes("-") && option.value != "+Code") {
            const dialCode = option.value?.split("-")[0];
            return {
              value: dialCode,
              label: option.label,
              languageCode: option.languageCode,
              mobileMaxLeng: option.mobileMaxLeng,
              name: "mobileCountryCode",
            };
          }
          return option;
        });

        // Update the state with transformed options
        setCountryCodedrpOptions(transformedOptions);
        setCountryCodeOptions(formattedOptions);
        const itemDocumentsHistory = lstDocumentsHistory.find((item) => (item.documentId === popupDocumentId));
        setPrintEnabledType(itemDocumentsHistory?.documentOptions?.isPrintEnabledForEveryone === true ? "everyone" : "selectedUsers");
        return transformedOptions;
      }
    } catch (error) {
      console.error("Error fetching country codes:", error);
    }
  }
  function handleSearchEvent(e, leftOrRight) {
    if (leftOrRight == "left") {
      setLeftSearchValue(e.target.value);
      setTemSelectedLeftList(
        activeSelectList.filter((item) =>
          item.email.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      var list = Array.from(
        document.getElementsByClassName("inActiveUserSelected")
      );
      list.map((element) => {
        element.className = "inActiveUserUnSelected";
      });
    } else if (leftOrRight == "right") {
      setRightSearchValue(e.target.value);
      setTemSelectedRightList(
        inActiveSelectList.filter((item) =>
          item.email.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      var list = Array.from(
        document.getElementsByClassName("activeUserSelected")
      );
      list.map((element) => {
        element.className = "activeUserUnSelected";
      });
    }
  }
  function viewmore(event, DocId) {
    event.stopPropagation();
    setRecipientsViewMorePopup(true);

    const getEmailsByRecipientTypes = (docId, recipientTypes) => {
      return lstDocumentsHistory
        .filter((item) => item.documentId === docId)
        .flatMap((item) =>
          item.documentOptions.recipients
            .filter((recipient) =>
              recipientTypes.includes(recipient.recipientType)
            )
            .map((recipient) => recipient.email)
            .join(", ")
        )
        .join("\n");
    };

    const toEmails = getEmailsByRecipientTypes(DocId, ["To", "", null]);
    const ccEmails = getEmailsByRecipientTypes(DocId, ["CC"]);
    const bccEmails = getEmailsByRecipientTypes(DocId, ["BCC"]);

    setRecipientToEmails(toEmails);
    setRecipientCcEmails(ccEmails);
    setRecipientBccEmails(bccEmails);
  }

  const handlerModelCancelForSave = () => {
    setRecipientsViewMorePopup(false);
  };

  const RefreshGridCtrl = () => {
    var rowdata = document.getElementsByClassName("view");
    var controldata = document.getElementsByClassName("fold");
    var Statisticlogoctrl = document.getElementsByClassName("Statictextlogo");
    var StatisTextLink = document.getElementsByClassName("StaticTextLink");
    var collapseStatisticstable = document.getElementsByClassName(
      "CollapseStaticTable"
    );
    for (let Statisticlogoctrlitem of Statisticlogoctrl) {
      Statisticlogoctrlitem.className =
        "Statictextlogo material-icons material-icons-custom collapsed";
      Statisticlogoctrlitem.ariaExpanded = "false";
    }
    for (let StatisTextLinkitem of StatisTextLink) {
      StatisTextLinkitem.className =
        "StaticTextLink arrow_circle_text_class collapsed";
      StatisTextLinkitem.ariaExpanded = "false";
    }
    for (let collapseStatisticstableItem of collapseStatisticstable) {
      collapseStatisticstableItem.className =
        "CollapseStaticTable inertable mb-2 box-shadow-light bg-white collapse tblStatistics";
    }
    for (let collapseRow of rowdata) {
      collapseRow.className = "view";
    }
    for (let collapseControlData of controldata) {
      collapseControlData.className = "fold";
    }
  };

  const ShowHideContentOnTabChange = () => {
    var accessManagmentTabSelected = document.getElementById("messages");
    accessManagmentTabSelected.classList.remove("active");
    accessManagmentTabSelected.classList.remove("show");

    var CommonTabSelected = document.getElementsByClassName("tabchange");
    if (CommonTabSelected != null) {
      for (let tabSelected of CommonTabSelected) {
        tabSelected.classList.add("active");
        tabSelected.classList.add("show");
      }
    }
  };

  const FolderViewSelected = () => {
    setIsFilterChanged(false);
    setIsFolderViewselected(true);
    setIsAllItems(false);
    setIsAccessManagement(false);
    sortDown.current = true;
    setSortBy("desc");
    folderViewTabSelected = 1;
    setFolderId("");
    let leftsideBar = document.querySelector(".commontableft-section");
    //let rightsideBar = document.querySelector(".commontabright-section");
    leftsideBar.style.display = "block";
    if (
      leftsideBar.style.width == "13.66667%" ||
      leftsideBar.style.width == "13.6667%"
    ) {
      // rightsideBar.style.width = "86.33333%";
      dynamicWidthSet.current = false;
      setToggleMenu(false);
    } else if (leftsideBar.style.width == "4.66667%") {
      //rightsideBar.style.width = "95.33333%";
      dynamicWidthSet.current = true;
      setToggleMenu(true);
    }
    openLoaderFolder = false;
    folderViewKilledFlag = true;
    setIsKilledOpt(false);
    resetKilledFlag = false;
    ShowHideContentOnTabChange();
    setIsTrackKillHeader(false);
    RDocsDefaultSettingsData();
    getCustomColumns(false);
    setIsKilledOpt(false);
    setCurrentPage(1);
    setPageView(25);
    currentPagevalue = 1;
    setDefaultSelected(true);
    setMasterSelection(false);
    clearFilters();
    setfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
    RefreshGridCtrl();
    const userRole = localStorage.getItem("UserRole");
    const loggedInEmail = localStorage.getItem("UserName");
    const companyName = localStorage.getItem("Companyname");
    if (userRole === "RDocsSupportAdmin") {
      setUserRoleBased(true);
      if (companyName) {
        setCompanySearch(companyName);
        setShowCompanyWhenApply(companyName);
      }
      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
        setShowOwnerWhenApply(loggedInEmail);
      }
    } else if (userRole === "RDocsCustomerAdmin") {
      setUserRoleBased(false);
      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
        setShowOwnerWhenApply(loggedInEmail);
      }
      setCompanySearch("");
      setShowCompanyWhenApply("");
    }

    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setIsControlClick(() => {
      return { isClear: false, isSearchOrRefresh: true, isMoveToFolder: false };
    });
  };

  const GetDefaultDocuments = (ddlpagecount = 25, oldSearch = false) => {
    setActiveTabName("FolderItems");
    folderViewTabSelected = 1;
    setFolderId(folderViewTabSelected);
    GetFoldersLists(folderViewTabSelected);
    currentPageViewCount = ddlpagecount;
    documentsList("", 0, oldSearch == false ? 1 : 0);
    var litems = lstDocumentsHistory.filter(
      (element) => element.selection === true
    );
    for (const item of litems) {
      item.selection = false;
    }
  };
  const GetAllItems = () => {
    setIsFilterChanged(false);
    RDocsDefaultSettingsData();
    sortDown.current = true;
    setSortBy("desc");
    setIsAllItems(true);
    setIsFolderViewselected(false);
    setToggleMenu(false);
    setIsAccessManagement(false);
    let leftsideBar = document.querySelector(".commontableft-section");
    let rightsideBar = document.querySelector(".commontabright-section");
    if (leftsideBar) {
      leftsideBar.style.display = "none";
    }
    if (rightsideBar) {
      rightsideBar.style.width = "";
    }
    folderViewKilledFlag = true;
    openLoaderFolder = false;
    setIsTrackKillHeader(false);
    getCustomColumns(false);
    setIsKilledOpt(false);
    ShowHideContentOnTabChange();
    setIsFolderViewselected(false);
    setActiveTabName("AllItems");
    setMasterSelection(false);
    setfolderName("");
    setFolderNameText("");
    setFolderId("");
    clearFilters();
    const userRole = localStorage.getItem("UserRole");
    const loggedInEmail = localStorage.getItem("UserName");
    const companyName = localStorage.getItem("Companyname");
    if (userRole === "RDocsSupportAdmin") {
      setUserRoleBased(true);
      if (companyName) {
        setCompanySearch(companyName);
        setShowCompanyWhenApply(companyName);
      }
      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
        setShowOwnerWhenApply(loggedInEmail);
      }
    } else if (userRole === "RDocsCustomerAdmin") {
      setUserRoleBased(false);
      if (loggedInEmail) {
        setOwnerSearch(loggedInEmail);
        setShowOwnerWhenApply(loggedInEmail);
      }
      setCompanySearch("");
      setShowCompanyWhenApply("");
    }
    setCurrentPage(1);
    setPageView(25);
    RefreshGridCtrl();
    currentPagevalue = 1;
    folderViewTabSelected = 0;
    var litems = lstDocumentsHistory.filter(
      (element) => element.selection === true
    );
    for (const item of litems) {
      item.selection = false;
    }
    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setIsControlClick(() => {
      return { isClear: false, isSearchOrRefresh: true, isMoveToFolder: false };
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
  };
  const GetuserlistFromChild = (childData) => {
    setChildUserListData(childData);
  };
  const handleDataFromChild = (childData) => {
    setChildUserData(childData);
    setModalIsUserPopupOpen(false);
  };

  async function handlecreateFolder(e) {
    if (
      folderNameText.trim().toLowerCase() ===
      selectedLanguage.LstLanguageCodes.UI_Default.toLowerCase()
    ) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_DefaultCannotBeUsedAsFilderName
      );
      setAlertType("warning");
      return;
    }

    document.body.style.overflowY = "visible";
    e.stopPropagation();
    setOpen(true);
    try {
      let rpDFolderDetials = {
        FolderName: folderNameText.trim(),
        SharedUserId: childUserData,
        IsShared: Number(selectedOption)
      };
      const url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_CreateFolders
        }`;
      if (folderNameText.trim() == "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EnterFolderName + ".");
        setAlertType("warning");
        setOpen(false);
        return;
      }
      if (selectedOption == "1" && childUserData.length == 0) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOneUser
        );
        setOpen(false);
        setAlertType("warning");
        return;
      }

      var jsonDocs = await APIRequest.POSTSaveSettings(
        JSON.stringify(rpDFolderDetials),
        url
      );
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (jsonDocs.status == 200) {
        setOpen(false);
        setModalIsCreateFolderOpen(false);
        GetFoldersLists();
      } else if (jsonDocs.statusCode == 10) {
        setOpen(false);
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_DefaultCannotBeUsedAsFilderName
        );
        setAlertType("warning");
        return;
      } else if (jsonDocs.statusCode == 409) {
        setOpen(false);
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateFolder);
        setAlertType("warning");
        return;
      }
      setfolderName("");
      setFolderNameText("");
    } catch (error) {
      setOpen(false);
      setOpenLoaderSearch(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoCreateFolder + "."
      );
      setAlertType("warning");
      return;
    }
  }

  async function GetFoldersLists(DefaultId = 0) {
    try {
      var FoldersList = [];
      const url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetFolders
        }`;
      var jsonDocs = await APIRequest.GET("", url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (jsonDocs.length > 0) {
        if (DefaultId == 0) {
          jsonDocs.map((item, i) =>
            FoldersList.push({
              folderID: item.id,
              folderName: item.folderName.trim(),
              isShared: item.isShared,
              isActive: item.id == folderId ? true : false,
              email: item.email,
            })
          );
        } else {
          jsonDocs.map((item, i) =>
            FoldersList.push({
              folderID: item.id,
              folderName: item.folderName.trim(),
              isShared: item.isShared,
              isActive: false,
              email: item.email,
            })
          );
        }
        setFoldersDetailsLst(FoldersList);
      } else {
        setFoldersDetailsLst([]);
        var myfoldersTab = document.getElementById("myfolders");
        myfoldersTab.classList.add("collapsed");
      }
    } catch (error) {
      setOpenLoaderSearch(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoloadFolders + "."
      );
      setAlertType("warning");
      return;
    }
  }
  function handleFolderId(Id, Name, isSharedvalue = 0, isActive) {
    if (isActive == true) {
      openLoaderFolder = true;
    } else {
      openLoaderFolder = false;
    }
    if (managepopupOpen == true) {
      if (Id != 1) {
        setDefaultSelected(false);
        setfolderName(Name);
        setFolderId(Id);
      }
      return;
    }
    setOwnerSearch(showOwnerWhenApply);
    setCompanySearch(showCompanyWhenApply);
    sortDown.current = true;
    setSortBy("desc");
    setMasterSelection(false);
    setisDisableNext(false);
    setPageView(25);
    setCurrentPage(1);
    currentPagevalue = 1;
    if (Id === 1) {
      setClearSearchcalled(true);
      setDefaultSelected(true);
      setfolderName(Name);
      setFolderNameText(Name);
      setFolderId("");
      setSelectedSearchRecords(() => {
        return [{ page: 0, docs: [] }];
      });
      setRecordsSelectedCount(() => {
        return { showRecords: false, count: 0 };
      });
      setIsControlClick(() => {
        return {
          isClear: false,
          isSearchOrRefresh: false,
          isKilled: false,
          isMoveToFolder: true,
          isBanOrActive: false,
        };
      });
      RefreshGridCtrl();
    } else {
      var FoldersList = [];
      foldersDetailsLst.map((item, i) =>
        FoldersList.push({
          folderID: item.folderID,
          folderName: item.folderName.trim(),
          isShared: item.isShared,
          isActive: item.folderID == Id ? true : false,
          email: item.email,
        })
      );
      setFoldersDetailsLst(FoldersList);
      setDefaultSelected(false);
      setFoldersDetailsLst(FoldersList);
      setfolderName(Name);
      setFolderNameText(Name);
      setFolderId(Id);
      GetDocumentByFolderId(Id);
      setSelectedOption(String(isSharedvalue));
      setIsSharedFlag(String(isSharedvalue));
      setClearSearchcalled(false);
      RefreshGridCtrl();
    }
  }
  let managepopupOpen = false;

  function manageFolderOpen(id, SelectedFolderName, isSharedvalue, isActive) {
    if (isActive == true) {
      openLoaderFolder = true;
    } else {
      openLoaderFolder = false;
    }
    setModalIsManageFolderOpen(true);
    document.body.style.overflowY = "hidden";
    setFolderNameText(SelectedFolderName);
    setSelectedOption(String(isSharedvalue));
    setChildUserData([]);
    managepopupOpen = false;
    if (isActive == false) {
      handleFolderId(id, SelectedFolderName, isSharedvalue, isActive);
    }
    return;
  }
  function handlerModelDeleteConfirm() {
    if (folderName == "" || folderNameText == "") {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EnterFolderName + ".");
      setAlertType("warning");
      setOpen(false);
      return;
    } else if (lstDocumentsHistory.length > 0 && isSharedFlag != 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_SharedDeleteWarning);
      setAlertType("warning");
      setOpen(false);
      return;
    }
    setModalIsDeleteOpen(true);
  }
  function handleEditFn() {
    setModalIsUserPopupOpen(true);
    isUserPopupopen = true;
  }
  function handlerModelUpdateConfirm() {
    if (
      selectedOption == "1" &&
      childUserListData.length == 0 &&
      childUserData.length == 0 &&
      isUserPopupopen
    ) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne + "."
      );
      setOpen(false);
      setAlertType("warning");
      return;
    }
    setModalIsUpdateconfirmOpen(true);
  }
  async function handlerModelEditFolder() {
    document.body.style.overflowY = "visible";
    setOpen(true);
    try {
      let rpdFoldersData = {
        FolderName: folderNameText.trim(),
        FolderId: folderId,
        SharedUserId: childUserData,
        IsShared: selectedOption,
      };
      const url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_PutFolderName
        }`;
      if (folderNameText.trim() == "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EnterFolderName + ".");
        setAlertType("warning");
        setOpen(false);
        return;
      }
      var jsonDocs = await APIRequest.PUT(JSON.stringify(rpdFoldersData), url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        setOpen(false);
        return;
      } else if (jsonDocs.status == 200) {
        setModalIsManageFolderOpen(false);
        setModalIsUpdateconfirmOpen(false);
        isUserPopupopen = false;
        GetFoldersLists();
        setfolderName(folderNameText);
        if (
          foldersDetailsLst.filter((item) => item.isShared == 0).length == 1
        ) {
          var mfolder = document.getElementById("myfolders");
          mfolder.classList.add("accordion-button", "collapsed");
        }
        if (
          foldersDetailsLst.filter((item) => item.isShared != 0).length == 1
        ) {
          var sfolder = document.getElementById("SharedFolder");
          sfolder.classList.add("accordion-button", "collapsed");
        }
      } else if (jsonDocs.statusCode == 10) {
        setOpen(false);
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_DefaultCannotBeUsedAsFilderName
        );
        setAlertType("warning");
        return;
      } else if (jsonDocs.statusCode == 409) {
        setOpen(false);
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateFolder);
        setAlertType("warning");
        return;
      }
      setOpen(false);
    } catch (error) {
      setOpen(false);
      setOpenLoaderSearch(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoEditFolder + "."
      );
      setAlertType("warning");
      return;
    }
  }
  async function GetDocumentByFolderId(Id) {
    folderViewTabSelected = Id;
    // documentsList("");
    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setIsControlClick(() => {
      return {
        isClear: false,
        isSearchOrRefresh: true,
        isKilled: false,
        isMoveToFolder: false,
        isBanOrActive: false,
      };
    });
  }
  const handleCloseUpdatePopop = () => {
    setIsExpireChangePopup(false);
    expireToActivePopup = 1;
  }
  async function handlerModelDeleteFolder() {
    try {
      document.body.style.overflowY = "visible";
      const url =
        `${process.env.REACT_APP_API + process.env.REACT_APP_API_DeleteFolder
        }` +
        "/" +
        folderId;

      var jsonDocs = await APIRequest.DELETE(url);
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        setOpen(false);
        return;
      } else if (jsonDocs.status == 200) {
        setModalIsManageFolderOpen(false);
        setModalIsDeleteOpen(false);
        GetDefaultDocuments(25, true);
        setfolderName("");
        setFolderNameText("");
        setFolderId("");
        setDefaultSelected(true);
        setClearSearchcalled(true);
        if (
          foldersDetailsLst.filter((item) => item.isShared == 0).length == 1
        ) {
          var mfolder = document.getElementById("myfolders");
          mfolder.classList.add("accordion-button", "collapsed");
        }
        if (
          foldersDetailsLst.filter((item) => item.isShared != 0).length == 1
        ) {
          var sfolder = document.getElementById("SharedFolder");
          sfolder.classList.add("accordion-button", "collapsed");
        }
      }
    } catch (error) {
      setOpenLoaderSearch(false);
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_FailedtoDeleteFolder + "."
      );
      setAlertType("warning");
      return;
    }
  }
  async function MoveDocumentsToFolder() {
    document.body.style.overflowY = "visible";
    const allDocs = selectedSearchRecords.reduce((accumulator, item) => {
      return accumulator.concat(item.docs);
    }, []);
    try {
      setOpen(true);
      for (const item of allDocs) {
        var response = await APIRequest.POST(
          "",
          `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_MoveDocumentsToFolder
          }` +
          "/" +
          ddlfolderId +
          "/" +
          item
        );
        if (response && response === "Server maintenance") {
          history("/maintenance");
          return;
        }
      }
      setOpen(false);
    } catch {
      setOpen(false);
    }

    if (folderId != "" && folderId != 1) {
      var FoldersList = [];
      foldersDetailsLst.map((item, i) =>
        FoldersList.push({
          folderID: item.folderID,
          folderName: item.folderName.trim(),
          isShared: item.isShared,
          isActive: item.folderID == folderId ? true : false,
          email: item.email,
        })
      );
      setDefaultSelected(false);
      setFoldersDetailsLst(FoldersList);
      //GetDocumentByFolderId(folderId);
    } else {
      setDefaultSelected(true);
      // GetDefaultDocuments(25, true);
    }
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setSelectedSearchRecords(() => {
      return [{ page: 0, docs: [] }];
    });
    setIsControlClick((prev) => {
      return { ...prev, isMoveToFolder: true };
    });
    setMasterSelection(false);
    setModalIsMoveFolderOpen(false);
    setmodalIsMoveConfirmOpen(false);
    setDDLFolderId("");
  }
  function ddlFoldername(event) {
    const selectedValue = event.target.value;

    if (selectedValue === "1") {
      setddlSelectedfolderName(selectedLanguage.LstLanguageCodes.UI_Default);
      setDDLFolderId("1");
    } else {
      const selectedOption = foldersDetailsLst.find(
        (option) => option.folderID === selectedValue
      );
      if (selectedOption) {
        const selectedText = selectedOption.folderName;
        setddlSelectedfolderName(selectedText);
        setDDLFolderId(selectedValue);
      } else {
        setddlSelectedfolderName("");
        setDDLFolderId("");
      }
    }
  }
  const MenuClick = () => {
    setToggleMenu(true);
    let folderListSection = document.getElementById("folderList");
    let foldernameSection = document.getElementById("foldername");
    folderListSection.style.display = "none";
    foldernameSection.style.display = "block";
    let leftsideBar = document.querySelector(".commontableft-section");
    let rightsideBar = document.querySelector(".commontabright-section");
    leftsideBar.style.width = "4.66667%";
    rightsideBar.style.width = "95.33333%";
  };
  async function handleRefreshTrackInterActivity(updatedDocumentID, e, docIndexValue) {
    try {
      setOpen(true);
      if (searchInputRefForTrackInteractivity.current) {
        searchInputRefForTrackInteractivity.current.value = "";
      }
      trackRef.current = trackRef.current.map((item) => {
        if (item != null && item.nextElementSibling && item.nextElementSibling.classList && item.nextElementSibling.classList.contains("open")) {
          item.click();
        }
      });
      var url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetTrackInteractivityData
        }` +
        "\\" +
        updatedDocumentID;
      var jsonDoc = await APIRequest.GET(
        "",
        url)
      if (jsonDoc && jsonDoc === "Server maintenance") {
        history("/maintenance");
        return;
        setOpen(false);
      }
      setOpen(false);
      //setTrackInteractivityDetails((prev) =>
      const updatedData = trackInteractivityDetails.map((doc) => {
        if (doc.docId !== updatedDocumentID) return doc;

        const emailMap = new Map(
          doc.records
            .filter((r) => r.email)
            .map((r) => [r.email.toLowerCase(), r])
        );

        // 1. Update existing readers
        let updatedRecords = doc.records.map((reader) => {
          const matchingData = jsonDoc.find(
            (item) =>
              item.email &&
              reader.email &&
              item.email.toLowerCase() === reader.email.toLowerCase()
          );

          if (matchingData) {
            return {
              ...reader,
              totalTime: matchingData.totalTime || "00:00:00",
              readCount: matchingData.readCount || "0",
              firstName: matchingData.firstName || "",
              lastName: matchingData.lastName || "",
              openedTime: matchingData.openedTime || "",
              mobileCountryCode: matchingData.mobileCountryCode || "",
              mobileNumber: matchingData.mobileNumber || "",
            };
          }
          return reader;
        });

        // 2. Push unmatched items from jsonDoc
        jsonDoc.forEach((item) => {
          const email = item.email?.toLowerCase();
          if (email && !emailMap.has(email)) {
            updatedRecords.push({
              ...item,
              totalTime: item.totalTime || "00:00:00",
              readCount: item.readCount || "0",
              firstName: item.firstName || "",
              lastName: item.lastName || "",
              openedTime: item.openedTime || "",
              mobileCountryCode: item.mobileCountryCode || "",
              mobileNumber: item.mobileNumber || "",
              trackInteractivityData: []
            });
          }
        });
        jsonDoc.forEach((item) => {
          updatedRecords = updatedRecords.map((reader) => {
            if (reader.email && reader.email.toLowerCase() === item.email?.toLowerCase()) {
              return { ...reader, printCount: item.printCount || "0" };
            } else if (!reader.email && item.email == "") {
              return { ...reader, printCount: item.printCount || "0" }
            }
            return reader;
          });
        });


        return {
          ...doc,
          records: updatedRecords,
        };
      })
      //);
      //setTrackInteractivityDetails(updatedData);
      handlerModelOkSorting(updatedDocumentID, updatedData);


    }
    catch (error) {
      console.error("Error in handleRefreshTrackInterActivity:", error);
      setOpen(false);
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ErrorFetchingData);
      setAlertType("danger");
      return;
    }
  }

  const MenuClick1 = () => {
    setToggleMenu(false);
    let folderListSection = document.getElementById("folderList");
    let foldernameSection = document.getElementById("foldername");
    folderListSection.style.display = "block";
    foldernameSection.style.display = "none";
    let leftsideBar = document.querySelector(".commontableft-section");
    let rightsideBar = document.querySelector(".commontabright-section");
    leftsideBar.style.width = "13.66667%";
    rightsideBar.style.width = "86.33333%";
  };
  const [selectedOption, setSelectedOption] = React.useState("0");
  const options = [
    { value: "0", label: selectedLanguage.LstLanguageCodes.UI_Myfolders },
    {
      value: "1",
      label: selectedLanguage.LstLanguageCodes.UI_ShareWithSpecific,
    },
    {
      value: "2",
      label: selectedLanguage.LstLanguageCodes.UI_ShareWitheveryone,
    },
  ];
  const handleCloseReaderActivityLog = () => {
    setModalIsReaderActivityLogOpen(false);
  }

  const handleSelectFolderAccess = (event) => {
    if (event.target.value !== "0") {
      setModalIsUserPopupOpen(true);
    }
    setddlShareFolderSelected(true);
    setSelectedOption(event.target.value);
  };
  const showIcon = (event) => {
    setddlShareFolderSelected(false);
  };
  const getTimeFormat = (seconds) => {
    var time = "00:00:00";
    if (seconds != null) {
      var seconds = parseInt(seconds, 10);
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      seconds = seconds - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      time = hours + ":" + minutes + ":" + seconds;
    }
    return time;
  };

  const options1 = [
    { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
    // { value: 'whatsapp', label: selectedLanguage.LstLanguageCodes.UI_Whatsapp },
    { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
  ];
  const filteredOptions = options1.filter((option) => {
    if (option.value === "text" && !isSMSAuthentication) return false; // Exclude "Text" if IsSMSAuthentication is false
    // if (option.value === 'whatsapp' && !isWhatsAppAuthentication) return false; // Exclude "WhatsApp" if SsWhatsAppAuthentication is false
    return true; // Include other options
  });
  const handleSelectionChange = (selected) => {
    if (selected.length === 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_AtleastOneOptionRequired);
      setAlertType("warning");
      return;
    }
    const selectedDocument = trackInteractivityDetails.find(
      (item) => item.docId == popupDocumentId
    );

    if (!selectedDocument) return;

    const unSelectedOption = options1.find(
      (item) => !selected.some((opt) => opt.value === item.value)
    );

    const hasUnselectedAuthType = (!unSelectedOption) ? false : selectedDocument.records.some(
      (record) => (record.authType === unSelectedOption?.value || record.authType === 'both')
    );

    let msg = "";
    if (unSelectedOption) {
      if (unSelectedOption?.value === "text") {
        msg = selectedLanguage.LstLanguageCodes.UI_SomeRecipientshavetextselected;
      } else {
        msg =
          selectedLanguage.LstLanguageCodes.UI_SomeRecipientshaveEmailselected;
      }
    }

    if (hasUnselectedAuthType) {
      unSaveWarnModal.current.open(
        msg,
        () => {
          setSelectedOptions(selected);
          const selectedValues = selected.map((opt) => opt.value);
          if (
            selectedValues.includes("text") &&
            !selectedValues.includes("email")
          ) {
            setIsSMS(true);
            emailAuth.current = false;
            multiAuth.current = false;
          } else if (
            selectedValues.includes("email") &&
            !selectedValues.includes("text")
          ) {
            emailAuth.current = true;
            setIsSMS(false);
            multiAuth.current = false;
          } else if (
            selectedValues.includes("text") &&
            selectedValues.includes("email")
          ) {
            multiAuth.current = true;
            setIsSMS(false);
            emailAuth.current = false;
          }
          changeOfAuthType.current = true;
        },
        () => { }
      );
    } else {
      setSelectedOptions(selected);
      const selectedValues = selected.map((opt) => opt.value);
      if (
        selectedValues.includes("text") &&
        !selectedValues.includes("email")
      ) {
        setIsSMS(true);
        emailAuth.current = false;
        multiAuth.current = false;
      } else if (
        selectedValues.includes("email") &&
        !selectedValues.includes("text")
      ) {
        emailAuth.current = true;
        setIsSMS(false);
        multiAuth.current = false;
      } else if (
        selectedValues.includes("text") &&
        selectedValues.includes("email")
      ) {
        multiAuth.current = true;
        setIsSMS(false);
        emailAuth.current = false;
      }
    }
  };

  // Custom component to remove the cancel button for the Email option
  const MultiValueRemove = (props) => {
    // if (props.data.value === "email") {
    //   return null;
    // }
    return <components.MultiValueRemove {...props} />;
  };

  const handleAuthTypeChange = (event, index) => {
    let input = event.value;
    if (index !== undefined) {
      setInputFields(
        inputFields.map((prevFields, locIndex) => {
          if (locIndex === index) {
            const updatedFields = { ...prevFields };
            updatedFields.authType = input;
            return updatedFields;
          }
          return prevFields;
        })
      );
    } else {
      //verificationCodeRefValue.current=input;
      setVerificationCode(input);
    }

  }


  const handleMobileChange = (event, index) => {
    let input = event.target.value;
    input = input.replace(/[^0-9]/g, "");
    if (index !== undefined) {
      setInputFields(
        inputFields.map((prevFields, locIndex) => {
          if (locIndex === index) {
            const updatedFields = { ...prevFields };
            updatedFields.mobileNumber = input;
            return updatedFields;
          }
          return prevFields;
        })
      );
    } else {
      setMobileNumber(input);
    }
  };
  const handleCodeChange = (selectedOption, index) => {
    selectedOption.value = selectedOption.value?.split("-")[0];
    if (selectedOption.languageCode == "ca") {
      const updatedOptions1 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "ca" || option.languageCode == "") {
          return {
            ...option,
            value: `${option.value?.split("-")[0]
              }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });

      setCountryCodeOptions(updatedOptions1);
    }
    if (selectedOption.languageCode == "us") {
      const updatedOptions2 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "us" || option.languageCode == "") {
          return {
            ...option,
            value: `${option.value?.split("-")[0]
              }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setCountryCodeOptions(updatedOptions2);
    }
    if (index !== undefined) {
      setInputFields(
        inputFields.map((prevFields, locIndex) => {
          if (locIndex === index) {
            const updatedFields = { ...prevFields }; // Copy the current object
            updatedFields.mobileCountryCode = selectedOption; // Update the countryCode field
            return updatedFields; // Return the updated object
          }
          return prevFields; // Return unchanged objects for other indices
        })
      );
    } else {
      setSelectedCode(selectedOption); // Directly set selectedOption for single reader scenario
    }
  };
  function handleExpiryChange(expiry) {
    setSelectedExpiryDate(expiry);
  }
  function handleLaunchChange(launch) {
    setSelectedLaunchDate(launch);
  }
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const stickySection = document.querySelector(".sticky-section");
      if (window.scrollY >= stickySection?.offsetTop - -75) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const stickySection = document.querySelector(".sticky-section");
    const isScrollY = window.scrollY >= stickySection.offsetTop - -75;
    if (
      isScrollY &&
      isAllItems &&
      !isFolderViewselected &&
      !toggleMenu &&
      !isAccessManagement
    ) {
      setClassNameSticky("sticky-section fixed");
    } else if (
      isScrollY &&
      isFolderViewselected &&
      !toggleMenu &&
      !isAllItems &&
      !isAccessManagement
    ) {
      setClassNameSticky("sticky-section fixed-folderview");
    } else if (
      isScrollY &&
      isFolderViewselected &&
      toggleMenu &&
      !isAllItems &&
      !isAccessManagement
    ) {
      setClassNameSticky("sticky-section fixed-folderview2");
    } else if (
      isScrollY &&
      isAccessManagement &&
      !isFolderViewselected &&
      !isAllItems &&
      !toggleMenu
    ) {
      setClassNameSticky("sticky-section fixed-accessManage");
    } else {
      setClassNameSticky("sticky-section");
    }
  }, [isSticky]);

  const innerTabs = [
    { id: "Control_Status", label: selectedLanguage.LstLanguageCodes.UI_ControlStatus, icontext: "display_settings" },
    { id: "Track_Interactivity", label: selectedLanguage.LstLanguageCodes.UI_TarckInteractivity, icontext: "sensor_occupied" },
    { id: "Summary", label: selectedLanguage.LstLanguageCodes.UI_Summary, icontext: "list_alt" },
    { id: "Activity_Log", label: selectedLanguage.LstLanguageCodes.UI_ActivityLog, icontext: "history_toggle_off" },
    { id: "Statistics", label: selectedLanguage.LstLanguageCodes.UI_Statistics, icontext: "stacked_bar_chart" },
  ];

  const setActiveTabWrapper = (id, documentid) => {

    const updated = lstDocumentsHistory.map(item =>
      item.documentId === documentid
        ? { ...item, activeTabName: id }
        : item
    );
    setLstDocumentsHistory(updated);
    if (id == "Track_Interactivity") {
      handleRefreshTrackInterActivity(documentid);
    }
    if (id == "Statistics") {
      handleToShowStaticData(documentid);
    }
    if (id == "Summary") {
      onSummaryClickHandler(documentid);
    }
  }

  const defaultGridColumns = [
    {
      name: "checkbox",
      class: 'w-5p res-pr-0 pe-0',
      classData: "w-5p text-start",
      classTrack: 'w-5p res-pr-0 pe-0',
      fixed: true,
      active: true,
      order: 0.5
    },
    {
      name: "type",
      label: selectedLanguage.LstLanguageCodes.UI_Type,
      class: "w-4p res-pl-3 res-pl-0 pl-2px text-center",
      classData: "w-4p text-center grid-border-left",
      classTrack: "w-6p res-pl-3 res-pl-0 pl-2px",
      fixed: true,
      active: true,
      order: 0.6
    },
    {
      name: "created",
      label: selectedLanguage.LstLanguageCodes.UI_Created,
      labelTab: selectedLanguage.LstLanguageCodes.UI_Created,
      class: "w-10p pl-5px ",
      classData: "text-start w-10p grid-border-left",
      classTrack: "w-10p pl-5px",
      sortable: true,
      active: true,
      order: 3
    },
    {
      name: "subjectdescription",
      class: "w-13p pl-5px",
      classData: "text-start w-13p grid-border-left",
      classTrack: "w-15p pl-5px",
      label: `${selectedLanguage.LstLanguageCodes.UI_Subject}/${selectedLanguage.LstLanguageCodes.UI_Description}`,
      active: true,
      order: 4
    },
    {
      name: "documentname",
      class: "w-13p pl-5px",
      classData: "text-start w-13p grid-border-left",
      classTrack: "w-14p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_DocumentName,
      active: true,
      order: 5
    },
    {
      name: "initialreaders",
      class: "w-14p pl-5px",
      classData: "text-start w-14p grid-border-left",
      classTrack: "w-14p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_InitialReaders,
      active: true,
      order: 6
    },
    {
      name: "dayssincelastview",
      class: "w-12p pl-5px text-center",
      classData: "text-start w-12p grid-border-left",
      classTrack: "w-12p pl-5px text-center",
      label: selectedLanguage.LstLanguageCodes.UI_DaysSinceLastView,
      sortable: true,
      active: true,
      order: 7
    },
    {
      name: "status",
      class: "w-10p pl-5px text-center",
      classData: "text-center w-10p  all-tdBtn grid-border-left",
      classTrack: "w-10p pl-5px text-center",
      label: selectedLanguage.LstLanguageCodes.UI_Status,
      active: true,
      order: 8
    },
    {
      name: "accesscontrol",
      class: "w-12p text-center pl-5px",
      classData: "text-center w-12p  all-tdBtn grid-border-left",
      classTrack: "w-12p text-center pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_AccessControl,
      active: true,
      order: 9
    },
    {
      name: "documentid",
      class: "w-10p pl-5px",
      classData: "text-start w-10p grid-border-left",
      classTrack: "w-12p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_DocumentID,
      active: false,
      order: 10
    },
    {
      name: "owner",
      class: "w-12p pl-5px",
      classData: "text-start w-12p grid-border-left",
      classTrack: "w-12p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Owner,
      active: false,
      order: 11,
    },
    {
      name: "pages",
      class: "w-10p text-center pl-5px",
      classData: "text-center w-10p grid-border-left",
      classTrack: "w-12p text-center pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Pages,
      active: false,
      order: 14
    },
    {
      name: "launches",
      class: "w-10p pl-5px",
      classData: "w-10p text-start pl-5px grid-border-left",
      classTrack: "w-10p text-start pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Launches,
      labelTab: selectedLanguage.LstLanguageCodes.UI_Launches,
      active: false,
      order: 15
    },
    {
      name: "expires",
      class: "w-10p pl-5px",
      classData: "w-10p text-start pl-5px grid-border-left",
      classTrack: "w-10p text-start pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Expires,
      labelTab: selectedLanguage.LstLanguageCodes.UI_Expires,
      active: false,
      order: 16
    }
  ];
  const killGridColumns = [
    {
      name: "type",
      label: selectedLanguage.LstLanguageCodes.UI_Type,
      class: "w-4p res-pl-3 res-pl-0 pl-2px text-center",
      classData: "w-4p text-center",
      classTrack: "w-6p res-pl-3 res-pl-0 pl-2px",
      active: true,
      order: 1
    },
    {
      name: "created",
      label: selectedLanguage.LstLanguageCodes.UI_Created + " " + "(" + timeZoneAbbrevation.current + ")",
      class: "w-10p pl-5px ",
      classData: "text-start w-10p grid-border-left",
      classTrack: "w-10p pl-5px",
      sortable: true,
      active: true,
      order: 2
    },
    {
      name: "documentid",
      class: "w-12p pl-5px",
      classData: "text-start w-12p grid-border-left",
      classTrack: "w-12p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_DocumentID,
      active: true,
      order: 3
    },
    {
      name: "documentname",
      class: "w-17p pl-5px",
      classData: "text-start w-17p grid-border-left",
      classTrack: "w-14p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_DocumentName,
      active: true,
      order: 4
    },
    {
      name: "owner",
      class: "w-12p pl-5px",
      classData: "text-start w-12p grid-border-left",
      classTrack: "w-12p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Owner,
      active: true,
      order: 5
    },
    {
      name: "killedby",
      class: "w-12p pl-5px",
      classData: "text-start w-12p grid-border-left",
      classTrack: "w-12p pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_KilledBy,
      active: true,
      order: 6
    },
    {
      name: "killeddate",
      class: "w-10p pl-5px ",
      classData: "text-start w-10p grid-border-left",
      classTrack: "w-10p pl-5px ",
      label: selectedLanguage.LstLanguageCodes.UI_KilledDate,
      active: true,
      order: 7
    },
    {
      name: "status",
      class: "w-10p pl-5px text-center",
      classData: "text-center w-10p  all-tdBtn grid-border-left",
      classTrack: "w-10p pl-5px text-center",
      label: selectedLanguage.LstLanguageCodes.UI_Status,
      active: true,
      order: 8
    },
    {
      name: "accesscontrol",
      class: "w-12p text-center pl-5px",
      classData: "text-center w-12p  all-tdBtn grid-border-left",
      classTrack: "w-12p text-center pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_AccessControl,
      active: true,
      order: 9
    },
    {
      name: "pages",
      class: "w-12p text-center pl-5px",
      classData: "text-center w-12p grid-border-left",
      classTrack: "w-12p text-center pl-5px",
      label: selectedLanguage.LstLanguageCodes.UI_Pages,
      active: false,
      order: 10
    }
  ];
  const [sortedColumns, setSortedColumns] = useState();
  useEffect(() => {
  }, [sortedColumns]);
  const [position, setPosition] = useState(null);
  const handleMouseEnter = (e) => {
    const box = e.target.getBoundingClientRect();
    const { top, bottom, left, right } = box;
    const centerX = left + (right - left) / 2;
    const centerY = top + (bottom - top) / 2;
    const newPosition = centerY < window.innerHeight / 2 ? "bottom" : "top";
    setPosition(newPosition);
  };

  const handleSaveRecipientPrintSettings = (data) => {
    setRecipientPrintData(data.recipients);
    setPrintEnabledType(data.printEnabledType);
  }

  const renderCell = (key, item, index) => {
    switch (key) {
      case "checkbox":
        return (
          <div className={`checkbox mt-n5p marginTop8 res-ml-n8 all ${item?.canEditRPDRecords == false ? "disabled" : ""}`}>
            <label className="p-0 mb-0">
              <input
                type="checkbox"
                checked={item.selection}
                onChange={(e) => handlerSelection(e, index)}
                ref={(el) => (itemsCheckRef.current[index] = el)}
              />
              <span className="cr"><i className="cr-icon material-icons">check</i></span>
            </label>
          </div>
        );

      case "type":
        return item.rpdType === "Create" ? (
          <img src="assets/img/icons/create.svg" height="28px" />
        ) : (
          <span className="material-icons top-2px">mail</span>
        );

      case "created":
        return <div className="d-flex flex-wrap textwrap">
          {
            moment.utc(new Date(item.created))
              .utcOffset(timeZoneRef.current)
              .format(`${dateFormatValueUpper} HH:mm`)

          }
        </div>

      case "subjectdescription":
        return <div
          className="d-flex flex-wrap Wordbreak"
          title={
            item.documentOptions.subject
          }>
          <p className="textwrap mb-0">
            {item.documentOptions.subject}
          </p>
        </div>

      case "documentid":
        return <div class="d-flex flex-wrap Wordbreak" title={item.documentId}><p class="textwrap mb-0">{item.documentId}</p></div>;

      case "documentname":
        return <div className="align-items-center flex-wrap textwrap tootltip-history ">
          <span className="Wordbreak">
            {item.fileName}
          </span>


          <strong
            className={
              "seeMore" +
              (item.inputFiles &&
                item.inputFiles.length > 1
                ? ""
                : " d-none ")
            }
            id={"modifiedFileNames" + index}
            data-html="true"
            style={{ paddingLeft: "5px" }}>
            <i className="material-icons">
              more_horiz
            </i>
          </strong>

          <ReactTooltip
            className="seemore-tooltip"
            anchorId={"modifiedFileNames" + index}
            clickable>
            <table className="tooltip-table timeintractivity-table">
              <div className="tooltip-intial-receipts ps-2 pb-2 pt-1">
                {item.inputFiles &&
                  item.inputFiles.length > 0 &&
                  item.inputFiles.map((temp_file, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        whiteSpace: "normal",
                        width: "100%"
                      }}
                    >
                      <span style={{ wordBreak: "break-word" }}>
                        {temp_file.modifiedFileName}
                      </span>

                    </div>
                  ))}

              </div>
            </table>
          </ReactTooltip>
        </div>

      case "initialreaders":
        return (
          <>
            <div className="align-items-center flex-wrap textwrap tootltip-history">
              {item.documentOptions.recipients
                .length > 0 &&
                item.documentOptions.recipients[0]
                  .email}

              <strong
                className={
                  "seeMore" +
                  (item.documentOptions.recipients
                    .length > 1
                    ? ""
                    : " d-none ")
                }
                id={"intial-receipts" + index}
                data-html="true"
                style={{ paddingLeft: "5px" }}>
                <i
                  className="material-icons"
                  onClick={(e) =>
                    viewmore(e, item.documentId)
                  }>
                  more_horiz
                </i>
              </strong>
            </div>
          </>
        );

      case "owner":
        return <div class="d-flex flex-wrap Wordbreak" title={item.senderAddress}>{item.senderAddress}</div>;

      case "dayssincelastview":
        return <div className="text-center">{item.daysSinceLastView}</div>

      case "killedby":
        return <span>{item.killedBy}</span>;

      case "killeddate":
        return moment.utc(applyTimeZoneToDisplay(new Date(item.killedDate), timeZoneRef.current)).format(dateFormatValueUpper);

      case "status":
        return renderStatusButton(item, index);

      case "accesscontrol":
        return renderAccessControl(item);

      case "pages":
        return <span>{item.pages}</span>;

      case "launches":
        return (
          <span>
            {item.documentOptions?.startTime &&
              (
                isDatetimeControl === "true"
                  ? moment.utc(
                    applyTimeZoneToDisplay(
                      new Date(item.documentOptions.startTime),
                      timeZoneRef.current
                    )
                  ).format(`${dateFormatValueUpper} HH:mm`)
                  : moment.utc(
                    applyTimeZoneToDisplay(
                      new Date(item.documentOptions.startTime),
                      timeZoneRef.current
                    )
                  ).format(dateFormatValueUpper)
              )
            }
          </span>
        );

      case "expires":
        return (
          item.documentOptions?.expiryTime &&
          (
            isDatetimeControl === "true"
              ? moment.utc(
                applyTimeZoneToDisplay(
                  new Date(item.documentOptions.expiryTime),
                  timeZoneRef.current
                )
              ).format(`${dateFormatValueUpper} HH:mm`)
              : moment.utc(
                applyTimeZoneToDisplay(
                  new Date(item.documentOptions.expiryTime),
                  timeZoneRef.current
                )
              ).format(dateFormatValueUpper)
          )
        );
      default:
        return null;
    }
  };

  const renderStatusButton = (item, index) => {
    const lang = selectedLanguage.LstLanguageCodes;
    const style = { padding: "9px 14px" };

    if (item.documentOptions.enabled === true) {
      return (
        <button
          title={lang.UI_Active}
          className={`btn btn-outline-success w-120p truncate ${item?.canEditRPDRecords == false ? "disabled" : ""}`}
          style={style}
          onClick={(e) =>
            handlerActiveInactive(e, false, item.documentId, true, false)
          }>
          {lang.UI_Active}
        </button>
      );
    }

    if (!item.documentOptions.enabled && !item.isPermanentExpire && !item.isKilled) {
      return (
        <button
          title={lang.UI_Expired}
          className={`btn btn-outline-danger w-120p truncate ${item?.canEditRPDRecords == false ? "disabled" : ""}`}
          style={style}
          onClick={(e) =>
            handlerActiveInactive(e, true, item.documentId, true, false)
          }>
          {lang.UI_Expired}
        </button>
      );
    }

    return (
      <button
        title={lang.UI_Expired}
        className="btn btn-outline-danger w-120p truncate disabled"
        style={style}>
        {lang.UI_Expired}
      </button>
    );
  };
  const renderAccessControl = (item) => {
    const lang = selectedLanguage.LstLanguageCodes;
    const baseStyle = "btn text-white font-w600 pd-16 w-150p truncate";

    switch (item.securityLevel) {
      case 3:
        return (
          <input
            type="button"
            title={lang.UI_LimitReaders}
            className={`${baseStyle} btn-danger`}
            value={lang.UI_LimitReaders}
          />
        );
      case 2:
        return (
          <input
            type="button"
            title={lang.UI_TrackReaders}
            className={`${baseStyle} btn-warning`}
            value={lang.UI_TrackReaders}
          />
        );
      default:
        return (
          <input
            type="button"
            title={lang.UI_TrackViews}
            className={`${baseStyle} btn-success`}
            style={{ backgroundColor: "#5a8eff" }}
            value={lang.UI_TrackViews}
          />
        );
    }
  };





  useEffect(() => {
    if (backupRecords.current
      && trackInteractivityDetails
      && trackInteractivityDetails.length > 0
      && currTrackDetails.current.docId
      && currTrackDetails.current.recipientEmail !== "") {
      const docIndex = trackInteractivityDetails.findIndex(item => item.docId === currTrackDetails.current.docId);
      if (docIndex !== -1) {
        const updatedDetails = [...trackInteractivityDetails];
        const recipient = updatedDetails[docIndex].records.find(item => item?.email?.toLowerCase() === currTrackDetails.current.recipientEmail.toLowerCase());
        if (recipient) {
          const refDocIndex = trackInteractivityDetailsRef.current.findIndex(item => item.docId === currTrackDetails.current.docId);
          if (refDocIndex !== -1) {
            const updatedRef = [...trackInteractivityDetailsRef.current];
            const index = updatedRef[refDocIndex].records.findIndex(item => item?.email?.toLowerCase() === currTrackDetails.current.recipientEmail.toLowerCase());
            updatedRef[refDocIndex].records[index] = recipient;
            trackInteractivityDetailsRef.current = updatedRef;
          } else {
            trackInteractivityDetailsRef.current = updatedDetails;
          }
        }
      }
    }

  }, [trackInteractivityDetails, backupRecords.current]);

  const onSearchTrackInteractivityDetailsHandler = (e, documentId) => {
    if (searchInputTimeout.current) {
      clearTimeout(searchInputTimeout.current);
    }
    searchInputTimeout.current = setTimeout(() => {
      const records = trackInteractivityDetailsRef.current.find((item) => item.docId === documentId).records;
      const results = records.filter((item) => {
        const searchValue = e.target.value.toLowerCase();
        if (searchValue === "") {
          return true;
        }
        if ((!item.email)) {
          return false;
        }
        return (
          JSON.stringify(item.email).toLowerCase().includes(searchValue) ||
          JSON.stringify(item.firstName).toLowerCase().includes(searchValue) ||
          JSON.stringify(item.lastName).toLowerCase().includes(searchValue))
      }).map((item) => {
        return { ...item, open: false };
      });
      let count = results.filter((record) => record.checked && record.email).length;
      const selectAll =
        count ===
          results.filter((record) => record.email).length
          ? true
          : false;

      setTrackInteractivityDetails((prev) => {
        return prev.map((doc) => {
          if (doc.docId === documentId) {
            return {
              ...doc,
              records: results,
              selectAllRecipients: (results.length > 0) ? selectAll : false,
            };
          }
          return doc;
        });
      })
      if (e.target.value === "") {
        onSearch.current = false;
        backupRecords.current = true;
        currTrackDetails.current.docId = '';
        currTrackDetails.current.recipientEmail = "";
      } else {
        onSearch.current = true;
      }
      backupRecords.current = false;

      console.log("results", results);
    }, 500);

  }


  return (
    <div className="manage-page">
      {openLoader ? (
        <LoadingSpinner
          className={openLoaderSearch ? "backgroundTransprent" : undefined}
        />
      ) : null}
      {onlineStatus === false && (
        <div
          className="rpdFont modal z-index-for-no-internet"
          id="PagewModel"
          style={{
            display: "block",
            backgroundColor: "#54404061",
            zIndex: 9999,
          }}
          onContextMenu={(e) => e.preventDefault()}>
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content noInternetpopup">
              <div className="modal-body p-4">
                <div className="text-center mb-3">
                  <img
                    className="h-100px"
                    src={`data:image/png;base64,${noInternetImg}`}
                  />
                </div>
                <div className="mt-3">
                  <h6 className="font-22 mb-1 pt-2 text-center">
                    {" "}
                    {selectedLanguage.LstLanguageCodes.UI_NoInternetConnection}
                  </h6>
                  <p
                    className="text-center my-1"
                    style={{ color: "#000", fontSize: "17px" }}>
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_PleaseMakeSureYouHaveInternet
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Header></Header>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist"
        resetTrigger={isAllItems ? "AllItems" : isFolderViewselected ? "FolderView" : isAccessManagement ? "AccessManagement" : ""}></Alert>
      <section className="mt-4 mx-2 mysection res-section ">
        <div className="card">
          <ul className="nav nav-tabs common-tabs" id="myTab">
            <li className="nav-item">
              <a
                href="#home"
                ref={allItems}
                className="nav-link manage-link active"
                data-bs-toggle="tab"
                onClick={(e) => GetAllItems(e)}>
                {selectedLanguage.LstLanguageCodes.UI_AllItems}
              </a>
            </li>
            <li className="nav-item">
              <a
                href="#profile"
                ref={folderView}
                className="nav-link manage-link"
                onClick={(e) => FolderViewSelected(e)}
                data-bs-toggle="tab">
                {selectedLanguage.LstLanguageCodes.UI_FolderView}
              </a>
            </li>
            <li className="nav-item">
              <a
                href="#messages"
                className="nav-link manage-link"
                data-bs-toggle="tab"
                ref={l3TabNavigation}
                onClick={handleAccessManagement}>
                {selectedLanguage.LstLanguageCodes.UI_AccessManagement}
              </a>
            </li>
          </ul>
        </div>
        <div className="mycontainer res-container">
          <div className="card managebox-shadow p-0 h-475 tab-content">
            <div
              className="tab-pane fade show active tabchange"
              id={isFolderViewselected == false ? "home" : "profile"}>
              <>
                <div
                  className={
                    isFolderViewselected == false
                      ? "card-header card-headercustome pe-2"
                      : "card-header card-headercustome  pb-0 pe-2"
                  }
                  style={{
                    borderBottom:
                      isFolderViewselected == false
                        ? ""
                        : "1px solid rgb(229 230 234)",
                  }}>
                  <h5 className="my-2 pt-1 mails d-flex align-items-center font-18 manage-title">
                    <img
                      src={"assets/img/icons/document.png"}
                      className="me-2"
                      alt="Document"
                      height="21px"
                    />
                    <span className="material-icons me-2 d-none">
                      schedule_send
                    </span>{" "}
                    {selectedLanguage.LstLanguageCodes.UI_ControlAfterSending}
                  </h5>
                  <div className="row d-flex align-items-center flex-wrap justify-content-between my-3 pt-2 mx-1">
                    <div
                      className=" d-flex justify-content-between resflex-wrap pe-0"
                      style={{ marginTop: "-10px", marginLeft: '-32px' }}>

                      <div className="d-flex align-items-center">
                        {isKilledOpt === true ? (
                          Object.values(killedFilterComponents)
                        ) : (
                          orderedFilters.map(([key]) => (
                            <div key={key}>
                              {filterComponents[key]}
                            </div>
                          ))

                        )}
                      </div>

                      <div className="d-flex align-items-center justify-content-end res-controls">
                        {!userfilterDisbale && (
                          <span
                            className="material-icons res-controls"
                            style={{
                              fontSize: "40px",
                              marginTop: "5px",
                              marginLeft: "14px",
                              cursor: "pointer",
                            }}
                            onClick={handleSearchPopup}>
                            tune
                          </span>
                        )}
                        <span
                          className="material-icons searchHistory"
                          onClick={SearchDocumentData}
                          style={{ cursor: "pointer" }}>
                          search
                        </span>
                        <span
                          className="material-icons cancelHistory"
                          id="clearFiltersButton"
                          onClick={
                            isFolderViewselected === false
                              ? RetainDocumentList
                              : () => RetainDocumentList(1)
                          }
                          style={{
                            cursor: "pointer",
                            margin: "2px 0px 2px 0",
                          }}>
                          block
                        </span>
                      </div>
                      {userRoleBased && searchFilterPopup && (
                        <div className="SuporadminPopup popup" style={{ maxWidth: "none", height: "auto", width: "auto" }}>
                          <div className="d-flex justify-content-between">
                            <label
                              className="form-label mb-0"
                              style={{ fontSize: "15px" }}>
                              {selectedLanguage.LstLanguageCodes.UI_Owner}
                            </label>
                            <button
                              type="button"
                              className="btn btn-outline-danger Readerclose modalclose download advanced-close"
                              onClick={() => handleCloseModalSearch()}>
                              <span className="material-icons font-20">
                                highlight_off
                              </span>
                            </button>
                          </div>

                          <div>
                            <input
                              className="res-controls"
                              type="text"
                              autoComplete="none"
                              value={ownerSearch}
                              title={ownerSearch}
                              style={{ width: "300px", marginTop: "3px" }}
                              onChange={(e) => setOwnerSearch(e.target.value)}
                            />
                          </div>

                          <div style={{ marginTop: "6px", fontSize: "15px" }}>
                            <label
                              className="form-label mb-0"
                              style={{ fontSize: "15px" }}>
                              {selectedLanguage.LstLanguageCodes.UI_Company}
                            </label>
                          </div>
                          <input
                            type="text"
                            name="documentIdInput"
                            autoComplete="none"
                            value={companySearch}
                            title={companySearch}
                            style={{ width: "300px", marginTop: "5px" }}
                            onChange={(e) => { setCompanySearch(e.target.value) }}
                          />

                          <div style={{ textAlign: "center" }}>
                            <input
                              type="button"
                              value={selectedLanguage.LstLanguageCodes.UI_Search}
                              className="ApplyBtn"
                              // style={{ width: "75px", background: "lightgreen", fontWeight: "600", color: "white", marginTop: '10px' }}
                              onClick={handleSearchApply} // Call handleSearch on button click
                            />
                            <input
                              type="button"
                              value={selectedLanguage.LstLanguageCodes.UI_Clear}
                              className="ClearBtn"
                              // style={{ width: "75px", marginLeft: "10px", background: "red", fontWeight: "600", color: "white", marginTop: '10px' }}
                              onClick={handleSearchClear} // Call handleSearch on button click
                            />
                          </div>
                        </div>
                      )}
                      {!userRoleBased && searchFilterPopup && (
                        <div className="CustomeradminPopup popup" style={{ height: "auto", width: "auto" }}>
                          <div className="d-flex justify-content-between">
                            <label
                              className="form-label mb-0"
                              style={{ fontSize: "15px" }}>
                              {selectedLanguage.LstLanguageCodes.UI_Owner}
                            </label>
                            <button
                              type="button"
                              className="btn btn-outline-danger Readerclose modalclose download advanced-close"
                              onClick={() => handleCloseModalSearch()}>
                              <span className="material-icons font-20">
                                highlight_off
                              </span>
                            </button>
                          </div>

                          <div>
                            <input
                              className="res-controls"
                              type="text"
                              autoComplete="none"
                              value={ownerSearch}
                              title={ownerSearch}
                              style={{ width: "300px", marginTop: "5px" }}
                              onChange={(e) => setOwnerSearch(e.target.value)}
                            />
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <input
                              type="button"
                              value={selectedLanguage.LstLanguageCodes.UI_Search}
                              className="ApplyBtn"
                              // style={{ width: "75px", background: "rgb(58, 177, 109) !important", fontWeight: "600", color: "white", marginTop: '10px' }}
                              onClick={handleSearchApply} // Call handleSearch on button click
                            />
                            <input
                              type="button"
                              value={selectedLanguage.LstLanguageCodes.UI_Clear}
                              className="ClearBtn"
                              // style={{ width: "75px", marginLeft: "10px", background: "rgb(220 53 69) !important", fontWeight: "600", color: "white", marginTop: '10px' }}
                              onClick={handleSearchClear} // Call handleSearch on button click
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div>

                    </div>
                    <div
                      className="mt-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingRight: "0px",
                        paddingLeft: "0px",
                      }}>
                      <div
                        className={
                          isFolderViewselected == false
                            ? "col-sm-4 col-lg-4 d-flex"
                            : "col-sm-4 col-lg-4 d-lg-flex"
                        }>
                        {showOwnerWhenApply && (
                          <div
                            className="cancelOwnerText"
                            title={showOwnerWhenApply}>
                            {showOwnerWhenApply && (
                              <span>
                                {selectedLanguage.LstLanguageCodes.UI_Owner}:{" "}
                                {showOwnerWhenApply}
                              </span>
                            )}
                            {showOwnerWhenApply && (
                              <AiOutlineCloseCircle
                                onClick={clearOwnerSearch}
                                className="cancelsmalicon"
                              />
                            )}
                          </div>
                        )}
                        {(recordsSelectedCount.showRecords && !istrackkillHeader) && (
                          <div className="cancelOwnerText">
                            {recordsSelectedCount.showRecords && (
                              <span>{`${recordsSelectedCount.count} ${recordsSelectedCount.count === 1
                                ? "RPD"
                                : "RPDs"
                                }  ${selectedLanguage.LstLanguageCodes.UI_Selected}`}</span>
                            )}

                            {recordsSelectedCount.showRecords && (
                              <AiOutlineCloseCircle
                                onClick={handleClearRecordCount}
                                className="cancelsmalicon"
                              />
                            )}
                          </div>
                        )}

                        {showCompanyWhenApply && defaultTheCompany && (
                          <div
                            className="cancelOwnerText"
                            style={{ marginLeft: "2px" }}
                            title={showCompanyWhenApply}>
                            {showCompanyWhenApply && (
                              <span>
                                {selectedLanguage.LstLanguageCodes.UI_Company}:{" "}
                              </span>
                            )}
                            {showCompanyWhenApply}
                            {showCompanyWhenApply && (
                              <AiOutlineCloseCircle
                                onClick={clearCompanySearch}
                                className="cancelsmalicon"
                              />
                            )}
                          </div>
                        )}
                        {isFolderViewselected == true
                          ? folderName &&
                          (ClearSearchcalled == false &&
                            folderName !=
                            selectedLanguage.LstLanguageCodes.UI_Default ? (
                            <div
                              className="cancelOwnerText"
                              title={folderName}
                              style={{ marginLeft: "7px" }}>
                              {folderName}
                              <AiOutlineCloseCircle
                                onClick={() => clearOwnerSearch(1)}
                                className="cancelsmalicon"
                              />
                            </div>
                          ) : (
                            <div
                              className="cancelOwnerText"
                              title={folderName}
                              style={{
                                marginLeft: "7px",
                                paddingRight: "17px",
                              }}>
                              <span>{folderName}</span>{" "}
                            </div>
                          ))
                          : ""}
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6 res-px0 pe-0 Refresh-All d-flex align-items-center">
                        {/* <div className="d-flex align-items-center"> */}
                        {(recordsSelectedCount.showRecords && !istrackkillHeader) && (

                          <div className="d-flex mt-2">
                            <button
                              title={
                                selectedLanguage.LstLanguageCodes
                                  .UI_ExpireSelected
                              }
                              className="btn btn-outline-danger btnPaddingExpireActive fw-semi-bold "
                              //style={{ padding: "9px 14px" }}
                              onClick={(e) =>
                                handlerActiveInactive(e, false, "", true, true)
                              }>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_ExpireSelected
                              }
                            </button>
                            <button
                              title={
                                selectedLanguage.LstLanguageCodes
                                  .UI_ActivateSelected
                              }
                              className="btn btn-outline-success btnPaddingExpireActive fw-semi-bold  ms-2 "
                              //style={{ padding: "9px 14px" }}
                              onClick={(e) =>
                                handlerActiveInactive(e, true, "", true, true)
                              }>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_ActivateSelected
                              }
                            </button>
                          </div>
                        )}
                        {isFolderViewselected == false ? (
                          ""
                        ) : (
                          <img
                            className="move-icon ms-2"
                            src={"assets/img/icons/move-to-folder.png"}
                            alt="Folder Move"
                            height="24px"
                            onClick={(e) => OpenMoveModalPopUp(e)}
                          />
                        )}
                        {!istrackkillHeader && (<img
                          style={{
                            height: "30px",
                            marginLeft: "12px"
                          }}
                          onClick={(e) =>
                            handleCustomColumnsLayout()
                          }
                          src="assets/img/icons/customcolumns.png"
                          title={"Custom Layout"}
                          className="material-icons me-1 pb-1 light mt-3 Refresh-icon" alt={selectedLanguage.LstLanguageCodes.UI_CustomColumnLayout}>

                        </img>)}
                        <span
                          onClick={(e) =>
                            handleRefreshAll(
                              e,
                              isFolderViewselected == false ? 0 : 1
                            )
                          }
                          className="material-icons me-1 pb-1 light mt-3 Refresh-icon">
                          refresh
                        </span>
                        {!istrackkillHeader && (
                          <button
                            style={{
                              padding: "0.4rem 0.8rem",
                              height: "38px",
                            }}
                            className="kill-selected fw-semi-bold  mt-2 btn-outline-danger btn shadow d-flex align-items-center res-btn w-auto c-py"
                            onClick={(e) => handlerClickKillNote(e)}>
                            <span className="material-icons me-1 font-20">
                              delete_outline
                            </span>
                            {selectedLanguage.LstLanguageCodes.UI_KillSelected}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="commontableft-section px-0">
                    {/* id="sidebarMenu" */}
                    <nav className="sidebar" id="folderList">
                      <div className="d-flex align-items-center mb-1 pb-2 justify-content-between folder-left px-1">
                        <button
                          className="fw-semi-bold  mt-2 btn-danger btn shadow d-flex align-items-center res-btn w-auto newfolder-btn"
                          onClick={(e) => OpenCreateFolderModalPopUp(e)}>
                          <span className="material-icons me-2 font-20">
                            add
                          </span>{" "}
                          {selectedLanguage.LstLanguageCodes.UI_Folders}
                        </button>
                        <div className="cricle-box" onClick={MenuClick}>
                          <span className="material-icons pointer">
                            chevron_left
                          </span>
                        </div>
                      </div>
                      <ul className="nav flex-column folder-list">
                        <li
                          className={
                            defaultSelected == true
                              ? "nav-item active w-100"
                              : "nav-item w-100"
                          }
                          onClick={(e) =>
                            handleFolderId(
                              1,
                              selectedLanguage.LstLanguageCodes.UI_Default
                            )
                          }>
                          {defaultSelected == true ? (
                            <svg
                              className="folderimg"
                              xmlns="http://www.w3.org/2000/svg"
                              height="24px"
                              viewBox="0 -960 960 960"
                              width="24px"
                              fill="#5f6368">
                              <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z" />
                            </svg>
                          ) : (
                            <span className="material-icons ms-2 font-20 foldericon">
                              folder
                            </span>
                          )}
                          <a
                            className="nav-link ps-2 folder-items"
                            href="#"
                            contentEditable="false"
                            suppressContentEditableWarning={true}
                            title="Default">
                            {selectedLanguage.LstLanguageCodes.UI_Default}
                          </a>
                        </li>
                      </ul>
                      <div className="position-sticky scrollbar">
                        <div className="accordion" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                id="myfolders"
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle={
                                  foldersDetailsLst.filter(
                                    (item) => item.isShared == 0
                                  ).length > 0
                                    ? "collapse"
                                    : ""
                                }
                                data-bs-target={
                                  foldersDetailsLst.filter(
                                    (item) => item.isShared == 0
                                  ).length > 0
                                    ? "#collapseOne"
                                    : "#"
                                }
                                aria-expanded={
                                  foldersDetailsLst.filter(
                                    (item) => item.isShared == 0
                                  ).length > 0
                                    ? "true"
                                    : "false"
                                }
                                style={{
                                  cursor:
                                    foldersDetailsLst.filter(
                                      (item) => item.isShared == 0
                                    ).length == 0
                                      ? "not-allowed"
                                      : "",
                                }}
                                disabled={
                                  foldersDetailsLst.filter(
                                    (item) => item.isShared == 0
                                  ).length == 0
                                }
                                aria-controls={
                                  foldersDetailsLst.filter(
                                    (item) => item.isShared == 0
                                  ).length == 0
                                    ? ""
                                    : "collapseOne"
                                }>
                                <span className="folder-name">
                                  {" "}
                                  {
                                    selectedLanguage.LstLanguageCodes
                                      .UI_Myfolders
                                  }
                                </span>
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample">
                              <div className="accordion-body p-0">
                                <ul className="nav flex-column folder-list">
                                  {foldersDetailsLst.length > 0 &&
                                    foldersDetailsLst
                                      .filter((item) => item.isShared == 0)
                                      .map((option) => (
                                        <li
                                          id={"li_" + option.folderID}
                                          className={
                                            option.isActive
                                              ? "nav-item ps-2 active w-100"
                                              : "nav-item ps-2 w-100"
                                          }
                                          onClick={(e) =>
                                            handleFolderId(
                                              option.folderID,
                                              option.folderName,
                                              option.isShared,
                                              option.isActive
                                            )
                                          }
                                          style={{ position: "relative" }}>
                                          {" "}
                                          {/* Set position to relative for the li element */}
                                          {option.isActive ? (
                                            <svg
                                              className="folderimg"
                                              xmlns="http://www.w3.org/2000/svg"
                                              height="24px"
                                              viewBox="0 -960 960 960"
                                              width="24px"
                                              fill="#5f6368">
                                              <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z" />
                                            </svg>
                                          ) : (
                                            <span className="material-icons ms-2 font-20 foldericon">
                                              folder
                                            </span>
                                          )}
                                          <a
                                            id={option.folderID}
                                            className="nav-link ps-2 folder-items"
                                            href="#"
                                            contentEditable="false"
                                            suppressContentEditableWarning={true}
                                            title={option.folderName}>
                                            {option.folderName}
                                          </a>
                                          <p
                                            className="material-icons"
                                            style={{
                                              fontSize: "18px",
                                              position: "absolute",
                                              right: "9px",
                                              top: "25%",
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) =>
                                              manageFolderOpen(
                                                option.folderID,
                                                option.folderName,
                                                option.isShared,
                                                option.isActive
                                              )
                                            }>
                                            edit
                                          </p>
                                        </li>
                                      ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          {localStorage.getItem("UserRole") !=
                            "RDocsSupportAdmin" && (
                              <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne1">
                                  <button
                                    id="SharedFolder"
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle={
                                      foldersDetailsLst.filter(
                                        (item) => item.isShared != 0
                                      ).length > 0
                                        ? "collapse"
                                        : ""
                                    }
                                    data-bs-target={
                                      foldersDetailsLst.filter(
                                        (item) => item.isShared != 0
                                      ).length > 0
                                        ? "#collapseOne1"
                                        : "#"
                                    }
                                    aria-expanded={
                                      foldersDetailsLst.filter(
                                        (item) => item.isShared != 0
                                      ).length > 0
                                        ? "true"
                                        : "false"
                                    }
                                    aria-controls={
                                      foldersDetailsLst.filter(
                                        (item) => item.isShared != 0
                                      ).length == 0
                                        ? ""
                                        : "collapseOne1"
                                    }
                                    style={{
                                      cursor:
                                        foldersDetailsLst.filter(
                                          (item) => item.isShared != 0
                                        ).length == 0
                                          ? "not-allowed"
                                          : "",
                                    }}
                                    disabled={
                                      foldersDetailsLst.filter(
                                        (item) => item.isShared != 0
                                      ).length == 0
                                    }>
                                    <span className="folder-name">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Shared
                                      }{" "}
                                    </span>
                                  </button>
                                </h2>
                                <div
                                  id="collapseOne1"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="headingOne1"
                                  data-bs-parent="#accordionExample">
                                  <div className="accordion-body p-1">
                                    <ul className="nav flex-column folder-list">
                                      {foldersDetailsLst.length > 0 &&
                                        foldersDetailsLst
                                          .filter((item) => item.isShared != 0)
                                          .map((option) => (
                                            <li
                                              id={"li_" + option.folderID}
                                              className={
                                                option.isActive == true
                                                  ? "nav-item ps-1 active w-100"
                                                  : "nav-item ps-1 w-100"
                                              }
                                              onClick={(e) =>
                                                handleFolderId(
                                                  option.folderID,
                                                  option.folderName,
                                                  option.isShared,
                                                  option.isActive
                                                )
                                              }>
                                              {option.isActive == true ? (
                                                <svg
                                                  className="folderimg"
                                                  xmlns="
                                        http://www.w3.org/2000/svg"
                                                  height="24px"
                                                  viewBox="0 -960 960 960"
                                                  width="24px"
                                                  fill="#5f6368">
                                                  <title>
                                                    {"Created by:" +
                                                      " " +
                                                      option.email}
                                                  </title>
                                                  <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z" />
                                                </svg>
                                              ) : (
                                                <span
                                                  className="material-icons ms-1 font-20 foldericon"
                                                  title={
                                                    "Created by:" +
                                                    " " +
                                                    option.email
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    handleFolderId(
                                                      option.folderID,
                                                      option.folderName,
                                                      option.isShared,
                                                      option.isActive
                                                    )
                                                  }>
                                                  folder
                                                </span>
                                              )}
                                              <a
                                                id={option.folderID}
                                                // style={{ width: "120px" }}
                                                className="nav-link ps-2 folder-items"
                                                href="#"
                                                contentEditable="false"
                                                suppressContentEditableWarning={true}
                                                title={option.folderName}>
                                                {option.folderName}
                                              </a>
                                              {localStorage.getItem("UserRole") ==
                                                "RDocsCustomerAdmin" ? (
                                                <p
                                                  className="material-icons"
                                                  style={{
                                                    fontSize: "20px",
                                                    position: "absolute",
                                                    right: "4px",
                                                    margin: "0px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={(e) => {
                                                    localStorage.getItem(
                                                      "UserRole"
                                                    ) == "RDocsCustomerAdmin"
                                                      ? manageFolderOpen(
                                                        option.folderID,
                                                        option.folderName,
                                                        option.isShared,
                                                        option.isActive
                                                      )
                                                      : e.preventDefault();
                                                  }}>
                                                  edit
                                                </p>
                                              ) : (
                                                ""
                                              )}
                                            </li>
                                          ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </nav>
                    <nav className="sidebar" id="foldername">
                      <div className="d-flex align-items-center mb-1 pb-2 justify-content-center folder-left px-1">
                        <div
                          className="cricle-box secondone"
                          onClick={MenuClick1}>
                          <span className="material-icons pointer">
                            navigate_next
                          </span>
                        </div>
                      </div>
                      <div className="position-sticky small-size scrollbar">
                        <h2 className="folder-heading">Folders</h2>
                      </div>
                    </nav>
                  </div>
                  {/* )} */}
                  <div
                    className={
                      isFolderViewselected == false
                        ? ""
                        : " commontabright-section px-0"
                    }
                    style={
                      isFolderViewselected
                        ? {
                          width: dynamicWidthSet.current
                            ? "95.33333%"
                            : "86.33333%",
                        }
                        : {}
                    }>
                    <div className="card-body-new pt-0">
                      <div className="table-responsive res-card">
                        <table
                          className="fold-table table tablelayout "
                          cellPadding="0"
                          cellSpacing="0">
                          <div className={classNameSticky}>
                            <thead className={istrackkillHeader ? "bg-lightblue table-kill-manage" : "bg-lightblue"}>
                              <tr>
                                {sortedColumns?.filter(col => col && col.active).map((col, idx) => {
                                  if (col.active === false) return null;
                                  switch (col.name) {
                                    case "checkbox":
                                      if (istrackkillHeader) return null;
                                      return (
                                        <th key={col.name} className="w-5p res-pr-0 pe-0">
                                          <div className={`checkbox res-ml ms-22 ${isFolderViewselected ? "folder-th" : "all-th"}`}>
                                            <label className="p-0 mb-0">
                                              <input
                                                type="checkbox"
                                                checked={masterSelection}
                                                onChange={(e) => handlerMasterSelection(e)}
                                              />
                                              <span className="cr">
                                                <i className="cr-icon material-icons">check</i>
                                              </span>
                                            </label>
                                          </div>
                                        </th>
                                      );
                                    case "created":
                                    case "dayssincelastview":
                                      return (
                                        <th
                                          key={col.name}
                                          className={`${istrackkillHeader ? col.class : col.classTrack}`}
                                          onClick={(e) => sorting(e, col.name)}
                                          style={{ cursor: "pointer" }}>
                                          <div className="d-flex align-items-center">
                                            <span className={isFolderViewselected ? "left-n6" : ""}>{col.label}</span>
                                            <div className="d-flex flex-column ms-2 position-relative">
                                              <i className={`fa fa-caret-up ${sortColumn.toLowerCase() === col.name
                                                ? sortDown.current ? "rotate-up sort-disable" : "rotate-up"
                                                : "rotate-up sort-disable"
                                                }`} />
                                              <i className={`fa fa-caret-up ${sortColumn.toLowerCase() === col.name
                                                ? sortDown.current ? "rotate-down" : "rotate-down sort-disable"
                                                : "rotate-down sort-disable"
                                                }`} />
                                            </div>
                                          </div>
                                        </th>
                                      );

                                    default:
                                      return (
                                        <th key={col.name} className={`${istrackkillHeader ? col.classTrack : col.class}`}>
                                          <span className={isFolderViewselected ? "left-n6" : ""}>
                                            {col.label}
                                          </span>
                                        </th>
                                      );
                                  }
                                })}
                              </tr>
                            </thead>
                          </div>
                          <tbody className="scrollable-content">
                            {/* <!-------- First one ---------> */}

                            {lstDocumentsHistory.length > 0 &&
                              lstDocumentsHistory.map((item, i) => (
                                <tr className="borderrow">
                                  <td colSpan={sortedColumns?.filter(col => col && col.active).length} className="innertTableTd">
                                    <table
                                      className={"table-layout"}
                                      cellPadding="0"
                                      cellSpacing="0">
                                      <tr key={item.documentId} className="view" onClick={(e) => rowclick(e, item.documentId)} ref={(el) => (trRef.current[i] = el)}>
                                        {sortedColumns?.filter(col => col && col.active).map((col) => (
                                          <td key={col.name} className={`${col.classData}`}>
                                            {renderCell(col.name, item, i)}
                                          </td>
                                        ))}
                                      </tr>

                                      <tr className="fold" id={"trChailed" + i}>
                                        <td colSpan={sortedColumns?.filter(col => col && col.active).length}>
                                          {/*------ New Tab design -------------*/}
                                          <div className="fold-content">
                                            <div className="manageTabs-page">
                                              <ul className="nav nav-tabs" role="tablist">
                                                {innerTabs.map((tab) => (
                                                  !(item.securityLevel === 1 && tab.id === "Track_Interactivity") && (
                                                    <li
                                                      role="presentation"
                                                      className={`nav-item ${item.activeTabName === tab.id ? "active" : ""}`}
                                                      key={tab.id}
                                                    >
                                                      <a
                                                        role="tab"
                                                        className={`nav-link d-flex align-items-center ${item.activeTabName === tab.id ? "active" : ""}`}
                                                        onClick={() => setActiveTabWrapper(tab.id, item.documentId)}
                                                      >
                                                        <span className={`material-icons ${tab.id === "Track_Interactivity" || tab.id === "Summary" ? "font-18 mr-2px" : "font-20"}`}>
                                                          {tab.icontext}
                                                        </span>
                                                        <span className="ms-1">
                                                          {tab.label}
                                                        </span>

                                                      </a>
                                                    </li>
                                                  )
                                                ))}
                                                <label className="d-flex align-items-center ms-auto">
                                                  <span
                                                    className={
                                                      item.isHistoryRecordsExists ==
                                                        false ||
                                                        item.isHistoryRecordsExists ==
                                                        undefined
                                                        ? "History-IconHide"
                                                        : "material-icons me-2 font-21"
                                                    }
                                                    title={
                                                      selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_DoucmentHistoryToolTip
                                                    }
                                                    style={{
                                                      position:
                                                        "relative",
                                                      fontWeight: 800,
                                                      cursor:
                                                        "pointer",
                                                      top: "8px",
                                                    }}
                                                    onClick={(
                                                      e
                                                    ) =>
                                                      handleDocumentHistory(
                                                        item.documentId
                                                      )
                                                    }
                                                  >
                                                    history
                                                  </span>
                                                  <span
                                                    onClick={(
                                                      e
                                                    ) => {
                                                      handleRefresh(
                                                        item.documentId,
                                                        e,
                                                        i
                                                      );
                                                    }}
                                                    style={{
                                                      cursor: 'pointer',
                                                      marginTop: '18px',
                                                    }}
                                                    className="material-icons me-3 font-22"
                                                  >
                                                    {" "}
                                                    refresh
                                                  </span>
                                                </label>

                                              </ul>
                                              {/*------ innerTabs panel content -------- */}
                                              <div className="tab-content p-3">
                                                {innerTabs.map((tab) =>
                                                  item.activeTabName === tab.id ? (
                                                    <div
                                                      key={tab.id}
                                                      className="tab-pane fade show active"
                                                      role="tabpanel"
                                                    >
                                                      {tab.id ===
                                                        "Control_Status" && (
                                                          <div>
                                                            <div className="w-100 mb-2 d-flex justify-content-between align-items-center">
                                                              <aside className="d-flex align-items-center flex-grow-1 min-w-0 me-3">
                                                                <span className={"material-icons me-2 font-20 " + item.chailedClass}>
                                                                  assignment
                                                                </span>
                                                                <h5 title={item.fileName} className="mb-0 pb-1 text-truncate" style={{ fontWeight: "600", fontSize: "16px" }}>
                                                                  {
                                                                    item.fileName
                                                                  }
                                                                </h5>
                                                              </aside>

                                                              <div className="mb-1 pb-1 flex-shrink-0 text-end">
                                                                {!(
                                                                  item.isKilled ==
                                                                  true ||
                                                                  item.isPermanentExpire ==
                                                                  true
                                                                ) && (
                                                                    <span
                                                                      className={
                                                                        item.isKilled ==
                                                                          true || item.canEditRPDRecords == false
                                                                          ? "fa fa-pencil-square-o top3 disabled font20"
                                                                          : "fa fa-pencil-square-o top3 font20"
                                                                      }
                                                                      title={
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_ModifyDocumnetProperties
                                                                      }
                                                                      style={{
                                                                        marginLeft:
                                                                          "4pt",
                                                                        fontWeight: 800,
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={(
                                                                        e
                                                                      ) =>
                                                                        handleControlStatus(
                                                                          item.documentId
                                                                        )
                                                                      }
                                                                    >
                                                                    </span>

                                                                  )}
                                                              </div>

                                                            </div>

                                                            <div className="row my-4 mt-n1 mx-0 cardborder">
                                                              <div
                                                                className="bg-white mt-1"
                                                                style={{ width: "36%" }}>
                                                                <table className="table table-borderless view-table">
                                                                  <tbody>
                                                                    {(sortedColumns)?.map((col, i) => {
                                                                      if (!col || !col.name) return null;
                                                                      let value;
                                                                      switch (col.name) {
                                                                        case 'documentid':
                                                                          value = item.documentId;
                                                                          break;
                                                                        case 'senderaddress':
                                                                          value = item.senderAddress;
                                                                          break;
                                                                        case 'originalFileNames':
                                                                          value = (
                                                                            <div className="align-items-center flex-wrap textwrap tootltip-history">
                                                                              {item.inputFiles?.[0]?.fileName}
                                                                              <strong
                                                                                className={
                                                                                  'seeMore' + (item.inputFiles?.length > 1 ? '' : ' d-none')
                                                                                }
                                                                                id={'original-files' + i}
                                                                                data-html="true"
                                                                                style={{ paddingLeft: '5px' }}>
                                                                                <i className="material-icons">more_horiz</i>
                                                                              </strong>
                                                                              <ReactTooltip
                                                                                className="seemore-tooltip"
                                                                                anchorId={'original-files' + i}
                                                                                clickable>
                                                                                <div className="tooltip-intial-receipts ps-2 pb-2 pt-1">
                                                                                  {item.inputFiles?.map((file, j) =>
                                                                                    j > 0 ? file.fileName + '\n\r' : ''
                                                                                  )}
                                                                                </div>
                                                                              </ReactTooltip>
                                                                            </div>
                                                                          );
                                                                          break;
                                                                        case 'pages':
                                                                          value = item.pages;
                                                                          break;
                                                                        case 'owner':
                                                                          value = item.senderAddress;
                                                                          break;
                                                                        case 'accesscontrol':
                                                                          switch (item.securityLevel) {
                                                                            case 3:
                                                                              value = selectedLanguage.LstLanguageCodes.UI_LimitReaders;
                                                                              break;
                                                                            case 2:
                                                                              value = selectedLanguage.LstLanguageCodes.UI_TrackReaders;
                                                                              break;
                                                                            default:
                                                                              value = selectedLanguage.LstLanguageCodes.UI_TrackViews;
                                                                          }
                                                                          break;
                                                                        case 'subjectdescription':
                                                                          value =
                                                                            (<div
                                                                              className="d-flex flex-wrap Wordbreak"
                                                                              title={
                                                                                item.documentOptions.subject
                                                                              }>
                                                                              <p className="textwrap mb-0">
                                                                                {item.documentOptions.subject}
                                                                              </p>
                                                                            </div>);
                                                                          break;
                                                                        case "dayssincelastview":
                                                                          value = (<div className="">{item.daysSinceLastView}</div>);
                                                                          break;
                                                                        case "initialreaders":
                                                                          value =
                                                                            (<div className="align-items-center flex-wrap textwrap tootltip-history">
                                                                              {item.documentOptions.recipients
                                                                                .length > 0 &&
                                                                                item.documentOptions.recipients[0]
                                                                                  .email}

                                                                              <strong
                                                                                className={
                                                                                  "seeMore" +
                                                                                  (item.documentOptions.recipients
                                                                                    .length > 1
                                                                                    ? ""
                                                                                    : " d-none ")
                                                                                }
                                                                                id={"intial-receipts" + i}
                                                                                data-html="true"
                                                                                style={{ paddingLeft: "5px", cursor: 'pointer' }}>
                                                                                <i
                                                                                  className="material-icons"
                                                                                  onClick={(e) =>
                                                                                    viewmore(e, item.documentId)
                                                                                  }>
                                                                                  more_horiz
                                                                                </i>
                                                                              </strong>
                                                                            </div>
                                                                            );
                                                                          break;
                                                                        case "documentname":
                                                                          value = (<div className="align-items-center flex-wrap textwrap tootltip-history ">
                                                                            <span className="Wordbreak">
                                                                              {item.fileName}
                                                                            </span>

                                                                            <strong
                                                                              className={
                                                                                "seeMore" +
                                                                                (item.inputFiles &&
                                                                                  item.inputFiles.length > 1
                                                                                  ? ""
                                                                                  : " d-none ")
                                                                              }
                                                                              id={"modifiedFileNames" + i}
                                                                              data-html="true"
                                                                              style={{ paddingLeft: "5px" }}>
                                                                              <i className="material-icons">
                                                                                more_horiz
                                                                              </i>
                                                                            </strong>

                                                                            <ReactTooltip
                                                                              className="seemore-tooltip"
                                                                              anchorId={"modifiedFileNames" + i}
                                                                              clickable>
                                                                              <table className="tooltip-table timeintractivity-table">
                                                                                <div className="tooltip-intial-receipts ps-2 pb-2 pt-1">
                                                                                  {item.inputFiles &&
                                                                                    item.inputFiles.length > 0 &&
                                                                                    item.inputFiles.map((temp_file, j) => (
                                                                                      <div
                                                                                        key={j}
                                                                                        style={{
                                                                                          display: "flex",
                                                                                          justifyContent: "space-between",
                                                                                          alignItems: "center",
                                                                                          whiteSpace: "normal",
                                                                                          width: "100%"
                                                                                        }}
                                                                                      >
                                                                                        <span style={{ wordBreak: "break-word" }}>
                                                                                          {temp_file.modifiedFileName}
                                                                                        </span>

                                                                                      </div>
                                                                                    ))}

                                                                                </div>
                                                                              </table>
                                                                            </ReactTooltip>
                                                                          </div>);
                                                                          break;
                                                                        case "created":
                                                                          value = (
                                                                            <div className="d-flex flex-wrap textwrap">
                                                                              {
                                                                                moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(item.created),
                                                                                    timeZoneRef.current
                                                                                  )
                                                                                ).format(`${dateFormatValueUpper} HH:mm`)
                                                                                + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                              }
                                                                            </div>
                                                                          );
                                                                          break;
                                                                        case "launches":
                                                                          value =
                                                                            item.documentOptions?.startTime &&
                                                                            (
                                                                              isDatetimeControl === "true"
                                                                                ? moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(item.documentOptions.startTime),
                                                                                    timeZoneRef.current
                                                                                  )
                                                                                ).format(`${dateFormatValueUpper} HH:mm`)
                                                                                : moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(item.documentOptions.startTime),
                                                                                    timeZoneRef.current
                                                                                  )
                                                                                ).format(dateFormatValueUpper)
                                                                            ) +
                                                                            " " + "(" + timeZoneAbbrevation.current + ")";
                                                                          break;

                                                                        case "expires":
                                                                          value =
                                                                            item.documentOptions?.expiryTime &&
                                                                            (
                                                                              isDatetimeControl === "true"
                                                                                ? moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(item.documentOptions.expiryTime),
                                                                                    timeZoneRef.current
                                                                                  )
                                                                                ).format(`${dateFormatValueUpper} HH:mm`)
                                                                                : moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(item.documentOptions.expiryTime),
                                                                                    timeZoneRef.current
                                                                                  )
                                                                                ).format(dateFormatValueUpper)
                                                                            ) +
                                                                            " " + "(" + timeZoneAbbrevation.current + ")";
                                                                          break;

                                                                        case 'verification':
                                                                          if (item.securityLevel !== 1) {
                                                                            value = item.documentOptions?.isSMS === false
                                                                              ? selectedLanguage.LstLanguageCodes.UI_Email
                                                                              : `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text}`;
                                                                          } else {
                                                                            value = '';
                                                                          }
                                                                          break;
                                                                        case 'status':
                                                                          if (item.documentOptions.enabled === true) {
                                                                            value = selectedLanguage.LstLanguageCodes.UI_Active;
                                                                          } else if (!item.documentOptions.enabled && !item.isPermanentExpire && !item.isKilled) {
                                                                            value = selectedLanguage.LstLanguageCodes.UI_Expired;
                                                                          } else {
                                                                            value = selectedLanguage.LstLanguageCodes.UI_Expired;
                                                                          }
                                                                          break;
                                                                        default:
                                                                          value = '';
                                                                      }

                                                                      return (
                                                                        !col.active &&
                                                                        <tr key={col.name}>
                                                                          <td className="w-38 border-0 font-lighter">{col.labelTab ? col.labelTab : col.label}:</td>
                                                                          <td className="f-w550 border-0">{value}</td>
                                                                        </tr>
                                                                      );
                                                                    }
                                                                    )}
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_OriginalFileName
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        <div className="align-items-center flex-wrap textwrap tootltip-history">
                                                                          {item.inputFiles &&
                                                                            item.inputFiles
                                                                              .length > 0 &&
                                                                            item.inputFiles[0]
                                                                              .fileName}


                                                                          <strong
                                                                            className={
                                                                              "seeMore" +
                                                                              (item.inputFiles &&
                                                                                item.inputFiles
                                                                                  .length > 1
                                                                                ? ""
                                                                                : " d-none ")
                                                                            }
                                                                            id={
                                                                              "original-files" +
                                                                              i
                                                                            }
                                                                            data-html="true"
                                                                            style={{
                                                                              paddingLeft:
                                                                                "5px",
                                                                            }}>
                                                                            <i className="material-icons">
                                                                              more_horiz
                                                                            </i>
                                                                          </strong>

                                                                          <ReactTooltip
                                                                            className="seemore-tooltip"
                                                                            anchorId={
                                                                              "original-files" +
                                                                              i
                                                                            }
                                                                            clickable>
                                                                            <table className="tooltip-table timeintractivity-table">
                                                                              <div className="tooltip-intial-receipts ps-2 pb-2 pt-1">
                                                                                {item.inputFiles &&
                                                                                  item.inputFiles.length > 0 &&
                                                                                  item.inputFiles.map((temp_file, j) => (
                                                                                    <div
                                                                                      key={j}
                                                                                      style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        whiteSpace: "normal",
                                                                                        width: "100%"
                                                                                      }}
                                                                                    >
                                                                                      <span style={{ wordBreak: "break-word" }}>
                                                                                        {temp_file.modifiedFileName}
                                                                                      </span>
                                                                                    </div>
                                                                                  ))}

                                                                              </div>
                                                                            </table>
                                                                          </ReactTooltip>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage.LstLanguageCodes.UI_OriginalFileSize
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        <div className="align-items-center flex-wrap textwrap tootltip-history">
                                                                          <span >

                                                                            {item.inputFiles && item.inputFiles.length > 0 && (
                                                                              <span >
                                                                                {(() => {
                                                                                  let totalKB = 0;
                                                                                  let validFound = false;

                                                                                  item.inputFiles.forEach(file => {
                                                                                    const sizeStr = file.fileSize?.toString().trim().toLowerCase();
                                                                                    if (!sizeStr) return;

                                                                                    const sizeValue = parseFloat(sizeStr);
                                                                                    if (isNaN(sizeValue)) return;

                                                                                    validFound = true;

                                                                                    if (sizeStr.includes("mb")) {
                                                                                      totalKB += sizeValue * 1024;
                                                                                    } else if (sizeStr.includes("kb")) {
                                                                                      totalKB += sizeValue;
                                                                                    } else {
                                                                                      totalKB += sizeValue;
                                                                                    }
                                                                                  });

                                                                                  if (!validFound) return "";

                                                                                  // Round the value to nearest whole number
                                                                                  if (totalKB >= 1024) {
                                                                                    return `${Math.round(totalKB / 1024)} MB`;
                                                                                  } else {
                                                                                    return `${Math.round(totalKB)} KB`;
                                                                                  }
                                                                                })()}
                                                                              </span>
                                                                            )}

                                                                          </span>
                                                                          <strong
                                                                            className={
                                                                              "seeMore" +
                                                                              (item.inputFiles &&
                                                                                item.inputFiles
                                                                                  .length > 1
                                                                                ? ""
                                                                                : " d-none ")
                                                                            }
                                                                            id={
                                                                              "original-filesizes" +
                                                                              i
                                                                            }
                                                                            data-html="true"
                                                                            style={{
                                                                              paddingLeft:
                                                                                "5px",
                                                                            }}>
                                                                            <i className="material-icons">
                                                                              more_horiz
                                                                            </i>
                                                                          </strong>
                                                                          <ReactTooltip
                                                                            className="seemore-tooltip"
                                                                            anchorId={
                                                                              "original-filesizes" +
                                                                              i
                                                                            }
                                                                            clickable>
                                                                            <table className="tooltip-table timeintractivity-table">
                                                                              <div className="tooltip-intial-receipts ps-2 pb-2 pt-1">
                                                                                {item.inputFiles &&
                                                                                  item.inputFiles.length > 0 &&
                                                                                  item.inputFiles.map((temp_file, j) => (
                                                                                    <div
                                                                                      key={j}
                                                                                      style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        whiteSpace: "normal",
                                                                                        width: "100%"
                                                                                      }}
                                                                                    >
                                                                                      <span style={{ wordBreak: "break-word" }}>
                                                                                        {temp_file.fileName}
                                                                                      </span>
                                                                                      <span style={{ whiteSpace: "nowrap" }}>
                                                                                        ({temp_file.fileSize})
                                                                                      </span>
                                                                                    </div>
                                                                                  ))}

                                                                              </div>
                                                                            </table>
                                                                          </ReactTooltip>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_Sent
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        {
                                                                          moment
                                                                            .utc(item.created)
                                                                            .utcOffset(timeZoneRef.current)
                                                                            .format(dateFormatValueUpper + " HH:mm")
                                                                          + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                        }
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_SendVerificationCode
                                                                        }
                                                                        :
                                                                      </td>
                                                                      {item.securityLevel !==
                                                                        1 && (
                                                                          <td className="f-w550 border-0">
                                                                            {(item.documentOptions.isBoth == true ||
                                                                              (item.documentOptions.isSMS == true && item.documentOptions.isEmail == true))
                                                                              ? `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                                              : item
                                                                                .documentOptions
                                                                                .isEmail ==
                                                                                true
                                                                                ? selectedLanguage
                                                                                  .LstLanguageCodes
                                                                                  .UI_Email
                                                                                : item.documentOptions.isSMS == true ?
                                                                                  selectedLanguage
                                                                                    .LstLanguageCodes
                                                                                    .UI_Text
                                                                                  : ""
                                                                            }
                                                                          </td>
                                                                        )}
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                              <div
                                                                className="bg-white mt-1"
                                                                style={{
                                                                  width: "39%",
                                                                  borderLeft:
                                                                    "1px solid #d4d0d0a8",
                                                                }}>
                                                                <table className="table table-borderless view-table">
                                                                  <tbody>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_RestrictToDomains
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          {
                                                                            item.documentOptions
                                                                              .domains
                                                                          }
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_AllowedIP
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="border-0">
                                                                        {item.documentOptions
                                                                          .ips.length > 0 &&
                                                                          item.documentOptions.ips.map(
                                                                            (ips, j) => (
                                                                              <div className="d-flex flex-wrap f-w550">
                                                                                {ips}
                                                                              </div>
                                                                            )
                                                                          )}
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_MaxReadsperReader
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        {item.documentOptions
                                                                          .maxReads === 0
                                                                          ? selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_Unlimited
                                                                          : item.documentOptions
                                                                            .maxReads}
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_MaxviewsPerDocument
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        {item.documentOptions
                                                                          .maxViewsPerDocument ===
                                                                          0
                                                                          ? selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_Unlimited
                                                                          : item.documentOptions
                                                                            .maxViewsPerDocument}
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {" "}
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_AllowResponsesTo
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          {item.documentOptions
                                                                            .allowResponsesTo !==
                                                                            undefined &&
                                                                            item.documentOptions
                                                                              .allowResponsesTo}
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="w-38 border-0 font-lighter">
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_Watermark
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td className="f-w550 border-0">
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          {item.documentOptions
                                                                            .watermark === 1
                                                                            ? selectedLanguage
                                                                              .LstLanguageCodes
                                                                              .UI_Confidential
                                                                            : item
                                                                              .documentOptions
                                                                              .watermark === 2
                                                                              ? selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_Draft
                                                                              : item
                                                                                .documentOptions
                                                                                .watermark === 3
                                                                                ? selectedLanguage
                                                                                  .LstLanguageCodes
                                                                                  .UI_MyLogo
                                                                                : selectedLanguage
                                                                                  .LstLanguageCodes
                                                                                  .UI_None}
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td
                                                                        className="w-38 border-0 font-lighter"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        {
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_BannedRegions
                                                                        }
                                                                        :
                                                                      </td>
                                                                      <td
                                                                        className="f-w550 border-0"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          <div
                                                                            className="d-flex flex-wrap f-w550"
                                                                            style={{
                                                                              fontSize: "13px",
                                                                            }}>
                                                                            {item.documentOptions.regions != null ? item.regions : ''}
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td
                                                                        className="w-38 border-0 font-lighter"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        {selectedLanguage
                                                                          .LstLanguageCodes.UI_Template}
                                                                        :
                                                                      </td>
                                                                      <td
                                                                        className="f-w550 border-0"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          <div
                                                                            className="d-flex flex-wrap f-w550"
                                                                            style={{
                                                                              fontSize: "13px",
                                                                            }}>
                                                                            {item.documentOptions.templateName != null ? item.documentOptions.templateName : ''}
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td
                                                                        className="w-38 border-0 font-lighter"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        {selectedLanguage
                                                                          .LstLanguageCodes.UI_MaxPrintsPerReader}
                                                                        :
                                                                      </td>
                                                                      <td
                                                                        className="f-w550 border-0"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          <div
                                                                            className="d-flex flex-wrap f-w550"
                                                                            style={{
                                                                              fontSize: "13px",
                                                                            }}>
                                                                            {item.documentOptions.maxPrintsPerReader && item.documentOptions.maxPrintsPerReader !== "0" ? item.documentOptions.maxPrintsPerReader : selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td
                                                                        className="w-38 border-0 font-lighter"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        {selectedLanguage
                                                                          .LstLanguageCodes.UI_MaxPrintsPerDocument}
                                                                        :
                                                                      </td>
                                                                      <td
                                                                        className="f-w550 border-0"
                                                                        style={{
                                                                          verticalAlign: "top",
                                                                        }}>
                                                                        <div className="d-flex flex-wrap textwrap">
                                                                          <div
                                                                            className="d-flex flex-wrap f-w550"
                                                                            style={{
                                                                              fontSize: "13px",
                                                                            }}>
                                                                            {item.documentOptions.maxPrintsPerDocument && item.documentOptions.maxPrintsPerDocument !== "0" ? item.documentOptions.maxPrintsPerDocument : selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                    </tr>

                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                              <div
                                                                className="bg-white mt-1"
                                                                style={{
                                                                  width: "25%",
                                                                  borderLeft:
                                                                    "1px solid #d4d0d0a8",
                                                                }}>
                                                                <table className="table table-borderless">
                                                                  <tbody>
                                                                    <tr>
                                                                      <td className="pb-0 pt-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2  " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .timestamp
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_TimeStamp
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .print
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_CanPrint
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .distributionList
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_DisplayDistributionlist
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1 ">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .voting
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_Voting
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .voteSharing
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_ShareVotes
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1 ">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .steganography
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_IDLeakers
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1 ">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .pageLevelRestriction
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_Pagelevelrestrictions
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                    <tr>
                                                                      <td className="pb-0 border-0">
                                                                        <div className="d-flex align-items-center mt-1 ">
                                                                          <span
                                                                            className={
                                                                              "material-icons me-2 " +
                                                                              item.chailedClass
                                                                            }>
                                                                            {item
                                                                              .documentOptions
                                                                              .eDisclosure
                                                                              ? "check_box"
                                                                              : "check_box_outline_blank"}
                                                                          </span>
                                                                          <label
                                                                            htmlFor=""
                                                                            className="mb-0 pb-0">
                                                                            {" "}
                                                                            {
                                                                              selectedLanguage
                                                                                .LstLanguageCodes
                                                                                .UI_EDisclosure
                                                                            }
                                                                          </label>
                                                                          {item.documentOptions.eDisclosure ?
                                                                            <span>  <a className="pointer"
                                                                              style={{
                                                                                padding:
                                                                                  "0px 5px 1px 5px",
                                                                              }}
                                                                              onClick={() => handleTermOfservicePopup(item.eDisclosureTermsOfService
                                                                              )}
                                                                            >
                                                                              {
                                                                                selectedLanguage
                                                                                  .LstLanguageCodes
                                                                                  .UI_View
                                                                              }
                                                                            </a></span> : ""}
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      {tab.id ===
                                                        "Track_Interactivity" && (
                                                          <div>

                                                            <div className="w-100 d-flex align-items-center justify-content-between">
                                                              <aside className="d-flex align-items-center flex-grow-1 min-w-0 me-3">
                                                                <span className={"material-icons me-2 font-20 " + item.chailedClass}>
                                                                  assignment
                                                                </span>
                                                                <h5 title={item.fileName} className="mb-0 pb-1 text-truncate" style={{ fontWeight: "600", fontSize: "16px" }}>
                                                                  {
                                                                    item.fileName
                                                                  }
                                                                </h5>
                                                              </aside>

                                                              <div className="manage-sortby-text d-flex align-items-center flex-shrink-0 justify-content-end">
                                                                {trackInteractivityDetailsRef.current[i] && trackInteractivityDetailsRef.current[i].records.length > 1 &&
                                                                  <>
                                                                    <input className={`search-Reader-FirstNameLastName mr-12p ${item.canEditRPDRecords == false ? "disabled" : ""}`} onChange={(e) => { onSearchTrackInteractivityDetailsHandler(e, item.documentId) }} type="search"
                                                                      ref={searchInputRefForTrackInteractivity} placeholder={selectedLanguage.LstLanguageCodes.UI_EnterEmailOrFirstNameOrLastNameToSearch} title={selectedLanguage.LstLanguageCodes.UI_EnterEmailOrFirstNameOrLastNameToSearch} />
                                                                  </>
                                                                }
                                                                <label className="font-w600">
                                                                  <span
                                                                    onClick={(
                                                                      e
                                                                    ) => {
                                                                      handleRefreshTrackInterActivity(
                                                                        item.documentId,
                                                                        e,
                                                                        i
                                                                      );
                                                                    }}
                                                                    style={{
                                                                      cursor: 'pointer',
                                                                      // marginTop: '18px',
                                                                    }}
                                                                    className={`material-icons top3 ${item.canEditRPDRecords == false ? "disabled" : ""}`}
                                                                  >
                                                                    {" "}
                                                                    refresh
                                                                  </span>
                                                                  {item.securityLevel ===
                                                                    3 &&
                                                                    !(
                                                                      item.isKilled ==
                                                                      true ||
                                                                      item.isPermanentExpire ==
                                                                      true
                                                                    ) && (
                                                                      <span
                                                                        className={
                                                                          item.isKilled ==
                                                                            true
                                                                            ? "material-icons top3 disabled"
                                                                            : "material-icons top3"
                                                                        }
                                                                        title={
                                                                          selectedLanguage
                                                                            .LstLanguageCodes
                                                                            .UI_AddAutherizedReaders
                                                                        }
                                                                        style={{
                                                                          fontSize: "26px",
                                                                          marginRight: "4px",
                                                                          marginLeft: "10px",
                                                                          fontWeight: 800,
                                                                          cursor: "pointer",
                                                                        }}
                                                                        onClick={(e) =>
                                                                          handleReceiptsAdd(
                                                                            item.documentId
                                                                          )
                                                                        }>
                                                                        person_add
                                                                      </span>
                                                                    )}
                                                                </label>
                                                                {trackInteractivityDetails[
                                                                  i
                                                                ] &&
                                                                  trackInteractivityDetails[
                                                                    i
                                                                  ]
                                                                    .showBanActiveButtons && (
                                                                    <span className="" style={{ marginRight: '5px' }}>
                                                                      <input
                                                                        className="btn btn-outline-danger checked-btn track-btns"
                                                                        onClick={(e) =>
                                                                          handlerMultiUserActiveInactive(
                                                                            item.documentId,
                                                                            false,
                                                                            i
                                                                          )
                                                                        }
                                                                        type="button"
                                                                        value={selectedLanguage.LstLanguageCodes.UI_BanSelected}
                                                                      />
                                                                      <input
                                                                        className="btn btn-outline-success checked-btn track-btns"
                                                                        onClick={(e) =>
                                                                          handlerMultiUserActiveInactive(
                                                                            item.documentId,
                                                                            true,
                                                                            i
                                                                          )
                                                                        }
                                                                        type="button"
                                                                        value={selectedLanguage.LstLanguageCodes.UI_ActivateSelected}
                                                                      />
                                                                    </span>
                                                                  )}

                                                                {trackInteractivityDetails[
                                                                  i
                                                                ] &&
                                                                  trackInteractivityDetails[
                                                                    i
                                                                  ].sortDetails.length > 0 &&
                                                                  trackInteractivityDetails[
                                                                    i
                                                                  ].sortDetails.map(
                                                                    (
                                                                      sortDtl
                                                                    ) => {
                                                                      if ((sortDtl.value == "days_since_firstAuth" || sortDtl.value == "days_since_first" || sortDtl.value == "days_since_last") && sortDtl.active == "true") {
                                                                        return (
                                                                          <>
                                                                            <span className="ms-2" style={{ marginTop: "-5px" }}>
                                                                              {selectedLanguage.LstLanguageCodes.UI_SortBy}:{" "}
                                                                              {sortDtl.value === "days_since_firstAuth"
                                                                                ? selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstAuthorized
                                                                                : (sortDtl.value === "days_since_first"
                                                                                  ? selectedLanguage.LstLanguageCodes.UI_DaysSinceFirstSActivity
                                                                                  : selectedLanguage.LstLanguageCodes.UI_DaysSinceLastActivity)}
                                                                              <img
                                                                                src={sortDtl.order == "desc" ? "assets/img/icons/down.png" : "assets/img/icons/up.png"}
                                                                                className="m-h-15p"
                                                                                alt="Sort"
                                                                              />
                                                                            </span>
                                                                          </>
                                                                        );

                                                                      }
                                                                    })
                                                                }

                                                                <img
                                                                  src={
                                                                    "assets/img/icons/sort.png"
                                                                  }
                                                                  style={{
                                                                    cursor: "pointer",
                                                                    height: "39px",
                                                                    marginRight: '5px'
                                                                  }}
                                                                  className={item.canEditRPDRecords == false ? "disabled" : ""}
                                                                  alt="Sort"
                                                                  onClick={(e) =>
                                                                    SortingOptionsPopupOpen(
                                                                      item.documentId
                                                                    )
                                                                  }

                                                                />
                                                                <img
                                                                  src={
                                                                    "assets/img/icons/download.png"
                                                                  }
                                                                  className={`h-30p ${item.canEditRPDRecords == false ? "disabled" : ""}`} style={{ marginRight: '5px', height: "24px" }}
                                                                  alt="Download"
                                                                  title={
                                                                    selectedLanguage
                                                                      .LstLanguageCodes
                                                                      .UI_DownloadReaderlist
                                                                  }
                                                                  onClick={(e) =>
                                                                    Downloaduserstatus(
                                                                      item.documentId
                                                                    )
                                                                  }

                                                                />
                                                              </div>
                                                            </div>


                                                            <div className="innertable-responsive table-container trakintrativity">
                                                              <table className="trackInteractivity-table inertable box-shadow-light bg-white header-fixed">
                                                                <thead className="bg-lightred">
                                                                  <tr>
                                                                    <th
                                                                      className={`w-5p vertical-top ${isFolderViewselected
                                                                        ? ""
                                                                        : "borderRight"
                                                                        }`}>
                                                                      <div
                                                                        className={`checkbox res-ml ${item?.canEditRPDRecords === false ? 'disabled' : ''} ${isFolderViewselected
                                                                          ? "ms-44 ms-44-f"
                                                                          : "ms-44"
                                                                          }`}>
                                                                        <label
                                                                          style={{
                                                                            position:
                                                                              "relative",
                                                                            cursor:
                                                                              (item
                                                                                .documentOptions
                                                                                .enabled ===
                                                                                false &&
                                                                                item.isPermanentExpire ==
                                                                                false &&
                                                                                item.isKilled ==
                                                                                false) ||
                                                                                item
                                                                                  .documentOptions
                                                                                  .recipients
                                                                                  .length ===
                                                                                0
                                                                                ? "not-allowed"
                                                                                : "pointer",
                                                                          }}
                                                                          className="p-0 mb-0 ">
                                                                          <input
                                                                            type="checkbox"
                                                                            checked={
                                                                              trackInteractivityDetails[
                                                                              i
                                                                              ] &&
                                                                              trackInteractivityDetails[
                                                                                i
                                                                              ]
                                                                                .selectAllRecipients
                                                                            }
                                                                            disabled={
                                                                              (item
                                                                                .documentOptions
                                                                                .enabled ===
                                                                                false &&
                                                                                item.isPermanentExpire ==
                                                                                false &&
                                                                                item.isKilled ==
                                                                                false
                                                                                ? true
                                                                                : false) ||
                                                                              (item
                                                                                .documentOptions
                                                                                .recipients
                                                                                .length ===
                                                                                0
                                                                                ? true
                                                                                : false) || (item?.canEditRPDRecords == false)
                                                                            }
                                                                            ref={(el) => {
                                                                              if (
                                                                                !chkReaderSelectionRef
                                                                                  .current[
                                                                                i
                                                                                ]
                                                                              )
                                                                                chkReaderSelectionRef.current[
                                                                                  i
                                                                                ] = [];
                                                                              chkReaderSelectionRef.current[
                                                                                i
                                                                              ].selectAll =
                                                                                el;
                                                                            }}
                                                                            onChange={(e) =>
                                                                              handlerSelectAllRecipents(
                                                                                e,
                                                                                i,
                                                                                item.documentId
                                                                              )
                                                                            }
                                                                          />
                                                                          <span className="cr">
                                                                            <i className="cr-icon material-icons">
                                                                              check
                                                                            </i>
                                                                          </span>
                                                                        </label>
                                                                      </div>
                                                                    </th>
                                                                    <th className="borderRight thead-th  w-18p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Adress
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight w-10p thead-th">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_FirstName
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight w-10p thead-th">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_LastName
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight w-12p thead-th">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Mobile
                                                                      }
                                                                    </th>
                                                                    <th
                                                                      className={`thead-th borderRight w-12p`}>
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_FirstRead + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                      }
                                                                      {trackInteractivityDetails[
                                                                        i
                                                                      ] &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.length > 0 &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.map(
                                                                          (
                                                                            sortDtl
                                                                          ) => {
                                                                            if (sortDtl.value == "first_read" && sortDtl.active == "true") {
                                                                              return <img
                                                                                src={sortDtl.order == "desc" ? "assets/img/icons/down.png" : "assets/img/icons/up.png"}
                                                                                className="m-h-15p"
                                                                                alt="Sort"
                                                                              />
                                                                            }
                                                                          })
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight thead-th w-6p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Reads
                                                                      }
                                                                      {trackInteractivityDetails[
                                                                        i
                                                                      ] &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.length > 0 &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.map(
                                                                          (
                                                                            sortDtl
                                                                          ) => {
                                                                            if (sortDtl.value == "reads" && sortDtl.active == "true") {
                                                                              return <img
                                                                                src={sortDtl.order == "desc" ? "assets/img/icons/down.png" : "assets/img/icons/up.png"}
                                                                                className="m-h-15p"
                                                                                alt="Sort"
                                                                              />
                                                                            }
                                                                          })
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight thead-th w-10p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_TotalMinutes
                                                                      }
                                                                      <>
                                                                        <span
                                                                          className={`material-icons info-TotalTime `}
                                                                          id={`timeFormat_${item.documentId}`}
                                                                          data-toggle="tooltip"
                                                                          data-html="true">
                                                                          info
                                                                        </span>
                                                                        <ReactTooltip
                                                                          className={`totalTime-tooltip`}
                                                                          style={{
                                                                            opacity: 1,
                                                                          }}
                                                                          anchorId={`timeFormat_${item.documentId}`}
                                                                          place="bottom">
                                                                          <table className="tooltip-table">
                                                                            <tr>
                                                                              <td>
                                                                                <div className="d-flex flex-column p-1">
                                                                                  <p className="statistics-tooltip-text mb-0">
                                                                                    {
                                                                                      selectedLanguage
                                                                                        .LstLanguageCodes
                                                                                        .UI_TotalTimeFormat
                                                                                    }
                                                                                  </p>
                                                                                </div>
                                                                              </td>
                                                                            </tr>
                                                                          </table>
                                                                        </ReactTooltip>
                                                                      </>
                                                                      {trackInteractivityDetails[
                                                                        i
                                                                      ] &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.length > 0 &&
                                                                        trackInteractivityDetails[
                                                                          i
                                                                        ].sortDetails.map(
                                                                          (
                                                                            sortDtl
                                                                          ) => {
                                                                            if (sortDtl.value == "total_time" && sortDtl.active == "true") {
                                                                              return <img
                                                                                src={sortDtl.order == "desc" ? "assets/img/icons/down.png" : "assets/img/icons/up.png"}
                                                                                className="m-h-15p"
                                                                                alt="Sort"
                                                                              />
                                                                            }
                                                                          })
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight thead-th w-6p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Vote
                                                                      }
                                                                    </th>
                                                                    <th className="thead-th w-10p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Status
                                                                      }
                                                                    </th>
                                                                  </tr>
                                                                </thead>

                                                                <tbody className="">
                                                                  {(item.securityLevel !== 1 &&
                                                                    trackInteractivityDetails[
                                                                    i
                                                                    ] &&
                                                                    trackInteractivityDetails[
                                                                      i
                                                                    ].records.length > 0) ? (
                                                                    trackInteractivityDetails[
                                                                      i
                                                                    ].records.map(
                                                                      (
                                                                        recp,
                                                                        recipientIndex
                                                                      ) => {
                                                                        return (
                                                                          <tr
                                                                            className={
                                                                              "borderrow"
                                                                            }>
                                                                            <td
                                                                              colSpan={10}
                                                                              className="innertTableTd">
                                                                              <table
                                                                                className="table-layout"
                                                                                cellPadding="0"
                                                                                cellSpacing="0">
                                                                                <tr
                                                                                  className={`borderrow text-wrap-custom ${recp.open ===
                                                                                    true
                                                                                    ? "open view"
                                                                                    : "view"
                                                                                    }`}
                                                                                  onClick={(
                                                                                    e
                                                                                  ) =>
                                                                                    TrackIntereactivityrowclick(
                                                                                      e,
                                                                                      item.documentId,
                                                                                      recp.email,
                                                                                      recipientIndex
                                                                                    )
                                                                                  }
                                                                                  ref={(
                                                                                    el
                                                                                  ) =>
                                                                                  (trackRef.current[
                                                                                    recipientIndex
                                                                                  ] = el)
                                                                                  }
                                                                                  id={
                                                                                    "trMain" +
                                                                                    recipientIndex
                                                                                  }
                                                                                  key={
                                                                                    recipientIndex
                                                                                  }>
                                                                                  <td
                                                                                    className="w-5p text-center"
                                                                                    style={{
                                                                                      display:
                                                                                        "",
                                                                                    }}>
                                                                                    {recp?.email && (
                                                                                      <div className={`checkbox mt-n5p marginTop8 res-ml-n8 ${item?.canEditRPDRecords == false ? "disabled" : ""}`}>
                                                                                        <label
                                                                                          className="p-0 mb-0"
                                                                                          style={{
                                                                                            cursor:
                                                                                              item
                                                                                                .documentOptions
                                                                                                .enabled ===
                                                                                                false &&
                                                                                                item.isPermanentExpire ==
                                                                                                false &&
                                                                                                item.isKilled ==
                                                                                                false
                                                                                                ? "not-allowed"
                                                                                                : "pointer",
                                                                                          }}>
                                                                                          <input
                                                                                            type="checkbox"
                                                                                            disabled={
                                                                                              ((item
                                                                                                .documentOptions
                                                                                                .enabled ===
                                                                                                false &&
                                                                                                item.isPermanentExpire ==
                                                                                                false &&
                                                                                                item.isKilled ==
                                                                                                false) || item?.canEditRPDRecords == false)
                                                                                                ? true
                                                                                                : false
                                                                                            }
                                                                                            ref={(
                                                                                              el
                                                                                            ) => {
                                                                                              if (
                                                                                                !chkReaderSelectionRef
                                                                                                  .current[
                                                                                                i
                                                                                                ]
                                                                                              )
                                                                                                chkReaderSelectionRef.current[
                                                                                                  i
                                                                                                ] =
                                                                                                  [];
                                                                                              chkReaderSelectionRef.current[
                                                                                                i
                                                                                              ][
                                                                                                recipientIndex
                                                                                              ] =
                                                                                                el;
                                                                                            }}
                                                                                            email={
                                                                                              recp.email
                                                                                            }
                                                                                            id={
                                                                                              recp.email
                                                                                            }
                                                                                            data-status={
                                                                                              recp.status
                                                                                            }
                                                                                            checked={
                                                                                              recp.checked
                                                                                            }
                                                                                            onChange={(
                                                                                              e
                                                                                            ) =>
                                                                                              handlerReaderSelection(
                                                                                                e,
                                                                                                i,
                                                                                                recipientIndex,
                                                                                                item.documentId,
                                                                                                recp.status
                                                                                              )
                                                                                            }
                                                                                          />
                                                                                          <span className="cr">
                                                                                            <i className="cr-icon material-icons">
                                                                                              check
                                                                                            </i>
                                                                                          </span>
                                                                                        </label>
                                                                                      </div>
                                                                                    )}
                                                                                  </td>
                                                                                  <td className="w-18p">
                                                                                    {recp?.email && (
                                                                                      <div
                                                                                        className={`firstNameLastNameMobile mail-wrap  ${isFolderViewselected
                                                                                          ? "floderView-th address-Folderview"
                                                                                          : "AllItems-th"
                                                                                          }`}>
                                                                                        {
                                                                                          recp.email
                                                                                        }
                                                                                        <span
                                                                                          className={
                                                                                            item.isKilled ==
                                                                                              true || item?.canEditRPDRecords == false
                                                                                              ? "material-icons top3 disabled"
                                                                                              : "material-icons top3"
                                                                                          }
                                                                                          title={
                                                                                            selectedLanguage
                                                                                              .LstLanguageCodes
                                                                                              .UI_EditReaderDetails
                                                                                          }
                                                                                          style={{
                                                                                            marginLeft:
                                                                                              "4pt",
                                                                                            fontWeight: 100,
                                                                                            cursor:
                                                                                              "pointer",
                                                                                            fontSize:
                                                                                              "18px",
                                                                                          }}
                                                                                          onClick={(
                                                                                            e
                                                                                          ) =>
                                                                                            handleEditReaderDetails(
                                                                                              e,
                                                                                              item.documentId,
                                                                                              recp.id
                                                                                            )
                                                                                          }>
                                                                                          edit
                                                                                        </span>
                                                                                      </div>
                                                                                    )}
                                                                                  </td>
                                                                                  <td className="w-10p">
                                                                                    <div
                                                                                      className={`firstNameLastNameMobile d-flex flex-wrap textwrap ${isFolderViewselected
                                                                                        ? " firstName-Folderview"
                                                                                        : ""
                                                                                        }`}>
                                                                                      <span
                                                                                        className="Wordbreak firstNameLastNameMobile"
                                                                                      >
                                                                                        {
                                                                                          recp.firstName
                                                                                        }
                                                                                      </span>
                                                                                    </div>
                                                                                  </td>
                                                                                  <td className="text-center w-10p">
                                                                                    <div
                                                                                      className={`firstNameLastNameMobile d-flex flex-wrap textwrap ${isFolderViewselected
                                                                                        ? " lastName-Folderview"
                                                                                        : ""
                                                                                        } `}>
                                                                                      <span
                                                                                        className="Wordbreak firstNameLastNameMobile"
                                                                                      >
                                                                                        {
                                                                                          recp.lastName
                                                                                        }
                                                                                      </span>
                                                                                    </div>
                                                                                  </td>
                                                                                  <td className="text-center w-12p">
                                                                                    <div
                                                                                      className={`firstNameLastNameMobile d-flex flex-wrap textwrap ${isFolderViewselected
                                                                                        ? " mobileNumer-Folderview"
                                                                                        : ""
                                                                                        }`}>
                                                                                      <span
                                                                                        className="Wordbreak"
                                                                                      >
                                                                                        {recp?.mobileCountryCode &&
                                                                                          recp?.mobileNumber
                                                                                          ? `${recp.mobileCountryCode} ${recp.mobileNumber}`
                                                                                          : ""}
                                                                                      </span>
                                                                                    </div>
                                                                                  </td>
                                                                                  <td
                                                                                    className={`pcs w-12p ${isFolderViewselected ? " firstRead-Folderview" : ""
                                                                                      }`}
                                                                                  >
                                                                                    {recp.openedTime !== ""
                                                                                      ? moment.utc(
                                                                                        applyTimeZoneToDisplay(
                                                                                          new Date(recp.openedTime),
                                                                                          timeZoneRef.current
                                                                                        )
                                                                                      ).format(dateFormatValueUpper + " HH:mm")
                                                                                      : ""}
                                                                                  </td>
                                                                                  <td className="per w-6p">
                                                                                    {
                                                                                      recp.readCount
                                                                                    }
                                                                                  </td>
                                                                                  <td
                                                                                    className={`cur w-10p ${isFolderViewselected
                                                                                      ? " totalTime-Folderview"
                                                                                      : ""
                                                                                      }`}>
                                                                                    {
                                                                                      recp.totalTime
                                                                                    }
                                                                                  </td>
                                                                                  <td
                                                                                    className="w-6p"
                                                                                  >
                                                                                    {recp.vote !==
                                                                                      undefined &&
                                                                                      recp.vote ===
                                                                                      1 ? (
                                                                                      <span className="material-icons me-2 colorGreen">
                                                                                        thumb_up_alt
                                                                                      </span>
                                                                                    ) : recp.vote !==
                                                                                      undefined &&
                                                                                      recp.vote ===
                                                                                      0 ? (
                                                                                      <span className="material-icons me-2 colorRed">
                                                                                        thumb_down_alt
                                                                                      </span>
                                                                                    ) : (
                                                                                      "-"
                                                                                    )}
                                                                                  </td>
                                                                                  {recp.email !==
                                                                                    null && recp.email != "" && (
                                                                                      <td className="per w-10p">
                                                                                        {recp.email !==
                                                                                          null && recp.email != "" && recp.email != undefined &&
                                                                                          recp.enabled ==
                                                                                          true && (
                                                                                            <button
                                                                                              style={{
                                                                                                padding:
                                                                                                  "5px 18px 5px 18px",
                                                                                              }}
                                                                                              type="button"
                                                                                              className={
                                                                                                ((item.isKilled ==
                                                                                                  false &&
                                                                                                  item.isPermanentExpire ==
                                                                                                  false && item?.canEditRPDRecords !== false))
                                                                                                  ? "btn btn-outline-success track-btn"
                                                                                                  : "btn btn-outline-success disabled track-btn"
                                                                                              }
                                                                                              onClick={(
                                                                                                e
                                                                                              ) =>
                                                                                                item.isKilled ==
                                                                                                  false &&
                                                                                                  item.isPermanentExpire ==
                                                                                                  false
                                                                                                  ? handlerUserActiveInactive(
                                                                                                    e,
                                                                                                    false,
                                                                                                    item.documentId,
                                                                                                    recp.email
                                                                                                  )
                                                                                                  : undefined
                                                                                              }>
                                                                                              {
                                                                                                selectedLanguage
                                                                                                  .LstLanguageCodes
                                                                                                  .UI_Active
                                                                                              }
                                                                                            </button>
                                                                                          )}
                                                                                        {recp.email !==
                                                                                          null && recp.email != "" && recp.email != undefined &&
                                                                                          recp.enabled ==
                                                                                          false && (
                                                                                            <div title={
                                                                                              recp.status === "Pause"
                                                                                                ? "The Reader status cannot be altered while the RPD is in an Expired state."
                                                                                                : ""
                                                                                            } style={{ cursor: recp.status == "Pause" ? "not-allowed" : "pointer" }}>
                                                                                              <button
                                                                                                style={{
                                                                                                  padding:
                                                                                                    recp.status ==
                                                                                                      "Pause" &&
                                                                                                      item
                                                                                                        .documentOptions
                                                                                                        .enabled ==
                                                                                                      false
                                                                                                      ? "5px 20px 5px 20px"
                                                                                                      : "5px 13px",
                                                                                                  cursor:
                                                                                                    ((recp.status == "Pause")) ? 'not-allowed' : 'pointer'
                                                                                                }}
                                                                                                type="button"
                                                                                                className={
                                                                                                  ((recp.status ==
                                                                                                    "Pause" &&
                                                                                                    item
                                                                                                      .documentOptions
                                                                                                      .enabled ==
                                                                                                    false) || item?.canEditRPDRecords == false)
                                                                                                    ? "btn btn-outline-danger Pause disabled track-btn"
                                                                                                    : recp.status ==
                                                                                                      "Banned" &&
                                                                                                      item
                                                                                                        .documentOptions
                                                                                                        .enabled ==
                                                                                                      false || item?.canEditRPDRecords == false
                                                                                                      ? "btn  btn-outline-danger BannedBtn disabled track-btn"
                                                                                                      : item.isKilled ==
                                                                                                        false &&
                                                                                                        item.isPermanentExpire ==
                                                                                                        false && item?.canEditRPDRecords !== false
                                                                                                        ? "btn btn-outline-danger"
                                                                                                        : "btn btn-outline-danger disabled track-btn"
                                                                                                }
                                                                                                onClick={(
                                                                                                  e
                                                                                                ) =>
                                                                                                  item.isKilled ==
                                                                                                    false &&
                                                                                                    item.isPermanentExpire ==
                                                                                                    false
                                                                                                    ? handlerUserActiveInactive(
                                                                                                      e,
                                                                                                      true,
                                                                                                      item.documentId,
                                                                                                      recp.email
                                                                                                    )
                                                                                                    : undefined
                                                                                                }>

                                                                                                {
                                                                                                  recp.email != "" && recp.email != null && recp.email != undefined && (
                                                                                                    recp.status ==
                                                                                                      "Pause"
                                                                                                      ? selectedLanguage
                                                                                                        .LstLanguageCodes
                                                                                                        .UI_Pause
                                                                                                      : selectedLanguage
                                                                                                        .LstLanguageCodes
                                                                                                        .UI_Banned)}
                                                                                              </button>
                                                                                            </div>
                                                                                          )}
                                                                                      </td>
                                                                                    )}
                                                                                  {recp.email === "" && (
                                                                                    <td className="per w-10p"></td>
                                                                                  )}
                                                                                </tr>
                                                                                {recp.open ===
                                                                                  true && (
                                                                                    <tr
                                                                                      key={`recipient-${recp.email}`}
                                                                                      className={
                                                                                        recp.open
                                                                                          ? "fold open"
                                                                                          : "fold"
                                                                                      }
                                                                                    >
                                                                                      <td colSpan="10">
                                                                                        <div
                                                                                          className="fold-content"
                                                                                          style={{
                                                                                            padding:
                                                                                              "0em",
                                                                                            boxShadow:
                                                                                              "none",
                                                                                          }}>
                                                                                          <div className="row mx-0 cardborder align-items-start">

                                                                                            <div className="col-sm-12 col-md-5 ps-1">
                                                                                              <div className="d-flex flex-column">
                                                                                                <h6 className="font-w600 daysince mb-0 text-dec w-auto">
                                                                                                  <span className="material-icons me-1">date_range</span>
                                                                                                  <span className="">
                                                                                                    {
                                                                                                      selectedLanguage
                                                                                                        .LstLanguageCodes
                                                                                                        .UI_DaysSince
                                                                                                    }
                                                                                                    {
                                                                                                      ""
                                                                                                    }
                                                                                                  </span>
                                                                                                </h6>
                                                                                                <div className="d-flex align-itmes-center py-0 tracktext">
                                                                                                  <div className="d-flex align-items-center" >
                                                                                                    <span className="font-w400">
                                                                                                      {
                                                                                                        selectedLanguage
                                                                                                          .LstLanguageCodes
                                                                                                          .UI_DaysSinceFirstAuthorized
                                                                                                      }:
                                                                                                    </span>
                                                                                                    <span className="ms-2" style={{ fontWeight: '600' }}>
                                                                                                      {recp.daysFirstAuthrized >=
                                                                                                        1
                                                                                                        ? recp.daysFirstAuthrized
                                                                                                        : 0}
                                                                                                    </span>
                                                                                                  </div>

                                                                                                  <div className="d-flex align-items-center mx-3" >
                                                                                                    <span className="font-w400">
                                                                                                      {
                                                                                                        selectedLanguage
                                                                                                          .LstLanguageCodes
                                                                                                          .UI_DaysSinceFirstSActivity
                                                                                                      }:
                                                                                                    </span>
                                                                                                    <span className="ms-2" style={{ fontWeight: '600' }}>
                                                                                                      {recp.daysSinceFirstView >=
                                                                                                        1
                                                                                                        ? recp.daysSinceFirstView
                                                                                                        : 0}
                                                                                                    </span>
                                                                                                  </div>

                                                                                                  <div className="d-flex align-items-center" >
                                                                                                    <span className="font-w400">
                                                                                                      {
                                                                                                        selectedLanguage
                                                                                                          .LstLanguageCodes
                                                                                                          .UI_DaysSinceLastActivity
                                                                                                      }:
                                                                                                    </span>
                                                                                                    <span className="ms-2" style={{ fontWeight: '600' }}>
                                                                                                      {recp.daysSinceLastView >=
                                                                                                        1
                                                                                                        ? recp.daysSinceLastView
                                                                                                        : 0}
                                                                                                    </span>
                                                                                                  </div>
                                                                                                </div>
                                                                                                {recp.email !== "" && recp.email != undefined && (
                                                                                                  <div style={{ fontWeight: '400' }} className="d-flex align-items-center">
                                                                                                    <span style={{ color: '#d21513' }} className="material-icons me-1">stacked_bar_chart</span>
                                                                                                    <span >{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbyPage}:</span>
                                                                                                    <a style={{ color: '#3045c0fc', cursor: "pointer" }} className="ms-1" onClick={() => ReaderStatsClick(item.documentId, recp.email)} >{selectedLanguage?.LstLanguageCodes?.UI_View}</a>
                                                                                                  </div>
                                                                                                )}
                                                                                                <div className="text-start d-flex tracktext">
                                                                                                  <span className="font-w400">
                                                                                                    {
                                                                                                      selectedLanguage
                                                                                                        .LstLanguageCodes
                                                                                                        .UI_PrintCount
                                                                                                    }
                                                                                                    {
                                                                                                      ":"
                                                                                                    }
                                                                                                  </span>
                                                                                                  <span className="ms-2 font-w600" >
                                                                                                    {recp.printCount !== undefined ? recp.printCount : 0}
                                                                                                  </span>
                                                                                                </div>

                                                                                              </div>

                                                                                              {/* ---Table design */}
                                                                                              {isReaderStatistics && AppContext.IsReaderStatsEnabled === true && recp.email !== "" && recp.email != undefined && recp.email == activeEmail && item.documentId == trackDocumentId && (
                                                                                                <div className="modalCus documentversion-history" id="myModal">
                                                                                                  <div className="modal-dialog modal-dialog-centered">
                                                                                                    <div className="modal-content">
                                                                                                      <div className="card-body pt-1">
                                                                                                        <div
                                                                                                          className="mb-2 mt-3 justify-content-between d-flex"
                                                                                                          style={{ borderBottom: "2px solid #918d8d4d" }}
                                                                                                        >
                                                                                                          <h4 >
                                                                                                            {selectedLanguage?.LstLanguageCodes?.UI_PagesReadAllSessions}
                                                                                                          </h4>
                                                                                                          <button
                                                                                                            type="button"
                                                                                                            className="btn btn-outline-danger modalclose download"
                                                                                                            onClick={(e) => handlecloseReaderStats()}
                                                                                                          >
                                                                                                            <span className="material-icons font-20">
                                                                                                              highlight_off
                                                                                                            </span>
                                                                                                          </button>
                                                                                                        </div>

                                                                                                        <div
                                                                                                          className="card-body pt-0 "
                                                                                                          style={{
                                                                                                            display: "block"
                                                                                                          }}
                                                                                                        >
                                                                                                          <div className="table-responsive res-card" >


                                                                                                            <div className="track-container mt-2">
                                                                                                              <div className="d-flex justify-content-between align-items-center ">
                                                                                                                <div lassName="Docnamewrap  d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_DocumentName}:</span> <span>{item.fileName}</span></div>
                                                                                                                <div className=" d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_DocumentID}:</span> <span className="ms-1">{item.documentId}</span></div>
                                                                                                              </div>
                                                                                                              <div className=" d-flex"><span className="fontWeight-500"> {selectedLanguage?.LstLanguageCodes?.UI_ReaderEmail}:</span ><span className="ms-1"> {recp.email}</span></div>
                                                                                                              <div className="reader-statis mt-2 d-flex justify-content-between align-items-center">
                                                                                                                <div style={{ color: '#d21513' }} className="d-flex align-items-center ms-2">
                                                                                                                  <span className="material-icons me-1">stacked_bar_chart</span>
                                                                                                                  <span style={{ color: '#272d4efc' }}>{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbyPage}</span>
                                                                                                                </div>

                                                                                                                <div className="position-relative number-search" style={{ maxWidth: "150px", flexShrink: 0, marginRight: '12px' }}>
                                                                                                                  <input
                                                                                                                    type="search"
                                                                                                                    className="form-control custom-inputBorder"
                                                                                                                    placeholder={`${selectedLanguage?.LstLanguageCodes?.UI_PageNumber}...`}
                                                                                                                    onInput={(e) =>
                                                                                                                      (e.target.value = e.target.value.replace(/\D/g, ""))
                                                                                                                    }
                                                                                                                    onChange={onSearchHandler}
                                                                                                                  />
                                                                                                                </div>

                                                                                                              </div>

                                                                                                              <div className="d-flex border py-2 track-header">
                                                                                                                <div className="flex-fill text-center w-25 text-wrap font-13 firefox-22">
                                                                                                                  {selectedLanguage?.LstLanguageCodes?.UI_PageNumber}
                                                                                                                </div>
                                                                                                                <div className="flex-fill text-center w-50 px-2 text-wrap font-13">
                                                                                                                  {selectedLanguage?.LstLanguageCodes?.UI_NumberOfUniqueReads}
                                                                                                                </div>
                                                                                                                <div className="flex-fill text-center w-25 px-2 text-wrap font-13">
                                                                                                                  {selectedLanguage?.LstLanguageCodes?.UI_TotalTimeViewed}
                                                                                                                  {/* <span style={{fontSize:'18px', marginLeft:'2px'}}
                                                                                                            className={`material-icons info-TotalTime`}
                                                                                                            id={`timeFormat_${item.documentId1}`}
                                                                                                            data-toggle="tooltip"
                                                                                                            data-html="true">
                                                                                                            info
                                                                                                          </span> */}
                                                                                                                  <ReactTooltip
                                                                                                                    className={`totalTime-tooltip`}
                                                                                                                    style={{
                                                                                                                      opacity: 1,
                                                                                                                    }}
                                                                                                                    anchorId={`timeFormat_${item.documentId1}`}
                                                                                                                    place="bottom">
                                                                                                                    <table className="tooltip-table">
                                                                                                                      <tr>
                                                                                                                        <td>
                                                                                                                          <div className="d-flex flex-column p-1">
                                                                                                                            <p className="statistics-tooltip-text mb-0">
                                                                                                                              {
                                                                                                                                selectedLanguage
                                                                                                                                  .LstLanguageCodes
                                                                                                                                  .UI_TotalTimeFormat
                                                                                                                              }
                                                                                                                            </p>
                                                                                                                          </div>
                                                                                                                        </td>
                                                                                                                      </tr>
                                                                                                                    </table>
                                                                                                                  </ReactTooltip>
                                                                                                                </div>
                                                                                                              </div>

                                                                                                              <div className={`track-bodyscroll ${trackInteractivityDetails[i].records.find((r) => r.email === activeEmail)?.trackInteractivityData?.length > 0 ? "" : "track-noBodyscroll"}`}>
                                                                                                                {(() => {
                                                                                                                  const matchingRecord = trackInteractivityDetails[i].records.find(
                                                                                                                    (r) => r.email === activeEmail
                                                                                                                  );

                                                                                                                  if (matchingRecord?.trackInteractivityData?.length > 0) {
                                                                                                                    return matchingRecord.trackInteractivityData.map((openstatistics, l) => (
                                                                                                                      <div
                                                                                                                        className="d-flex border-bottom py-1 align-items-center borderrow pe-3"
                                                                                                                        key={l} >
                                                                                                                        <div className="flex-fill text-center w-25 text-wrap font-12">
                                                                                                                          {openstatistics.pageNumber}
                                                                                                                        </div>
                                                                                                                        <div className="flex-fill text-center w-50 px-2 text-wrap font-12">
                                                                                                                          {openstatistics.totalCount}
                                                                                                                        </div>
                                                                                                                        <div className="flex-fill text-center w-25 px-2 text-wrap font-12">
                                                                                                                          {String(openstatistics.totalHours).padStart(2, "0")}:
                                                                                                                          {String(openstatistics.totalMinutes).padStart(2, "0")}:
                                                                                                                          {String(openstatistics.totalSeconds).padStart(2, "0")}
                                                                                                                        </div>
                                                                                                                      </div>
                                                                                                                    ));
                                                                                                                  }
                                                                                                                  else {
                                                                                                                    return (
                                                                                                                      <div className="d-flex py-3 align-items-center borderrow justify-content-center">
                                                                                                                        <span className="material-icons" style={{ fontSize: "18px", color: '#ff9800' }}>report_problem</span>
                                                                                                                        <span className="font-13 ms-2" style={{ fontWeight: '600' }}>  {selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                                                                      </div>
                                                                                                                    );
                                                                                                                  }
                                                                                                                  return null;
                                                                                                                })()}
                                                                                                              </div>
                                                                                                            </div>


                                                                                                          </div>
                                                                                                        </div>
                                                                                                      </div>
                                                                                                    </div>
                                                                                                  </div>

                                                                                                </div>

                                                                                              )}

                                                                                            </div>

                                                                                            <div className="col-md-7 col-sm-12 text-start d-flex flex-column">

                                                                                              {recp.eDisclosureAgreed !== undefined ? (
                                                                                                <>
                                                                                                  <div className="col-sm-12 text-start d-flex tracktext">
                                                                                                    <span className="font-w400 w-38">
                                                                                                      {
                                                                                                        selectedLanguage
                                                                                                          .LstLanguageCodes
                                                                                                          .UI_EDisclosureStatus
                                                                                                      }
                                                                                                      {
                                                                                                        ":"
                                                                                                      }
                                                                                                    </span>
                                                                                                    <span className="ms-1" style={{ fontWeight: '600' }}>
                                                                                                      {recp.eDisclosureAgreed !== undefined ? (
                                                                                                        recp.eDisclosureAgreed !== null ? (
                                                                                                          <>
                                                                                                            {recp.eDisclosureAgreed
                                                                                                              ? selectedLanguage.LstLanguageCodes.UI_Agreed
                                                                                                              : selectedLanguage.LstLanguageCodes.UI_DisAgreed}
                                                                                                            &nbsp;[
                                                                                                            {
                                                                                                              moment.utc(
                                                                                                                applyTimeZoneToDisplay(
                                                                                                                  new Date(recp.eDisclosureTime),
                                                                                                                  timeZoneRef.current
                                                                                                                )
                                                                                                              ).format(`${dateFormatValueUpper} HH:mm`)
                                                                                                            }
                                                                                                            &nbsp;{timeZoneAbbrevation.current}]
                                                                                                          </>
                                                                                                        ) : ""
                                                                                                      ) : ""}
                                                                                                    </span>

                                                                                                  </div>
                                                                                                </>
                                                                                              ) : ""}
                                                                                              {item.securityLevel !== 1 && recp.email != "" && recp.email != null && recp.email != undefined && (
                                                                                                <div className="col-sm-12 text-start d-flex tracktext pt-0">
                                                                                                  <span className="font-w400 w-38">
                                                                                                    {
                                                                                                      selectedLanguage
                                                                                                        .LstLanguageCodes
                                                                                                        .UI_ReferenceTxt
                                                                                                    }
                                                                                                    {
                                                                                                      ":"
                                                                                                    }
                                                                                                  </span>
                                                                                                  <span className="ms-1" style={{ fontWeight: '600' }}>                                                                                                    {recp.reference !== "" && recp.reference}
                                                                                                  </span>
                                                                                                </div>
                                                                                              )}
                                                                                              {recp.email && recp.email !== "" && (
                                                                                                <>
                                                                                                  <div className="col-sm-12 text-start d-flex tracktext pt-0">
                                                                                                    <span className="font-w400 w-38">
                                                                                                      {
                                                                                                        selectedLanguage
                                                                                                          .LstLanguageCodes
                                                                                                          .UI_SendVerificationCode
                                                                                                      }
                                                                                                      {
                                                                                                        ":"
                                                                                                      }
                                                                                                    </span>
                                                                                                    <span
                                                                                                      className="ms-1"
                                                                                                      style={{
                                                                                                        fontWeight:
                                                                                                          "600",
                                                                                                      }}>
                                                                                                      {" "}
                                                                                                      {recp.authType ?
                                                                                                        recp.authType == "both" ?
                                                                                                          `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text} `
                                                                                                          :
                                                                                                          recp.authType.charAt(
                                                                                                            0
                                                                                                          )
                                                                                                            .toUpperCase() +
                                                                                                          recp.authType.slice(1)
                                                                                                        : ""}
                                                                                                    </span>
                                                                                                  </div>
                                                                                                </>
                                                                                              )}
                                                                                              {recp.email && recp.email !== "" && recp.maxPrintsPerReader !== "" && (
                                                                                                <>
                                                                                                  <div className="col-sm-12 text-start d-flex tracktext pt-0">
                                                                                                    <span className="font-w400 w-38">
                                                                                                      {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}{":"}
                                                                                                    </span>
                                                                                                    <span className="ms-1" style={{ fontWeight: "600", }}>
                                                                                                      {" "} {recp.maxPrintsPerReader}
                                                                                                    </span>
                                                                                                  </div>
                                                                                                </>
                                                                                              )}

                                                                                            </div>
                                                                                          </div>

                                                                                        </div>
                                                                                      </td>
                                                                                    </tr>
                                                                                  )}
                                                                              </table>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      }
                                                                    )
                                                                  ) : (<>
                                                                    <div className="no-record d-flex align-items-center justify-content-center">
                                                                      <span className="material-icons">report_problem</span>
                                                                      <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                    </div>
                                                                  </>)}
                                                                  {item.securityLevel === 1 && (
                                                                    <>
                                                                      <div className="no-record d-flex align-items-center justify-content-center">
                                                                        <span className="material-icons">report_problem</span>
                                                                        <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                      </div>
                                                                    </>
                                                                  )}
                                                                </tbody>
                                                                <tfoot>
                                                                  <tr>
                                                                    <td colSpan="22"></td>
                                                                    <td colSpan="4">
                                                                      <div
                                                                        className={`d-flex justify-content-start py-2 ${"voting-section"
                                                                          }`}>
                                                                        <label
                                                                          htmlFor=""
                                                                          className="mb-0 pt-2 me-2">
                                                                          {
                                                                            selectedLanguage
                                                                              .LstLanguageCodes
                                                                              .UI_Total
                                                                          }
                                                                          :
                                                                        </label>
                                                                        <label
                                                                          htmlFor=""
                                                                          className="mb-0 d-flex align-items-center me-2">
                                                                          <span className="material-icons me-2 colorGreen">
                                                                            thumb_up_alt
                                                                          </span>
                                                                          {item
                                                                            .documentOptions
                                                                            .recipients
                                                                            .length > 0
                                                                            ? item.documentOptions.recipients.filter(
                                                                              (bill) =>
                                                                                bill.vote ===
                                                                                1
                                                                            ).length
                                                                            : 0}
                                                                        </label>
                                                                        <label
                                                                          htmlFor=""
                                                                          className="mb-0 d-flex align-items-center">
                                                                          <span className="material-icons me-2 colorRed">
                                                                            thumb_down_alt
                                                                          </span>
                                                                          {item
                                                                            .documentOptions
                                                                            .recipients
                                                                            .length > 0
                                                                            ? item.documentOptions.recipients.filter(
                                                                              (bill) =>
                                                                                bill.vote ===
                                                                                0
                                                                            ).length
                                                                            : 0}
                                                                        </label>
                                                                      </div>
                                                                    </td>
                                                                  </tr>
                                                                </tfoot>
                                                              </table>
                                                            </div>

                                                          </div>
                                                        )}
                                                      {tab.id ===
                                                        "Summary" && (
                                                          <div>

                                                            <div className="mb-2">
                                                              <aside className="d-flex align-items-center mb-0">
                                                                <span className={"material-icons me-2 font-20 " + item.chailedClass}>
                                                                  assignment
                                                                </span>
                                                                <h5 title={item.fileName} className="mb-0 pb-1 text-truncate" style={{ fontWeight: "600", fontSize: "16px", width: "100%", }}>
                                                                  {
                                                                    item.fileName
                                                                  }
                                                                </h5>
                                                                {/* <div className="manage-sortby-text d-flex align-items-center flex-shrink-0 justify-content-end">
                                                                  <label className="font-w600">
                                                                    <span
                                                                      style={{
                                                                        cursor: 'pointer',
                                                                        fontSize: '22px',
                                                                      }}
                                                                      onClick={() => {
                                                                        onSummaryClickHandler(item.documentId);
                                                                      }}
                                                                      className={`m-sm-0 material-icons top3`}
                                                                    >
                                                                      {" "}
                                                                      refresh
                                                                    </span>
                                                                  </label>
                                                              </div> */}
                                                              </aside>

                                                            </div>
                                                            <div className="summary-table-container">
                                                              <table className="inertable box-shadow-light bg-white summary-table">
                                                                <thead className="bg-lightred">
                                                                  <tr>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_GeneratedDate + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_FirstRead + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_LastViewDate + " " + "(" + timeZoneAbbrevation.current + ")"
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Reads
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_TotalPrints
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_TotalMinutes
                                                                      }
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {
                                                                    summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords?.length > 0 ?
                                                                      (
                                                                        <tr>
                                                                          <td className="pcs">
                                                                            {moment
                                                                              .utc(
                                                                                applyTimeZoneToDisplay(
                                                                                  new Date(item.created),
                                                                                  timeZoneRef.current
                                                                                )
                                                                              )
                                                                              .format(dateFormatValueUpper + " HH:mm")}
                                                                          </td>
                                                                          <td className="pcs">
                                                                            {(() => {
                                                                              const openedRecord = summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords?.find(
                                                                                (records) =>
                                                                                  records.event === "Opened" || records.event == null
                                                                              );

                                                                              return openedRecord?.opened
                                                                                ? moment
                                                                                  .utc(
                                                                                    applyTimeZoneToDisplay(
                                                                                      new Date(openedRecord.opened),
                                                                                      timeZoneRef.current
                                                                                    )
                                                                                  )
                                                                                  .format(dateFormatValueUpper + " HH:mm")
                                                                                : "";
                                                                            })()}
                                                                          </td>

                                                                          <td className="pcs">
                                                                            {(() => {
                                                                              const openedRecords = summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords?.filter(
                                                                                (records) => records.event === "Opened" || records.event == null
                                                                              );

                                                                              if (!openedRecords || openedRecords.length === 0) return "";

                                                                              const lastOpened = openedRecords[openedRecords.length - 1];

                                                                              return lastOpened?.opened
                                                                                ? (moment.utc(
                                                                                  applyTimeZoneToDisplay(
                                                                                    new Date(lastOpened.opened),
                                                                                    timeZoneRef.current
                                                                                  ))
                                                                                ).format(dateFormatValueUpper + " HH:mm")
                                                                                : ""
                                                                            })()}
                                                                          </td>

                                                                          <td className="per">
                                                                            {item.documentOptions.recipients.filter(
                                                                              (records) =>
                                                                                records.readCount !=
                                                                                null &&
                                                                                records.readCount !=
                                                                                0
                                                                            ).length > 0
                                                                              ? item.documentOptions.recipients
                                                                                .filter(
                                                                                  (records) =>
                                                                                    records.readCount !=
                                                                                    null
                                                                                )
                                                                                .map(
                                                                                  (countCalc) =>
                                                                                    countCalc.readCount
                                                                                )
                                                                                .reduce(
                                                                                  (
                                                                                    accTime,
                                                                                    countCalc
                                                                                  ) =>
                                                                                    countCalc +
                                                                                    accTime
                                                                                ) +
                                                                              summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords.filter(
                                                                                (records) =>
                                                                                  (records.email ==
                                                                                    null ||
                                                                                    records.email ==
                                                                                    "") &&
                                                                                  (records.event ==
                                                                                    "Opened" ||
                                                                                    records.event ==
                                                                                    null)
                                                                              ).length
                                                                              : summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords.filter(
                                                                                (records) =>
                                                                                  records.event ==
                                                                                  "Opened" ||
                                                                                  records.event ==
                                                                                  null
                                                                              ).length}
                                                                          </td>
                                                                          <td className="per">
                                                                            {summaryDetails.current.find(record => record.docId === item.documentId)?.printCount || 0}
                                                                          </td>
                                                                          <td className="cur">
                                                                            {summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords.filter(
                                                                              (records) =>
                                                                                records.activityTime !==
                                                                                undefined &&
                                                                                (records.event ==
                                                                                  "Opened" ||
                                                                                  records.event ==
                                                                                  null)
                                                                            ).length > 0
                                                                              ? getTimeFormat(
                                                                                summaryDetails.current.find(record => record.docId === item.documentId)?.openRecords
                                                                                  .filter(
                                                                                    (records) =>
                                                                                      records.activityTime !==
                                                                                      undefined &&
                                                                                      (records.event ==
                                                                                        "Opened" ||
                                                                                        records.event ==
                                                                                        null)
                                                                                  )
                                                                                  .map(
                                                                                    (timeCalc) =>
                                                                                      timeCalc.activityTime
                                                                                  )
                                                                                  .reduce(
                                                                                    (
                                                                                      accTime,
                                                                                      timeCalc
                                                                                    ) =>
                                                                                      timeCalc +
                                                                                      accTime
                                                                                  )
                                                                              )
                                                                              : "00:00:00"}
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                      : (<tr>
                                                                        <td colSpan={5}>
                                                                          <div className="no-record mt-n1 d-flex align-items-center justify-content-center">
                                                                            <span className="material-icons">report_problem</span>
                                                                            <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                          </div>
                                                                        </td>
                                                                      </tr>)
                                                                  }
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        )}
                                                      {tab.id ===
                                                        "Activity_Log" && (
                                                          <div className="pb-3 mb-1">
                                                            <div className="w-100 mb-2 d-flex justify-content-between align-items-center">
                                                              <aside className="d-flex align-items-center flex-grow-1 min-w-0 me-3">
                                                                <span className={"material-icons me-2 font-20 " + item.chailedClass}>
                                                                  assignment
                                                                </span>
                                                                <h5 title={item.fileName} className="mb-0 pb-1 text-truncate" style={{ fontWeight: "600", fontSize: "16px" }}>
                                                                  {
                                                                    item.fileName
                                                                  }
                                                                </h5>
                                                              </aside>
                                                              <div className="flex-shrink-0 text-end">
                                                                <img
                                                                  src={
                                                                    "assets/img/icons/download.png"
                                                                  }
                                                                  className="h-30p" style={{ marginRight: '5px', height: '24px' }}
                                                                  alt="Download"
                                                                  title={
                                                                    selectedLanguage
                                                                      .LstLanguageCodes
                                                                      .UI_DownloadUserActivityLog
                                                                  }
                                                                  onClick={(e) =>
                                                                    DownloadActivityLog(
                                                                      item.documentId
                                                                    )
                                                                  }
                                                                />

                                                              </div>
                                                            </div>
                                                            <div className="innertable-responsive activityLogtable-container">
                                                              <table
                                                                className="activityLog-table mb-2 box-shadow-light bg-white collapse show header-fixed"
                                                                id={"collapseExample" + i}>
                                                                <thead className="bg-lightred">
                                                                  <tr>
                                                                    <th
                                                                      className={`borderRight ${item.securityLevel !==
                                                                        1
                                                                        ? "w-10p"
                                                                        : "w-15p"
                                                                        }`}>
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Event
                                                                      }
                                                                    </th>
                                                                    {item.securityLevel !==
                                                                      1 && (
                                                                        <th className="borderRight w-18p">
                                                                          {
                                                                            selectedLanguage
                                                                              .LstLanguageCodes
                                                                              .UI_Raeder
                                                                          }{" "}
                                                                        </th>)}

                                                                    <th
                                                                      className={`borderRight ${(sortDirectionForActivityLog[
                                                                        item.documentId
                                                                      ] || "desc") === "asc"
                                                                        ? "headerSortUp"
                                                                        : "headerSortDown"
                                                                        } ${item.securityLevel !==
                                                                          1
                                                                          ? "w-12p"
                                                                          : "w-15p"
                                                                        }`}
                                                                      onClick={() => {
                                                                        handleSortDirectionForActivityLog(
                                                                          item.documentId
                                                                        );
                                                                      }}>
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_TimeUTC + " (" + timeZoneAbbrevation.current + ")"
                                                                      }
                                                                    </th>
                                                                    <th
                                                                      className={`borderRight ${item.securityLevel !==
                                                                        1
                                                                        ? " w-10p"
                                                                        : "w-15p"
                                                                        }`}>
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_IP
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight w-15p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Loaction
                                                                      }
                                                                    </th>
                                                                    <th
                                                                      className={`borderRight ${item.securityLevel !==
                                                                        1
                                                                        ? " w-12p"
                                                                        : "w-15p"
                                                                        }`}>
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Country
                                                                      }
                                                                    </th>
                                                                    <th className="borderRight w-22p">
                                                                      {
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Network
                                                                      }
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody className="">
                                                                  {(activityLogDetails[i] &&
                                                                    activityLogDetails[i]
                                                                      .records.length > 0) ?
                                                                    activityLogDetails[
                                                                      i
                                                                    ].records.map(
                                                                      (openRecord, index) => {
                                                                        return (
                                                                          <tr
                                                                            className={
                                                                              "borderrow"
                                                                            }>
                                                                            <td
                                                                              colSpan={
                                                                                item.securityLevel !==
                                                                                  1
                                                                                  ? 9
                                                                                  : 6
                                                                              }
                                                                              className="innertTableTd">
                                                                              <table
                                                                                className="table-layout"
                                                                                cellPadding="0"
                                                                                cellSpacing="0">
                                                                                <tr
                                                                                  className={`borderrow text-wrap-custom ${openRecord.open ===
                                                                                    true
                                                                                    ? "open view"
                                                                                    : "view"
                                                                                    }`}
                                                                                  onClick={(
                                                                                    e
                                                                                  ) =>
                                                                                    ActivityLogrowclick(
                                                                                      e,
                                                                                      item.documentId,
                                                                                      openRecord.id,
                                                                                      index
                                                                                    )
                                                                                  }
                                                                                  key={index}>
                                                                                  <td
                                                                                    className={
                                                                                      item.securityLevel !==
                                                                                        1
                                                                                        ? "w-10p activityLog-table_td_first-child"
                                                                                        : "w-15p activityLog-table_td_first-child"
                                                                                    }>
                                                                                    {openRecord.event ==
                                                                                      null
                                                                                      ? selectedLanguage
                                                                                        .LstLanguageCodes
                                                                                        .UI_opened
                                                                                      : (openRecord.event == 'Auto Lock' ?
                                                                                        selectedLanguage
                                                                                          .LstLanguageCodes
                                                                                          .UI_AutoLock : selectedLanguage
                                                                                            .LstLanguageCodes
                                                                                          .UI_Restricted)}
                                                                                  </td>
                                                                                  {item.securityLevel !==
                                                                                    1 && (
                                                                                      <td className="w-18p">
                                                                                        {
                                                                                          openRecord.email
                                                                                        }
                                                                                      </td>
                                                                                    )}
                                                                                  <td
                                                                                    className={
                                                                                      item.securityLevel !== 1
                                                                                        ? (activityLogDetails[i].records.length > 4
                                                                                          ? "w-12p pl-16p"
                                                                                          : "w-12p pl-14p")
                                                                                        : "w-15p"
                                                                                    }
                                                                                  >
                                                                                    {openRecord.opened !== null &&
                                                                                      (moment.utc(
                                                                                        applyTimeZoneToDisplay(
                                                                                          new Date(openRecord.opened),
                                                                                          timeZoneRef.current
                                                                                        ))
                                                                                      ).format(dateFormatValueUpper + " HH:mm")}
                                                                                  </td>
                                                                                  <td
                                                                                    className={`per ${item.securityLevel !==
                                                                                      1
                                                                                      ? (activityLogDetails[i]
                                                                                        .records.length > 4 ?
                                                                                        "w-10p pl-16p" : "w-10p pl-14p")
                                                                                      : "w-15p"
                                                                                      } `}>
                                                                                    {
                                                                                      openRecord.ip
                                                                                    }
                                                                                  </td>
                                                                                  <td className={activityLogDetails[i]
                                                                                    .records.length > 4 ? "w-15p pl-16p" : "w-15p pl-14p"}>
                                                                                    {openRecord.geolocation !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .city !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .region_code !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .city +
                                                                                      ", " +
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .region_code}
                                                                                  </td>
                                                                                  <td
                                                                                    className={
                                                                                      item.securityLevel !==
                                                                                        1
                                                                                        ? (activityLogDetails[i]
                                                                                          .records.length > 4 ? "w-12p pl-16p" : "w-12p pl-14p")
                                                                                        : "w-15p pl-14p"
                                                                                    }>
                                                                                    {openRecord.geolocation !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .country_name !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .country_name}
                                                                                  </td>
                                                                                  <td
                                                                                    className={
                                                                                      item.securityLevel !==
                                                                                        1
                                                                                        ? (activityLogDetails[i]
                                                                                          .records.length > 4 ? "w-22p pl-18p" : "w-22p pl-14p")
                                                                                        : "w-22p pl-14p"
                                                                                    }>
                                                                                    {openRecord.geolocation !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .org !=
                                                                                      null &&
                                                                                      openRecord
                                                                                        .geolocation
                                                                                        .org}
                                                                                  </td>
                                                                                </tr>
                                                                                {openRecord.open === true && (
                                                                                  <tr
                                                                                    onClick={(e) =>
                                                                                      ActivityLogrowclick(openRecord.id, item.documentId, index)}
                                                                                    key={`Openid-${openRecord.id}`}
                                                                                    className={openRecord.open ? "fold open" : "fold"}
                                                                                  >
                                                                                    <td colSpan={item.securityLevel !== 1 ? "7" : "6"}>
                                                                                      <div className="fold-content" style={{ padding: "0em", boxShadow: "none" }}>
                                                                                        <div className="row mx-0 cardborder">
                                                                                          <div className="bg-white mt-1" style={{ width: "45%" }}>
                                                                                            <div className="row">
                                                                                              <div className="col-md-6 col-sm-12 text-start d-flex">
                                                                                                <span className="material-icons me-2" style={{ fontSize: '20px' }}>update</span>
                                                                                                <span>
                                                                                                  {selectedLanguage?.LstLanguageCodes?.UI_ViewDuration}:
                                                                                                </span>
                                                                                                <span className="ms-3" style={{ fontWeight: '600' }}>
                                                                                                  {
                                                                                                    openRecord.timeFormatted
                                                                                                  }
                                                                                                </span>
                                                                                              </div>
                                                                                              <div className="col-md-6 col-sm-12 text-start border-left d-flex justify-content-end">
                                                                                                <span>
                                                                                                  {selectedLanguage?.LstLanguageCodes?.UI_PagesViewed}:
                                                                                                </span>
                                                                                                <span className="ms-3" style={{ fontWeight: '600' }}>
                                                                                                  {openRecord.TotalPagesviewed >= 1
                                                                                                    ? openRecord.totalPageViewed
                                                                                                    : 0}
                                                                                                </span>
                                                                                              </div>
                                                                                              <div className="d-flex align-items-center ">
                                                                                                <span style={{ color: '#d21513' }} className="material-icons me-1">stacked_bar_chart</span>
                                                                                                <span>{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbySession}:</span>
                                                                                                <a style={{ color: '#3045c0fc', cursor: "pointer" }} className="ms-1" onClick={() => ReaderActivityLogClick(item.documentId, openRecord.id)}  >{selectedLanguage?.LstLanguageCodes?.UI_View}</a>
                                                                                              </div>
                                                                                            </div>
                                                                                            {/* table -design */}

                                                                                            {modalIsActivityLogOpen && openRecord?.id === activeOpenId && item.documentId == activityDocumentId && (
                                                                                              <div className="modalCus documentversion-history" id="myModal">
                                                                                                <div className="modal-dialog modal-dialog-centered">
                                                                                                  <div className="modal-content">
                                                                                                    <div className="card-body pt-1">
                                                                                                      <div
                                                                                                        className="mb-2 mt-3 justify-content-between d-flex"
                                                                                                        style={{ borderBottom: "2px solid #918d8d4d" }}
                                                                                                      >
                                                                                                        <h4>
                                                                                                          {selectedLanguage?.LstLanguageCodes?.UI_PagesReadPerSession}
                                                                                                        </h4>
                                                                                                        <button
                                                                                                          type="button"
                                                                                                          className="btn btn-outline-danger modalclose download"
                                                                                                          onClick={(e) => handleCloseReaderActivityLog()}
                                                                                                        >
                                                                                                          <span className="material-icons font-20">
                                                                                                            highlight_off
                                                                                                          </span>
                                                                                                        </button>
                                                                                                      </div>
                                                                                                      <div
                                                                                                        className="card-body pt-0 "
                                                                                                        style={{
                                                                                                          display: "block"
                                                                                                        }}
                                                                                                      >
                                                                                                        <div className="table-responsive res-card" >
                                                                                                          <div className="d-flex justify-content-between align-items-center ">
                                                                                                            <div className="d-flex  Docnamewrap"><span className="fontWeight-500 "> {selectedLanguage?.LstLanguageCodes?.UI_DocumentName}:</span> <span className="ms-1">{item.fileName}</span></div>
                                                                                                            <div className=" d-flex"><span className="fontWeight-500">{selectedLanguage?.LstLanguageCodes?.UI_DocumentID}:</span> <span className="ms-1"> {item.documentId}</span></div>
                                                                                                          </div>
                                                                                                          <div className=" d-flex"> <span className="fontWeight-500">{selectedLanguage?.LstLanguageCodes?.UI_ReaderEmail}:</span> <span className="ms-1">{openRecord.email}</span></div>

                                                                                                          <div className="track-container mt-2">
                                                                                                            <div className="reader-statis d-flex justify-content-between align-items-center">

                                                                                                              <div style={{ color: '#d21513' }} className="d-flex align-items-center ms-2">
                                                                                                                <span className="material-icons me-1">stacked_bar_chart</span>
                                                                                                                <span style={{ color: '#272d4efc' }}>{selectedLanguage?.LstLanguageCodes?.UI_ReaderStatisticsbySession}</span>
                                                                                                              </div>
                                                                                                              <div className="position-relative number-search" style={{ maxWidth: "150px", flexShrink: 0, marginRight: '12px' }}>
                                                                                                                <input
                                                                                                                  type="search"
                                                                                                                  className="form-control custom-inputBorder"
                                                                                                                  placeholder={`${selectedLanguage?.LstLanguageCodes?.UI_PageNumber}...`}
                                                                                                                  onInput={(e) =>
                                                                                                                    (e.target.value = e.target.value.replace(/\D/g, ""))
                                                                                                                  }
                                                                                                                  onChange={onSearchActivityLogHandler}
                                                                                                                />
                                                                                                              </div>
                                                                                                            </div>

                                                                                                            <div className="d-flex border py-2 track-header pe-4">
                                                                                                              <div className="flex-fill text-center w-25 text-wrap font-13 firefox-22">
                                                                                                                {selectedLanguage?.LstLanguageCodes?.UI_PageNumber}
                                                                                                              </div>
                                                                                                              <div className="flex-fill text-center w-50 px-2 text-wrap font-13">
                                                                                                                {selectedLanguage?.LstLanguageCodes?.UI_TimeStarted}
                                                                                                              </div>
                                                                                                              <div className="flex-fill text-center w-25 px-2 text-wrap font-13">
                                                                                                                {selectedLanguage?.LstLanguageCodes?.UI_TotalTimeViewed}
                                                                                                                {/* <span style={{fontSize:'18px', marginLeft:'2px'}}
                                                                                                            className={`material-icons info-TotalTime`}
                                                                                                            id={`timeFormat_${item.documentId2}`}
                                                                                                            data-toggle="tooltip"
                                                                                                            data-html="true">
                                                                                                            info
                                                                                                          </span> */}
                                                                                                                <ReactTooltip
                                                                                                                  className={`totalTime-tooltip`}
                                                                                                                  style={{
                                                                                                                    opacity: 1,
                                                                                                                  }}
                                                                                                                  anchorId={`timeFormat_${item.documentId2}`}
                                                                                                                  place="bottom">
                                                                                                                  <table className="tooltip-table">
                                                                                                                    <tr>
                                                                                                                      <td>
                                                                                                                        <div className="d-flex flex-column p-1">
                                                                                                                          <p className="statistics-tooltip-text mb-0">
                                                                                                                            {
                                                                                                                              selectedLanguage
                                                                                                                                .LstLanguageCodes
                                                                                                                                .UI_TotalTimeFormat
                                                                                                                            }
                                                                                                                          </p>
                                                                                                                        </div>
                                                                                                                      </td>
                                                                                                                    </tr>
                                                                                                                  </table>
                                                                                                                </ReactTooltip>
                                                                                                              </div>
                                                                                                            </div>

                                                                                                            <div className={`track-bodyscroll ${activityLogDetails[i].records.find((r) => (r) => r.id === openRecord.id)?.activityLogData?.length > 0 ? "" : "track-noBodyscroll"}`}>
                                                                                                              {(() => {
                                                                                                                const matchingRecord = activityLogDetails[i].records.find(
                                                                                                                  (r) => r.id === activeOpenId
                                                                                                                );

                                                                                                                if (matchingRecord?.activityLogData?.length > 0) {
                                                                                                                  return matchingRecord.activityLogData.map((openstatistics, l) => (
                                                                                                                    <div
                                                                                                                      className="d-flex border-bottom py-1 align-items-center borderrow pe-3"
                                                                                                                      key={l} >
                                                                                                                      <div className="flex-fill text-center w-25 text-wrap font-12">
                                                                                                                        {openstatistics.pageNumber}
                                                                                                                      </div>
                                                                                                                      <div className="flex-fill text-center w-50 px-2 text-wrap font-12">
                                                                                                                        {(moment.utc(
                                                                                                                          applyTimeZoneToDisplay(
                                                                                                                            new Date(openstatistics.timeStarted),
                                                                                                                            timeZoneRef.current
                                                                                                                          ))
                                                                                                                        ).format(dateFormatValueUpper + " HH:mm")}

                                                                                                                      </div>
                                                                                                                      <div className="flex-fill text-center pcs w-25 px-2 text-wrap font-12">
                                                                                                                        {String(openstatistics.totalHours).padStart(2, "0")}:
                                                                                                                        {String(openstatistics.totalMinutes).padStart(2, "0")}:
                                                                                                                        {String(openstatistics.totalSeconds).padStart(2, "0")}
                                                                                                                      </div>
                                                                                                                    </div>
                                                                                                                  ));
                                                                                                                }
                                                                                                                return (
                                                                                                                  <div className="d-flex py-3 align-items-center borderrow justify-content-center">
                                                                                                                    <span className="material-icons" style={{ fontSize: "18px", color: '#ff9800' }}>report_problem</span>
                                                                                                                    <span className="font-13 ms-2" style={{ fontWeight: '600' }}>  {selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                                                                  </div>
                                                                                                                );
                                                                                                              })()}
                                                                                                            </div>
                                                                                                          </div>

                                                                                                        </div>
                                                                                                      </div>
                                                                                                    </div>
                                                                                                  </div>
                                                                                                </div>
                                                                                              </div>
                                                                                            )}
                                                                                          </div>

                                                                                        </div>
                                                                                      </div>
                                                                                    </td>
                                                                                  </tr>
                                                                                )}

                                                                              </table>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      }
                                                                    ) : (

                                                                      <div className="no-record mt-n1 d-flex align-items-center justify-content-center w-100">
                                                                        <span className="material-icons">report_problem</span>
                                                                        <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                      </div>

                                                                    )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                            <div
                                                              id={"collapseExample" + i}
                                                              className="collapse show me-3 pb-3 pt-1"
                                                              style={{ float: "right" }}>
                                                              {" "}
                                                              {
                                                                selectedLanguage
                                                                  .LstLanguageCodes
                                                                  .UI_LoactionRegisteredLoaction
                                                              }
                                                            </div>
                                                          </div>
                                                        )}
                                                      {tab.id ===
                                                        "Statistics" && (
                                                          <div>
                                                            <div className=" w-100 d-flex justify-content-between align-items-center">

                                                              <aside className="d-flex align-items-center flex-grow-1 min-w-0 me-3 mb-2">
                                                                <div className="d-flex align-items-center overflow-hidden">
                                                                  <span className={"material-icons me-2 font-20 " + item.chailedClass}>
                                                                    assignment
                                                                  </span>
                                                                  <h5 title={item.fileName} className="mb-0 text-truncate" style={{ fontWeight: "600", fontSize: "16px", minWidth: "0" }}>
                                                                    {
                                                                      item.fileName
                                                                    }
                                                                  </h5>
                                                                </div>

                                                                <div className="d-flex align-items-center flex-shrink-0">
                                                                  <a
                                                                    className="StaticTextLink arrow_circle_text_class StaticTextLink2 p-1"

                                                                    aria-controls={
                                                                      "collapseStatistics" +
                                                                      item.documentId
                                                                    }
                                                                    id={
                                                                      "StatisTextLink" +
                                                                      item.documentId
                                                                    }>
                                                                    {" "}
                                                                    {
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_StatisticsTop
                                                                    }
                                                                  </a>
                                                                  <InfoToolTip
                                                                    languageCode={
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_StatisticsInfo
                                                                    }
                                                                    classNameInfo={"info-Statistics-stat-manage"}
                                                                    classNameTooltip={"statistics-tooltip"}
                                                                    anchorId={
                                                                      `statistics-tooltip-${item.documentId}`
                                                                    }
                                                                  />
                                                                </div>
                                                              </aside>

                                                              <div className="d-flex align-items-center justify-content-end flex-shrink-0">
                                                                <span className="StaticTextLink2">
                                                                  {" "}
                                                                  {
                                                                    selectedLanguage
                                                                      .LstLanguageCodes
                                                                      .UI_TotalPages
                                                                  }
                                                                  :
                                                                </span>
                                                                <span className="rdocsRedColor StaticTextLink2 ms-1">
                                                                  {item.pages}
                                                                </span>

                                                              </div>

                                                            </div>
                                                            <table
                                                              className="CollapseStaticTable inertable mb-2 box-shadow-light bg-white collapse show tblStatistics"
                                                              id={
                                                                "collapseStatistics" +
                                                                item.documentId
                                                              }>
                                                              <thead className="bg-lightred">
                                                                <tr>
                                                                  <th className="borderRight">
                                                                    {
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_PageNumber
                                                                    }
                                                                  </th>
                                                                  <th className="borderRight">
                                                                    {
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_TotalMinutes
                                                                    }
                                                                    <InfoToolTip
                                                                      languageCode={
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_StatisticsTotalTime
                                                                      }
                                                                      classNameInfo={"info-Statistics"}
                                                                      classNameTooltip={"statistics-tooltip"}
                                                                      anchorId={
                                                                        `statistics-totalTime-${item.documentId}`
                                                                      }
                                                                    />
                                                                  </th>
                                                                  <th className="borderRight">
                                                                    {
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_TotalReads
                                                                    }
                                                                    <InfoToolTip
                                                                      languageCode={
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_StatisticsTotalPageReads
                                                                      }
                                                                      classNameInfo={"info-Statistics"}
                                                                      classNameTooltip={"statistics-tooltip"}
                                                                      anchorId={
                                                                        `statistics-totalPageReads-${item.documentId}`
                                                                      }
                                                                    />
                                                                  </th>
                                                                  <th className="borderRight">
                                                                    {
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_TotalReadspersession
                                                                    }

                                                                    <InfoToolTip
                                                                      languageCode={
                                                                        selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_StatisticsTotalPageReadsPerSession
                                                                      }
                                                                      classNameInfo={"info-Statistics"}
                                                                      classNameTooltip={"statistics-tooltip_pageReadsPerSession"}
                                                                      anchorId={
                                                                        `statistics-totalPageReadsPerSession-${item.documentId}`
                                                                      }
                                                                    />
                                                                  </th>
                                                                </tr>
                                                              </thead>
                                                              <tbody className="">
                                                                {(item.statistics != null &&
                                                                  item.statistics.length > 0) ?
                                                                  item.statistics.map(
                                                                    (openstatistics, l) =>
                                                                      openstatistics.totalReads !=
                                                                      0 && (
                                                                        <tr className="borderrow">
                                                                          <td>
                                                                            {
                                                                              openstatistics.pageNumber
                                                                            }
                                                                          </td>
                                                                          <td className="pcs">
                                                                            {String(
                                                                              openstatistics.totalHours
                                                                            ).padStart(
                                                                              2,
                                                                              "0"
                                                                            )}
                                                                            :
                                                                            {String(
                                                                              openstatistics.totalMinutes
                                                                            ).padStart(
                                                                              2,
                                                                              "0"
                                                                            )}
                                                                            :
                                                                            {String(
                                                                              openstatistics.totalSeconds
                                                                            ).padStart(
                                                                              2,
                                                                              "0"
                                                                            )}
                                                                          </td>
                                                                          <td className="cur">
                                                                            {
                                                                              openstatistics.totalReads
                                                                            }
                                                                          </td>
                                                                          <td className="per">
                                                                            {
                                                                              openstatistics.totalReadsPerSession
                                                                            }
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                  ) : (
                                                                    <tr>
                                                                      <td colSpan={4}>
                                                                        <div className="no-record mt-n1 d-flex align-items-center justify-content-center">
                                                                          <span className="material-icons">report_problem</span>
                                                                          <span className="">{selectedLanguage.LstLanguageCodes.UI_NoRecordsFound}</span>
                                                                        </div>
                                                                      </td>
                                                                    </tr>

                                                                  )
                                                                }
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        )}
                                                    </div>
                                                  ) : null
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          {/*------- New tab design End -------- */}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              ))}

                            {lstKilledDocuments.length > 0 &&
                              lstKilledDocuments.map((item, i) => (
                                <>
                                  <tr>
                                    <td colSpan={9} className="innertTableTd">
                                      <table className="table-layout ">
                                        <tr
                                          className={
                                            item.open == true
                                              ? "open view"
                                              : "view"
                                          }
                                          onClick={(e) =>
                                            killedrowclick(e, item.documentId)
                                          }
                                          style={{
                                            borderBottom:
                                              "0.1rem solid #e7e5e570",
                                          }}
                                          ef={(el) => (trRef.current[i] = el)}
                                          id={"trMain" + i}>
                                          <td
                                            className="w-6p text-center"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            {item.rpdType !== undefined &&
                                              item.rpdType === "Create" ? (
                                              <img
                                                className="create-img"
                                                src="assets/img/icons/create.svg"
                                                height="28px"
                                              />
                                            ) : (
                                              <span className="material-icons top3 folderview">
                                                mail{" "}
                                              </span>
                                            )}
                                          </td>
                                          <td
                                            className="text-start w-10p "
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={item.createdDate}>
                                              <p className="textwrap mb-0">
                                                {moment(item.created)
                                                  .tz("UTC")
                                                  .format(
                                                    dateFormatValueUpper +
                                                    " HH:mm"
                                                  )}
                                              </p>
                                            </div>
                                          </td>
                                          <td
                                            className="text-start w-12p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={item.documentId}>
                                              <p className="textwrap mb-0">
                                                {item.documentId}
                                              </p>
                                            </div>
                                          </td>
                                          <td
                                            className="text-start w-14p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={item.fileName}>
                                              <p className="textwrap mb-0">
                                                {item.fileName}
                                              </p>
                                            </div>
                                          </td>

                                          <td
                                            className="text-start w-12p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={item.owner}>
                                              <p className="textwrap mb-0">
                                                {item.owner}
                                              </p>
                                            </div>
                                          </td>

                                          <td
                                            className="text-start w-12p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={item.killedBy}>
                                              <p className="textwrap mb-0">
                                                {item.killedBy == "" ||
                                                  item.killedBy == null
                                                  ? "NA"
                                                  : item.killedBy}
                                              </p>
                                            </div>
                                          </td>
                                          <td
                                            className="text-start w-10p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="d-flex flex-wrap Wordbreak"
                                              title={moment(item.killDate)
                                                .tz("UTC")
                                                .format(
                                                  dateFormatValueUpper +
                                                  " HH:mm"
                                                )}>
                                              <p className="textwrap mb-0">
                                                {moment.utc(applyTimeZoneToDisplay(new Date(item.killDate), timeZoneRef.current))
                                                  .format(
                                                    dateFormatValueUpper +
                                                    " HH:mm"
                                                  )}
                                              </p>
                                            </div>
                                          </td>
                                          <td
                                            className="text-start w-10p"
                                            style={{
                                              borderLeft:
                                                "0.1rem solid #e7e5e570",
                                            }}>
                                            <div
                                              className="text-center Wordbreak"
                                              title={item.status}>
                                              <p className="textwrap mb-0">
                                                {item.status === "Killed"
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Killed
                                                  : item.status}
                                              </p>
                                            </div>
                                          </td>

                                          <td
                                            className="text-center w-12p"
                                            style={borderleft}>
                                            {item.securityLevel === 3 ? (
                                              <input
                                                type="button"
                                                title={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_LimitReaders
                                                }
                                                className="btn btn-danger text-white font-w600 pd-17 w-150p truncate"
                                                name=""
                                                value={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_LimitReaders
                                                }
                                              />
                                            ) : item.securityLevel === 2 ? (
                                              <input
                                                type="button"
                                                title={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_TrackReaders
                                                }
                                                className="btn btn-warning text-white font-w600 pd-16 w-150p truncate"
                                                name=""
                                                value={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_TrackReaders
                                                }
                                              />
                                            ) : (
                                              <input
                                                type="button"
                                                title={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_TrackViews
                                                }
                                                style={{
                                                  backgroundColor: "#5a8eff",
                                                }}
                                                className="btn btn-success text-white font-w600 pd-16 w-150p truncate"
                                                name=""
                                                value={
                                                  selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_TrackViews
                                                }
                                              />
                                            )}
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                  {item.open == true && (
                                    <tr className="fold open">
                                      <td colSpan="9" className="">
                                        <div
                                          className="fold-content mb-3"
                                          style={{
                                            padding: "0em",
                                            boxShadow: "none",
                                          }}>
                                          <div className="row my-4 mt-n1 mx-0 cardborder">
                                            <div
                                              className="bg-white mt-1"
                                              style={{ width: "45%" }}>
                                              <table className="table table-borderless">
                                                <tbody>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage
                                                          .LstLanguageCodes
                                                          .UI_Reason
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.killNotes}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {item.rpdType == "Send"
                                                        ? selectedLanguage
                                                          .LstLanguageCodes
                                                          .UI_Subject
                                                        : selectedLanguage
                                                          .LstLanguageCodes
                                                          .UI_Description}
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {
                                                          item.documentOptions
                                                            .subject
                                                        }
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </>
                              ))}

                            {noRecordsFound &&
                              lstDocumentsHistory.length == 0 && (
                                <tr>
                                  <td
                                    colSpan={8}
                                    style={{ textAlign: "center" }}>
                                    {
                                      selectedLanguage.LstLanguageCodes
                                        .UI_NoRecordsFound
                                    }
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>

                      <div className="row gx-1 d-flex justify-content-between me-2">
                        <p className="w-auto ms-3">
                          <label
                            htmlFor="pageView"
                            className="radio-label font-w600 control res-w  res-left12"
                            style={{ paddingTop: "9px", paddingRight: "5px" }}>
                            {selectedLanguage.LstLanguageCodes.UI_pageView}:
                          </label>
                          <select
                            className=""
                            name="documentIdInput"
                            value={pageView}
                            onChange={(e) =>
                              setpageViewDrp(
                                e.target.value,
                                isFolderViewselected == false ? 0 : 1
                              )
                            }>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </p>
                        {totalPagesCount > 1 ? (
                          <Pagination
                            {...paginationAttributes}
                            onPrevClick={onPrevClick}
                            onNextClick={onNextClick}
                            onPageChange={onPageChange}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>
            <PendingRequestHeaderBar
              languageTranslations={{
                docID: selectedLanguage.LstLanguageCodes.UI_DocumentID,
                subject:
                  selectedLanguage.LstLanguageCodes.UI_Subject +
                  "/" +
                  selectedLanguage.LstLanguageCodes.UI_Description,
                readerEmail: selectedLanguage.LstLanguageCodes.UI_ReaderEmail,
                readers: selectedLanguage.LstLanguageCodes.UI_Raeder,
                pendingRequest:
                  selectedLanguage.LstLanguageCodes.UI_PendingRequest,
                Approved: selectedLanguage.LstLanguageCodes.UI_Approved,
                Declined: selectedLanguage.LstLanguageCodes.UI_Declined,
                ApproveBtnText: selectedLanguage.LstLanguageCodes.UI_Approve,
                DeclineBtnText: selectedLanguage.LstLanguageCodes.UI_Decline,
                continueText: selectedLanguage.LstLanguageCodes.UI_Continue,
                pageView: selectedLanguage.LstLanguageCodes.UI_pageView,
                UI_Type: selectedLanguage.LstLanguageCodes.UI_Type,
                UI_RequestedDate:
                  selectedLanguage.LstLanguageCodes.UI_RequestedDate + " " + "(" + timeZoneAbbrevation.current + ")",
                UI_Reason: selectedLanguage.LstLanguageCodes.UI_Reason,
                UI_DocumentName:
                  selectedLanguage.LstLanguageCodes.UI_DocumentName,
                status: selectedLanguage.LstLanguageCodes.UI_Status,
                UI_NoPendingRequests:
                  selectedLanguage.LstLanguageCodes.UI_NoPendingRequests,
                UI_PleaseSelectAtleastOne:
                  selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOne,
                UI_NoRecordsFound:
                  selectedLanguage.LstLanguageCodes.UI_NoRecordsFound,
                UI_Override: selectedLanguage.LstLanguageCodes.UI_Override,
                UI_Reject: selectedLanguage.LstLanguageCodes.UI_Reject,
                UI_Overridden: selectedLanguage.LstLanguageCodes.UI_Overridden,
                UI_Rejected: selectedLanguage.LstLanguageCodes.UI_Rejected,
                UI_L3DocumentAcess:
                  selectedLanguage.LstLanguageCodes.UI_L3DocumentAcess,
                UI_AIAutoLockAccess:
                  selectedLanguage.LstLanguageCodes.UI_AIAutoLockAccess,
                UI_PageLockerAccess:
                  selectedLanguage.LstLanguageCodes.UI_PageLockerAccess ||
                  "Page Locker Access",
                UI_PageNumbers:
                  selectedLanguage.LstLanguageCodes.UI_PageNumbers ||
                  "Page Numbers",
                UI_RequestedPages:
                  selectedLanguage.LstLanguageCodes.UI_RequestedPages ||
                  "Requested Pages",
                UI_Approve:
                  selectedLanguage.LstLanguageCodes.UI_Approve || "Approve",
                UI_MyRequests: selectedLanguage.LstLanguageCodes.UI_MyRequests,
                UI_OwnwerSearch: selectedLanguage.LstLanguageCodes.UI_Owner,
                UI_CompanySearch: selectedLanguage.LstLanguageCodes.UI_Company,
                UI_Search: selectedLanguage.LstLanguageCodes.UI_Search,
                UI_Clear: selectedLanguage.LstLanguageCodes.UI_Clear,
                UI_Pleaseentervalidmail: selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail || "Please enter a valid email address.",
                UI_PartiallyApproved: selectedLanguage.LstLanguageCodes.UI_PartiallyApproved,
                UI_PartiallyDeclined: selectedLanguage.LstLanguageCodes.UI_PartiallyDeclined,
                UI_Declined: selectedLanguage.LstLanguageCodes.UI_Declined,
              }}
              dateFormatValueUpper={dateFormatValueUpper}
              activeTabName={activeTabName}
              applyTimeZoneToDisplay={applyTimeZoneToDisplay}
              timeZoneRef={timeZoneRef}
              timeZoneAbbrevation={timeZoneAbbrevation}
            />
          </div>
        </div>
        {modalIsOpen && (
          <div className="modalCus" id="myModal">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body justify-content-center d-flex mt-2">
                  <img
                    src="assets/img/icons/folder.png"
                    alt=""
                    className="h-90p"
                  />
                </div>
                <div className="d-flex justify-content-center mb-3">
                  <h4 className="mb-2 mt-2 text-danger fw-bold" htmlFor="">
                    {selectedLanguage.LstLanguageCodes.UI_KillDocument}
                  </h4>
                </div>
                <div className="d-flex justify-content-center flex-column mb-3 text-center">
                  <p
                    className="w-100 f-w550 mb-1 res-px10"
                    style={{ display: "content" }}>
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_Thiswilldeletethedocrecord
                    }
                  </p>
                  <p className="w-100 f-w550" style={{ display: "content" }}>
                    {selectedLanguage.LstLanguageCodes.UI_PleaseConfirmThat}
                  </p>
                </div>
                <div className="d-flex justify-content-center mb-4 ">
                  <button
                    type="button"
                    className="btn btn-danger px-4 me-1"
                    data-bs-dismiss="modal"
                    onClick={(e) => handlerModelCancel()}>
                    {selectedLanguage.LstLanguageCodes.UI_Cancel}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary px-4 ms-3"
                    onClick={(e) => handlerModelConfirmKill(1)}>
                    {selectedLanguage.LstLanguageCodes.UI_Confirm}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <TrackSortingPopup
          trackInteractivitySortingPopUp={trackInteractivitySortingPopUp}
          sortOptions={sortOptions}
          toggleSortOrder={toggleSortOrder}
          handlerModelCancelSorting={handlerModelCancelSorting}
          handlerModelOkSorting={handlerModelOkSorting}
          selectedLanguage={selectedLanguage}
        />
        <KillNoteModal
          modalIsOpenKillNote={modalIsOpenKillNote}
          killNotes={killNotes}
          setKillNotes={setKillNotes}
          handlerOpenKillNotesClosed={handlerOpenKillNotesClosed}
          handlerClickKill={handlerClickKill}
          selectedLanguage={selectedLanguage}
        />

        <NotesModal
          modalIsOpen={modalIsOpenNotes}
          senderNotes={senderNotes}
          setSenderNotes={setSenderNotes}
          handlerOpenNotesClosed={handlerOpenNotesClosed}
          handleToContinue={handleToContinue}
          selectedLanguage={selectedLanguage}
        />
      </section>
      {modalForAddUser &&
        <div className="modalCus" id="myModal">
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "1150px" }}>
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-center">
                <h4 className="mb-0 text-danger fw-bold font-20" htmlFor="">
                  <img
                    src="assets/img/icons/authorize.png"
                    alt=""
                    className="h-30p me-2" style={{ height: '24px' }}></img>
                  {selectedLanguage.LstLanguageCodes.UI_NewAutherizedReaders}
                </h4>
              </div>
              <div className="d-flex NewAuthBulBtn mt-2">
                <span
                  className="material-icons bulKUplodbtnNew mleft275"
                  onClick={() => handleReceiptsAdding()}
                  style={{ cursor: "pointer" }}>
                  file_upload
                </span>
                <span className="bulKUplodbtnNew" style={{ paddingTop: "1px" }}>
                  {selectedLanguage.LstLanguageCodes.UI_ImportReaderstooltip}
                </span>
              </div>
              <div className="modal-body pb-0 ps-3 pe-3 res-px0">
                <div
                  className=" authorizedReaders table-scrollbar max-width-popup"
                  style={{
                    maxHeight: "350px",
                    overflow: "auto",
                    overflowX: "hidden",
                    paddingRight: "3px",
                    display: "block",
                  }}>
                  {inputFields.map((data, index) => {
                    return (
                      <div className="row d-flex align-items-center ps-1 mb-2">
                        {inputFields.length !== 1 ? (
                          <div className="col-11 col-sm-11 col-md-11 pe-0 " >
                            <div className="w-100" key={index}>
                              <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" >
                                <div className="gridcol-22">
                                  <input
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) =>
                                      handleChange(index, evnt)
                                    }
                                    value={data.email}
                                    name="email" title={data.email}
                                    className="form-control custom-inputBorder"
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes.UI_Email
                                    }
                                  />
                                </div>
                                <div className="gridcol-17 pe-0 gridcol-16">
                                  <input
                                    // style={{ marginLeft: '-12px' }}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) =>
                                      handleChange(index, evnt)
                                    }
                                    value={data.firstName}
                                    name="firstName" title={data.firstName}
                                    className="form-control custom-inputBorder"
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_FirstName
                                    }
                                  />
                                </div>
                                <div className="gridcol-17 pe-0 gridcol-16">
                                  <input
                                    //  style={{marginLeft:'-22px'}}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) =>
                                      handleChange(index, evnt)
                                    }
                                    value={data.lastName}
                                    name="lastName" title={data.lastName}
                                    className="form-control custom-inputBorder"
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_LastName
                                    }
                                  />
                                </div>
                              </div>
                              <div
                                style={{ marginTop: "9px" }}
                                className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                                <div className="gridcol-22">
                                  <Select
                                    options={verificationOptions.current || []}
                                    value={data?.authType ? verificationOptions.current.find(option => option.label.toLowerCase() === data?.authType.toLowerCase()) : null}
                                    // value={selectVerificationCode?.value ? selectVerificationCode : ""}
                                    onChange={(event) => handleAuthTypeChange(event, index)}
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_SendVerificationCodeTo
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    closeMenuOnScroll={() => true}
                                    className="sendVerficationCodeBorder"
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        display: "flex",
                                        fontSize: "15px",
                                        width: "100%",
                                        minHeight: "40px",
                                        height: "40px",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        textAlign: "center",
                                        width: "100%",
                                        cursor: "default",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        // width: "233px",
                                        overflow: "hidden",
                                        // marginTop: '18px',
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                        marginTop: "3px",
                                      }),
                                      menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        // width: "233px",
                                        //marginTop: '4px',
                                      }),

                                    }}
                                  />
                                </div>
                                <div className="gridcol-25">
                                  <div className="input-group custom-inputBorder">
                                    <span
                                      className="input-group-text mobile-group50"
                                      style={{ padding: "0px", width: '48%' }}>
                                      <SelectCountry
                                        value={data.mobileCountryCode?.value ? data.mobileCountryCode : globePlaceholder}
                                        placeholder="+Code"
                                        // placeholder={
                                        //   selectedLanguage.LstLanguageCodes
                                        //     .UI_CountryCode
                                        // }
                                        onChange={(event) =>
                                          handleCodeChange(event, index)
                                        }
                                        //closeMenuOnScroll={() => true}
                                        menuPosition="fixed"
                                        options={countryCodeOptions}
                                        styles={{
                                          control: (provided) => ({
                                            ...provided,
                                            display: "flex",
                                            fontSize: "15px",
                                            width: "100%",
                                            minHeight: "40px",
                                            height: '40px',
                                          }),
                                          valueContainer: (provided) => ({
                                            ...provided,
                                            height: "40px",
                                          }),
                                          indicatorsContainer: (provided) => ({
                                            ...provided,
                                            height: "40px",
                                          }),
                                          placeholder: (provided) => ({
                                            ...provided,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "center",
                                            width: "100%",
                                            cursor: "default",
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            width: "233px",
                                            overflow: "hidden",
                                            // marginTop: '18px',
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                          }),
                                          menuPortal: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            width: "233px",
                                            //marginTop: '4px',
                                          }),
                                          indicatorSeparator: () => ({
                                            display: "none",
                                          }),
                                        }}
                                        menuPortalTarget={document.body}
                                        getOptionLabel={(e) => `${e.label}`}
                                        getOptionValue={(e) => `${e.value}`}
                                        title="Select code"
                                        formatOptionLabel={(
                                          data,
                                          { context }
                                        ) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}>
                                            <div
                                              className={`${data.label === "+Code"
                                                ? "bg-  "
                                                : `bg-${data.languageCode}`
                                                }`}
                                              style={{
                                                width: "36px",
                                                height: "16px",
                                                marginRight: "8px",
                                              }}
                                            ></div>
                                            {context === "menu"
                                              ? `${data.label}`
                                              : `${data.value?.split("-")[0]}`}
                                          </div>
                                        )}
                                        noOptionsMessage={() => null}
                                      />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control res-mobileinput"
                                      value={data.mobileNumber}
                                      maxLength={
                                        data.mobileCountryCode == undefined ||
                                          data.mobileCountryCode == null ||
                                          data.mobileCountryCode == "" ||
                                          data.mobileCountryCode == [] ||
                                          data.mobileCountryCode.value ==
                                          "+Code"
                                          ? 10
                                          : data.mobileCountryCode.mobileMaxLeng
                                      }
                                      onChange={(evnt) =>
                                        handleMobileChange(evnt, index)
                                      }
                                      placeholder={
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Mobile
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="gridcol-17 pe-0 gridcol-16">
                                  <input
                                    type="text"
                                    //  disabled={securityLevl2}
                                    className="form-control custom-inputBorder"
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_ReferenceTxt
                                    }
                                    value={data.reference} title={data.reference}
                                    name="reference"
                                    onChange={(evnt) =>
                                      handleChange(index, evnt)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                                <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                                  <div className={`checkbox mt-0 mb-0 d-flex align-items-center ${!canPrint || (data.canPrint && printEnabledType === "everyone") ? "disabled" : ""}`} style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                    <label className="ps-0 mb-0">
                                      <input
                                        type="checkbox"
                                        name="canPrint"
                                        checked={canPrint ? data.canPrint : false}
                                        onChange={(e) => handleChange(index, e)}
                                        value={readerPrint}
                                        id="txtPrint"
                                        disabled={!canPrint || (data.canPrint && printEnabledType === "everyone")}
                                      />
                                      <span className="cr" tabIndex="42">
                                        <i className="cr-icon material-icons">check</i>
                                      </span>
                                      <span
                                        className={`toolltipModified  top`}
                                        onMouseEnter={handleMouseEnter}>
                                        {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                      </span>
                                    </label>
                                  </div>
                                  <div className="d-flex flex-grow-1 align-items-center">
                                    <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                      <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                        {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                      </span>
                                      <input
                                        type="text"
                                        placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                        className="control form-control h-47p border-Left"
                                        name="maxPrintsPerReader"
                                        value={(data.maxPrintsPerReader != 0 ? data.maxPrintsPerReader : "") ?? ""}
                                        onChange={(e) => handleChange(index, e)}
                                        disabled={!data.canPrint}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className=" col-sm-12 col-md-12">
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" key={index} >
                              <div className="gridcol-22">
                                <input
                                  className="form-control custom-inputBorder"
                                  type="text"
                                  autoComplete="none" title={data.email}
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  value={data.email}
                                  name="email"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes.UI_Email
                                  }
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                                <input
                                  // style={{ marginLeft: '-12px' }}
                                  className="form-control custom-inputBorder"
                                  type="text"
                                  autoComplete="none" title={data.firstName}
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  value={data.firstName}
                                  name="firstName"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_FirstName
                                  }
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                                <input
                                  //  style={{marginLeft:'-22px'}}
                                  className="form-control custom-inputBorder"
                                  type="text"
                                  autoComplete="none" title={data.lastName}
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                  value={data.lastName}
                                  name="lastName"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_LastName
                                  }
                                />
                              </div>
                              {/* Country Code Dropdown and Mobile Number */}
                              {/* <div className="d-flex align-items-center res-w98"> */}
                            </div>
                            <div
                              style={{ marginTop: "9px" }}
                              className="gap-12p d-flex align-items-center mobile-flow w-max-content"
                              key={index}>
                              <div className="gridcol-22">
                                <Select
                                  options={verificationOptions.current || []}
                                  value={data?.authType ? verificationOptions.current.find(option => option.label.toLowerCase() === data?.authType.toLowerCase()) : null}
                                  // value={selectVerificationCode?.value ? selectVerificationCode : ""}
                                  onChange={(event) => handleAuthTypeChange(event, index)}
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_SendVerificationCodeTo
                                  }
                                  closeMenuOnScroll={() => true}
                                  className="sendVerficationCodeBorder"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      fontSize: "15px",
                                      width: "100%",
                                      minHeight: "40px",
                                      height: "40px",
                                      // borderColor: "#adadad",
                                      // boxShadow: "none !important",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    placeholder: (provided) => ({
                                      ...provided,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                      width: "100%",
                                      cursor: "default",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                      // width: "233px",
                                      overflow: "hidden",
                                      // marginTop: '18px',
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      marginTop: "3px",
                                    }),
                                    menuPortal: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                      // width: "233px",
                                      //marginTop: '4px',
                                    }),
                                  }}
                                  menuPortalTarget={document.body}
                                />
                              </div>
                              <div className="gridcol-25">
                                <div className="input-group custom-inputBorder">
                                  <span
                                    className="input-group-text mobile-group50"
                                    style={{ padding: "0px", width: '45%' }}>
                                    <SelectCountry
                                      value={data.mobileCountryCode?.value ? data.mobileCountryCode : globePlaceholder}
                                      onChange={(event) =>
                                        handleCodeChange(event, index)
                                      } // Pass index 0 to handle updates for the single reader
                                      options={countryCodeOptions}
                                      menuPosition="fixed"
                                      //closeMenuOnScroll={() => true}

                                      // placeholder="+Code"
                                      // menuIsOpen={false}
                                      // placeholder={
                                      //   selectedLanguage.LstLanguageCodes
                                      //     .UI_CountryCode
                                      // }
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          display: "flex",
                                          fontSize: "15px",
                                          width: "100%",
                                          minHeight: "40px",
                                          height: "40px",
                                        }),
                                        valueContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        indicatorsContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        placeholder: (provided) => ({
                                          ...provided,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          textAlign: "center",
                                          width: "100%",
                                          cursor: "default",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: "233px",
                                          overflow: "hidden",
                                          // marginTop: '1px',
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        }),
                                        menuPortal: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: "233px",
                                          //marginTop: '4px',
                                        }),
                                        indicatorSeparator: () => ({
                                          display: "none",
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      getOptionLabel={(e) => `${e.label}`}
                                      getOptionValue={(e) => `${e.value}`}
                                      title="Select code"
                                      formatOptionLabel={(
                                        data,
                                        { context }
                                      ) => (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}>
                                          <div
                                            className={`${data.label === "+Code"
                                              ? "bg-"
                                              : `bg-${data.languageCode}`
                                              }`}
                                            // className="bg-"
                                            style={{
                                              width: "36px",
                                              height: "16px",
                                              marginRight: "8px",
                                            }}
                                          ></div>
                                          {context === "menu"
                                            ? `${data.label}`
                                            : `${data.value?.split("-")[0]}`}
                                        </div>
                                      )}
                                      noOptionsMessage={() => null}
                                    />
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control res-mobileinput res-mobileinputrightborder"
                                    value={data.mobileNumber}
                                    maxLength={
                                      data.mobileCountryCode == undefined ||
                                        data.mobileCountryCode == null ||
                                        data.mobileCountryCode == "" ||
                                        data.mobileCountryCode == [] ||
                                        data.mobileCountryCode.value ==
                                        "+Code"
                                        ? 10
                                        : data.mobileCountryCode.mobileMaxLeng
                                    }
                                    onChange={(evnt) =>
                                      handleMobileChange(evnt, index)
                                    }
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_Mobile
                                    }
                                  />
                                </div>
                              </div>
                              <div className="gridcol-17 pe-0 gridcol-16 res-16p">
                                <input
                                  type="text"
                                  className="form-control custom-inputBorder"
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes
                                      .UI_ReferenceTxt
                                  }
                                  name="reference" title={data.reference}
                                  value={data.reference}
                                  onChange={(evnt) =>
                                    handleChange(index, evnt)
                                  }
                                />
                              </div>
                            </div>
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                              <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                                <div className={`checkbox mt-0 mb-0 d-flex align-items-center ${!canPrint || (data.canPrint && printEnabledType === "everyone") ? "disabled" : ""}`} style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                  <label className="ps-0 mb-0">
                                    <input
                                      type="checkbox"
                                      name="canPrint"
                                      checked={canPrint ? data.canPrint : false}
                                      onChange={(e) => handleChange(index, e)}
                                      value={readerPrint}
                                      id="txtPrint"
                                      disabled={!canPrint || (data.canPrint && printEnabledType === "everyone")}
                                    />
                                    <span className="cr" tabIndex="42">
                                      <i className="cr-icon material-icons">check</i>
                                    </span>
                                    <span
                                      className={`toolltipModified  top`}
                                      onMouseEnter={handleMouseEnter}>
                                      {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                    </span>
                                  </label>
                                </div>
                                <div className="d-flex flex-grow-1 align-items-center">
                                  <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                    <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                      {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                    </span>
                                    <input
                                      type="text"
                                      placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                      className="control form-control h-47p border-Left"
                                      name="maxPrintsPerReader"
                                      value={(data.maxPrintsPerReader !== 0 && data.maxPrintsPerReader !== null && data.maxPrintsPerReader !== undefined ? data.maxPrintsPerReader : "")}
                                      onChange={(e) => handleChange(index, e)}
                                      disabled={!data.canPrint}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        )}
                        <div className="col-12 col-sm-12 col-md-1 res-mobilClose justify-content-end">
                          {inputFields.length !== 1 ? (
                            <button
                              className="btn btn-outline-danger d-flex res-px"
                              style={{
                                borderBottomColor: "#bc272e",
                                padding: "8px 10px",
                                verticalAlign: "middle",
                                position: "relative",
                                left: "10px"
                              }}
                              onClick={(e) => removeInputFields(index)}>
                              <span className="material-icons">backspace</span>
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div ref={endRef} ></div>
                </div>
              </div>

              <div className="pb-4 px-3 d-flex flex-wrap justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline-success px-2 mt-3 ms-1 add-reader truncate"
                  data-bs-dismiss="modal"
                  title={selectedLanguage.LstLanguageCodes.UI_AddReader}
                  onClick={addInputField}>
                  <span
                    className="material-icons me-2 font-20"
                    style={{ verticalAlign: "bottom" }}>
                    add_circle_outline{" "}
                  </span>
                  {selectedLanguage.LstLanguageCodes.UI_AddReader}
                </button>
                <div className="d-flex align-items-center mt-3">
                  <button
                    type="button"
                    title={selectedLanguage.LstLanguageCodes.UI_Cancel}
                    className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                    data-bs-dismiss="modal"
                    onClick={(e) => handlerModelCancelForAddUser()}>
                    {selectedLanguage.LstLanguageCodes.UI_Cancel}
                  </button>
                  <button
                    type="button"
                    title={selectedLanguage.LstLanguageCodes.UI_Save}
                    className="btn btn-primary px-2 ms-1 w-140p truncate"
                    onClick={(e) => handlerModelConfirmForAddUser(false)}>
                    {selectedLanguage.LstLanguageCodes.UI_Save}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <AddRecipientModal
        isModalAddRecipientOpen={isModalAddRecipientOpen}
        handleCloseModal={handleCloseModal}
        selectedLanguage={selectedLanguage}
        DownloadReaderCSV={DownloadReaderCSV}
        DownloadReaderXLS={DownloadReaderXLS}
        ReadersfileSelectionClick={ReadersfileSelectionClick}
        ReadersfileSelection={ReadersfileSelection}
        AddDragActive={AddDragActive}
        ReadersinputFields={ReadersinputFields}
        ReadersfileName={ReadersfileName}
        selectedFiles={selectedFiles}
        fileNames={fileNames}
        handleFileChange={handleFileChange}
      />
      <ValidationPopup
        isValidationPopup={isValidationPopup}
        handleCloseValidationModal={handleCloseValidationModal}
        selectedLanguage={selectedLanguage}
        duplicateInFile={duplicateInFile}
        emailLeanghtValidation={emailLeanghtValidation}
        invalidEmailsWithoutDotCom={invalidEmailsWithoutDotCom}
        localpartValiadation={localpartValiadation}
        longDomainEmails={longDomainEmails}
        longFirstName={longFirstName}
        longLastName={longLastName}
        invalidMobileNumbers={invalidMobileNumbers}
        unauthorizedCountryCodes={unauthorizedCountryCodes}
        duplicateMobileNumbers={duplicateMobileNumbers}
        missingMobileNumbers={missingMobileNumbers}
        missingCountryCodes={missingCountryCodes}
        longReference={longReference}
        inValidAuthType={inValidAuthType.current}
        inValidMsgForBoth={inValidMsgForBoth.current}
        invalidCanPrintValues={invalidCanPrintValues}
        exceedMaxPrintsPerDoc={exceedMaxPrintsPerDoc}
        maxPrintsWithoutCanPrint={maxPrintsWithoutCanPrint}
        canPrintNotEnabledAtDocLevel={canPrintNotEnabledAtDocLevel}
        maxPrintsExceedLimit={maxPrintsExceedLimit}
        invalidMaxPrintsValues={invalidMaxPrintsValues}
      />
      <AddUserConfirmationModal
        show={modalForAddUserConfirmation}
        newReceipentsCount={newReceipentsCount}
        selectedLanguage={selectedLanguage}
        onConfirm={AddUserConfirmation}
      />
      <PendingReaderConfirmModal
        show={modalForPendingReaderConfirmation}
        selectedLanguage={selectedLanguage}
        onConfirm={handlePendingReaderConfirm}
        onCancel={handlePendingReaderCancel}
      />
      <PendingReaderConfirmModal
        show={modalForControlStatusPendingConfirmation}
        selectedLanguage={selectedLanguage}
        onConfirm={handleControlStatusPendingConfirm}
        onCancel={handleControlStatusPendingCancel}
      />
      <ControlStatusModal
        modalForControlStatus={modalForControlStatus}
        selectedLanguage={selectedLanguage}
        securityLevelTextColor={securityLevelTextColor}
        handleLevelChange={handleLevelChange}
        constSecurityLevelText={constSecurityLevelText}
        isDatetimeControl={isDatetimeControl}
        startTime={startTime}
        expiryTime={expiryTime}
        handlerExpirationDaysStartTime={handlerExpirationDaysStartTime}
        handlerExpirationDaysExpiryTime={handlerExpirationDaysExpiryTime}
        dateFormatValueOriginal={dateFormatValueOriginal}
        dateFormatValueLower={dateFormatValueLower}
        domains={domains}
        setDomains={setDomains}
        maxReadsText={maxReadsText}
        ChangeMaxReadsTexts={ChangeMaxReadsTexts}
        maxViewsPerDocumentText={maxViewsPerDocumentText}
        ChangeMaxViewsPerDocumentTexts={ChangeMaxViewsPerDocumentTexts}
        responseAddress={responseAddress}
        setResponseAddress={setResponseAddress}
        constAllowResFlag={constAllowResFlag}
        sendVerificationCodeDisable={sendVerificationCodeDisable}
        handleSelectionChange={handleSelectionChange}
        selectedOptions={selectedOptions}
        filteredOptions={filteredOptions}
        MultiValueRemove={MultiValueRemove}
        steganography={steganography}
        setSteganography={setSteganography}
        canPrint={canPrint}
        setPrint={setPrint}
        voting={voting}
        handleSetVoting={handleSetVoting}
        voteSharing={voteSharing}
        setVoteSharing={setVoteSharing}
        distributionList={distributionList}
        setDistributionList={setDistributionList}
        isPageLevelRestrictionChecked={isPageLevelRestrictionChecked}
        handlePageLevelRestrictionCheck={handlePageLevelRestrictionCheck}
        handlePageLevelRestrictionEdit={handlePageLevelRestrictionEdit}
        handlerModelCancelForControlStatus={handlerModelCancelForControlStatus}
        handlerModelConfirmForControlStatus={handlerModelConfirmForControlStatus}
        IntiateTime={IntiateTime}
        constSecurityLevelClass={constSecurityLevelClass}
        components={components}
        isPageLevelRestrictionSetting={isPageLevelRestrictionSetting}
        isPageLevelData={isPageLevelData}
        pageLevelResRef={pageLevelResRef}
        constContinents={constContinents}
        constmultipleips={constmultipleips}
        setConstMultipleIps={setConstMultipleIps}
        eDisclosure={eDisclosure}
        EDisclosureResRef={EDisclosureResRef}
        handleEDisclosure={handleEDisclosure}
        isEDisclosureChecked={isEDisclosureChecked}
        maxPrintsPerReader={maxPrintsPerReader.current}
        maxPrintsPerDocument={maxPrintsPerDocument.current}
        currentDocument={currentDocument}
        onSaveRecipientPrintSettings={handleSaveRecipientPrintSettings}
        recipientPrintData={recipientPrintData}
        setRecipientPrintData={setRecipientPrintData}
      />
      <PageLevelViewPopup
        isPageLevelViewPopup={isPageLevelViewPopup}
        selectedLanguage={selectedLanguage}
        latestUpdatedTime={latestUpdatedTime}
        dateFormatValueUpper={dateFormatValueUpper}
        handleCloseVersionHisrtyPageLevel={handleCloseVersionHisrtyPageLevel}
        pageLevelFilteredArr={pageLevelFilteredArr}
        timeZoneRef={timeZoneRef}
        applyTimeZoneToDisplay={applyTimeZoneToDisplay}
        timeZoneAbbrevation={timeZoneAbbrevation}
        approvedAccessRequests={approvedAccessRequestsForPopup}
      />

      <ControlStatusConfirmationModal
        isOpen={modalForControlStatusConfirmation}
        onConfirm={ControlStatusConfirmation}
        selectedLanguage={selectedLanguage}
      />
      <DocumentHistoryPopup
        modalForDocumentHistory={modalForDocumentHistory}
        selectedLanguage={selectedLanguage}
        handlermodalForDocumentHistory={handlermodalForDocumentHistory}
        fileName={fileName}
        lstDocumentsHistoryDetails={lstDocumentsHistoryDetails}
        dateFormatValueUpper={dateFormatValueUpper}
        handleVersionHisrtyPageLevel={handleVersionHisrtyPageLevel}
        handleTermOfservicePopup={handleTermOfservicePopup}
        isDatetimeControl={isDatetimeControl}
        applyTimeZoneToDisplay={applyTimeZoneToDisplay}
        timeZoneRef={timeZoneRef}
        timeZoneAbbrevation={timeZoneAbbrevation}
        handleVersionHistoryCanPrint={handleVersionHistoryCanPrint}
      />
      <Level3Popup
        isOpen={modalForLevel3Popup}
        onCancel={handlerModelCancelForLeve3Popup}
        onNo={handlerModelNoForLeve3Popup}
        onYes={handlerModelYesForLeve3Popup}
        onPickMine={handlerModelIWillPickForLeve3Popup}
        selectedLanguage={selectedLanguage}
        maxPrintsFields={maxPrintsFields.current}
      />
      <Level3AddUserModal
        modalForLevel3AddUser={modalForLevel3AddUser}
        selectedLanguage={selectedLanguage}
        inputFields={inputFields}
        handleChange={handleChange}
        handleCodeChange={handleCodeChange}
        handleMobileChange={handleMobileChange}
        removeInputFields={removeInputFields}
        addInputField={addInputField}
        handlerModelCancelForLeve3AddUser={handlerModelCancelForLeve3AddUser}
        handlerModelConfirmLevel3ForAddUser={handlerModelConfirmLevel3ForAddUser}
        handleReceiptsAdding={handleReceiptsAdding}
        countryCodeOptions={countryCodeOptions}
        handleAuthTypeChange={handleAuthTypeChange}
        authType={{
          verificationCode: "",
          rpdLevelOptions: selectedOptions,
        }}
        maxPrintsFields={maxPrintsFields.current}
        readerPrint={readerPrint}
        printEnabledType={printEnabledType}
        docLevelCanPrint={canPrint}
        defaultMaxPrintsPerReader={
          maxPrintsFields.current?.maxPrintsPerReader !== undefined
            ? maxPrintsFields.current.maxPrintsPerReader
            : maxPrintsPerReader.current
        }
      />
      <ManageUserModal
        modalForManageUser={modalForManageUser}
        selectedLanguage={selectedLanguage}
        leftSearchValue={leftSearchValue}
        rightSearchValue={rightSearchValue}
        temSelectedLeftList={temSelectedLeftList}
        temSelectedRightList={temSelectedRightList}
        handleSearchEvent={handleSearchEvent}
        handleToggleClass={handleToggleClass}
        moveSelectedValueRight={moveSelectedValueRight}
        moveSelectedValueLeft={moveSelectedValueLeft}
        handlerModelCancelForManageUser={handlerModelCancelForManageUser}
        handlerModelConfirmForManageUser={handlerModelConfirmForManageUser}
        addInputField={addInputField}
      />
      <IsActiveModal
        isOpen={modalActiveIsOpen}
        onCancel={handlerModelCancelActive}
        onConfirm={handlerActiveInactive}
        selectedLanguage={selectedLanguage}
        activeIsOpenEvent={activeIsOpenEvent}
        activeIsOpenDocId={activeIsOpenDocId}
        activeIsOpenHistoryFlag={activeIsOpenHistoryFlag}
      />
      <RecipientsModal
        isVisible={recipientsViewMorePopup}
        handlerModelCancelForSave={handlerModelCancelForSave}
        selectedLanguage={selectedLanguage}
        recipientToEmails={recipientToEmails}
        recipientCcEmails={recipientCcEmails}
        recipientBccEmails={recipientBccEmails}
      />
      <EditReaderModal
        isOpen={isModalFnLnOpen}
        handleClose={handleCloseFnLnModal}
        selectedLanguage={selectedLanguage}
        currentEmail={currentEmail}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        selectedCode={selectedCode}
        handleCodeChange={handleCodeChange}
        countryCodeDrpOptions={countryCodeDrpOptions}
        mobileNumber={mobileNumber}
        handleMobileChange={handleMobileChange}
        handleAddFnLn={handleAddFnLn}
        handleCloseFnLnModal={handleCloseFnLnModal}
        reference={reference}
        setReference={setReference}
        authType={{
          verificationCode: verificationCode,
          rpdLevelOptions: selectedOptions,
        }}
        handleAuthTypeChange={handleAuthTypeChange}
        readerPrint={readerPrint}
        setReaderPrint={setReaderPrint}
        maxPrintsPerIndReader={maxPrintsPerIndReader}
        setMaxPrintsPerIndReader={setMaxPrintsPerIndReader}
        printEnabledType={printEnabledType}
        docLevelCanPrint={canPrint}
      />
      <MoveFolderPopup
        isVisible={modalIsMoveFolderOpen}
        handlerMoveModelCancel={handlerMoveModelCancel}
        handlerMoveConfirmOpen={handlerMoveConfirmOpen}
        selectedLanguage={selectedLanguage}
        ddlSelectedfolderName={ddlSelectedfolderName}
        folderId={folderId}
        foldersDetailsLst={foldersDetailsLst}
        ddlFoldername={ddlFoldername}
        shareIcon={shareIcon}
      />
      <CreateFolderModal
        modalIsCreateFolderOpen={modalIsCreateFolderOpen}
        folderNameText={folderNameText}
        handleCreatefolderChange={handleCreatefolderChange}
        selectedLanguage={selectedLanguage}
        selectedOption={selectedOption}
        handleSelectFolderAccess={handleSelectFolderAccess}
        options={options}
        showIcon={showIcon}
        handlerCreatefolderModelCancel={handlerCreatefolderModelCancel}
        handlecreateFolder={handlecreateFolder}
      />
      <ManageFolderModal
        isOpen={modalIsManageFolderOpen}
        folderNameText={folderNameText}
        selectedLanguage={selectedLanguage}
        selectedOption={selectedOption}
        options={options}
        handleManageCloseModal={handleManageCloseModal}
        handleCreatefolderChange={handleCreatefolderChange}
        handleSelectFolderAccess={handleSelectFolderAccess}
        handleEditFn={handleEditFn}
        handlerModelUpdateConfirm={handlerModelUpdateConfirm}
        handlerModelDeleteConfirm={handlerModelDeleteConfirm}
        showIcon={showIcon}
        EditIcon={EditIcon}
      />
      <DeleteConfirmationModal
        isOpen={modalIsDeleteOpen}
        folderName={folderName}
        selectedLanguage={selectedLanguage}
        onCancel={handlerDeleteModelCancel}
        onConfirm={handlerModelDeleteFolder}
      />
      <UpdateConfirmModal
        isOpen={modalIsUpdateconfirmOpen}
        folderName={folderName}
        selectedLanguage={selectedLanguage}
        onCancel={handlerUpdateModelCancel}
        onConfirm={handlerModelEditFolder}
      />
      <MoveConfirmModal
        isOpen={modalIsMoveConfirmOpen}
        handlerConfirmMoveModelCancel={handlerConfirmMoveModelCancel}
        MoveDocumentsToFolder={MoveDocumentsToFolder}
        selectedLanguage={selectedLanguage}
        ddlSelectedfolderName={ddlSelectedfolderName}
      />
      <CanPrintViewPopup
        isCanPrintViewPopup={isCanPrintViewPopup}
        selectedLanguage={selectedLanguage}
        latestUpdatedTime={latestCanPrintUpdatedTime}
        dateFormatValueUpper={dateFormatValueUpper}
        handleCloseCanPrintViewPopup={handleCloseCanPrintViewPopup}
        canPrintFilteredArr={canPrintFilteredArr}
        timeZoneRef={timeZoneRef}
        applyTimeZoneToDisplay={applyTimeZoneToDisplay}
      />
      {modalTermsOfServicePopup && (
        <div
          className="modal "
          id="TermsOfService"
          style={{ display: "block", backgroundColor: "#8080801c" }}>
          <div className="modal-dialog modal-dialog-centered modal-customelg modal-terms-of-service">
            <div className="modal-content">
              <div className="modal-header pb-1">
                <h4
                  className="d-flex align-items-center text-danger fw-bold "
                  htmlFor="">
                  {selectedLanguage.LstLanguageCodes.UI_TermsOfService}
                </h4>
                <button
                  type="button"
                  className="btn btn-outline-danger Readerclose modalclose download "
                  onClick={() => handleTermofServiceCloseModal()}>
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="quill">
                <div className="ql-container ql-snow">
                  <div className="ql-editor">
                    {TermsofServiceMessage}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {modalIsUserPopupOpen && (
        <UserListPopup
          isOpen={modalIsUserPopupOpen}
          onCancel={handlerUserModelCancel}
          sendDataToParent={handleDataFromChild}
          sendDataListToParaent={GetuserlistFromChild}
          folderID={folderId}
          sharingOption={selectedOption}
          isEditUsersOfFolder={isUserPopupopen}
        />
      )}
      {customColumnLayoutFlag &&
        <CustomColumnLayout
          selectedLanguage={selectedLanguage}
          handlerCustomColumnLayoutCancel={handlerCustomColumnLayoutCancel}
          handlerCustomColumnLayoutConfirm={handlerCustomColumnLayoutConfirm}
          sortedColumns={sortedColumns}
          setParentAlertMsg={setParentAlertMsg}
          timeZoneAbbrevation={timeZoneAbbrevation.current}
          customFilterOptionsArray={customFilterOptionsArray}
          setCustomColumnLayoutFlag={() => setCustomColumnLayoutFlag(false)}
          clearFilters={clearFiltersForLayout}
        />
      }
      {/* Move modal popup */}
      <PageRestrictions
        DeleteData={deleteSelectionOfRestriction}
        onCancel={onCancelPageLevelRestriction}
        onSave={onSavePageLevelRestriction}
        addNewReaders={onAddNewReaderHandler}
        ref={pageLevelResModalRef}
        isFromManage="true"
      />
      <UpdatePopup
        isOpenModal={isExpireChangePopup}
        onCancel={onCancelUpdatePopup}
        onConfirm={onConfirmUpdatePopup}
        message={selectedLanguage.LstLanguageCodes.UI_TheExpiryDateHasbeenchanged}
        selectedLanguage={selectedLanguage}
        isExpiry={true}
        handleCloseUpdatePopop={handleCloseUpdatePopop}
      />
      <ModalPopUp ref={unSaveWarnModal} headerText={"Update"} />
      <Footer></Footer>
    </div>
  );
}
export default Manage;
